{
  "level": "mt02e",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02e",
    "objects": "AREAS.E3:mt02e.e3",
    "mesh": "TREES.E3:mt02e.e3"
  },
  "spawn_point": {
    "position": [
      -1598.4804700519444,
      -3758.5701485591535,
      1218.825439453125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1598.4804700519444,
      -3658.5701485591535,
      1218.825439453125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1707.9254150390625,
      -4001.042236328125,
      1194.825439453125
    ],
    "bbox_max": [
      -1466.8427734375,
      -3521.130615234375,
      1505.0
    ],
    "vertex_count": 2344,
    "vertices": [
      [
        -1593.6995849609375,
        -3677.602783203125,
        1405.224365234375
      ],
      [
        -1593.697998046875,
        -3677.605224609375,
        1405.224365234375
      ],
      [
        -1593.697998046875,
        -3677.605224609375,
        1405.224365234375
      ],
      [
        -1593.7000732421875,
        -3677.60205078125,
        1405.2265625
      ],
      [
        -1593.7000732421875,
        -3677.60205078125,
        1405.2265625
      ],
      [
        -1593.6995849609375,
        -3677.602783203125,
        1405.224365234375
      ],
      [
        -1547.9188232421875,
        -3681.810302734375,
        1398.0
      ],
      [
        -1545.5,
        -3686.0,
        1405.9273681640625
      ],
      [
        -1558.869384765625,
        -3687.09228515625,
        1409.5
      ],
      [
        -1559.5,
        -3686.0,
        1407.64111328125
      ],
      [
        -1559.5,
        -3686.0,
        1407.64111328125
      ],
      [
        -1556.9732666015625,
        -3681.62353515625,
        1398.0
      ],
      [
        -1547.5792236328125,
        -3689.601318359375,
        1409.5
      ],
      [
        -1558.869384765625,
        -3687.09228515625,
        1409.5
      ],
      [
        -1527.1983642578125,
        -3650.5,
        1422.0
      ],
      [
        -1527.1983642578125,
        -3644.5,
        1422.0
      ],
      [
        -1524.115966796875,
        -3651.79052734375,
        1422.0
      ],
      [
        -1527.1983642578125,
        -3650.5,
        1422.0
      ],
      [
        -1526.8095703125,
        -3643.961181640625,
        1422.0
      ],
      [
        -1527.1983642578125,
        -3644.5,
        1422.0
      ],
      [
        -1526.8095703125,
        -3643.961181640625,
        1422.0
      ],
      [
        -1524.115966796875,
        -3643.20947265625,
        1422.0
      ],
      [
        -1559.1038818359375,
        -3686.68603515625,
        1409.5
      ],
      [
        -1547.7928466796875,
        -3682.028564453125,
        1409.5
      ],
      [
        -1559.5,
        -3686.0,
        1407.9293212890625
      ],
      [
        -1556.0,
        -3679.937744140625,
        1399.38330078125
      ],
      [
        -1547.7928466796875,
        -3682.028564453125,
        1409.5
      ],
      [
        -1549.0,
        -3679.937744140625,
        1404.7138671875
      ],
      [
        -1556.0,
        -3679.937744140625,
        1399.38330078125
      ],
      [
        -1549.0,
        -3679.937744140625,
        1404.7138671875
      ],
      [
        -1559.1038818359375,
        -3686.68603515625,
        1409.5
      ],
      [
        -1559.5,
        -3686.0,
        1407.9293212890625
      ],
      [
        -1545.1923828125,
        -3667.838134765625,
        1422.0
      ],
      [
        -1543.88232421875,
        -3667.838134765625,
        1422.0
      ],
      [
        -1543.227294921875,
        -3669.0,
        1422.0
      ],
      [
        -1543.723876953125,
        -3668.118896484375,
        1422.0
      ],
      [
        -1543.88232421875,
        -3667.838134765625,
        1422.0
      ],
      [
        -1543.723876953125,
        -3668.118896484375,
        1422.0
      ],
      [
        -1544.3558349609375,
        -3667.081787109375,
        1400.0
      ],
      [
        -1579.9364013671875,
        -3667.08154296875,
        1400.0
      ],
      [
        -1545.6431884765625,
        -3671.041748046875,
        1400.0
      ],
      [
        -1546.724853515625,
        -3669.0,
        1400.0
      ],
      [
        -1542.3980712890625,
        -3669.0,
        1400.0
      ],
      [
        -1542.4505615234375,
        -3669.09912109375,
        1400.0
      ],
      [
        -1542.4505615234375,
        -3669.09912109375,
        1400.0
      ],
      [
        -1543.4801025390625,
        -3671.041748046875,
        1400.0
      ],
      [
        -1546.724853515625,
        -3669.0,
        1400.0
      ],
      [
        -1545.6431884765625,
        -3667.08154296875,
        1400.0
      ],
      [
        -1543.4801025390625,
        -3671.041748046875,
        1400.0
      ],
      [
        -1545.6431884765625,
        -3671.041748046875,
        1400.0
      ],
      [
        -1556.0,
        -3679.937744140625,
        1400.0
      ],
      [
        -1555.190185546875,
        -3679.937744140625,
        1400.0
      ],
      [
        -1556.2525634765625,
        -3680.375244140625,
        1400.0
      ],
      [
        -1556.0,
        -3679.937744140625,
        1400.0
      ],
      [
        -1545.1923828125,
        -3670.23681640625,
        1422.0
      ],
      [
        -1545.8475341796875,
        -3669.0,
        1422.0
      ],
      [
        -1545.8475341796875,
        -3669.0,
        1422.0
      ],
      [
        -1545.1923828125,
        -3667.838134765625,
        1422.0
      ],
      [
        -1543.227294921875,
        -3669.0,
        1422.0
      ],
      [
        -1543.723876953125,
        -3669.937744140625,
        1422.0
      ],
      [
        -1543.723876953125,
        -3669.937744140625,
        1422.0
      ],
      [
        -1543.88232421875,
        -3670.23681640625,
        1422.0
      ],
      [
        -1543.88232421875,
        -3670.23681640625,
        1422.0
      ],
      [
        -1545.1923828125,
        -3670.23681640625,
        1422.0
      ],
      [
        -1542.8973388671875,
        -3668.162841796875,
        1400.7115478515625
      ],
      [
        -1545.6475830078125,
        -3671.01904296875,
        1400.19775390625
      ],
      [
        -1545.94140625,
        -3670.479248046875,
        1400.0
      ],
      [
        -1544.3558349609375,
        -3667.081787109375,
        1400.0
      ],
      [
        -1543.486083984375,
        -3667.092529296875,
        1400.317138671875
      ],
      [
        -1545.63916015625,
        -3671.034423828125,
        1400.203369140625
      ],
      [
        -1545.6475830078125,
        -3671.01904296875,
        1400.19775390625
      ],
      [
        -1542.8973388671875,
        -3668.162841796875,
        1400.7115478515625
      ],
      [
        -1542.4365234375,
        -3669.00048828125,
        1401.020263671875
      ],
      [
        -1543.497802734375,
        -3671.006103515625,
        1400.974853515625
      ],
      [
        -1544.5609130859375,
        -3673.015380859375,
        1400.9293212890625
      ],
      [
        -1540.97412109375,
        -3671.65869140625,
        1402.0
      ],
      [
        -1542.970703125,
        -3675.93701171875,
        1402.0
      ],
      [
        -1556.6397705078125,
        -3681.0458984375,
        1400.9453125
      ],
      [
        -1556.0,
        -3679.937744140625,
        1400.4571533203125
      ],
      [
        -1556.0,
        -3679.937744140625,
        1400.4571533203125
      ],
      [
        -1554.734130859375,
        -3679.937744140625,
        1400.3472900390625
      ],
      [
        -1556.0,
        -3679.937744140625,
        1401.4765625
      ],
      [
        -1552.5640869140625,
        -3679.937744140625,
        1401.999755859375
      ],
      [
        -1557.0716552734375,
        -3681.7939453125,
        1401.999755859375
      ],
      [
        -1556.0,
        -3679.937744140625,
        1401.4765625
      ],
      [
        -1580.305419921875,
        -3667.085693359375,
        1400.123779296875
      ],
      [
        -1579.9364013671875,
        -3667.08154296875,
        1400.0
      ],
      [
        -1585.89990234375,
        -3667.150146484375,
        1402.0
      ],
      [
        -1580.305419921875,
        -3667.085693359375,
        1400.123779296875
      ],
      [
        -1541.885986328125,
        -3667.112548828125,
        1400.9005126953125
      ],
      [
        -1538.8702392578125,
        -3667.150390625,
        1402.0
      ],
      [
        -1541.885986328125,
        -3667.112548828125,
        1400.9005126953125
      ],
      [
        -1559.1422119140625,
        -3661.927490234375,
        1400.0
      ],
      [
        -1562.032958984375,
        -3661.927490234375,
        1400.0
      ],
      [
        -1559.1422119140625,
        -3657.072509765625,
        1400.0
      ],
      [
        -1562.032958984375,
        -3657.072509765625,
        1400.0
      ],
      [
        -1557.69677734375,
        -3659.5,
        1400.0
      ],
      [
        -1559.1422119140625,
        -3657.072509765625,
        1400.0
      ],
      [
        -1562.032958984375,
        -3657.072509765625,
        1400.0
      ],
      [
        -1563.4783935546875,
        -3659.5,
        1400.0
      ],
      [
        -1557.69677734375,
        -3659.5,
        1400.0
      ],
      [
        -1559.1422119140625,
        -3661.927490234375,
        1400.0
      ],
      [
        -1562.032958984375,
        -3661.927490234375,
        1400.0
      ],
      [
        -1563.4783935546875,
        -3659.5,
        1400.0
      ],
      [
        -1561.74365234375,
        -3657.57763671875,
        1422.0
      ],
      [
        -1559.480224609375,
        -3657.577392578125,
        1422.0
      ],
      [
        -1559.480224609375,
        -3657.57763671875,
        1422.0
      ],
      [
        -1558.3485107421875,
        -3659.478271484375,
        1422.0
      ],
      [
        -1562.87548828125,
        -3659.478271484375,
        1422.0
      ],
      [
        -1561.7437744140625,
        -3657.577392578125,
        1422.0
      ],
      [
        -1563.4783935546875,
        -3661.927490234375,
        1412.0577392578125
      ],
      [
        -1561.8216552734375,
        -3666.427490234375,
        1413.9000244140625
      ],
      [
        -1559.480224609375,
        -3661.379150390625,
        1422.0
      ],
      [
        -1561.7437744140625,
        -3661.379150390625,
        1422.0
      ],
      [
        -1558.3485107421875,
        -3659.478271484375,
        1422.0
      ],
      [
        -1559.480224609375,
        -3661.379150390625,
        1422.0
      ],
      [
        -1561.74365234375,
        -3661.379150390625,
        1422.0
      ],
      [
        -1562.87548828125,
        -3659.478271484375,
        1422.0
      ],
      [
        -1555.5,
        -3630.0,
        1452.5
      ],
      [
        -1561.0,
        -3630.0,
        1452.5
      ],
      [
        -1581.094970703125,
        -3683.516845703125,
        1452.5
      ],
      [
        -1580.69189453125,
        -3683.6064453125,
        1452.5
      ],
      [
        -1539.119873046875,
        -3680.06298828125,
        1452.5
      ],
      [
        -1538.640380859375,
        -3679.03564453125,
        1452.5
      ],
      [
        -1539.119873046875,
        -3680.06298828125,
        1452.5
      ],
      [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      [
        -1555.76123046875,
        -3686.57177734375,
        1452.5
      ],
      [
        -1529.866455078125,
        -3658.09765625,
        1452.5
      ],
      [
        -1538.640380859375,
        -3679.03564453125,
        1452.5
      ],
      [
        -1581.3045654296875,
        -3683.202392578125,
        1452.5
      ],
      [
        -1581.094970703125,
        -3683.516845703125,
        1452.5
      ],
      [
        -1592.255126953125,
        -3667.790283203125,
        1452.5
      ],
      [
        -1581.3045654296875,
        -3683.202392578125,
        1452.5
      ],
      [
        -1592.255126953125,
        -3667.790283203125,
        1452.5
      ],
      [
        -1592.0147705078125,
        -3667.136962890625,
        1452.5
      ],
      [
        -1570.2978515625,
        -3685.83349609375,
        1452.5
      ],
      [
        -1580.69189453125,
        -3683.6064453125,
        1452.5
      ],
      [
        -1583.8328857421875,
        -3644.662353515625,
        1452.5
      ],
      [
        -1585.565673828125,
        -3649.61328125,
        1452.5
      ],
      [
        -1585.565673828125,
        -3649.61328125,
        1452.5
      ],
      [
        -1584.85791015625,
        -3644.5,
        1445.8250732421875
      ],
      [
        -1587.25439453125,
        -3650.5,
        1443.994873046875
      ],
      [
        -1584.53662109375,
        -3644.203857421875,
        1447.167724609375
      ],
      [
        -1584.85791015625,
        -3644.5,
        1445.8250732421875
      ],
      [
        -1586.125244140625,
        -3650.5,
        1450.9617919921875
      ],
      [
        -1594.47900390625,
        -3650.5,
        1452.5
      ],
      [
        -1594.47900390625,
        -3644.5,
        1452.5
      ],
      [
        -1584.086181640625,
        -3644.5,
        1450.5863037109375
      ],
      [
        -1594.8358154296875,
        -3644.386474609375,
        1452.5
      ],
      [
        -1587.972900390625,
        -3642.666259765625,
        1450.239990234375
      ],
      [
        -1583.8565673828125,
        -3643.576904296875,
        1450.0093994140625
      ],
      [
        -1584.086181640625,
        -3644.5,
        1450.5863037109375
      ],
      [
        -1594.47900390625,
        -3644.5,
        1452.5
      ],
      [
        -1587.5576171875,
        -3653.5,
        1448.78173828125
      ],
      [
        -1595.2913818359375,
        -3650.619873046875,
        1452.5
      ],
      [
        -1594.8358154296875,
        -3650.613525390625,
        1452.5
      ],
      [
        -1587.04052734375,
        -3652.567626953125,
        1449.9329833984375
      ],
      [
        -1587.25439453125,
        -3650.5,
        1443.994873046875
      ],
      [
        -1586.9942626953125,
        -3651.41015625,
        1447.5650634765625
      ],
      [
        -1587.97314453125,
        -3652.333740234375,
        1450.2401123046875
      ],
      [
        -1594.8358154296875,
        -3650.613525390625,
        1452.5
      ],
      [
        -1594.47900390625,
        -3650.5,
        1452.5
      ],
      [
        -1586.125244140625,
        -3650.5,
        1450.9617919921875
      ],
      [
        -1586.8245849609375,
        -3652.07958984375,
        1450.17578125
      ],
      [
        -1586.9942626953125,
        -3651.41015625,
        1447.5650634765625
      ],
      [
        -1587.5576171875,
        -3653.5,
        1448.78173828125
      ],
      [
        -1587.225830078125,
        -3652.315673828125,
        1448.092041015625
      ],
      [
        -1587.04052734375,
        -3652.567626953125,
        1449.9329833984375
      ],
      [
        -1584.53662109375,
        -3644.203857421875,
        1447.167724609375
      ],
      [
        -1583.340576171875,
        -3641.5,
        1448.708251953125
      ],
      [
        -1583.34130859375,
        -3641.505126953125,
        1448.7147216796875
      ],
      [
        -1587.0186767578125,
        -3652.572998046875,
        1449.92578125
      ],
      [
        -1587.5286865234375,
        -3653.5,
        1448.78125
      ],
      [
        -1587.0186767578125,
        -3652.572998046875,
        1449.92578125
      ],
      [
        -1587.5286865234375,
        -3653.5,
        1448.78125
      ],
      [
        -1568.525634765625,
        -3636.10009765625,
        1452.5
      ],
      [
        -1570.7779541015625,
        -3637.413818359375,
        1452.5
      ],
      [
        -1583.8328857421875,
        -3644.662353515625,
        1452.5
      ],
      [
        -1570.7779541015625,
        -3637.413818359375,
        1452.5
      ],
      [
        -1583.296630859375,
        -3643.86083984375,
        1450.0706787109375
      ],
      [
        -1580.6146240234375,
        -3641.9189453125,
        1447.88818359375
      ],
      [
        -1580.6146240234375,
        -3641.9189453125,
        1447.88818359375
      ],
      [
        -1583.33935546875,
        -3643.377197265625,
        1447.624267578125
      ],
      [
        -1583.296630859375,
        -3643.86083984375,
        1450.0706787109375
      ],
      [
        -1584.0543212890625,
        -3644.371826171875,
        1450.506103515625
      ],
      [
        -1583.33935546875,
        -3643.377197265625,
        1447.624267578125
      ],
      [
        -1584.40673828125,
        -3643.91015625,
        1447.3350830078125
      ],
      [
        -1583.29296875,
        -3644.219970703125,
        1450.2779541015625
      ],
      [
        -1580.35791015625,
        -3641.958740234375,
        1447.8104248046875
      ],
      [
        -1580.35791015625,
        -3641.958740234375,
        1447.8104248046875
      ],
      [
        -1583.341796875,
        -3643.6259765625,
        1447.4805908203125
      ],
      [
        -1583.29296875,
        -3644.219970703125,
        1450.2779541015625
      ],
      [
        -1583.683837890625,
        -3644.5,
        1450.51220703125
      ],
      [
        -1584.194580078125,
        -3644.81884765625,
        1450.6063232421875
      ],
      [
        -1583.683837890625,
        -3644.5,
        1450.51220703125
      ],
      [
        -1584.4796142578125,
        -3644.218017578125,
        1447.1585693359375
      ],
      [
        -1583.341796875,
        -3643.6259765625,
        1447.4805908203125
      ],
      [
        -1584.4796142578125,
        -3644.218017578125,
        1447.1585693359375
      ],
      [
        -1584.57568359375,
        -3644.23974609375,
        1447.004638671875
      ],
      [
        -1545.22705078125,
        -3637.528564453125,
        1452.5
      ],
      [
        -1547.0638427734375,
        -3636.10009765625,
        1452.5
      ],
      [
        -1534.8753662109375,
        -3644.363037109375,
        1452.5
      ],
      [
        -1545.22705078125,
        -3637.528564453125,
        1452.5
      ],
      [
        -1527.1639404296875,
        -3643.890380859375,
        1422.324462890625
      ],
      [
        -1532.9171142578125,
        -3641.5,
        1429.9600830078125
      ],
      [
        -1530.7928466796875,
        -3642.83544921875,
        1429.5980224609375
      ],
      [
        -1532.9171142578125,
        -3641.5,
        1429.9600830078125
      ],
      [
        -1527.1639404296875,
        -3643.890380859375,
        1422.324462890625
      ],
      [
        -1526.860107421875,
        -3644.03125,
        1422.0
      ],
      [
        -1530.7928466796875,
        -3642.83544921875,
        1429.5980224609375
      ],
      [
        -1529.2276611328125,
        -3644.5,
        1433.0205078125
      ],
      [
        -1529.2276611328125,
        -3644.5,
        1433.0205078125
      ],
      [
        -1524.115966796875,
        -3647.6865234375,
        1431.9981689453125
      ],
      [
        -1534.8753662109375,
        -3644.363037109375,
        1452.5
      ],
      [
        -1534.1982421875,
        -3646.106689453125,
        1452.5
      ],
      [
        -1528.55810546875,
        -3643.611572265625,
        1423.6007080078125
      ],
      [
        -1532.0908203125,
        -3641.84326171875,
        1428.8634033203125
      ],
      [
        -1531.8753662109375,
        -3642.1279296875,
        1428.2049560546875
      ],
      [
        -1530.36962890625,
        -3644.5,
        1433.2489013671875
      ],
      [
        -1524.115966796875,
        -3649.066162109375,
        1431.9981689453125
      ],
      [
        -1531.359130859375,
        -3642.94873046875,
        1429.9654541015625
      ],
      [
        -1530.36962890625,
        -3644.5,
        1433.2489013671875
      ],
      [
        -1528.55810546875,
        -3643.611572265625,
        1423.6007080078125
      ],
      [
        -1527.100341796875,
        -3644.3642578125,
        1422.0
      ],
      [
        -1531.359130859375,
        -3642.94873046875,
        1429.9654541015625
      ],
      [
        -1532.050048828125,
        -3642.427490234375,
        1430.032958984375
      ],
      [
        -1532.2056884765625,
        -3641.947265625,
        1429.8388671875
      ],
      [
        -1533.279052734375,
        -3641.5,
        1430.153076171875
      ],
      [
        -1533.279052734375,
        -3641.5,
        1430.153076171875
      ],
      [
        -1529.866455078125,
        -3658.09765625,
        1452.5
      ],
      [
        -1530.771484375,
        -3654.93017578125,
        1452.5
      ],
      [
        -1531.6099853515625,
        -3644.5,
        1433.4969482421875
      ],
      [
        -1529.856201171875,
        -3650.5,
        1433.146240234375
      ],
      [
        -1529.4716796875,
        -3651.571044921875,
        1432.450927734375
      ],
      [
        -1528.3663330078125,
        -3653.5,
        1427.532958984375
      ],
      [
        -1528.7388916015625,
        -3650.5,
        1423.232421875
      ],
      [
        -1530.6229248046875,
        -3644.5,
        1424.7396240234375
      ],
      [
        -1528.5758056640625,
        -3652.608154296875,
        1427.129638671875
      ],
      [
        -1528.7388916015625,
        -3650.5,
        1423.232421875
      ],
      [
        -1529.4716796875,
        -3651.571044921875,
        1432.450927734375
      ],
      [
        -1529.856201171875,
        -3650.5,
        1433.146240234375
      ],
      [
        -1531.1666259765625,
        -3643.08984375,
        1425.98876953125
      ],
      [
        -1531.6181640625,
        -3642.242919921875,
        1427.8477783203125
      ],
      [
        -1531.1666259765625,
        -3643.08984375,
        1425.98876953125
      ],
      [
        -1530.6229248046875,
        -3644.5,
        1424.7396240234375
      ],
      [
        -1531.659912109375,
        -3643.0087890625,
        1430.16064453125
      ],
      [
        -1531.6099853515625,
        -3644.5,
        1433.4969482421875
      ],
      [
        -1531.659912109375,
        -3643.0087890625,
        1430.16064453125
      ],
      [
        -1531.7418212890625,
        -3642.659912109375,
        1430.0028076171875
      ],
      [
        -1528.5758056640625,
        -3652.608154296875,
        1427.129638671875
      ],
      [
        -1528.3663330078125,
        -3653.5,
        1427.532958984375
      ],
      [
        -1530.771484375,
        -3654.93017578125,
        1452.5
      ],
      [
        -1531.849609375,
        -3643.046630859375,
        1430.28369140625
      ],
      [
        -1531.8031005859375,
        -3644.5,
        1433.5355224609375
      ],
      [
        -1531.212158203125,
        -3643.00439453125,
        1426.1763916015625
      ],
      [
        -1531.8753662109375,
        -3642.1279296875,
        1428.204833984375
      ],
      [
        -1531.8031005859375,
        -3644.5,
        1433.5355224609375
      ],
      [
        -1531.0916748046875,
        -3646.273193359375,
        1433.393310546875
      ],
      [
        -1531.849609375,
        -3643.046630859375,
        1430.28369140625
      ],
      [
        -1532.0504150390625,
        -3642.427001953125,
        1430.032958984375
      ],
      [
        -1568.525634765625,
        -3636.10009765625,
        1452.5
      ],
      [
        -1547.0638427734375,
        -3636.10009765625,
        1452.5
      ],
      [
        -1563.0,
        -3635.7001953125,
        1450.5
      ],
      [
        -1553.5,
        -3635.7001953125,
        1450.5
      ],
      [
        -1553.5,
        -3635.0,
        1452.5
      ],
      [
        -1553.5,
        -3635.7001953125,
        1450.5
      ],
      [
        -1553.5,
        -3636.10009765625,
        1452.5
      ],
      [
        -1563.0,
        -3635.7001953125,
        1450.5
      ],
      [
        -1563.0,
        -3635.0,
        1452.5
      ],
      [
        -1563.0,
        -3636.10009765625,
        1452.5
      ],
      [
        -1556.5,
        -3633.7998046875,
        1441.0
      ],
      [
        -1556.5,
        -3633.400146484375,
        1439.0
      ],
      [
        -1556.5,
        -3635.7001953125,
        1450.5
      ],
      [
        -1556.5,
        -3633.7998046875,
        1441.0
      ],
      [
        -1555.0,
        -3633.400146484375,
        1439.0
      ],
      [
        -1555.0,
        -3633.7998046875,
        1441.0
      ],
      [
        -1555.0,
        -3635.7001953125,
        1450.5
      ],
      [
        -1555.0,
        -3633.7998046875,
        1441.0
      ],
      [
        -1555.0,
        -3633.400146484375,
        1439.0
      ],
      [
        -1556.5,
        -3633.400146484375,
        1439.0
      ],
      [
        -1562.0,
        -3633.7998046875,
        1441.0
      ],
      [
        -1562.0,
        -3633.400146484375,
        1439.0
      ],
      [
        -1562.0,
        -3635.7001953125,
        1450.5
      ],
      [
        -1562.0,
        -3633.7998046875,
        1441.0
      ],
      [
        -1560.5,
        -3633.400146484375,
        1439.0
      ],
      [
        -1560.5,
        -3633.7998046875,
        1441.0
      ],
      [
        -1560.5,
        -3635.7001953125,
        1450.5
      ],
      [
        -1560.5,
        -3633.7998046875,
        1441.0
      ],
      [
        -1562.0,
        -3633.400146484375,
        1439.0
      ],
      [
        -1560.5,
        -3633.400146484375,
        1439.0
      ],
      [
        -1561.7547607421875,
        -3646.212890625,
        1442.989013671875
      ],
      [
        -1561.7547607421875,
        -3646.212890625,
        1442.989013671875
      ],
      [
        -1583.2901611328125,
        -3647.58056640625,
        1450.439697265625
      ],
      [
        -1531.8189697265625,
        -3644.00244140625,
        1432.4224853515625
      ],
      [
        -1539.115966796875,
        -3641.64404296875,
        1433.3492431640625
      ],
      [
        -1532.6890869140625,
        -3641.945068359375,
        1430.0953369140625
      ],
      [
        -1533.222412109375,
        -3647.5,
        1426.8192138671875
      ],
      [
        -1566.2061767578125,
        -3647.5,
        1442.536376953125
      ],
      [
        -1532.8662109375,
        -3641.8115234375,
        1430.1126708984375
      ],
      [
        -1575.9456787109375,
        -3644.60400390625,
        1445.3370361328125
      ],
      [
        -1582.409912109375,
        -3643.105224609375,
        1447.5836181640625
      ],
      [
        -1582.5361328125,
        -3643.17578125,
        1447.5697021484375
      ],
      [
        -1572.48681640625,
        -3645.349853515625,
        1444.162841796875
      ],
      [
        -1562.2998046875,
        -3646.162841796875,
        1441.5247802734375
      ],
      [
        -1572.48681640625,
        -3645.349853515625,
        1444.162841796875
      ],
      [
        -1575.9456787109375,
        -3644.60400390625,
        1445.3370361328125
      ],
      [
        -1530.1689453125,
        -3645.94580078125,
        1424.37646484375
      ],
      [
        -1585.220703125,
        -3647.838134765625,
        1450.7952880859375
      ],
      [
        -1585.0067138671875,
        -3647.20849609375,
        1450.755859375
      ],
      [
        -1583.6610107421875,
        -3647.500244140625,
        1450.508056640625
      ],
      [
        -1584.27685546875,
        -3644.112548828125,
        1447.2159423828125
      ],
      [
        -1585.694091796875,
        -3646.59375,
        1445.1864013671875
      ],
      [
        -1583.3358154296875,
        -3651.9716796875,
        1447.82568359375
      ],
      [
        -1587.400634765625,
        -3652.9990234375,
        1448.48974609375
      ],
      [
        -1583.3358154296875,
        -3651.9716796875,
        1447.82568359375
      ],
      [
        -1585.25390625,
        -3647.935791015625,
        1450.8013916015625
      ],
      [
        -1583.409912109375,
        -3647.5546875,
        1450.4617919921875
      ],
      [
        -1587.2939453125,
        -3653.073486328125,
        1449.3079833984375
      ],
      [
        -1583.2901611328125,
        -3647.58056640625,
        1450.439697265625
      ],
      [
        -1532.6636962890625,
        -3652.20947265625,
        1432.720703125
      ],
      [
        -1531.2020263671875,
        -3645.998046875,
        1433.4154052734375
      ],
      [
        -1531.818359375,
        -3644.021484375,
        1432.46484375
      ],
      [
        -1583.2901611328125,
        -3647.47021484375,
        1450.439697265625
      ],
      [
        -1584.977294921875,
        -3647.121826171875,
        1450.75048828125
      ],
      [
        -1583.2901611328125,
        -3647.47021484375,
        1450.439697265625
      ],
      [
        -1531.2325439453125,
        -3645.921875,
        1433.4215087890625
      ],
      [
        -1580.4755859375,
        -3642.0244140625,
        1447.79736328125
      ],
      [
        -1583.338134765625,
        -3644.252197265625,
        1450.3050537109375
      ],
      [
        -1553.5,
        -3640.0,
        1452.5
      ],
      [
        -1563.0,
        -3640.0,
        1452.5
      ],
      [
        -1563.0,
        -3640.0,
        1452.5
      ],
      [
        -1561.0,
        -3640.0,
        1452.5
      ],
      [
        -1555.5,
        -3640.0,
        1452.5
      ],
      [
        -1553.5,
        -3640.0,
        1452.5
      ],
      [
        -1542.4527587890625,
        -3669.0,
        1452.5
      ],
      [
        -1543.5064697265625,
        -3670.989501953125,
        1452.5
      ],
      [
        -1543.5064697265625,
        -3667.130859375,
        1452.5
      ],
      [
        -1542.4527587890625,
        -3669.0,
        1452.5
      ],
      [
        -1543.5064697265625,
        -3670.989501953125,
        1452.5
      ],
      [
        -1545.6138916015625,
        -3670.989501953125,
        1452.5
      ],
      [
        -1545.6138916015625,
        -3670.989501953125,
        1452.5
      ],
      [
        -1546.6676025390625,
        -3669.0,
        1452.5
      ],
      [
        -1546.6676025390625,
        -3669.0,
        1452.5
      ],
      [
        -1545.6138916015625,
        -3667.130859375,
        1452.5
      ],
      [
        -1545.6138916015625,
        -3667.130859375,
        1452.5
      ],
      [
        -1543.5064697265625,
        -3667.130859375,
        1452.5
      ],
      [
        -1544.8236083984375,
        -3667.9755859375,
        1426.0
      ],
      [
        -1544.22607421875,
        -3667.9755859375,
        1426.0
      ],
      [
        -1544.22607421875,
        -3667.9755859375,
        1426.0
      ],
      [
        -1544.8236083984375,
        -3667.9755859375,
        1426.0
      ],
      [
        -1544.5550537109375,
        -3667.838134765625,
        1422.0
      ],
      [
        -1544.484130859375,
        -3667.838134765625,
        1422.0
      ],
      [
        -1546.686279296875,
        -3667.114990234375,
        1432.0
      ],
      [
        -1546.686279296875,
        -3667.114990234375,
        1432.0
      ],
      [
        -1546.4359130859375,
        -3667.251708984375,
        1428.2735595703125
      ],
      [
        -1545.5401611328125,
        -3668.73779296875,
        1426.0
      ],
      [
        -1545.5189208984375,
        -3668.417236328125,
        1422.0
      ],
      [
        -1545.232421875,
        -3667.9091796875,
        1422.0
      ],
      [
        -1545.5401611328125,
        -3668.73779296875,
        1426.0
      ],
      [
        -1546.4359130859375,
        -3667.251708984375,
        1428.2735595703125
      ],
      [
        -1546.7489013671875,
        -3670.090087890625,
        1432.0
      ],
      [
        -1549.2830810546875,
        -3670.090087890625,
        1432.0
      ],
      [
        -1546.7489013671875,
        -3670.090087890625,
        1432.0
      ],
      [
        -1545.25,
        -3669.826904296875,
        1426.0
      ],
      [
        -1546.570068359375,
        -3669.906494140625,
        1427.8128662109375
      ],
      [
        -1549.2830810546875,
        -3670.090087890625,
        1432.0
      ],
      [
        -1546.570068359375,
        -3669.906494140625,
        1427.8128662109375
      ],
      [
        -1545.25,
        -3669.826904296875,
        1426.0
      ],
      [
        -1545.3126220703125,
        -3669.783447265625,
        1425.0078125
      ],
      [
        -1545.317138671875,
        -3669.7802734375,
        1424.936767578125
      ],
      [
        -1545.50244140625,
        -3669.651611328125,
        1422.0
      ],
      [
        -1570.2978515625,
        -3685.83349609375,
        1452.5
      ],
      [
        -1559.807373046875,
        -3687.844482421875,
        1452.5
      ],
      [
        -1559.807373046875,
        -3687.844482421875,
        1452.5
      ],
      [
        -1559.5792236328125,
        -3687.903076171875,
        1452.5
      ],
      [
        -1559.5792236328125,
        -3687.903076171875,
        1452.5
      ],
      [
        -1559.55712890625,
        -3687.892578125,
        1452.5
      ],
      [
        -1559.3671875,
        -3687.80224609375,
        1452.5
      ],
      [
        -1559.3671875,
        -3687.80224609375,
        1452.5
      ],
      [
        -1545.234130859375,
        -3670.157958984375,
        1422.0
      ],
      [
        -1544.2264404296875,
        -3670.09033203125,
        1426.0
      ],
      [
        -1544.2264404296875,
        -3670.09033203125,
        1426.0
      ],
      [
        -1544.484619140625,
        -3670.23681640625,
        1422.0
      ],
      [
        -1543.5177001953125,
        -3668.752197265625,
        1426.0
      ],
      [
        -1544.0330810546875,
        -3667.838134765625,
        1422.0
      ],
      [
        -1543.5177001953125,
        -3668.752197265625,
        1426.0
      ],
      [
        -1543.5377197265625,
        -3668.44921875,
        1422.0
      ],
      [
        -1544.0330810546875,
        -3670.23681640625,
        1422.0
      ],
      [
        -1543.30029296875,
        -3669.137939453125,
        1422.0
      ],
      [
        -1582.396728515625,
        -3681.418701171875,
        1453.5147705078125
      ],
      [
        -1582.06201171875,
        -3682.13623046875,
        1452.5
      ],
      [
        -1541.9000244140625,
        -3669.0,
        1464.7470703125
      ],
      [
        -1543.2376708984375,
        -3671.52783203125,
        1464.7747802734375
      ],
      [
        -1543.1650390625,
        -3666.488525390625,
        1468.08935546875
      ],
      [
        -1541.9000244140625,
        -3669.0,
        1464.7470703125
      ],
      [
        -1543.2376708984375,
        -3671.52783203125,
        1464.7747802734375
      ],
      [
        -1546.0009765625,
        -3671.680908203125,
        1468.2618408203125
      ],
      [
        -1546.0928955078125,
        -3666.3271484375,
        1472.002685546875
      ],
      [
        -1543.1650390625,
        -3666.488525390625,
        1468.08935546875
      ],
      [
        -1546.0009765625,
        -3671.680908203125,
        1468.2618408203125
      ],
      [
        -1547.6072998046875,
        -3669.0,
        1472.1624755859375
      ],
      [
        -1547.6072998046875,
        -3669.0,
        1472.1624755859375
      ],
      [
        -1546.0928955078125,
        -3666.3271484375,
        1472.002685546875
      ],
      [
        -1560.907958984375,
        -3671.852294921875,
        1475.55322265625
      ],
      [
        -1560.907958984375,
        -3671.852294921875,
        1475.55322265625
      ],
      [
        -1563.124755859375,
        -3672.859619140625,
        1475.2021484375
      ],
      [
        -1585.7491455078125,
        -3650.11181640625,
        1452.5
      ],
      [
        -1584.54931640625,
        -3678.189697265625,
        1454.3350830078125
      ],
      [
        -1585.323974609375,
        -3677.54541015625,
        1452.5
      ],
      [
        -1564.13330078125,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1562.005126953125,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1554.594970703125,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1552.466796875,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1562.005126953125,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1554.594970703125,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1552.8375244140625,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1552.41552734375,
        -3632.0,
        1480.0438232421875
      ],
      [
        -1540.6697998046875,
        -3680.44775390625,
        1453.8641357421875
      ],
      [
        -1540.5159912109375,
        -3680.61474609375,
        1452.5
      ],
      [
        -1534.7388916015625,
        -3647.304443359375,
        1458.818115234375
      ],
      [
        -1534.0201416015625,
        -3646.565185546875,
        1452.5
      ],
      [
        -1551.083984375,
        -3632.0,
        1478.7122802734375
      ],
      [
        -1549.22705078125,
        -3632.0,
        1476.25146484375
      ],
      [
        -1549.22705078125,
        -3632.0,
        1476.25146484375
      ],
      [
        -1548.800048828125,
        -3632.0,
        1475.685546875
      ],
      [
        -1547.390625,
        -3636.10009765625,
        1452.5
      ],
      [
        -1534.212646484375,
        -3646.069580078125,
        1452.5
      ],
      [
        -1548.6080322265625,
        -3636.10009765625,
        1452.5
      ],
      [
        -1549.3641357421875,
        -3636.10009765625,
        1452.5
      ],
      [
        -1579.5699462890625,
        -3642.29541015625,
        1452.5
      ],
      [
        -1565.800048828125,
        -3630.06396484375,
        1475.5999755859375
      ],
      [
        -1565.800048828125,
        -3630.0,
        1475.5999755859375
      ],
      [
        -1565.800048828125,
        -3630.0,
        1470.8682861328125
      ],
      [
        -1565.8748779296875,
        -3630.0,
        1465.846435546875
      ],
      [
        -1567.800048828125,
        -3631.7802734375,
        1467.7716064453125
      ],
      [
        -1565.800048828125,
        -3630.0,
        1475.5999755859375
      ],
      [
        -1565.800048828125,
        -3630.06396484375,
        1475.5999755859375
      ],
      [
        -1565.7286376953125,
        -3630.0,
        1475.67138671875
      ],
      [
        -1584.6121826171875,
        -3646.88916015625,
        1452.5
      ],
      [
        -1568.41162109375,
        -3636.10009765625,
        1452.5
      ],
      [
        -1561.0,
        -3630.0,
        1455.8333740234375
      ],
      [
        -1561.0,
        -3630.0,
        1458.611083984375
      ],
      [
        -1561.0,
        -3630.0,
        1455.8333740234375
      ],
      [
        -1561.0,
        -3630.0,
        1452.5
      ],
      [
        -1561.0,
        -3631.984619140625,
        1452.5
      ],
      [
        -1561.0,
        -3632.71142578125,
        1456.004150390625
      ],
      [
        -1561.0,
        -3631.626220703125,
        1457.5
      ],
      [
        -1561.0,
        -3630.0,
        1458.611083984375
      ],
      [
        -1560.0811767578125,
        -3631.0,
        1457.5
      ],
      [
        -1559.797119140625,
        -3630.0,
        1458.611083984375
      ],
      [
        -1560.0811767578125,
        -3631.0,
        1457.5
      ],
      [
        -1561.0,
        -3631.626220703125,
        1457.5
      ],
      [
        -1561.0,
        -3635.253662109375,
        1452.5
      ],
      [
        -1562.2421875,
        -3636.10009765625,
        1452.5
      ],
      [
        -1563.0,
        -3635.0,
        1454.7288818359375
      ],
      [
        -1563.0,
        -3636.211669921875,
        1453.05859375
      ],
      [
        -1563.0,
        -3636.10009765625,
        1452.5
      ],
      [
        -1563.0,
        -3636.616943359375,
        1452.5
      ],
      [
        -1555.5,
        -3631.504638671875,
        1452.5
      ],
      [
        -1555.5,
        -3630.0,
        1452.5
      ],
      [
        -1555.5,
        -3630.0,
        1454.5740966796875
      ],
      [
        -1554.800048828125,
        -3630.0,
        1479.5999755859375
      ],
      [
        -1554.800048828125,
        -3630.30859375,
        1479.5999755859375
      ],
      [
        -1554.545654296875,
        -3630.0,
        1479.3455810546875
      ],
      [
        -1565.03369140625,
        -3632.0,
        1479.1947021484375
      ],
      [
        -1565.60888671875,
        -3632.0,
        1475.7911376953125
      ],
      [
        -1567.0848388671875,
        -3632.0,
        1467.056396484375
      ],
      [
        -1566.9010009765625,
        -3632.0,
        1468.1439208984375
      ],
      [
        -1566.9010009765625,
        -3632.0,
        1468.1439208984375
      ],
      [
        -1565.800048828125,
        -3632.0,
        1474.6595458984375
      ],
      [
        -1565.800048828125,
        -3630.0,
        1468.5999755859375
      ],
      [
        -1565.800048828125,
        -3630.297119140625,
        1468.5999755859375
      ],
      [
        -1565.800048828125,
        -3632.0,
        1474.6595458984375
      ],
      [
        -1566.220703125,
        -3630.31982421875,
        1466.1922607421875
      ],
      [
        -1567.0848388671875,
        -3632.0,
        1467.056396484375
      ],
      [
        -1565.60888671875,
        -3632.0,
        1475.7911376953125
      ],
      [
        -1564.161865234375,
        -3630.0,
        1477.2381591796875
      ],
      [
        -1565.800048828125,
        -3631.10009765625,
        1471.4569091796875
      ],
      [
        -1564.9576416015625,
        -3631.10009765625,
        1476.4423828125
      ],
      [
        -1564.9576416015625,
        -3631.10009765625,
        1476.4423828125
      ],
      [
        -1565.800048828125,
        -3631.10009765625,
        1471.4569091796875
      ],
      [
        -1565.800048828125,
        -3630.297119140625,
        1468.5999755859375
      ],
      [
        -1565.800048828125,
        -3630.0,
        1468.5999755859375
      ],
      [
        -1565.647216796875,
        -3630.0,
        1468.4471435546875
      ],
      [
        -1566.5816650390625,
        -3632.0,
        1466.55322265625
      ],
      [
        -1565.3983154296875,
        -3632.0,
        1468.1982421875
      ],
      [
        -1556.8421630859375,
        -3632.0,
        1480.0950927734375
      ],
      [
        -1557.1982421875,
        -3632.0,
        1479.5999755859375
      ],
      [
        -1561.800048828125,
        -3630.0,
        1479.5999755859375
      ],
      [
        -1561.800048828125,
        -3630.0,
        1479.5999755859375
      ],
      [
        -1557.1982421875,
        -3632.0,
        1479.5999755859375
      ],
      [
        -1554.800048828125,
        -3630.30859375,
        1479.5999755859375
      ],
      [
        -1554.800048828125,
        -3630.0,
        1479.5999755859375
      ],
      [
        -1555.9224853515625,
        -3631.10009765625,
        1479.5999755859375
      ],
      [
        -1564.6563720703125,
        -3631.10009765625,
        1467.456298828125
      ],
      [
        -1564.6563720703125,
        -3631.10009765625,
        1467.456298828125
      ],
      [
        -1555.9224853515625,
        -3631.10009765625,
        1479.5999755859375
      ],
      [
        -1565.800048828125,
        -3631.10009765625,
        1468.5999755859375
      ],
      [
        -1565.800048828125,
        -3631.10009765625,
        1471.457275390625
      ],
      [
        -1566.6219482421875,
        -3631.10009765625,
        1466.593505859375
      ],
      [
        -1566.5816650390625,
        -3632.0,
        1466.55322265625
      ],
      [
        -1565.8394775390625,
        -3631.10009765625,
        1465.81103515625
      ],
      [
        -1565.3983154296875,
        -3632.0,
        1468.1982421875
      ],
      [
        -1565.800048828125,
        -3631.10009765625,
        1468.5999755859375
      ],
      [
        -1564.65625,
        -3631.10009765625,
        1467.4561767578125
      ],
      [
        -1563.7490234375,
        -3630.0,
        1466.5489501953125
      ],
      [
        -1564.57373046875,
        -3631.0,
        1467.3736572265625
      ],
      [
        -1566.16162109375,
        -3631.0,
        1468.961669921875
      ],
      [
        -1564.9322509765625,
        -3630.0,
        1464.90380859375
      ],
      [
        -1566.5704345703125,
        -3631.0,
        1466.5419921875
      ],
      [
        -1565.7569580078125,
        -3631.0,
        1465.728515625
      ],
      [
        -1555.5,
        -3630.0,
        1458.611083984375
      ],
      [
        -1555.5,
        -3630.0,
        1455.8333740234375
      ],
      [
        -1555.5,
        -3630.0,
        1455.8333740234375
      ],
      [
        -1547.8970947265625,
        -3634.857177734375,
        1459.5
      ],
      [
        -1553.5,
        -3634.857177734375,
        1459.5
      ],
      [
        -1553.5,
        -3634.857177734375,
        1459.5
      ],
      [
        -1555.5,
        -3634.857177734375,
        1459.5
      ],
      [
        -1553.5,
        -3635.0,
        1459.333740234375
      ],
      [
        -1553.5,
        -3636.10009765625,
        1452.5
      ],
      [
        -1553.5,
        -3636.999755859375,
        1457.0
      ],
      [
        -1553.5,
        -3637.499755859375,
        1459.5
      ],
      [
        -1562.84619140625,
        -3634.857177734375,
        1459.5
      ],
      [
        -1567.8690185546875,
        -3634.857177734375,
        1459.5
      ],
      [
        -1562.84619140625,
        -3634.857177734375,
        1459.5
      ],
      [
        -1561.0,
        -3634.857177734375,
        1459.5
      ],
      [
        -1563.0,
        -3635.0,
        1459.333740234375
      ],
      [
        -1563.0,
        -3637.0,
        1456.999755859375
      ],
      [
        -1563.0,
        -3636.2119140625,
        1453.058349609375
      ],
      [
        -1563.0,
        -3637.5,
        1459.5
      ],
      [
        -1557.3077392578125,
        -3634.857177734375,
        1459.5
      ],
      [
        -1557.3077392578125,
        -3634.857177734375,
        1459.5
      ],
      [
        -1555.5,
        -3630.0,
        1458.611083984375
      ],
      [
        -1551.9716796875,
        -3632.0,
        1479.5999755859375
      ],
      [
        -1552.28271484375,
        -3631.068359375,
        1479.5999755859375
      ],
      [
        -1551.97900390625,
        -3631.39990234375,
        1479.5999755859375
      ],
      [
        -1550.800048828125,
        -3630.0,
        1475.5999755859375
      ],
      [
        -1546.125244140625,
        -3635.761474609375,
        1470.9251708984375
      ],
      [
        -1542.7000732421875,
        -3638.699951171875,
        1467.5
      ],
      [
        -1546.125244140625,
        -3635.761474609375,
        1470.9251708984375
      ],
      [
        -1551.281005859375,
        -3632.0,
        1478.9093017578125
      ],
      [
        -1550.590087890625,
        -3632.0,
        1475.6868896484375
      ],
      [
        -1550.590087890625,
        -3632.0,
        1475.6868896484375
      ],
      [
        -1548.800048828125,
        -3632.0,
        1473.60009765625
      ],
      [
        -1550.509033203125,
        -3632.0,
        1475.30908203125
      ],
      [
        -1548.800048828125,
        -3631.0,
        1467.7716064453125
      ],
      [
        -1553.9716796875,
        -3631.0,
        1462.5999755859375
      ],
      [
        -1550.800048828125,
        -3630.0,
        1475.5999755859375
      ],
      [
        -1550.800048828125,
        -3631.0,
        1475.5999755859375
      ],
      [
        -1550.800048828125,
        -3631.0,
        1468.5999755859375
      ],
      [
        -1550.800048828125,
        -3630.0,
        1468.5999755859375
      ],
      [
        -1550.800048828125,
        -3630.0,
        1468.5999755859375
      ],
      [
        -1550.800048828125,
        -3631.0,
        1468.5999755859375
      ],
      [
        -1554.800048828125,
        -3631.0,
        1464.5999755859375
      ],
      [
        -1554.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      [
        -1562.62841796875,
        -3631.0,
        1462.5999755859375
      ],
      [
        -1565.7569580078125,
        -3631.0,
        1465.728515625
      ],
      [
        -1554.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      [
        -1554.800048828125,
        -3631.0,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3631.0,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3631.0,
        1464.5999755859375
      ],
      [
        -1564.57373046875,
        -3631.0,
        1467.37353515625
      ],
      [
        -1553.73828125,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1554.068359375,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1562.53173828125,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1562.86181640625,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1554.068359375,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1562.53173828125,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1552.571533203125,
        -3631.0,
        1464.0001220703125
      ],
      [
        -1553.73828125,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1564.028564453125,
        -3631.0,
        1464.0001220703125
      ],
      [
        -1562.86181640625,
        -3632.0,
        1462.8333740234375
      ],
      [
        -1549.6307373046875,
        -3631.0,
        1466.9412841796875
      ],
      [
        -1545.885986328125,
        -3635.966796875,
        1470.6859130859375
      ],
      [
        -1548.90234375,
        -3632.0,
        1467.81396484375
      ],
      [
        -1548.876708984375,
        -3632.0,
        1467.6949462890625
      ],
      [
        -1550.5091552734375,
        -3632.0,
        1475.30908203125
      ],
      [
        -1548.90234375,
        -3632.0,
        1467.81396484375
      ],
      [
        -1550.800048828125,
        -3632.0,
        1465.7716064453125
      ],
      [
        -1554.800048828125,
        -3631.10009765625,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3631.10009765625,
        1464.5999755859375
      ],
      [
        -1550.800048828125,
        -3631.10009765625,
        1468.5999755859375
      ],
      [
        -1554.800048828125,
        -3631.10009765625,
        1464.5999755859375
      ],
      [
        -1561.800048828125,
        -3631.10009765625,
        1464.5999755859375
      ],
      [
        -1564.65625,
        -3631.10009765625,
        1467.4560546875
      ],
      [
        -1474.68798828125,
        -3953.42626953125,
        1335.75
      ],
      [
        -1467.4595947265625,
        -3967.612548828125,
        1319.2445068359375
      ],
      [
        -1474.68798828125,
        -3953.42626953125,
        1335.75
      ],
      [
        -1476.00341796875,
        -3950.8447265625,
        1363.090087890625
      ],
      [
        -1471.226806640625,
        -3960.219482421875,
        1355.642578125
      ],
      [
        -1473.24609375,
        -3956.25634765625,
        1352.68408203125
      ],
      [
        -1473.24609375,
        -3956.25634765625,
        1352.68408203125
      ],
      [
        -1470.8817138671875,
        -3960.896240234375,
        1348.7724609375
      ],
      [
        -1471.226806640625,
        -3960.219482421875,
        1355.642578125
      ],
      [
        -1466.8427734375,
        -3968.822998046875,
        1354.689453125
      ],
      [
        -1470.448974609375,
        -3961.74560546875,
        1301.125
      ],
      [
        -1467.4595947265625,
        -3967.612548828125,
        1319.2445068359375
      ],
      [
        -1495.40869140625,
        -3912.760009765625,
        1356.7884521484375
      ],
      [
        -1498.935546875,
        -3905.83837890625,
        1358.2596435546875
      ],
      [
        -1499.19482421875,
        -3905.329345703125,
        1351.5150146484375
      ],
      [
        -1500.8284912109375,
        -3902.123046875,
        1355.6229248046875
      ],
      [
        -1500.8284912109375,
        -3902.123046875,
        1355.6229248046875
      ],
      [
        -1498.935546875,
        -3905.83837890625,
        1358.2596435546875
      ],
      [
        -1610.322021484375,
        -3687.232421875,
        1405.224365234375
      ],
      [
        -1610.3212890625,
        -3687.23388671875,
        1405.224365234375
      ],
      [
        -1610.3212890625,
        -3687.23388671875,
        1405.224365234375
      ],
      [
        -1610.322265625,
        -3687.232177734375,
        1405.225341796875
      ],
      [
        -1610.322265625,
        -3687.232177734375,
        1405.225341796875
      ],
      [
        -1610.322021484375,
        -3687.232421875,
        1405.224365234375
      ],
      [
        -1570.0,
        -3594.5,
        1472.0
      ],
      [
        -1580.0,
        -3594.5,
        1472.0
      ],
      [
        -1580.0,
        -3594.5,
        1482.5
      ],
      [
        -1580.0,
        -3594.5,
        1477.5
      ],
      [
        -1580.0,
        -3594.5,
        1472.0
      ],
      [
        -1580.0,
        -3594.5,
        1477.0
      ],
      [
        -1580.0,
        -3595.0,
        1480.0001220703125
      ],
      [
        -1580.0,
        -3620.0,
        1474.0
      ],
      [
        -1580.0,
        -3594.5,
        1477.0
      ],
      [
        -1570.0,
        -3594.5,
        1477.0
      ],
      [
        -1580.0,
        -3594.5,
        1477.5
      ],
      [
        -1570.0,
        -3594.5,
        1477.5
      ],
      [
        -1570.0,
        -3594.5,
        1482.5
      ],
      [
        -1580.0,
        -3594.5,
        1482.5
      ],
      [
        -1570.0,
        -3594.5,
        1477.5
      ],
      [
        -1570.0,
        -3594.5,
        1482.5
      ],
      [
        -1570.0,
        -3594.5,
        1477.0
      ],
      [
        -1570.0,
        -3594.5,
        1472.0
      ],
      [
        -1610.0,
        -3566.0,
        1482.5999755859375
      ],
      [
        -1610.0,
        -3544.0,
        1482.5999755859375
      ],
      [
        -1610.0,
        -3544.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3544.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3544.239990234375,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3544.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3565.760009765625,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3566.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3544.239990234375,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3565.760009765625,
        1482.5999755859375
      ],
      [
        -1540.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1540.0,
        -3575.0,
        1482.5999755859375
      ],
      [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      [
        -1550.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1555.0,
        -3580.0,
        1473.470458984375
      ],
      [
        -1590.0,
        -3580.0,
        1470.0
      ],
      [
        -1590.0,
        -3590.0,
        1470.0
      ],
      [
        -1590.0,
        -3580.0,
        1475.0
      ],
      [
        -1590.0,
        -3580.0,
        1470.0
      ],
      [
        -1590.0,
        -3590.0,
        1475.0
      ],
      [
        -1590.0,
        -3580.0,
        1475.0
      ],
      [
        -1590.0,
        -3590.0,
        1475.0
      ],
      [
        -1590.0,
        -3590.0,
        1474.5
      ],
      [
        -1590.0,
        -3590.0,
        1470.0
      ],
      [
        -1550.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1540.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1540.0,
        -3575.0,
        1482.5999755859375
      ],
      [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3566.0,
        1482.5999755859375
      ],
      [
        -1610.0,
        -3566.0,
        1482.5999755859375
      ],
      [
        -1607.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1607.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1610.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1607.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1610.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1607.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1593.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1593.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1593.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3560.0,
        1482.5999755859375
      ],
      [
        -1593.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3550.0,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3526.0,
        1505.0
      ],
      [
        -1590.0,
        -3526.0,
        1495.0
      ],
      [
        -1590.0,
        -3550.0,
        1488.933349609375
      ],
      [
        -1590.0,
        -3550.0,
        1487.5
      ],
      [
        -1586.0,
        -3550.0,
        1487.5
      ],
      [
        -1586.0,
        -3550.0,
        1487.5
      ],
      [
        -1590.0,
        -3526.0,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1585.0,
        -3535.0,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1586.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1562.5,
        -3542.5,
        1489.5999755859375
      ],
      [
        -1562.5,
        -3535.0,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3521.4384765625,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3521.4384765625,
        1484.0777587890625
      ],
      [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      [
        -1590.0,
        -3521.4384765625,
        1495.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1486.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1489.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1492.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1483.0
      ],
      [
        -1582.4808349609375,
        -3525.433837890625,
        1489.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1489.0
      ],
      [
        -1582.4808349609375,
        -3525.433837890625,
        1492.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1492.0
      ],
      [
        -1582.4808349609375,
        -3525.433837890625,
        1486.0
      ],
      [
        -1583.3717041015625,
        -3524.10009765625,
        1486.0
      ],
      [
        -1590.0,
        -3522.0283203125,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3522.0283203125,
        1484.0777587890625
      ],
      [
        -1590.0,
        -3521.4384765625,
        1484.0777587890625
      ],
      [
        -1589.0498046875,
        -3521.708740234375,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3522.0283203125,
        1484.0777587890625
      ],
      [
        -1590.0,
        -3522.0283203125,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3522.0283203125,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3522.0283203125,
        1488.3538818359375
      ],
      [
        -1590.0,
        -3522.0283203125,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3522.0283203125,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3522.0283203125,
        1488.3538818359375
      ],
      [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      [
        -1589.0,
        -3521.360107421875,
        1489.199951171875
      ],
      [
        -1589.5,
        -3521.694091796875,
        1483.300048828125
      ],
      [
        -1588.6566162109375,
        -3521.130615234375,
        1483.13134765625
      ],
      [
        -1588.65673828125,
        -3521.130615234375,
        1489.1754150390625
      ],
      [
        -1589.0,
        -3521.360107421875,
        1489.199951171875
      ],
      [
        -1587.5999755859375,
        -3521.42041015625,
        1489.0999755859375
      ],
      [
        -1586.7431640625,
        -3521.25,
        1483.38671875
      ],
      [
        -1586.7427978515625,
        -3521.25,
        1488.7882080078125
      ],
      [
        -1587.5999755859375,
        -3521.42041015625,
        1489.0999755859375
      ],
      [
        -1585.4388427734375,
        -3522.4033203125,
        1485.13427734375
      ],
      [
        -1584.8179931640625,
        -3522.818115234375,
        1485.9881591796875
      ],
      [
        -1585.4388427734375,
        -3522.4033203125,
        1485.13427734375
      ],
      [
        -1587.2816162109375,
        -3521.642822265625,
        1482.5999755859375
      ],
      [
        -1586.5,
        -3521.69384765625,
        1488.699951171875
      ],
      [
        -1586.5,
        -3521.69384765625,
        1488.699951171875
      ],
      [
        -1587.0677490234375,
        -3521.314697265625,
        1488.9063720703125
      ],
      [
        -1590.0,
        -3526.0,
        1494.4000244140625
      ],
      [
        -1604.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1605.0,
        -3535.0,
        1494.4000244140625
      ],
      [
        -1604.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1604.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1600.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1600.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1600.0,
        -3535.0,
        1494.4000244140625
      ],
      [
        -1604.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1604.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1604.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1600.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1600.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1600.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1486.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1488.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1489.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1491.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1492.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1494.0
      ],
      [
        -1593.519287109375,
        -3525.43359375,
        1489.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1489.0
      ],
      [
        -1593.519287109375,
        -3525.43359375,
        1492.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1492.0
      ],
      [
        -1593.519287109375,
        -3525.43359375,
        1486.0
      ],
      [
        -1592.62841796875,
        -3524.10009765625,
        1486.0
      ],
      [
        -1474.8897705078125,
        -3954.0,
        1335.75
      ],
      [
        -1475.5670166015625,
        -3963.934326171875,
        1301.125
      ],
      [
        -1474.8897705078125,
        -3954.0,
        1335.75
      ],
      [
        -1474.3956298828125,
        -3954.0,
        1335.08251953125
      ],
      [
        -1477.5335693359375,
        -3956.651123046875,
        1356.8001708984375
      ],
      [
        -1479.3416748046875,
        -3961.751220703125,
        1356.983642578125
      ],
      [
        -1476.46728515625,
        -3954.433837890625,
        1353.275390625
      ],
      [
        -1477.208984375,
        -3957.316162109375,
        1349.933837890625
      ],
      [
        -1477.5335693359375,
        -3956.651123046875,
        1356.8001708984375
      ],
      [
        -1476.46728515625,
        -3954.433837890625,
        1353.275390625
      ],
      [
        -1487.521484375,
        -3978.5654296875,
        1374.0
      ],
      [
        -1485.4451904296875,
        -3982.1611328125,
        1341.60693359375
      ],
      [
        -1491.9293212890625,
        -3970.93115234375,
        1301.125
      ],
      [
        -1486.0059814453125,
        -3981.18994140625,
        1333.5626220703125
      ],
      [
        -1492.6265869140625,
        -3969.7236328125,
        1391.5518798828125
      ],
      [
        -1495.1326904296875,
        -3965.383056640625,
        1405.5526123046875
      ],
      [
        -1487.521484375,
        -3978.5654296875,
        1374.0
      ],
      [
        -1492.6265869140625,
        -3969.7236328125,
        1391.5518798828125
      ],
      [
        -1495.1326904296875,
        -3965.383056640625,
        1405.5526123046875
      ],
      [
        -1501.704833984375,
        -3954.0,
        1413.5855712890625
      ],
      [
        -1482.21923828125,
        -3954.0,
        1357.6602783203125
      ],
      [
        -1493.041259765625,
        -3954.0,
        1359.498291015625
      ],
      [
        -1477.2340087890625,
        -3954.0,
        1353.4161376953125
      ],
      [
        -1483.0703125,
        -3954.0,
        1351.009765625
      ],
      [
        -1482.21923828125,
        -3954.0,
        1357.6602783203125
      ],
      [
        -1477.2340087890625,
        -3954.0,
        1353.4161376953125
      ],
      [
        -1485.6651611328125,
        -3981.7802734375,
        1335.75
      ],
      [
        -1485.4451904296875,
        -3982.1611328125,
        1341.60693359375
      ],
      [
        -1486.0059814453125,
        -3981.18994140625,
        1333.5626220703125
      ],
      [
        -1485.6651611328125,
        -3981.7802734375,
        1335.75
      ],
      [
        -1518.828369140625,
        -3992.6494140625,
        1339.807373046875
      ],
      [
        -1524.8880615234375,
        -3994.3681640625,
        1339.4420166015625
      ],
      [
        -1524.8880615234375,
        -3994.3681640625,
        1339.4420166015625
      ],
      [
        -1527.9971923828125,
        -4001.042236328125,
        1336.69921875
      ],
      [
        -1527.9971923828125,
        -3995.083984375,
        1335.9588623046875
      ],
      [
        -1525.2244873046875,
        -3994.1220703125,
        1332.6416015625
      ],
      [
        -1527.9971923828125,
        -3995.073974609375,
        1335.7591552734375
      ],
      [
        -1527.9971923828125,
        -4000.187255859375,
        1332.6766357421875
      ],
      [
        -1518.8038330078125,
        -3992.565673828125,
        1339.8251953125
      ],
      [
        -1521.6087646484375,
        -3993.43798828125,
        1339.6397705078125
      ],
      [
        -1525.19921875,
        -3994.035888671875,
        1332.659912109375
      ],
      [
        -1526.57177734375,
        -3994.58447265625,
        1334.1563720703125
      ],
      [
        -1524.9742431640625,
        -3993.268310546875,
        1332.8231201171875
      ],
      [
        -1527.7362060546875,
        -3994.984375,
        1335.4656982421875
      ],
      [
        -1528.0,
        -3981.157958984375,
        1411.894775390625
      ],
      [
        -1527.9971923828125,
        -3994.801025390625,
        1335.9237060546875
      ],
      [
        -1516.0362548828125,
        -3954.0,
        1344.59619140625
      ],
      [
        -1513.0540771484375,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1527.9971923828125,
        -3969.145263671875,
        1301.125
      ],
      [
        -1527.9971923828125,
        -3991.38525390625,
        1333.3768310546875
      ],
      [
        -1527.9971923828125,
        -3991.38525390625,
        1333.3768310546875
      ],
      [
        -1527.9906005859375,
        -3993.344482421875,
        1335.75
      ],
      [
        -1527.9971923828125,
        -3993.335205078125,
        1335.7412109375
      ],
      [
        -1524.750244140625,
        -3992.504150390625,
        1332.9854736328125
      ],
      [
        -1526.3292236328125,
        -3993.05126953125,
        1334.7578125
      ],
      [
        -1527.693115234375,
        -3993.763427734375,
        1336.1441650390625
      ],
      [
        -1527.9971923828125,
        -3994.801025390625,
        1335.9237060546875
      ],
      [
        -1527.9906005859375,
        -3993.344482421875,
        1335.75
      ],
      [
        -1527.603759765625,
        -3993.51123046875,
        1336.2152099609375
      ],
      [
        -1527.617431640625,
        -3993.50537109375,
        1336.1990966796875
      ],
      [
        -1527.30517578125,
        -3993.560791015625,
        1335.749755859375
      ],
      [
        -1527.6148681640625,
        -3993.49658203125,
        1336.200927734375
      ],
      [
        -1507.4981689453125,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1513.0540771484375,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1513.462646484375,
        -3954.0,
        1341.1697998046875
      ],
      [
        -1516.0362548828125,
        -3954.0,
        1344.59619140625
      ],
      [
        -1491.7803955078125,
        -3971.189208984375,
        1301.940673828125
      ],
      [
        -1501.5892333984375,
        -3978.73876953125,
        1310.448486328125
      ],
      [
        -1525.362548828125,
        -3994.477294921875,
        1338.910400390625
      ],
      [
        -1485.5106201171875,
        -3982.214111328125,
        1342.0260009765625
      ],
      [
        -1485.473388671875,
        -3982.1123046875,
        1342.047607421875
      ],
      [
        -1491.4862060546875,
        -3985.40185546875,
        1376.7049560546875
      ],
      [
        -1488.8564453125,
        -3976.25341796875,
        1378.5897216796875
      ],
      [
        -1494.5736083984375,
        -3966.3515625,
        1402.428955078125
      ],
      [
        -1527.9971923828125,
        -3993.34228515625,
        1335.75
      ],
      [
        -1527.9971923828125,
        -3993.34228515625,
        1335.75
      ],
      [
        -1564.880859375,
        -3981.686767578125,
        1335.75
      ],
      [
        -1564.918701171875,
        -3981.752197265625,
        1336.561279296875
      ],
      [
        -1564.918701171875,
        -3981.752197265625,
        1336.561279296875
      ],
      [
        -1565.6466064453125,
        -3983.01318359375,
        1348.35595703125
      ],
      [
        -1564.7349853515625,
        -3985.592041015625,
        1376.098388671875
      ],
      [
        -1565.6466064453125,
        -3983.01318359375,
        1348.35595703125
      ],
      [
        -1565.986083984375,
        -3984.995849609375,
        1374.0
      ],
      [
        -1565.8663330078125,
        -3983.393798828125,
        1356.8558349609375
      ],
      [
        -1565.986083984375,
        -3984.995849609375,
        1374.0
      ],
      [
        -1564.7349853515625,
        -3985.592041015625,
        1376.098388671875
      ],
      [
        -1554.9559326171875,
        -3964.4970703125,
        1311.102294921875
      ],
      [
        -1564.880859375,
        -3981.686767578125,
        1335.75
      ],
      [
        -1551.77001953125,
        -3958.979248046875,
        1301.125
      ],
      [
        -1541.31982421875,
        -3963.447998046875,
        1301.125
      ],
      [
        -1527.9971923828125,
        -3986.522216796875,
        1326.3245849609375
      ],
      [
        -1554.9559326171875,
        -3964.4970703125,
        1311.102294921875
      ],
      [
        -1528.0,
        -3986.517578125,
        1409.10400390625
      ],
      [
        -1528.18701171875,
        -3986.193603515625,
        1409.9371337890625
      ],
      [
        -1528.18701171875,
        -3986.193603515625,
        1409.9371337890625
      ],
      [
        -1531.31982421875,
        -3980.767578125,
        1410.5526123046875
      ],
      [
        -1540.54541015625,
        -3964.7890625,
        1412.3651123046875
      ],
      [
        -1540.54541015625,
        -3964.7890625,
        1412.3651123046875
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1415.6007080078125
      ],
      [
        -1549.5673828125,
        -3955.164306640625,
        1414.491943359375
      ],
      [
        -1558.6348876953125,
        -3970.868896484375,
        1403.409423828125
      ],
      [
        -1558.6348876953125,
        -3970.868896484375,
        1403.409423828125
      ],
      [
        -1558.9488525390625,
        -3971.41259765625,
        1401.655517578125
      ],
      [
        -1560.0416259765625,
        -3973.305419921875,
        1395.550048828125
      ],
      [
        -1566.3095703125,
        -3984.161376953125,
        1374.0
      ],
      [
        -1560.0416259765625,
        -3973.305419921875,
        1395.550048828125
      ],
      [
        -1566.3095703125,
        -3984.161376953125,
        1374.0
      ],
      [
        -1549.5673828125,
        -3955.164306640625,
        1339.0
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1339.0
      ],
      [
        -1556.0213623046875,
        -3966.34228515625,
        1339.0
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1339.0
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1336.5
      ],
      [
        -1577.478515625,
        -3955.164306640625,
        1372.3759765625
      ],
      [
        -1574.950927734375,
        -3955.164306640625,
        1335.75
      ],
      [
        -1580.6329345703125,
        -3955.164306640625,
        1339.0
      ],
      [
        -1575.1754150390625,
        -3955.164306640625,
        1339.0
      ],
      [
        -1567.1689453125,
        -3977.935791015625,
        1339.0
      ],
      [
        -1577.5487060546875,
        -3955.164306640625,
        1374.0
      ],
      [
        -1577.478515625,
        -3955.164306640625,
        1372.3759765625
      ],
      [
        -1564.31298828125,
        -3955.164306640625,
        1303.3709716796875
      ],
      [
        -1566.908447265625,
        -3955.164306640625,
        1304.365478515625
      ],
      [
        -1560.691162109375,
        -3955.164306640625,
        1301.125
      ],
      [
        -1564.31298828125,
        -3955.164306640625,
        1303.3709716796875
      ],
      [
        -1565.026123046875,
        -3955.164306640625,
        1409.545166015625
      ],
      [
        -1576.9168701171875,
        -3955.164306640625,
        1375.2996826171875
      ],
      [
        -1576.9168701171875,
        -3955.164306640625,
        1375.2996826171875
      ],
      [
        -1577.5487060546875,
        -3955.164306640625,
        1374.0
      ],
      [
        -1565.0692138671875,
        -3982.012939453125,
        1339.0
      ],
      [
        -1565.7001953125,
        -3981.83203125,
        1339.0
      ],
      [
        -1565.026123046875,
        -3955.164306640625,
        1409.545166015625
      ],
      [
        -1575.3603515625,
        -3954.0,
        1335.75
      ],
      [
        -1580.941162109375,
        -3954.0,
        1339.0
      ],
      [
        -1575.584716796875,
        -3954.0,
        1339.0
      ],
      [
        -1575.1754150390625,
        -3955.164306640625,
        1339.0
      ],
      [
        -1577.5286865234375,
        -3955.164306640625,
        1373.5372314453125
      ],
      [
        -1549.31005859375,
        -3954.0,
        1339.0
      ],
      [
        -1563.4139404296875,
        -3954.0,
        1301.125
      ],
      [
        -1565.4803466796875,
        -3954.0,
        1302.406494140625
      ],
      [
        -1565.4803466796875,
        -3954.0,
        1302.406494140625
      ],
      [
        -1566.961181640625,
        -3954.0,
        1302.973876953125
      ],
      [
        -1549.31005859375,
        -3954.0,
        1339.0
      ],
      [
        -1549.31005859375,
        -3954.0,
        1336.5
      ],
      [
        -1546.7747802734375,
        -3954.0,
        1415.9920654296875
      ],
      [
        -1564.9932861328125,
        -3915.0859375,
        1403.4129638671875
      ],
      [
        -1566.102783203125,
        -3913.164306640625,
        1399.8203125
      ],
      [
        -1566.833984375,
        -3913.164306640625,
        1397.714599609375
      ],
      [
        -1566.833984375,
        -3913.164306640625,
        1397.714599609375
      ],
      [
        -1569.5673828125,
        -3913.164306640625,
        1390.0189208984375
      ],
      [
        -1574.666259765625,
        -3921.995361328125,
        1377.333740234375
      ],
      [
        -1574.666259765625,
        -3921.995361328125,
        1377.333740234375
      ],
      [
        -1574.5908203125,
        -3921.86474609375,
        1377.17333984375
      ],
      [
        -1569.5673828125,
        -3913.164306640625,
        1366.488525390625
      ],
      [
        -1566.833984375,
        -3913.164306640625,
        1358.79296875
      ],
      [
        -1584.77734375,
        -3939.507568359375,
        1339.0
      ],
      [
        -1582.23095703125,
        -3935.09716796875,
        1339.0
      ],
      [
        -1575.584716796875,
        -3954.0,
        1339.0
      ],
      [
        -1571.204833984375,
        -3916.0,
        1339.0
      ],
      [
        -1561.4742431640625,
        -3924.9970703125,
        1339.0
      ],
      [
        -1565.5684814453125,
        -3954.0,
        1339.0
      ],
      [
        -1554.60400390625,
        -3933.079833984375,
        1409.7821044921875
      ],
      [
        -1564.9932861328125,
        -3915.0859375,
        1403.4129638671875
      ],
      [
        -1542.5252685546875,
        -3954.0,
        1417.3519287109375
      ],
      [
        -1554.60400390625,
        -3933.079833984375,
        1409.7821044921875
      ],
      [
        -1573.746337890625,
        -3913.164306640625,
        1378.253662109375
      ],
      [
        -1573.746337890625,
        -3913.164306640625,
        1378.253662109375
      ],
      [
        -1570.2392578125,
        -3906.0,
        1371.2274169921875
      ],
      [
        -1566.5989990234375,
        -3912.304931640625,
        1358.472900390625
      ],
      [
        -1571.695068359375,
        -3909.498046875,
        1373.935546875
      ],
      [
        -1577.87744140625,
        -3906.0,
        1375.0704345703125
      ],
      [
        -1571.2015380859375,
        -3906.0,
        1373.9366455078125
      ],
      [
        -1566.5989990234375,
        -3912.304931640625,
        1398.213623046875
      ],
      [
        -1570.2392578125,
        -3906.0,
        1386.7725830078125
      ],
      [
        -1566.5989990234375,
        -3912.304931640625,
        1398.213623046875
      ],
      [
        -1566.5335693359375,
        -3912.41845703125,
        1372.9881591796875
      ],
      [
        -1570.2392578125,
        -3906.0,
        1373.773193359375
      ],
      [
        -1522.6693115234375,
        -3931.113525390625,
        1365.0850830078125
      ],
      [
        -1525.088134765625,
        -3926.92431640625,
        1362.199951171875
      ],
      [
        -1525.088134765625,
        -3926.92431640625,
        1362.199951171875
      ],
      [
        -1522.25634765625,
        -3931.82861328125,
        1358.2025146484375
      ],
      [
        -1522.6693115234375,
        -3931.113525390625,
        1365.0850830078125
      ],
      [
        -1517.4188232421875,
        -3940.207275390625,
        1363.972900390625
      ],
      [
        -1505.338134765625,
        -3946.631591796875,
        1349.5888671875
      ],
      [
        -1509.4552001953125,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1511.8421630859375,
        -3949.86572265625,
        1348.9013671875
      ],
      [
        -1510.1956787109375,
        -3944.249267578125,
        1350.09521484375
      ],
      [
        -1510.195556640625,
        -3944.2490234375,
        1350.09521484375
      ],
      [
        -1511.8421630859375,
        -3949.865966796875,
        1348.9013671875
      ],
      [
        -1513.787353515625,
        -3946.496826171875,
        1346.24755859375
      ],
      [
        -1512.1131591796875,
        -3949.396484375,
        1342.1483154296875
      ],
      [
        -1505.771728515625,
        -3927.764404296875,
        1346.746337890625
      ],
      [
        -1508.565673828125,
        -3928.5166015625,
        1350.0128173828125
      ],
      [
        -1513.820068359375,
        -3946.440185546875,
        1346.2030029296875
      ],
      [
        -1513.820068359375,
        -3946.440185546875,
        1346.2030029296875
      ],
      [
        -1508.565673828125,
        -3928.5166015625,
        1350.0128173828125
      ],
      [
        -1506.6483154296875,
        -3932.148681640625,
        1352.667236328125
      ],
      [
        -1475.3541259765625,
        -3952.118896484375,
        1349.5955810546875
      ],
      [
        -1476.2587890625,
        -3954.0,
        1352.5863037109375
      ],
      [
        -1501.9366455078125,
        -3935.028564453125,
        1352.05517578125
      ],
      [
        -1506.6483154296875,
        -3932.1484375,
        1352.667236328125
      ],
      [
        -1509.4552001953125,
        -3954.0,
        1416.065673828125
      ],
      [
        -1512.30029296875,
        -3913.164306640625,
        1403.0877685546875
      ],
      [
        -1517.8974609375,
        -3913.164306640625,
        1404.8787841796875
      ],
      [
        -1522.4373779296875,
        -3931.51513671875,
        1412.57275390625
      ],
      [
        -1495.5272216796875,
        -3913.164306640625,
        1356.7025146484375
      ],
      [
        -1501.0831298828125,
        -3913.164306640625,
        1356.7025146484375
      ],
      [
        -1504.065185546875,
        -3913.164306640625,
        1353.2760009765625
      ],
      [
        -1501.0831298828125,
        -3913.164306640625,
        1356.7025146484375
      ],
      [
        -1501.49169921875,
        -3913.164306640625,
        1349.849609375
      ],
      [
        -1504.065185546875,
        -3913.164306640625,
        1353.2760009765625
      ],
      [
        -1522.4373779296875,
        -3931.51513671875,
        1412.57275390625
      ],
      [
        -1517.8974609375,
        -3913.164306640625,
        1404.8787841796875
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1408.5294189453125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1410.097412109375
      ],
      [
        -1535.81591796875,
        -3923.986572265625,
        1414.18408203125
      ],
      [
        -1535.81591796875,
        -3923.986572265625,
        1414.18408203125
      ],
      [
        -1547.8350830078125,
        -3944.803466796875,
        1414.024169921875
      ],
      [
        -1535.680419921875,
        -3923.751953125,
        1367.473388671875
      ],
      [
        -1538.34521484375,
        -3928.3671875,
        1367.8140869140625
      ],
      [
        -1535.680419921875,
        -3923.751953125,
        1367.473388671875
      ],
      [
        -1534.452880859375,
        -3921.625732421875,
        1363.9189453125
      ],
      [
        -1534.452880859375,
        -3921.625732421875,
        1363.9189453125
      ],
      [
        -1535.8900146484375,
        -3924.11474609375,
        1360.705078125
      ],
      [
        -1512.6424560546875,
        -3951.2021484375,
        1341.7645263671875
      ],
      [
        -1513.84765625,
        -3946.534423828125,
        1346.1829833984375
      ],
      [
        -1513.84765625,
        -3946.534423828125,
        1346.1829833984375
      ],
      [
        -1513.787353515625,
        -3946.496826171875,
        1346.24755859375
      ],
      [
        -1525.430908203125,
        -3906.0,
        1404.7861328125
      ],
      [
        -1501.9649658203125,
        -3906.0,
        1354.798828125
      ],
      [
        -1498.98291015625,
        -3906.0,
        1358.225341796875
      ],
      [
        -1499.3914794921875,
        -3906.0,
        1351.3724365234375
      ],
      [
        -1501.9649658203125,
        -3906.0,
        1354.798828125
      ],
      [
        -1498.98291015625,
        -3906.0,
        1358.225341796875
      ],
      [
        -1498.8531494140625,
        -3906.0,
        1358.225341796875
      ],
      [
        -1567.0555419921875,
        -3906.0,
        1373.232421875
      ],
      [
        -1567.0555419921875,
        -3906.0,
        1373.232421875
      ],
      [
        -1562.0701904296875,
        -3906.0,
        1368.9881591796875
      ],
      [
        -1562.0701904296875,
        -3906.0,
        1368.9881591796875
      ],
      [
        -1567.9063720703125,
        -3906.0,
        1366.5819091796875
      ],
      [
        -1568.5020751953125,
        -3906.0,
        1366.336669921875
      ],
      [
        -1567.55908203125,
        -3910.641845703125,
        1361.8370361328125
      ],
      [
        -1535.7059326171875,
        -3923.796142578125,
        1414.0845947265625
      ],
      [
        -1575.208740234375,
        -3899.814453125,
        1372.8731689453125
      ],
      [
        -1563.3594970703125,
        -3906.0,
        1370.0858154296875
      ],
      [
        -1563.7257080078125,
        -3905.808837890625,
        1370.1719970703125
      ],
      [
        -1563.9417724609375,
        -3906.0,
        1370.58154296875
      ],
      [
        -1564.451171875,
        -3893.5,
        1383.2523193359375
      ],
      [
        -1624.04638671875,
        -3847.411865234375,
        1375.0999755859375
      ],
      [
        -1624.0462646484375,
        -3847.411865234375,
        1375.0999755859375
      ],
      [
        -1629.1417236328125,
        -3852.664794921875,
        1368.8232421875
      ],
      [
        -1570.1778564453125,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1565.2955322265625,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1571.83154296875,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1570.1778564453125,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1565.2955322265625,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3800.544189453125,
        1375.0999755859375
      ],
      [
        -1570.1778564453125,
        -3800.544189453125,
        1375.0999755859375
      ],
      [
        -1571.83154296875,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3800.544189453125,
        1375.0999755859375
      ],
      [
        -1570.1778564453125,
        -3800.544189453125,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1564.2955322265625,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1570.83154296875,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1564.2955322265625,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3812.044189453125,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3812.044189453125,
        1375.0999755859375
      ],
      [
        -1570.83154296875,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3812.044189453125,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3812.044189453125,
        1375.0999755859375
      ],
      [
        -1629.1417236328125,
        -3852.664794921875,
        1368.8232421875
      ],
      [
        -1630.8829345703125,
        -3854.459716796875,
        1375.022705078125
      ],
      [
        -1630.8829345703125,
        -3854.459716796875,
        1375.022705078125
      ],
      [
        -1630.884033203125,
        -3854.4609375,
        1375.0999755859375
      ],
      [
        -1618.741455078125,
        -3841.94287109375,
        1392.0999755859375
      ],
      [
        -1576.2244873046875,
        -3798.111083984375,
        1392.0999755859375
      ],
      [
        -1566.14013671875,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1570.9749755859375,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1570.9749755859375,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1573.462646484375,
        -3803.38818359375,
        1392.0999755859375
      ],
      [
        -1563.65283203125,
        -3803.38818359375,
        1392.0999755859375
      ],
      [
        -1566.14013671875,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1573.462646484375,
        -3803.38818359375,
        1392.0999755859375
      ],
      [
        -1570.9749755859375,
        -3799.203125,
        1392.0999755859375
      ],
      [
        -1566.14013671875,
        -3799.203125,
        1392.0999755859375
      ],
      [
        -1563.65283203125,
        -3803.38818359375,
        1392.0999755859375
      ],
      [
        -1570.9749755859375,
        -3799.203125,
        1392.0999755859375
      ],
      [
        -1566.14013671875,
        -3799.203125,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1572.462646484375,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1562.65283203125,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1572.462646484375,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3810.703125,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3810.703125,
        1392.0999755859375
      ],
      [
        -1562.65283203125,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3810.703125,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3810.703125,
        1392.0999755859375
      ],
      [
        -1566.849609375,
        -3788.446044921875,
        1380.7889404296875
      ],
      [
        -1566.849609375,
        -3788.446044921875,
        1380.7889404296875
      ],
      [
        -1566.88525390625,
        -3788.48291015625,
        1380.8370361328125
      ],
      [
        -1566.8338623046875,
        -3800.353515625,
        1387.9940185546875
      ],
      [
        -1565.2379150390625,
        -3803.328369140625,
        1387.4808349609375
      ],
      [
        -1569.758056640625,
        -3811.068115234375,
        1390.79736328125
      ],
      [
        -1565.7152099609375,
        -3811.656494140625,
        1388.6966552734375
      ],
      [
        -1565.7152099609375,
        -3811.656494140625,
        1388.6966552734375
      ],
      [
        -1564.0089111328125,
        -3814.837158203125,
        1388.14794921875
      ],
      [
        -1564.0089111328125,
        -3814.837158203125,
        1388.14794921875
      ],
      [
        -1565.5975341796875,
        -3818.244873046875,
        1389.392822265625
      ],
      [
        -1565.5975341796875,
        -3818.244873046875,
        1389.392822265625
      ],
      [
        -1569.9248046875,
        -3818.981201171875,
        1391.7987060546875
      ],
      [
        -1569.758056640625,
        -3811.068115234375,
        1390.79736328125
      ],
      [
        -1571.6571044921875,
        -3813.532958984375,
        1392.0999755859375
      ],
      [
        -1569.9248046875,
        -3818.981201171875,
        1391.7987060546875
      ],
      [
        -1570.7449951171875,
        -3817.778076171875,
        1392.0999755859375
      ],
      [
        -1565.2379150390625,
        -3803.328369140625,
        1387.4808349609375
      ],
      [
        -1566.723876953125,
        -3806.51611328125,
        1388.645263671875
      ],
      [
        -1570.6187744140625,
        -3799.802490234375,
        1389.9605712890625
      ],
      [
        -1566.8338623046875,
        -3800.353515625,
        1387.9940185546875
      ],
      [
        -1566.723876953125,
        -3806.51611328125,
        1388.645263671875
      ],
      [
        -1570.7747802734375,
        -3807.20556640625,
        1390.8974609375
      ],
      [
        -1573.3787841796875,
        -3803.385009765625,
        1391.8538818359375
      ],
      [
        -1570.6187744140625,
        -3799.802490234375,
        1389.9605712890625
      ],
      [
        -1570.7747802734375,
        -3807.20556640625,
        1390.8974609375
      ],
      [
        -1573.3787841796875,
        -3803.385009765625,
        1391.8538818359375
      ],
      [
        -1570.408447265625,
        -3800.156494140625,
        1388.697265625
      ],
      [
        -1567.08740234375,
        -3800.77392578125,
        1386.4932861328125
      ],
      [
        -1570.408447265625,
        -3800.156494140625,
        1388.697265625
      ],
      [
        -1572.7763671875,
        -3802.60302734375,
        1391.440673828125
      ],
      [
        -1565.60009765625,
        -3803.314697265625,
        1386.4254150390625
      ],
      [
        -1566.739013671875,
        -3806.48876953125,
        1388.5555419921875
      ],
      [
        -1567.08740234375,
        -3800.77392578125,
        1386.4932861328125
      ],
      [
        -1565.60009765625,
        -3803.314697265625,
        1386.4254150390625
      ],
      [
        -1566.739013671875,
        -3806.48876953125,
        1388.5555419921875
      ],
      [
        -1567.07958984375,
        -3806.57666015625,
        1388.843017578125
      ],
      [
        -1569.659912109375,
        -3811.233154296875,
        1390.2080078125
      ],
      [
        -1565.7802734375,
        -3811.764404296875,
        1388.311767578125
      ],
      [
        -1565.6800537109375,
        -3818.095458984375,
        1388.904541015625
      ],
      [
        -1569.7987060546875,
        -3818.74951171875,
        1391.041259765625
      ],
      [
        -1572.4166259765625,
        -3814.886474609375,
        1391.96484375
      ],
      [
        -1569.659912109375,
        -3811.233154296875,
        1390.2080078125
      ],
      [
        -1569.7987060546875,
        -3818.74951171875,
        1391.041259765625
      ],
      [
        -1572.4166259765625,
        -3814.886474609375,
        1391.96484375
      ],
      [
        -1564.13037109375,
        -3814.83251953125,
        1387.7940673828125
      ],
      [
        -1565.6800537109375,
        -3818.095458984375,
        1388.904541015625
      ],
      [
        -1565.7802734375,
        -3811.764404296875,
        1388.311767578125
      ],
      [
        -1564.13037109375,
        -3814.83251953125,
        1387.7940673828125
      ],
      [
        -1570.6734619140625,
        -3807.01953125,
        1390.289306640625
      ],
      [
        -1573.1424560546875,
        -3803.3759765625,
        1391.1602783203125
      ],
      [
        -1566.7867431640625,
        -3806.40234375,
        1388.2728271484375
      ],
      [
        -1570.6734619140625,
        -3807.01953125,
        1390.289306640625
      ],
      [
        -1573.1424560546875,
        -3803.3759765625,
        1391.1602783203125
      ],
      [
        -1571.7906494140625,
        -3801.584716796875,
        1390.298828125
      ],
      [
        -1566.7867431640625,
        -3806.40234375,
        1388.2728271484375
      ],
      [
        -1566.46435546875,
        -3805.72314453125,
        1388.041748046875
      ],
      [
        -1572.3466796875,
        -3814.8837890625,
        1391.759521484375
      ],
      [
        -1569.6141357421875,
        -3811.310302734375,
        1389.9329833984375
      ],
      [
        -1569.78857421875,
        -3818.730712890625,
        1390.980224609375
      ],
      [
        -1572.3466796875,
        -3814.8837890625,
        1391.759521484375
      ],
      [
        -1565.6893310546875,
        -3818.07861328125,
        1388.849365234375
      ],
      [
        -1569.78857421875,
        -3818.730712890625,
        1390.980224609375
      ],
      [
        -1569.6141357421875,
        -3811.310302734375,
        1389.9329833984375
      ],
      [
        -1565.8155517578125,
        -3811.82275390625,
        1388.1029052734375
      ],
      [
        -1564.1722412109375,
        -3814.8310546875,
        1387.671875
      ],
      [
        -1565.6893310546875,
        -3818.07861328125,
        1388.849365234375
      ],
      [
        -1565.8155517578125,
        -3811.82275390625,
        1388.1029052734375
      ],
      [
        -1564.1722412109375,
        -3814.8310546875,
        1387.671875
      ],
      [
        -1570.600830078125,
        -3806.885986328125,
        1389.8531494140625
      ],
      [
        -1572.9398193359375,
        -3803.368408203125,
        1390.565673828125
      ],
      [
        -1566.8492431640625,
        -3806.2890625,
        1387.9029541015625
      ],
      [
        -1570.600830078125,
        -3806.885986328125,
        1389.8531494140625
      ],
      [
        -1572.9398193359375,
        -3803.368408203125,
        1390.565673828125
      ],
      [
        -1570.7679443359375,
        -3800.528076171875,
        1389.1138916015625
      ],
      [
        -1566.8492431640625,
        -3806.2890625,
        1387.9029541015625
      ],
      [
        -1566.0643310546875,
        -3804.6083984375,
        1387.2935791015625
      ],
      [
        -1576.2244873046875,
        -3798.111083984375,
        1392.0999755859375
      ],
      [
        -1574.70263671875,
        -3797.11572265625,
        1390.63671875
      ],
      [
        -1575.19140625,
        -3797.046142578125,
        1390.8717041015625
      ],
      [
        -1557.7020263671875,
        -3868.8310546875,
        1375.572509765625
      ],
      [
        -1557.9388427734375,
        -3868.9267578125,
        1375.6214599609375
      ],
      [
        -1551.76416015625,
        -3866.431884765625,
        1376.2340087890625
      ],
      [
        -1557.7020263671875,
        -3868.8310546875,
        1375.572509765625
      ],
      [
        -1551.662841796875,
        -3866.39111328125,
        1376.7347412109375
      ],
      [
        -1551.76416015625,
        -3866.431884765625,
        1376.2340087890625
      ],
      [
        -1561.7230224609375,
        -3870.45556640625,
        1376.4410400390625
      ],
      [
        -1557.9388427734375,
        -3868.9267578125,
        1375.6214599609375
      ],
      [
        -1561.7230224609375,
        -3870.45556640625,
        1376.4410400390625
      ],
      [
        -1561.7315673828125,
        -3870.458984375,
        1376.46728515625
      ],
      [
        -1561.318359375,
        -3869.653076171875,
        1386.190673828125
      ],
      [
        -1561.318359375,
        -3869.653076171875,
        1386.190673828125
      ],
      [
        -1561.5504150390625,
        -3870.385986328125,
        1386.1217041015625
      ],
      [
        -1558.3336181640625,
        -3869.08642578125,
        1387.6434326171875
      ],
      [
        -1558.1209716796875,
        -3869.00048828125,
        1387.700927734375
      ],
      [
        -1557.7481689453125,
        -3868.849853515625,
        1387.6246337890625
      ],
      [
        -1558.1209716796875,
        -3869.00048828125,
        1387.700927734375
      ],
      [
        -1558.3336181640625,
        -3869.08642578125,
        1387.6434326171875
      ],
      [
        -1552.103515625,
        -3866.569091796875,
        1386.4703369140625
      ],
      [
        -1551.9547119140625,
        -3866.509033203125,
        1386.33349609375
      ],
      [
        -1551.98779296875,
        -3866.522216796875,
        1386.429443359375
      ],
      [
        -1551.9547119140625,
        -3866.509033203125,
        1386.33349609375
      ],
      [
        -1551.9443359375,
        -3866.5048828125,
        1386.29443359375
      ],
      [
        -1551.98779296875,
        -3866.522216796875,
        1386.429443359375
      ],
      [
        -1552.103515625,
        -3866.569091796875,
        1386.4703369140625
      ],
      [
        -1550.589111328125,
        -3865.957275390625,
        1381.2196044921875
      ],
      [
        -1550.589111328125,
        -3865.957275390625,
        1381.2196044921875
      ],
      [
        -1550.62841796875,
        -3865.97314453125,
        1381.0711669921875
      ],
      [
        -1576.157470703125,
        -3867.600341796875,
        1386.221923828125
      ],
      [
        -1570.6883544921875,
        -3871.086181640625,
        1383.978759765625
      ],
      [
        -1569.31591796875,
        -3870.885498046875,
        1384.304931640625
      ],
      [
        -1570.6883544921875,
        -3871.086181640625,
        1383.978759765625
      ],
      [
        -1576.157470703125,
        -3867.600341796875,
        1386.221923828125
      ],
      [
        -1562.827392578125,
        -3869.936279296875,
        1385.8470458984375
      ],
      [
        -1562.47998046875,
        -3870.226318359375,
        1385.647705078125
      ],
      [
        -1562.3983154296875,
        -3870.728515625,
        1385.7205810546875
      ],
      [
        -1561.3458251953125,
        -3869.739990234375,
        1386.1824951171875
      ],
      [
        -1562.5367431640625,
        -3870.784423828125,
        1385.1798095703125
      ],
      [
        -1562.471923828125,
        -3870.75830078125,
        1385.5201416015625
      ],
      [
        -1562.4896240234375,
        -3870.2705078125,
        1385.6103515625
      ],
      [
        -1562.3983154296875,
        -3870.728515625,
        1385.7205810546875
      ],
      [
        -1562.47998046875,
        -3870.226318359375,
        1385.647705078125
      ],
      [
        -1562.4896240234375,
        -3870.2705078125,
        1385.6103515625
      ],
      [
        -1562.471923828125,
        -3870.75830078125,
        1385.5201416015625
      ],
      [
        -1570.4677734375,
        -3861.292724609375,
        1392.0999755859375
      ],
      [
        -1562.827392578125,
        -3869.936279296875,
        1385.8470458984375
      ],
      [
        -1618.741455078125,
        -3841.94287109375,
        1392.0999755859375
      ],
      [
        -1593.1282958984375,
        -3861.204833984375,
        1375.0999755859375
      ],
      [
        -1575.336669921875,
        -3867.518310546875,
        1377.401611328125
      ],
      [
        -1571.21337890625,
        -3870.365234375,
        1378.7728271484375
      ],
      [
        -1567.49755859375,
        -3872.4970703125,
        1379.745849609375
      ],
      [
        -1561.8089599609375,
        -3870.490234375,
        1376.7056884765625
      ],
      [
        -1575.336669921875,
        -3867.518310546875,
        1377.401611328125
      ],
      [
        -1571.21337890625,
        -3870.365234375,
        1378.7728271484375
      ],
      [
        -1562.017822265625,
        -3870.25146484375,
        1377.228515625
      ],
      [
        -1564.6534423828125,
        -3871.307861328125,
        1378.782470703125
      ],
      [
        -1567.49755859375,
        -3872.4970703125,
        1379.745849609375
      ],
      [
        -1562.017822265625,
        -3870.25146484375,
        1377.228515625
      ],
      [
        -1562.0927734375,
        -3870.60498046875,
        1377.5804443359375
      ],
      [
        -1562.2646484375,
        -3870.30908203125,
        1377.973388671875
      ],
      [
        -1562.2646484375,
        -3870.30908203125,
        1377.973388671875
      ],
      [
        -1562.29541015625,
        -3870.686767578125,
        1378.204833984375
      ],
      [
        -1575.7259521484375,
        -3867.839599609375,
        1377.788330078125
      ],
      [
        -1575.7259521484375,
        -3867.839599609375,
        1377.788330078125
      ],
      [
        -1570.9102783203125,
        -3871.163818359375,
        1379.38916015625
      ],
      [
        -1570.9102783203125,
        -3871.163818359375,
        1379.38916015625
      ],
      [
        -1568.1483154296875,
        -3872.758544921875,
        1380.1209716796875
      ],
      [
        -1565.3740234375,
        -3871.5966796875,
        1379.207275390625
      ],
      [
        -1568.1483154296875,
        -3872.758544921875,
        1380.1209716796875
      ],
      [
        -1564.6534423828125,
        -3871.307861328125,
        1378.782470703125
      ],
      [
        -1562.3427734375,
        -3870.327392578125,
        1378.208984375
      ],
      [
        -1562.3427734375,
        -3870.327392578125,
        1378.208984375
      ],
      [
        -1562.3731689453125,
        -3870.71826171875,
        1378.444580078125
      ],
      [
        -1551.2940673828125,
        -3866.2421875,
        1378.5570068359375
      ],
      [
        -1551.2940673828125,
        -3866.2421875,
        1378.5570068359375
      ],
      [
        -1570.126220703125,
        -3873.2294921875,
        1380.9832763671875
      ],
      [
        -1569.31591796875,
        -3870.885498046875,
        1384.304931640625
      ],
      [
        -1568.397705078125,
        -3872.783447265625,
        1382.1558837890625
      ],
      [
        -1569.425537109375,
        -3873.248046875,
        1381.199951171875
      ],
      [
        -1569.641845703125,
        -3873.3583984375,
        1380.982177734375
      ],
      [
        -1569.425537109375,
        -3873.248046875,
        1381.199951171875
      ],
      [
        -1568.397705078125,
        -3872.783447265625,
        1382.1558837890625
      ],
      [
        -1570.126220703125,
        -3873.2294921875,
        1380.9832763671875
      ],
      [
        -1569.641845703125,
        -3873.3583984375,
        1380.982177734375
      ],
      [
        -1597.2252197265625,
        -3867.40869140625,
        1379.240234375
      ],
      [
        -1568.7542724609375,
        -3872.95166015625,
        1381.199951171875
      ],
      [
        -1565.3740234375,
        -3871.5966796875,
        1379.207275390625
      ],
      [
        -1568.7542724609375,
        -3872.95166015625,
        1381.199951171875
      ],
      [
        -1569.1566162109375,
        -3873.12646484375,
        1381.4500732421875
      ],
      [
        -1562.49365234375,
        -3870.314697265625,
        1385.5733642578125
      ],
      [
        -1567.879150390625,
        -3789.50732421875,
        1382.17724609375
      ],
      [
        -1563.2877197265625,
        -3871.087890625,
        1381.240234375
      ],
      [
        -1563.224609375,
        -3871.062255859375,
        1381.0677490234375
      ],
      [
        -1563.2877197265625,
        -3871.087890625,
        1381.240234375
      ],
      [
        -1563.224609375,
        -3871.062255859375,
        1381.0677490234375
      ],
      [
        -1567.879150390625,
        -3789.50732421875,
        1382.17724609375
      ],
      [
        -1566.3839111328125,
        -3814.070556640625,
        1380.080078125
      ],
      [
        -1565.3050537109375,
        -3814.788330078125,
        1378.09814453125
      ],
      [
        -1565.3050537109375,
        -3814.788330078125,
        1378.09814453125
      ],
      [
        -1565.2642822265625,
        -3814.703369140625,
        1377.8209228515625
      ],
      [
        -1566.369384765625,
        -3812.7412109375,
        1377.6357421875
      ],
      [
        -1565.52978515625,
        -3812.74951171875,
        1375.0999755859375
      ],
      [
        -1564.863525390625,
        -3813.87060546875,
        1375.0999755859375
      ],
      [
        -1566.369384765625,
        -3812.7412109375,
        1377.6357421875
      ],
      [
        -1566.420166015625,
        -3816.7548828125,
        1377.9420166015625
      ],
      [
        -1565.435791015625,
        -3816.744873046875,
        1375.0999755859375
      ],
      [
        -1566.420166015625,
        -3816.7548828125,
        1377.9420166015625
      ],
      [
        -1568.7332763671875,
        -3812.792236328125,
        1377.821044921875
      ],
      [
        -1568.2298583984375,
        -3812.044189453125,
        1375.0999755859375
      ],
      [
        -1568.7332763671875,
        -3812.792236328125,
        1377.821044921875
      ],
      [
        -1567.3839111328125,
        -3802.570556640625,
        1380.080078125
      ],
      [
        -1566.3050537109375,
        -3803.288330078125,
        1378.09814453125
      ],
      [
        -1566.3050537109375,
        -3803.288330078125,
        1378.09814453125
      ],
      [
        -1566.2642822265625,
        -3803.203369140625,
        1377.8209228515625
      ],
      [
        -1567.369384765625,
        -3801.241455078125,
        1377.6361083984375
      ],
      [
        -1566.52978515625,
        -3801.24951171875,
        1375.0999755859375
      ],
      [
        -1565.863525390625,
        -3802.37060546875,
        1375.0999755859375
      ],
      [
        -1567.369384765625,
        -3801.241455078125,
        1377.6361083984375
      ],
      [
        -1567.420166015625,
        -3805.2548828125,
        1377.9420166015625
      ],
      [
        -1566.435791015625,
        -3805.2451171875,
        1375.0999755859375
      ],
      [
        -1567.420166015625,
        -3805.2548828125,
        1377.9420166015625
      ],
      [
        -1569.7333984375,
        -3801.2919921875,
        1377.820556640625
      ],
      [
        -1569.22998046875,
        -3800.544189453125,
        1375.0999755859375
      ],
      [
        -1569.7333984375,
        -3801.2919921875,
        1377.820556640625
      ],
      [
        -1551.9136962890625,
        -3866.4921875,
        1376.2174072265625
      ],
      [
        -1561.850341796875,
        -3870.507080078125,
        1376.833251953125
      ],
      [
        -1649.749755859375,
        -3697.864013671875,
        1405.224365234375
      ],
      [
        -1649.749755859375,
        -3697.864013671875,
        1405.224365234375
      ],
      [
        -1649.7498779296875,
        -3697.864013671875,
        1405.224853515625
      ],
      [
        -1649.7498779296875,
        -3697.864013671875,
        1405.224853515625
      ],
      [
        -1686.2406005859375,
        -3724.1259765625,
        1405.224365234375
      ],
      [
        -1686.24072265625,
        -3724.1259765625,
        1405.224853515625
      ],
      [
        -1686.24072265625,
        -3724.1259765625,
        1405.224853515625
      ],
      [
        -1686.2406005859375,
        -3724.1259765625,
        1405.224365234375
      ],
      [
        -1647.530517578125,
        -3705.12255859375,
        1408.244384765625
      ],
      [
        -1647.5794677734375,
        -3705.15771484375,
        1408.244384765625
      ],
      [
        -1647.5794677734375,
        -3705.15771484375,
        1408.244384765625
      ],
      [
        -1647.4510498046875,
        -3705.382080078125,
        1415.00439453125
      ],
      [
        -1687.36376953125,
        -3723.33935546875,
        1408.8626708984375
      ],
      [
        -1699.703125,
        -3760.60009765625,
        1417.2216796875
      ],
      [
        -1698.3077392578125,
        -3759.658935546875,
        1418.5858154296875
      ],
      [
        -1698.3077392578125,
        -3759.658935546875,
        1418.5858154296875
      ],
      [
        -1698.1434326171875,
        -3759.548095703125,
        1418.5858154296875
      ],
      [
        -1699.703125,
        -3760.60009765625,
        1417.2216796875
      ],
      [
        -1699.9019775390625,
        -3760.734130859375,
        1416.9354248046875
      ],
      [
        -1699.7105712890625,
        -3760.60498046875,
        1405.224365234375
      ],
      [
        -1700.3167724609375,
        -3761.013916015625,
        1405.224365234375
      ],
      [
        -1700.593994140625,
        -3761.200927734375,
        1405.224365234375
      ],
      [
        -1700.3167724609375,
        -3761.013916015625,
        1405.224365234375
      ],
      [
        -1693.3895263671875,
        -3756.341552734375,
        1405.224365234375
      ],
      [
        -1699.7105712890625,
        -3760.60498046875,
        1405.224365234375
      ],
      [
        -1692.718505859375,
        -3755.888916015625,
        1418.5858154296875
      ],
      [
        -1693.3895263671875,
        -3756.341552734375,
        1405.224365234375
      ],
      [
        -1692.9703369140625,
        -3756.058837890625,
        1405.64990234375
      ],
      [
        -1692.3031005859375,
        -3755.608642578125,
        1418.0283203125
      ],
      [
        -1692.718505859375,
        -3755.888916015625,
        1418.5858154296875
      ],
      [
        -1692.9703369140625,
        -3756.058837890625,
        1405.64990234375
      ],
      [
        -1690.5386962890625,
        -3754.418701171875,
        1408.234130859375
      ],
      [
        -1690.15966796875,
        -3754.162841796875,
        1415.0157470703125
      ],
      [
        -1692.3031005859375,
        -3755.608642578125,
        1418.0283203125
      ],
      [
        -1690.5386962890625,
        -3754.418701171875,
        1408.234130859375
      ],
      [
        -1690.4619140625,
        -3754.366943359375,
        1409.5565185546875
      ],
      [
        -1690.4619140625,
        -3754.366943359375,
        1409.5565185546875
      ],
      [
        -1690.15966796875,
        -3754.162841796875,
        1415.0157470703125
      ],
      [
        -1701.34375,
        -3761.706787109375,
        1414.4871826171875
      ],
      [
        -1701.838623046875,
        -3762.04052734375,
        1408.7421875
      ],
      [
        -1701.3138427734375,
        -3761.6865234375,
        1414.902587890625
      ],
      [
        -1701.34375,
        -3761.706787109375,
        1414.4871826171875
      ],
      [
        -1701.3138427734375,
        -3761.6865234375,
        1414.902587890625
      ],
      [
        -1701.30712890625,
        -3761.681884765625,
        1414.912353515625
      ],
      [
        -1701.790771484375,
        -3762.008056640625,
        1408.412109375
      ],
      [
        -1700.593994140625,
        -3761.200927734375,
        1405.224365234375
      ],
      [
        -1701.838623046875,
        -3762.04052734375,
        1408.7421875
      ],
      [
        -1701.790771484375,
        -3762.008056640625,
        1408.412109375
      ],
      [
        -1619.747314453125,
        -3746.22509765625,
        1251.0999755859375
      ],
      [
        -1626.5146484375,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1623.41357421875,
        -3754.5751953125,
        1242.515380859375
      ],
      [
        -1625.771728515625,
        -3756.844482421875,
        1251.0999755859375
      ],
      [
        -1619.747314453125,
        -3746.22509765625,
        1251.0999755859375
      ],
      [
        -1632.3275146484375,
        -3733.342041015625,
        1242.515380859375
      ],
      [
        -1626.5146484375,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1635.23779296875,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1606.828857421875,
        -3774.850830078125,
        1251.0999755859375
      ],
      [
        -1601.766357421875,
        -3781.5693359375,
        1251.0999755859375
      ],
      [
        -1609.171142578125,
        -3787.149169921875,
        1251.0999755859375
      ],
      [
        -1613.82470703125,
        -3781.07666015625,
        1246.5
      ],
      [
        -1614.307373046875,
        -3780.424072265625,
        1247.0408935546875
      ],
      [
        -1614.233642578125,
        -3780.4306640625,
        1251.0999755859375
      ],
      [
        -1613.0626220703125,
        -3774.28173828125,
        1251.0999755859375
      ],
      [
        -1606.828857421875,
        -3774.850830078125,
        1251.0999755859375
      ],
      [
        -1602.9373779296875,
        -3787.71826171875,
        1251.0999755859375
      ],
      [
        -1609.171142578125,
        -3787.149169921875,
        1251.0999755859375
      ],
      [
        -1601.766357421875,
        -3781.5693359375,
        1251.0999755859375
      ],
      [
        -1602.9373779296875,
        -3787.71826171875,
        1251.0999755859375
      ],
      [
        -1614.233642578125,
        -3780.4306640625,
        1251.0999755859375
      ],
      [
        -1614.307373046875,
        -3780.424072265625,
        1247.0408935546875
      ],
      [
        -1614.2491455078125,
        -3780.065673828125,
        1246.5
      ],
      [
        -1613.0626220703125,
        -3774.28173828125,
        1251.0999755859375
      ],
      [
        -1612.685302734375,
        -3736.375244140625,
        1251.0999755859375
      ],
      [
        -1604.9388427734375,
        -3733.0869140625,
        1251.0999755859375
      ],
      [
        -1601.314697265625,
        -3741.624755859375,
        1251.0999755859375
      ],
      [
        -1609.0611572265625,
        -3744.9130859375,
        1251.0999755859375
      ],
      [
        -1614.7464599609375,
        -3742.288330078125,
        1251.0999755859375
      ],
      [
        -1612.685302734375,
        -3736.375244140625,
        1251.0999755859375
      ],
      [
        -1599.2535400390625,
        -3735.711669921875,
        1251.0999755859375
      ],
      [
        -1601.314697265625,
        -3741.624755859375,
        1251.0999755859375
      ],
      [
        -1604.9388427734375,
        -3733.0869140625,
        1251.0999755859375
      ],
      [
        -1599.2535400390625,
        -3735.711669921875,
        1251.0999755859375
      ],
      [
        -1609.0611572265625,
        -3744.9130859375,
        1251.0999755859375
      ],
      [
        -1614.7464599609375,
        -3742.288330078125,
        1251.0999755859375
      ],
      [
        -1640.009033203125,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1646.7763671875,
        -3746.22509765625,
        1251.0999755859375
      ],
      [
        -1645.1119384765625,
        -3751.12109375,
        1242.515380859375
      ],
      [
        -1646.7763671875,
        -3746.22509765625,
        1251.0999755859375
      ],
      [
        -1640.009033203125,
        -3758.154052734375,
        1251.0999755859375
      ],
      [
        -1640.042724609375,
        -3758.208740234375,
        1250.600830078125
      ],
      [
        -1634.6077880859375,
        -3759.095458984375,
        1242.515380859375
      ],
      [
        -1640.042724609375,
        -3758.208740234375,
        1250.600830078125
      ],
      [
        -1640.009033203125,
        -3758.154052734375,
        1251.0999755859375
      ],
      [
        -1626.5146484375,
        -3758.154052734375,
        1251.0999755859375
      ],
      [
        -1640.009033203125,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1626.5146484375,
        -3758.154052734375,
        1251.0999755859375
      ],
      [
        -1627.4873046875,
        -3752.46142578125,
        1212.60009765625
      ],
      [
        -1628.356689453125,
        -3751.81640625,
        1212.60009765625
      ],
      [
        -1624.16796875,
        -3751.7841796875,
        1210.0
      ],
      [
        -1622.47705078125,
        -3748.94970703125,
        1210.0
      ],
      [
        -1627.4873046875,
        -3752.46142578125,
        1212.60009765625
      ],
      [
        -1624.16796875,
        -3751.7841796875,
        1210.0
      ],
      [
        -1626.8687744140625,
        -3751.7841796875,
        1210.0
      ],
      [
        -1629.24072265625,
        -3748.94970703125,
        1210.0
      ],
      [
        -1628.356689453125,
        -3751.81640625,
        1212.60009765625
      ],
      [
        -1628.09033203125,
        -3750.8779296875,
        1210.0
      ],
      [
        -1643.8013916015625,
        -3753.43115234375,
        1242.515380859375
      ],
      [
        -1640.2171630859375,
        -3758.49267578125,
        1248.0130615234375
      ],
      [
        -1636.1661376953125,
        -3759.095458984375,
        1242.515380859375
      ],
      [
        -1640.2171630859375,
        -3758.49267578125,
        1248.0130615234375
      ],
      [
        -1651.181884765625,
        -3795.43603515625,
        1251.0999755859375
      ],
      [
        -1648.41015625,
        -3774.44384765625,
        1251.0999755859375
      ],
      [
        -1653.9532470703125,
        -3769.5166015625,
        1251.0999755859375
      ],
      [
        -1660.4202880859375,
        -3789.27685546875,
        1251.0999755859375
      ],
      [
        -1660.1121826171875,
        -3813.964599609375,
        1251.0999755859375
      ],
      [
        -1651.181884765625,
        -3795.43603515625,
        1251.0999755859375
      ],
      [
        -1660.4202880859375,
        -3789.27685546875,
        1251.0999755859375
      ],
      [
        -1661.9598388671875,
        -3806.57373046875,
        1251.0999755859375
      ],
      [
        -1661.9598388671875,
        -3806.57373046875,
        1251.0999755859375
      ],
      [
        -1660.1121826171875,
        -3813.964599609375,
        1251.0999755859375
      ],
      [
        -1648.41015625,
        -3774.44384765625,
        1251.0999755859375
      ],
      [
        -1653.9532470703125,
        -3769.5166015625,
        1251.0999755859375
      ],
      [
        -1663.17626953125,
        -3819.198486328125,
        1242.515380859375
      ],
      [
        -1662.4638671875,
        -3819.198486328125,
        1242.515380859375
      ],
      [
        -1663.0155029296875,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1663.1539306640625,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1665.80029296875,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1671.591064453125,
        -3830.196044921875,
        1251.0999755859375
      ],
      [
        -1669.9351806640625,
        -3834.699951171875,
        1242.515380859375
      ],
      [
        -1671.591064453125,
        -3830.196044921875,
        1251.0999755859375
      ],
      [
        -1669.614501953125,
        -3833.68017578125,
        1251.0999755859375
      ],
      [
        -1665.80029296875,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1668.70947265625,
        -3816.411865234375,
        1251.0999755859375
      ],
      [
        -1669.88232421875,
        -3824.7578125,
        1251.0999755859375
      ],
      [
        -1669.88232421875,
        -3824.7578125,
        1251.0999755859375
      ],
      [
        -1672.76513671875,
        -3826.804931640625,
        1246.5
      ],
      [
        -1672.647705078125,
        -3826.638427734375,
        1251.0999755859375
      ],
      [
        -1669.15283203125,
        -3815.76708984375,
        1246.5
      ],
      [
        -1668.70947265625,
        -3816.411865234375,
        1251.0999755859375
      ],
      [
        -1669.134033203125,
        -3815.902099609375,
        1251.0999755859375
      ],
      [
        -1657.0675048828125,
        -3841.1748046875,
        1242.515380859375
      ],
      [
        -1665.80029296875,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1657.119140625,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1654.165771484375,
        -3819.198486328125,
        1242.515380859375
      ],
      [
        -1654.4237060546875,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1665.80029296875,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1679.0809326171875,
        -3823.465087890625,
        1251.0999755859375
      ],
      [
        -1677.9080810546875,
        -3815.119140625,
        1251.0999755859375
      ],
      [
        -1677.9080810546875,
        -3815.119140625,
        1251.0999755859375
      ],
      [
        -1672.7222900390625,
        -3811.59228515625,
        1251.0999755859375
      ],
      [
        -1675.068115234375,
        -3828.284423828125,
        1251.0999755859375
      ],
      [
        -1679.0809326171875,
        -3823.465087890625,
        1251.0999755859375
      ],
      [
        -1672.7222900390625,
        -3811.59228515625,
        1251.0999755859375
      ],
      [
        -1675.068115234375,
        -3828.284423828125,
        1251.0999755859375
      ],
      [
        -1648.4681396484375,
        -3830.196044921875,
        1251.0999755859375
      ],
      [
        -1654.2589111328125,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1654.2589111328125,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1648.4681396484375,
        -3830.196044921875,
        1251.0999755859375
      ],
      [
        -1654.2589111328125,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1654.2589111328125,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1613.9210205078125,
        -3780.948974609375,
        1246.5
      ],
      [
        -1613.916748046875,
        -3780.952392578125,
        1246.6031494140625
      ],
      [
        -1614.5391845703125,
        -3772.76025390625,
        1225.8089599609375
      ],
      [
        -1616.344970703125,
        -3773.48779296875,
        1226.7838134765625
      ],
      [
        -1614.9757080078125,
        -3777.96923828125,
        1226.7838134765625
      ],
      [
        -1613.8426513671875,
        -3776.5380859375,
        1226.029052734375
      ],
      [
        -1616.344970703125,
        -3773.48779296875,
        1226.7838134765625
      ],
      [
        -1614.5391845703125,
        -3772.76025390625,
        1225.8089599609375
      ],
      [
        -1616.6602783203125,
        -3771.956787109375,
        1225.7862548828125
      ],
      [
        -1613.8426513671875,
        -3776.5380859375,
        1226.029052734375
      ],
      [
        -1614.9757080078125,
        -3777.96923828125,
        1226.7838134765625
      ],
      [
        -1614.625244140625,
        -3778.811767578125,
        1226.176025390625
      ],
      [
        -1629.593505859375,
        -3780.66064453125,
        1226.470458984375
      ],
      [
        -1628.4425048828125,
        -3781.993408203125,
        1226.705810546875
      ],
      [
        -1626.7784423828125,
        -3783.88720703125,
        1226.7047119140625
      ],
      [
        -1626.71484375,
        -3783.95263671875,
        1226.634521484375
      ],
      [
        -1627.3514404296875,
        -3783.237060546875,
        1226.72412109375
      ],
      [
        -1626.7784423828125,
        -3783.88720703125,
        1226.7047119140625
      ],
      [
        -1627.3514404296875,
        -3783.237060546875,
        1226.72412109375
      ],
      [
        -1628.4425048828125,
        -3781.993408203125,
        1226.705810546875
      ],
      [
        -1614.71337890625,
        -3779.06787109375,
        1226.192626953125
      ],
      [
        -1616.1395263671875,
        -3782.910400390625,
        1226.4425048828125
      ],
      [
        -1614.71337890625,
        -3779.06787109375,
        1226.192626953125
      ],
      [
        -1616.1395263671875,
        -3782.910400390625,
        1226.4425048828125
      ],
      [
        -1616.5963134765625,
        -3783.056396484375,
        1226.4569091796875
      ],
      [
        -1614.984375,
        -3777.94091796875,
        1226.7838134765625
      ],
      [
        -1616.69921875,
        -3771.94189453125,
        1225.785888671875
      ],
      [
        -1620.221435546875,
        -3784.2158203125,
        1226.5712890625
      ],
      [
        -1620.221435546875,
        -3784.2158203125,
        1226.5712890625
      ],
      [
        -1621.2711181640625,
        -3784.17333984375,
        1226.58154296875
      ],
      [
        -1627.982666015625,
        -3781.24169921875,
        1226.7235107421875
      ],
      [
        -1629.594482421875,
        -3780.527587890625,
        1226.46240234375
      ],
      [
        -1627.982666015625,
        -3781.24169921875,
        1226.7235107421875
      ],
      [
        -1625.744384765625,
        -3777.16357421875,
        1226.800048828125
      ],
      [
        -1628.3062744140625,
        -3768.203369140625,
        1225.9273681640625
      ],
      [
        -1625.744384765625,
        -3777.16357421875,
        1226.800048828125
      ],
      [
        -1628.3062744140625,
        -3768.203369140625,
        1225.9273681640625
      ],
      [
        -1628.434326171875,
        -3767.740234375,
        1225.8602294921875
      ],
      [
        -1624.625,
        -3782.72900390625,
        1227.267578125
      ],
      [
        -1628.6832275390625,
        -3766.83935546875,
        1225.7298583984375
      ],
      [
        -1628.6832275390625,
        -3766.83935546875,
        1225.7298583984375
      ],
      [
        -1628.7220458984375,
        -3766.634521484375,
        1225.6114501953125
      ],
      [
        -1619.0355224609375,
        -3770.95556640625,
        1225.754638671875
      ],
      [
        -1626.6258544921875,
        -3774.08056640625,
        1226.499755859375
      ],
      [
        -1616.375,
        -3775.504150390625,
        1230.8917236328125
      ],
      [
        -1617.5269775390625,
        -3771.62841796875,
        1225.7769775390625
      ],
      [
        -1617.5269775390625,
        -3771.62841796875,
        1225.7769775390625
      ],
      [
        -1625.8262939453125,
        -3778.97265625,
        1229.946533203125
      ],
      [
        -1615.04052734375,
        -3779.949462890625,
        1226.25
      ],
      [
        -1614.498779296875,
        -3772.97900390625,
        1225.8216552734375
      ],
      [
        -1627.5496826171875,
        -3751.7841796875,
        1210.0
      ],
      [
        -1627.5496826171875,
        -3751.7841796875,
        1210.0
      ],
      [
        -1677.2822265625,
        -3815.87060546875,
        1313.4520263671875
      ],
      [
        -1672.9154052734375,
        -3812.967529296875,
        1316.9749755859375
      ],
      [
        -1672.9154052734375,
        -3812.967529296875,
        1316.9749755859375
      ],
      [
        -1669.0494384765625,
        -3816.64306640625,
        1277.3194580078125
      ],
      [
        -1671.73828125,
        -3814.17578125,
        1308.55029296875
      ],
      [
        -1678.67724609375,
        -3823.1904296875,
        1282.2269287109375
      ],
      [
        -1677.2822265625,
        -3815.87060546875,
        1313.4520263671875
      ],
      [
        -1676.63427734375,
        -3826.403564453125,
        1251.0999755859375
      ],
      [
        -1678.67724609375,
        -3823.1904296875,
        1282.2269287109375
      ],
      [
        -1678.3868408203125,
        -3823.60302734375,
        1279.60888671875
      ],
      [
        -1669.0494384765625,
        -3816.64306640625,
        1277.3194580078125
      ],
      [
        -1669.3094482421875,
        -3820.68115234375,
        1251.0999755859375
      ],
      [
        -1661.5487060546875,
        -3805.46923828125,
        1280.0687255859375
      ],
      [
        -1660.3514404296875,
        -3813.0078125,
        1251.0999755859375
      ],
      [
        -1661.451416015625,
        -3804.492431640625,
        1281.02197265625
      ],
      [
        -1661.5487060546875,
        -3805.46923828125,
        1280.0687255859375
      ],
      [
        -1661.7418212890625,
        -3804.12451171875,
        1251.0999755859375
      ],
      [
        -1659.9903564453125,
        -3789.814453125,
        1295.346435546875
      ],
      [
        -1654.096923828125,
        -3770.618408203125,
        1266.9339599609375
      ],
      [
        -1657.9615478515625,
        -3783.245361328125,
        1286.5020751953125
      ],
      [
        -1659.9903564453125,
        -3789.814453125,
        1295.346435546875
      ],
      [
        -1654.096923828125,
        -3770.618408203125,
        1266.9339599609375
      ],
      [
        -1652.44775390625,
        -3770.854736328125,
        1251.0999755859375
      ],
      [
        -1653.4718017578125,
        -3770.830810546875,
        1262.5123291015625
      ],
      [
        -1669.2208251953125,
        -3816.759765625,
        1290.5335693359375
      ],
      [
        -1669.91845703125,
        -3824.71435546875,
        1254.697509765625
      ],
      [
        -1675.224365234375,
        -3828.096923828125,
        1251.0999755859375
      ],
      [
        -1669.2208251953125,
        -3816.759765625,
        1290.5335693359375
      ],
      [
        -1669.91845703125,
        -3824.71435546875,
        1254.697509765625
      ],
      [
        -1673.6495361328125,
        -3827.319580078125,
        1251.0999755859375
      ],
      [
        -1665.238525390625,
        -3820.9501953125,
        1261.54833984375
      ],
      [
        -1668.5245361328125,
        -3824.79052734375,
        1251.0999755859375
      ],
      [
        -1665.238525390625,
        -3820.9501953125,
        1261.54833984375
      ],
      [
        -1661.660400390625,
        -3819.988525390625,
        1251.0999755859375
      ],
      [
        -1662.2646484375,
        -3820.50634765625,
        1256.7275390625
      ],
      [
        -1670.6912841796875,
        -3823.786376953125,
        1331.699951171875
      ],
      [
        -1674.8316650390625,
        -3826.60205078125,
        1331.699951171875
      ],
      [
        -1674.8316650390625,
        -3826.60205078125,
        1331.699951171875
      ],
      [
        -1678.0355224609375,
        -3822.75390625,
        1331.699951171875
      ],
      [
        -1669.7547607421875,
        -3817.122802734375,
        1331.699951171875
      ],
      [
        -1670.6912841796875,
        -3823.786376953125,
        1331.699951171875
      ],
      [
        -1678.0355224609375,
        -3822.75390625,
        1331.699951171875
      ],
      [
        -1677.09912109375,
        -3816.090576171875,
        1331.699951171875
      ],
      [
        -1672.9586181640625,
        -3813.27490234375,
        1331.699951171875
      ],
      [
        -1669.7547607421875,
        -3817.122802734375,
        1331.699951171875
      ],
      [
        -1677.09912109375,
        -3816.090576171875,
        1331.699951171875
      ],
      [
        -1672.9586181640625,
        -3813.27490234375,
        1331.699951171875
      ],
      [
        -1665.0736083984375,
        -3821.232421875,
        1264.615966796875
      ],
      [
        -1666.2939453125,
        -3822.18359375,
        1258.192626953125
      ],
      [
        -1665.0736083984375,
        -3821.232421875,
        1264.615966796875
      ],
      [
        -1664.334228515625,
        -3820.815185546875,
        1260.0823974609375
      ],
      [
        -1685.4661865234375,
        -3834.88916015625,
        1275.7928466796875
      ],
      [
        -1683.8331298828125,
        -3834.16015625,
        1255.5928955078125
      ],
      [
        -1683.494140625,
        -3834.014404296875,
        1251.0999755859375
      ],
      [
        -1683.8331298828125,
        -3834.16015625,
        1255.5928955078125
      ],
      [
        -1674.317138671875,
        -3848.75,
        1331.699951171875
      ],
      [
        -1671.760986328125,
        -3848.06396484375,
        1304.765380859375
      ],
      [
        -1666.7406005859375,
        -3847.08251953125,
        1251.0999755859375
      ],
      [
        -1671.760986328125,
        -3848.06396484375,
        1304.765380859375
      ],
      [
        -1667.274658203125,
        -3830.240234375,
        1292.0670166015625
      ],
      [
        -1665.668212890625,
        -3840.1826171875,
        1253.5570068359375
      ],
      [
        -1664.4189453125,
        -3822.352783203125,
        1276.7904052734375
      ],
      [
        -1667.274658203125,
        -3830.240234375,
        1292.0670166015625
      ],
      [
        -1664.4189453125,
        -3822.352783203125,
        1276.7904052734375
      ],
      [
        -1665.668212890625,
        -3840.1826171875,
        1253.5570068359375
      ],
      [
        -1665.4881591796875,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1656.278076171875,
        -3752.542236328125,
        1331.699951171875
      ],
      [
        -1654.1226806640625,
        -3770.8154296875,
        1269.766845703125
      ],
      [
        -1654.1226806640625,
        -3770.8154296875,
        1269.766845703125
      ],
      [
        -1638.1982421875,
        -3737.281494140625,
        1277.9498291015625
      ],
      [
        -1643.5369873046875,
        -3746.243896484375,
        1276.0009765625
      ],
      [
        -1638.1982421875,
        -3737.281494140625,
        1277.9498291015625
      ],
      [
        -1632.026123046875,
        -3734.29638671875,
        1251.0999755859375
      ],
      [
        -1643.5369873046875,
        -3746.243896484375,
        1276.0009765625
      ],
      [
        -1643.3519287109375,
        -3752.261474609375,
        1251.0999755859375
      ],
      [
        -1654.9044189453125,
        -3839.3310546875,
        1263.0328369140625
      ],
      [
        -1649.4595947265625,
        -3830.2060546875,
        1260.480712890625
      ],
      [
        -1654.9044189453125,
        -3839.3310546875,
        1263.0328369140625
      ],
      [
        -1660.5916748046875,
        -3840.4033203125,
        1251.0999755859375
      ],
      [
        -1649.4595947265625,
        -3830.2060546875,
        1260.480712890625
      ],
      [
        -1650.6207275390625,
        -3826.401611328125,
        1251.0999755859375
      ],
      [
        -1667.5399169921875,
        -3852.925537109375,
        1321.958740234375
      ],
      [
        -1670.849365234375,
        -3847.8857421875,
        1295.0205078125
      ],
      [
        -1666.364501953125,
        -3854.7607421875,
        1331.699951171875
      ],
      [
        -1667.5399169921875,
        -3852.925537109375,
        1321.958740234375
      ],
      [
        -1664.6136474609375,
        -3838.420166015625,
        1273.1697998046875
      ],
      [
        -1656.2314453125,
        -3837.126220703125,
        1287.565673828125
      ],
      [
        -1656.2314453125,
        -3837.126220703125,
        1287.565673828125
      ],
      [
        -1650.84228515625,
        -3830.22021484375,
        1273.562744140625
      ],
      [
        -1650.84228515625,
        -3830.22021484375,
        1273.562744140625
      ],
      [
        -1651.5426025390625,
        -3824.776611328125,
        1251.0999755859375
      ],
      [
        -1664.6136474609375,
        -3838.420166015625,
        1273.1697998046875
      ],
      [
        -1666.14697265625,
        -3837.2197265625,
        1265.033447265625
      ],
      [
        -1617.32470703125,
        -3794.1015625,
        1251.0999755859375
      ],
      [
        -1602.3179931640625,
        -3781.518798828125,
        1281.48974609375
      ],
      [
        -1603.4005126953125,
        -3787.103759765625,
        1282.5230712890625
      ],
      [
        -1606.039306640625,
        -3775.898681640625,
        1251.0999755859375
      ],
      [
        -1602.3179931640625,
        -3781.518798828125,
        1281.48974609375
      ],
      [
        -1603.6214599609375,
        -3779.6845703125,
        1276.83154296875
      ],
      [
        -1603.4005126953125,
        -3787.103759765625,
        1282.5230712890625
      ],
      [
        -1609.1153564453125,
        -3786.85595703125,
        1267.4744873046875
      ],
      [
        -1609.1153564453125,
        -3786.85595703125,
        1267.4744873046875
      ],
      [
        -1612.6331787109375,
        -3782.5546875,
        1251.0999755859375
      ],
      [
        -1611.85400390625,
        -3783.434326171875,
        1257.9847412109375
      ],
      [
        -1651.955078125,
        -3830.231689453125,
        1284.09130859375
      ],
      [
        -1652.60498046875,
        -3822.90380859375,
        1251.0999755859375
      ],
      [
        -1656.474609375,
        -3836.722412109375,
        1292.0601806640625
      ],
      [
        -1651.955078125,
        -3830.231689453125,
        1284.09130859375
      ],
      [
        -1656.474609375,
        -3836.722412109375,
        1292.0601806640625
      ],
      [
        -1660.1837158203125,
        -3837.736328125,
        1280.77783203125
      ],
      [
        -1603.734619140625,
        -3786.660400390625,
        1305.1856689453125
      ],
      [
        -1609.0635986328125,
        -3786.58447265625,
        1282.6422119140625
      ],
      [
        -1609.0635986328125,
        -3786.58447265625,
        1282.6422119140625
      ],
      [
        -1602.4581298828125,
        -3781.506103515625,
        1289.211181640625
      ],
      [
        -1603.734619140625,
        -3786.660400390625,
        1305.1856689453125
      ],
      [
        -1602.4581298828125,
        -3781.506103515625,
        1289.211181640625
      ],
      [
        -1588.548095703125,
        -3754.662353515625,
        1331.699951171875
      ],
      [
        -1594.2821044921875,
        -3744.888671875,
        1331.699951171875
      ],
      [
        -1588.548095703125,
        -3754.662353515625,
        1331.699951171875
      ],
      [
        -1600.635009765625,
        -3736.298095703125,
        1314.1124267578125
      ],
      [
        -1601.482421875,
        -3741.54736328125,
        1261.5196533203125
      ],
      [
        -1605.08642578125,
        -3733.510498046875,
        1276.3995361328125
      ],
      [
        -1600.635009765625,
        -3736.298095703125,
        1314.1124267578125
      ],
      [
        -1606.768310546875,
        -3733.863525390625,
        1251.0999755859375
      ],
      [
        -1605.08642578125,
        -3733.510498046875,
        1276.3995361328125
      ],
      [
        -1601.482421875,
        -3741.54736328125,
        1261.5196533203125
      ],
      [
        -1602.0355224609375,
        -3741.9306640625,
        1251.0999755859375
      ],
      [
        -1629.007568359375,
        -3720.443603515625,
        1331.699951171875
      ],
      [
        -1621.709716796875,
        -3721.2255859375,
        1331.699951171875
      ],
      [
        -1629.007568359375,
        -3720.443603515625,
        1331.699951171875
      ],
      [
        -1621.709716796875,
        -3721.2255859375,
        1331.699951171875
      ],
      [
        -1605.306884765625,
        -3726.33447265625,
        1331.699951171875
      ],
      [
        -1605.306884765625,
        -3726.33447265625,
        1331.699951171875
      ],
      [
        -1594.2821044921875,
        -3744.888671875,
        1331.699951171875
      ],
      [
        -1605.087646484375,
        -3733.513916015625,
        1276.6099853515625
      ],
      [
        -1600.6444091796875,
        -3736.302001953125,
        1314.541015625
      ],
      [
        -1600.6444091796875,
        -3736.302001953125,
        1314.541015625
      ],
      [
        -1600.9918212890625,
        -3738.50830078125,
        1291.9681396484375
      ],
      [
        -1606.0516357421875,
        -3733.713134765625,
        1261.8797607421875
      ],
      [
        -1605.087646484375,
        -3733.513916015625,
        1276.6099853515625
      ],
      [
        -1634.5731201171875,
        -3749.314453125,
        1331.699951171875
      ],
      [
        -1631.5533447265625,
        -3749.314453125,
        1331.699951171875
      ],
      [
        -1629.835205078125,
        -3746.285888671875,
        1331.699951171875
      ],
      [
        -1631.5533447265625,
        -3743.25732421875,
        1331.699951171875
      ],
      [
        -1631.5533447265625,
        -3749.314453125,
        1331.699951171875
      ],
      [
        -1629.835205078125,
        -3746.285888671875,
        1331.699951171875
      ],
      [
        -1636.291259765625,
        -3746.285888671875,
        1331.699951171875
      ],
      [
        -1634.5731201171875,
        -3749.314453125,
        1331.699951171875
      ],
      [
        -1631.5533447265625,
        -3743.25732421875,
        1331.699951171875
      ],
      [
        -1634.5731201171875,
        -3743.25732421875,
        1331.699951171875
      ],
      [
        -1634.5731201171875,
        -3743.25732421875,
        1331.699951171875
      ],
      [
        -1636.291259765625,
        -3746.285888671875,
        1331.699951171875
      ],
      [
        -1612.9793701171875,
        -3741.5380859375,
        1331.699951171875
      ],
      [
        -1611.38818359375,
        -3736.973876953125,
        1331.699951171875
      ],
      [
        -1608.5909423828125,
        -3743.56396484375,
        1331.699951171875
      ],
      [
        -1612.9793701171875,
        -3741.5380859375,
        1331.699951171875
      ],
      [
        -1602.61181640625,
        -3741.026123046875,
        1331.699951171875
      ],
      [
        -1608.5909423828125,
        -3743.56396484375,
        1331.699951171875
      ],
      [
        -1611.38818359375,
        -3736.973876953125,
        1331.699951171875
      ],
      [
        -1605.4090576171875,
        -3734.43603515625,
        1331.699951171875
      ],
      [
        -1601.0206298828125,
        -3736.4619140625,
        1331.699951171875
      ],
      [
        -1602.61181640625,
        -3741.026123046875,
        1331.699951171875
      ],
      [
        -1605.4090576171875,
        -3734.43603515625,
        1331.699951171875
      ],
      [
        -1601.0206298828125,
        -3736.4619140625,
        1331.699951171875
      ],
      [
        -1659.401123046875,
        -3809.16064453125,
        1331.699951171875
      ],
      [
        -1652.562744140625,
        -3794.97216796875,
        1331.699951171875
      ],
      [
        -1652.562744140625,
        -3794.97216796875,
        1331.699951171875
      ],
      [
        -1650.4403076171875,
        -3778.8974609375,
        1331.699951171875
      ],
      [
        -1650.4403076171875,
        -3778.8974609375,
        1331.699951171875
      ],
      [
        -1654.6849365234375,
        -3775.12451171875,
        1331.699951171875
      ],
      [
        -1660.81591796875,
        -3803.5009765625,
        1331.699951171875
      ],
      [
        -1659.401123046875,
        -3809.16064453125,
        1331.699951171875
      ],
      [
        -1654.6849365234375,
        -3775.12451171875,
        1331.699951171875
      ],
      [
        -1659.6370849609375,
        -3790.256103515625,
        1331.699951171875
      ],
      [
        -1659.6370849609375,
        -3790.256103515625,
        1331.699951171875
      ],
      [
        -1660.81591796875,
        -3803.5009765625,
        1331.699951171875
      ],
      [
        -1612.770751953125,
        -3780.564453125,
        1331.699951171875
      ],
      [
        -1611.87451171875,
        -3775.858154296875,
        1331.699951171875
      ],
      [
        -1611.87451171875,
        -3775.858154296875,
        1331.699951171875
      ],
      [
        -1607.103759765625,
        -3776.2939453125,
        1331.699951171875
      ],
      [
        -1608.896240234375,
        -3785.7060546875,
        1331.699951171875
      ],
      [
        -1612.770751953125,
        -3780.564453125,
        1331.699951171875
      ],
      [
        -1607.103759765625,
        -3776.2939453125,
        1331.699951171875
      ],
      [
        -1603.229248046875,
        -3781.435546875,
        1331.699951171875
      ],
      [
        -1604.12548828125,
        -3786.141845703125,
        1331.699951171875
      ],
      [
        -1608.896240234375,
        -3785.7060546875,
        1331.699951171875
      ],
      [
        -1603.229248046875,
        -3781.435546875,
        1331.699951171875
      ],
      [
        -1604.12548828125,
        -3786.141845703125,
        1331.699951171875
      ],
      [
        -1658.618896484375,
        -3827.40625,
        1331.699951171875
      ],
      [
        -1661.4666748046875,
        -3827.40625,
        1331.699951171875
      ],
      [
        -1656.98681640625,
        -3830.283203125,
        1331.699951171875
      ],
      [
        -1658.618896484375,
        -3827.40625,
        1331.699951171875
      ],
      [
        -1663.0987548828125,
        -3830.283203125,
        1331.699951171875
      ],
      [
        -1661.4666748046875,
        -3833.16015625,
        1331.699951171875
      ],
      [
        -1661.4666748046875,
        -3833.16015625,
        1331.699951171875
      ],
      [
        -1658.618896484375,
        -3833.16015625,
        1331.699951171875
      ],
      [
        -1661.4666748046875,
        -3827.40625,
        1331.699951171875
      ],
      [
        -1663.0987548828125,
        -3830.283203125,
        1331.699951171875
      ],
      [
        -1658.618896484375,
        -3833.16015625,
        1331.699951171875
      ],
      [
        -1656.98681640625,
        -3830.283203125,
        1331.699951171875
      ],
      [
        -1630.4552001953125,
        -3854.018798828125,
        1373.5
      ],
      [
        -1664.4462890625,
        -3856.39013671875,
        1373.5
      ],
      [
        -1618.614501953125,
        -3839.637451171875,
        1373.5
      ],
      [
        -1625.3450927734375,
        -3848.7509765625,
        1373.5
      ],
      [
        -1664.4462890625,
        -3856.39013671875,
        1373.5
      ],
      [
        -1665.1510009765625,
        -3856.43115234375,
        1373.5
      ],
      [
        -1665.1510009765625,
        -3856.43115234375,
        1373.5
      ],
      [
        -1665.21728515625,
        -3856.4267578125,
        1373.5
      ],
      [
        -1667.302734375,
        -3805.3125,
        1373.5
      ],
      [
        -1666.11181640625,
        -3790.59423828125,
        1373.5
      ],
      [
        -1667.302734375,
        -3805.3125,
        1373.5
      ],
      [
        -1677.7623291015625,
        -3810.47412109375,
        1373.5
      ],
      [
        -1665.6068115234375,
        -3762.815673828125,
        1373.5
      ],
      [
        -1666.11181640625,
        -3790.59423828125,
        1373.5
      ],
      [
        -1701.213134765625,
        -3819.89453125,
        1373.5
      ],
      [
        -1677.7623291015625,
        -3810.47412109375,
        1373.5
      ],
      [
        -1700.058349609375,
        -3821.476318359375,
        1373.5
      ],
      [
        -1701.213134765625,
        -3819.89453125,
        1373.5
      ],
      [
        -1665.6068115234375,
        -3762.815673828125,
        1373.5
      ],
      [
        -1663.6046142578125,
        -3759.604736328125,
        1373.5
      ],
      [
        -1688.4173583984375,
        -3837.422607421875,
        1373.5
      ],
      [
        -1686.849853515625,
        -3840.005126953125,
        1373.5
      ],
      [
        -1688.4173583984375,
        -3837.422607421875,
        1373.5
      ],
      [
        -1671.080078125,
        -3851.9990234375,
        1373.5
      ],
      [
        -1686.849853515625,
        -3840.005126953125,
        1373.5
      ],
      [
        -1670.822265625,
        -3852.0048828125,
        1362.5904541015625
      ],
      [
        -1674.708984375,
        -3825.7294921875,
        1373.5
      ],
      [
        -1677.493408203125,
        -3822.38525390625,
        1373.5
      ],
      [
        -1670.296875,
        -3817.491455078125,
        1373.5
      ],
      [
        -1671.11083984375,
        -3823.282470703125,
        1373.5
      ],
      [
        -1677.493408203125,
        -3822.38525390625,
        1373.5
      ],
      [
        -1676.6795654296875,
        -3816.594482421875,
        1373.5
      ],
      [
        -1676.6795654296875,
        -3816.594482421875,
        1373.5
      ],
      [
        -1673.081298828125,
        -3814.1474609375,
        1373.5
      ],
      [
        -1673.081298828125,
        -3814.1474609375,
        1373.5
      ],
      [
        -1670.296875,
        -3817.491455078125,
        1373.5
      ],
      [
        -1671.11083984375,
        -3823.282470703125,
        1373.5
      ],
      [
        -1674.708984375,
        -3825.7294921875,
        1373.5
      ],
      [
        -1670.822265625,
        -3852.0048828125,
        1362.5904541015625
      ],
      [
        -1670.0867919921875,
        -3851.947509765625,
        1331.699951171875
      ],
      [
        -1606.09130859375,
        -3822.85205078125,
        1373.5
      ],
      [
        -1584.191162109375,
        -3801.2880859375,
        1373.5
      ],
      [
        -1606.09130859375,
        -3822.85205078125,
        1373.5
      ],
      [
        -1606.83203125,
        -3823.68359375,
        1373.5
      ],
      [
        -1606.83203125,
        -3823.68359375,
        1373.5
      ],
      [
        -1583.3819580078125,
        -3800.40234375,
        1373.5
      ],
      [
        -1584.191162109375,
        -3801.2880859375,
        1373.5
      ],
      [
        -1583.3819580078125,
        -3800.40234375,
        1373.5
      ],
      [
        -1583.1156005859375,
        -3799.396728515625,
        1373.5
      ],
      [
        -1659.3966064453125,
        -3752.85595703125,
        1373.5
      ],
      [
        -1659.3966064453125,
        -3752.85595703125,
        1373.5
      ],
      [
        -1655.8121337890625,
        -3734.974853515625,
        1373.5
      ],
      [
        -1655.8121337890625,
        -3734.974853515625,
        1373.5
      ],
      [
        -1645.6759033203125,
        -3729.34326171875,
        1373.5
      ],
      [
        -1645.6759033203125,
        -3729.34326171875,
        1373.5
      ],
      [
        -1643.7506103515625,
        -3727.763916015625,
        1373.5
      ],
      [
        -1583.1156005859375,
        -3799.396728515625,
        1373.5
      ],
      [
        -1577.7047119140625,
        -3772.523193359375,
        1373.5
      ],
      [
        -1587.265380859375,
        -3756.696533203125,
        1331.699951171875
      ],
      [
        -1587.251220703125,
        -3751.540283203125,
        1373.5
      ],
      [
        -1587.2330322265625,
        -3751.5830078125,
        1373.5
      ],
      [
        -1587.26123046875,
        -3751.535400390625,
        1373.5
      ],
      [
        -1587.251220703125,
        -3751.540283203125,
        1373.5
      ],
      [
        -1579.398193359375,
        -3769.259765625,
        1337.1728515625
      ],
      [
        -1628.9420166015625,
        -3715.61572265625,
        1373.5
      ],
      [
        -1655.064453125,
        -3778.032958984375,
        1373.5
      ],
      [
        -1659.2308349609375,
        -3790.763916015625,
        1373.5
      ],
      [
        -1579.2955322265625,
        -3769.45751953125,
        1339.375244140625
      ],
      [
        -1651.4931640625,
        -3781.207275390625,
        1373.5
      ],
      [
        -1655.064453125,
        -3778.032958984375,
        1373.5
      ],
      [
        -1659.0323486328125,
        -3806.669189453125,
        1373.5
      ],
      [
        -1653.2789306640625,
        -3794.731689453125,
        1373.5
      ],
      [
        -1653.2789306640625,
        -3794.731689453125,
        1373.5
      ],
      [
        -1651.4931640625,
        -3781.207275390625,
        1373.5
      ],
      [
        -1659.2308349609375,
        -3790.763916015625,
        1373.5
      ],
      [
        -1660.2227783203125,
        -3801.907470703125,
        1373.5
      ],
      [
        -1660.2227783203125,
        -3801.907470703125,
        1373.5
      ],
      [
        -1659.0323486328125,
        -3806.669189453125,
        1373.5
      ],
      [
        -1662.8577880859375,
        -3835.4853515625,
        1373.5
      ],
      [
        -1665.8248291015625,
        -3830.25537109375,
        1373.5
      ],
      [
        -1665.8248291015625,
        -3830.25537109375,
        1373.5
      ],
      [
        -1662.8577880859375,
        -3825.025146484375,
        1373.5
      ],
      [
        -1662.8577880859375,
        -3825.025146484375,
        1373.5
      ],
      [
        -1657.2193603515625,
        -3825.025146484375,
        1373.5
      ],
      [
        -1657.2193603515625,
        -3825.025146484375,
        1373.5
      ],
      [
        -1654.2523193359375,
        -3830.25537109375,
        1373.5
      ],
      [
        -1654.2523193359375,
        -3830.25537109375,
        1373.5
      ],
      [
        -1657.2193603515625,
        -3835.4853515625,
        1373.5
      ],
      [
        -1657.2193603515625,
        -3835.4853515625,
        1373.5
      ],
      [
        -1662.8577880859375,
        -3835.4853515625,
        1373.5
      ],
      [
        -1660.0450439453125,
        -3833.04345703125,
        1332.997802734375
      ],
      [
        -1657.8099365234375,
        -3831.734130859375,
        1331.699951171875
      ],
      [
        -1659.8443603515625,
        -3833.16015625,
        1331.699951171875
      ],
      [
        -1657.810302734375,
        -3828.83154296875,
        1331.699951171875
      ],
      [
        -1659.8253173828125,
        -3827.40625,
        1331.699951171875
      ],
      [
        -1662.28759765625,
        -3828.853515625,
        1331.699951171875
      ],
      [
        -1665.353515625,
        -3856.3544921875,
        1373.5
      ],
      [
        -1665.353515625,
        -3856.3544921875,
        1373.5
      ],
      [
        -1665.2421875,
        -3856.425048828125,
        1373.5
      ],
      [
        -1665.2421875,
        -3856.425048828125,
        1373.5
      ],
      [
        -1595.6251220703125,
        -3737.464599609375,
        1373.4637451171875
      ],
      [
        -1604.0145263671875,
        -3723.365234375,
        1373.5
      ],
      [
        -1595.63427734375,
        -3737.468505859375,
        1373.5
      ],
      [
        -1605.681884765625,
        -3722.845947265625,
        1373.5
      ],
      [
        -1604.0145263671875,
        -3723.365234375,
        1373.5
      ],
      [
        -1605.677978515625,
        -3722.833251953125,
        1373.4637451171875
      ],
      [
        -1587.0594482421875,
        -3751.989013671875,
        1373.5
      ],
      [
        -1577.7047119140625,
        -3772.523193359375,
        1373.5
      ],
      [
        -1587.0594482421875,
        -3751.989013671875,
        1373.5
      ],
      [
        -1587.286865234375,
        -3751.5166015625,
        1373.5
      ],
      [
        -1587.2813720703125,
        -3751.525390625,
        1373.5
      ],
      [
        -1587.286865234375,
        -3751.5166015625,
        1373.5
      ],
      [
        -1587.2813720703125,
        -3751.525390625,
        1373.5
      ],
      [
        -1627.38720703125,
        -3746.319091796875,
        1373.5
      ],
      [
        -1630.28662109375,
        -3751.43017578125,
        1373.5
      ],
      [
        -1630.28662109375,
        -3751.43017578125,
        1373.5
      ],
      [
        -1635.789794921875,
        -3751.43017578125,
        1373.5
      ],
      [
        -1630.28662109375,
        -3741.208251953125,
        1373.5
      ],
      [
        -1627.38720703125,
        -3746.319091796875,
        1373.5
      ],
      [
        -1635.789794921875,
        -3741.208251953125,
        1373.5
      ],
      [
        -1630.28662109375,
        -3741.208251953125,
        1373.5
      ],
      [
        -1635.789794921875,
        -3751.43017578125,
        1373.5
      ],
      [
        -1638.6893310546875,
        -3746.319091796875,
        1373.5
      ],
      [
        -1638.6893310546875,
        -3746.319091796875,
        1373.5
      ],
      [
        -1635.789794921875,
        -3741.208251953125,
        1373.5
      ],
      [
        -1629.959716796875,
        -3741.872802734375,
        1373.0
      ],
      [
        -1630.673828125,
        -3742.275634765625,
        1363.5902099609375
      ],
      [
        -1636.0845947265625,
        -3741.81591796875,
        1373.0
      ],
      [
        -1635.32958984375,
        -3742.162841796875,
        1363.4627685546875
      ],
      [
        -1633.704833984375,
        -3746.1689453125,
        1363.5
      ],
      [
        -1634.0968017578125,
        -3745.85693359375,
        1373.5
      ],
      [
        -1634.4622802734375,
        -3745.888916015625,
        1373.5
      ],
      [
        -1633.2000732421875,
        -3747.365966796875,
        1373.5
      ],
      [
        -1633.4478759765625,
        -3746.8017578125,
        1363.5
      ],
      [
        -1633.602783203125,
        -3748.005615234375,
        1373.5
      ],
      [
        -1632.5020751953125,
        -3746.20947265625,
        1373.0
      ],
      [
        -1634.424560546875,
        -3745.903076171875,
        1373.0
      ],
      [
        -1632.185546875,
        -3745.70654296875,
        1373.0
      ],
      [
        -1632.0208740234375,
        -3745.692138671875,
        1373.0
      ],
      [
        -1629.959716796875,
        -3741.872802734375,
        1373.0
      ],
      [
        -1636.0845947265625,
        -3741.81591796875,
        1373.0
      ],
      [
        -1635.7642822265625,
        -3741.251220703125,
        1373.0
      ],
      [
        -1630.3123779296875,
        -3741.251220703125,
        1373.0
      ],
      [
        -1631.7421875,
        -3742.279296875,
        1361.0
      ],
      [
        -1630.673828125,
        -3742.275634765625,
        1363.5902099609375
      ],
      [
        -1630.8106689453125,
        -3742.078857421875,
        1363.339599609375
      ],
      [
        -1635.32958984375,
        -3742.162841796875,
        1363.4627685546875
      ],
      [
        -1634.3677978515625,
        -3742.279296875,
        1361.0
      ],
      [
        -1635.2711181640625,
        -3742.07666015625,
        1363.3660888671875
      ],
      [
        -1635.5985107421875,
        -3750.48193359375,
        1366.2606201171875
      ],
      [
        -1635.7618408203125,
        -3751.38232421875,
        1372.9520263671875
      ],
      [
        -1635.7589111328125,
        -3751.43017578125,
        1373.5
      ],
      [
        -1637.917724609375,
        -3746.434814453125,
        1366.4920654296875
      ],
      [
        -1638.65380859375,
        -3746.256591796875,
        1373.5
      ],
      [
        -1638.4658203125,
        -3746.3173828125,
        1371.271484375
      ],
      [
        -1635.5985107421875,
        -3750.48193359375,
        1366.2606201171875
      ],
      [
        -1636.7183837890625,
        -3748.2744140625,
        1364.9459228515625
      ],
      [
        -1637.4873046875,
        -3746.91455078125,
        1364.9202880859375
      ],
      [
        -1637.917724609375,
        -3746.434814453125,
        1366.4920654296875
      ],
      [
        -1636.7183837890625,
        -3748.2744140625,
        1364.9459228515625
      ],
      [
        -1637.4873046875,
        -3746.91455078125,
        1364.9202880859375
      ],
      [
        -1636.31396484375,
        -3741.251220703125,
        1373.0
      ],
      [
        -1635.388916015625,
        -3742.05029296875,
        1363.6746826171875
      ],
      [
        -1636.31396484375,
        -3741.251220703125,
        1373.0
      ],
      [
        -1635.388916015625,
        -3742.05029296875,
        1363.6746826171875
      ],
      [
        -1635.3902587890625,
        -3744.764892578125,
        1331.99169921875
      ],
      [
        -1638.721435546875,
        -3746.262451171875,
        1373.5
      ],
      [
        -1641.5377197265625,
        -3751.115966796875,
        1369.90087890625
      ],
      [
        -1645.3358154296875,
        -3748.22265625,
        1371.4952392578125
      ],
      [
        -1646.2557373046875,
        -3751.117431640625,
        1373.5
      ],
      [
        -1646.0711669921875,
        -3751.43017578125,
        1373.5
      ],
      [
        -1645.3358154296875,
        -3748.22265625,
        1371.4952392578125
      ],
      [
        -1644.3209228515625,
        -3746.753662109375,
        1373.5
      ],
      [
        -1644.9384765625,
        -3747.092041015625,
        1373.5
      ],
      [
        -1644.3209228515625,
        -3746.753662109375,
        1373.5
      ],
      [
        -1635.79541015625,
        -3750.83349609375,
        1366.66552734375
      ],
      [
        -1641.5377197265625,
        -3751.115966796875,
        1369.90087890625
      ],
      [
        -1635.79541015625,
        -3750.83349609375,
        1366.66552734375
      ],
      [
        -1635.4429931640625,
        -3747.781005859375,
        1331.699951171875
      ],
      [
        -1635.4425048828125,
        -3744.789794921875,
        1331.699951171875
      ],
      [
        -1636.4681396484375,
        -3730.40087890625,
        1373.0
      ],
      [
        -1635.393310546875,
        -3733.032958984375,
        1368.822509765625
      ],
      [
        -1635.393310546875,
        -3733.032958984375,
        1368.822509765625
      ],
      [
        -1631.4896240234375,
        -3741.1015625,
        1362.0958251953125
      ],
      [
        -1636.4681396484375,
        -3730.40087890625,
        1373.0
      ],
      [
        -1631.4896240234375,
        -3741.1015625,
        1362.0958251953125
      ],
      [
        -1633.3109130859375,
        -3743.25732421875,
        1331.699951171875
      ],
      [
        -1628.9107666015625,
        -3715.608154296875,
        1373.5
      ],
      [
        -1628.9019775390625,
        -3715.61328125,
        1373.5
      ],
      [
        -1628.9019775390625,
        -3715.61328125,
        1373.5
      ],
      [
        -1612.810791015625,
        -3720.62548828125,
        1373.5
      ],
      [
        -1612.8072509765625,
        -3720.61279296875,
        1373.4637451171875
      ],
      [
        -1630.714111328125,
        -3744.736572265625,
        1331.699951171875
      ],
      [
        -1628.9107666015625,
        -3715.608154296875,
        1373.5
      ],
      [
        -1628.9420166015625,
        -3715.61572265625,
        1373.5
      ],
      [
        -1639.119140625,
        -3756.767333984375,
        1373.5
      ],
      [
        -1645.038330078125,
        -3753.179931640625,
        1373.5
      ],
      [
        -1639.119140625,
        -3756.767333984375,
        1373.5
      ],
      [
        -1645.038330078125,
        -3753.179931640625,
        1373.5
      ],
      [
        -1633.3111572265625,
        -3749.314453125,
        1331.699951171875
      ],
      [
        -1647.7288818359375,
        -3748.62158203125,
        1373.5
      ],
      [
        -1647.7288818359375,
        -3748.62158203125,
        1373.5
      ],
      [
        -1653.9222412109375,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1647.8101806640625,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1672.2469482421875,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1647.8101806640625,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1672.2469482421875,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1621.1893310546875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1621.1893310546875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1644.865966796875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1644.865966796875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1701.6458740234375,
        -3763.621826171875,
        1408.7421875
      ],
      [
        -1701.5181884765625,
        -3763.7265625,
        1408.0091552734375
      ],
      [
        -1699.65673828125,
        -3777.522216796875,
        1412.5760498046875
      ],
      [
        -1699.4874267578125,
        -3777.424560546875,
        1414.902587890625
      ],
      [
        -1701.0306396484375,
        -3764.127197265625,
        1414.902587890625
      ],
      [
        -1701.141357421875,
        -3764.0361328125,
        1413.6126708984375
      ],
      [
        -1701.141357421875,
        -3764.0361328125,
        1413.6126708984375
      ],
      [
        -1701.6458740234375,
        -3763.621826171875,
        1408.7421875
      ],
      [
        -1701.5181884765625,
        -3763.7265625,
        1408.0091552734375
      ],
      [
        -1700.3623046875,
        -3764.67578125,
        1405.224365234375
      ],
      [
        -1698.52294921875,
        -3766.185791015625,
        1418.5858154296875
      ],
      [
        -1698.2247314453125,
        -3776.6953125,
        1418.5858154296875
      ],
      [
        -1690.88427734375,
        -3772.45751953125,
        1418.5858154296875
      ],
      [
        -1699.4202880859375,
        -3777.3857421875,
        1414.998291015625
      ],
      [
        -1698.9132080078125,
        -3765.865478515625,
        1417.46044921875
      ],
      [
        -1701.0306396484375,
        -3764.127197265625,
        1414.902587890625
      ],
      [
        -1699.4874267578125,
        -3777.424560546875,
        1414.902587890625
      ],
      [
        -1698.2247314453125,
        -3776.6953125,
        1418.5858154296875
      ],
      [
        -1698.52294921875,
        -3766.185791015625,
        1418.5858154296875
      ],
      [
        -1698.9132080078125,
        -3765.865478515625,
        1417.46044921875
      ],
      [
        -1699.4202880859375,
        -3777.3857421875,
        1414.998291015625
      ],
      [
        -1697.92919921875,
        -3776.52490234375,
        1404.5374755859375
      ],
      [
        -1693.30859375,
        -3770.467041015625,
        1405.224365234375
      ],
      [
        -1692.7010498046875,
        -3770.9658203125,
        1404.928466796875
      ],
      [
        -1691.5672607421875,
        -3772.851806640625,
        1404.091552734375
      ],
      [
        -1698.7843017578125,
        -3777.018798828125,
        1404.597412109375
      ],
      [
        -1697.92919921875,
        -3776.52490234375,
        1404.5374755859375
      ],
      [
        -1693.30859375,
        -3770.467041015625,
        1405.224365234375
      ],
      [
        -1700.3623046875,
        -3764.67578125,
        1405.224365234375
      ],
      [
        -1699.6534423828125,
        -3777.520263671875,
        1408.3341064453125
      ],
      [
        -1698.7843017578125,
        -3777.018798828125,
        1404.597412109375
      ],
      [
        -1699.6932373046875,
        -3777.54345703125,
        1408.5052490234375
      ],
      [
        -1699.6534423828125,
        -3777.520263671875,
        1408.3341064453125
      ],
      [
        -1699.65673828125,
        -3777.522216796875,
        1412.5760498046875
      ],
      [
        -1699.69091796875,
        -3777.5419921875,
        1408.756103515625
      ],
      [
        -1699.6932373046875,
        -3777.54345703125,
        1408.5052490234375
      ],
      [
        -1699.69091796875,
        -3777.5419921875,
        1408.756103515625
      ],
      [
        -1691.5672607421875,
        -3772.851806640625,
        1404.091552734375
      ],
      [
        -1692.7010498046875,
        -3770.9658203125,
        1404.928466796875
      ],
      [
        -1692.5087890625,
        -3771.123779296875,
        1405.1431884765625
      ],
      [
        -1691.3543701171875,
        -3772.72900390625,
        1404.9853515625
      ],
      [
        -1691.3543701171875,
        -3772.72900390625,
        1404.9853515625
      ],
      [
        -1692.5087890625,
        -3771.123779296875,
        1405.1431884765625
      ],
      [
        -1690.88427734375,
        -3772.45751953125,
        1406.9580078125
      ],
      [
        -1657.73828125,
        -3820.2060546875,
        1426.417724609375
      ],
      [
        -1666.414794921875,
        -3823.90966796875,
        1413.455322265625
      ],
      [
        -1668.5179443359375,
        -3830.227783203125,
        1399.33056640625
      ],
      [
        -1667.7969970703125,
        -3831.215576171875,
        1397.7823486328125
      ],
      [
        -1653.669921875,
        -3821.47021484375,
        1426.4158935546875
      ],
      [
        -1654.2425537109375,
        -3819.96044921875,
        1429.1146240234375
      ],
      [
        -1660.445068359375,
        -3837.360595703125,
        1394.5888671875
      ],
      [
        -1667.7969970703125,
        -3831.215576171875,
        1397.7823486328125
      ],
      [
        -1663.9801025390625,
        -3837.361083984375,
        1394.5946044921875
      ],
      [
        -1660.445068359375,
        -3837.360595703125,
        1394.5888671875
      ],
      [
        -1656.084228515625,
        -3837.37109375,
        1394.7066650390625
      ],
      [
        -1655.987060546875,
        -3837.21484375,
        1394.7890625
      ],
      [
        -1655.987060546875,
        -3837.21484375,
        1394.7890625
      ],
      [
        -1655.6619873046875,
        -3836.669189453125,
        1394.93896484375
      ],
      [
        -1655.5018310546875,
        -3836.400390625,
        1395.0128173828125
      ],
      [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      [
        -1650.5738525390625,
        -3830.217529296875,
        1408.6728515625
      ],
      [
        -1653.669921875,
        -3821.47021484375,
        1426.4158935546875
      ],
      [
        -1655.1014404296875,
        -3835.728515625,
        1395.1973876953125
      ],
      [
        -1666.414794921875,
        -3823.90966796875,
        1413.455322265625
      ],
      [
        -1657.73828125,
        -3820.2060546875,
        1426.417724609375
      ],
      [
        -1665.2738037109375,
        -3820.889404296875,
        1418.914794921875
      ],
      [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      [
        -1654.4971923828125,
        -3834.714599609375,
        1395.4759521484375
      ],
      [
        -1654.4971923828125,
        -3834.714599609375,
        1395.4759521484375
      ],
      [
        -1656.1591796875,
        -3825.224853515625,
        1382.5
      ],
      [
        -1663.87841796875,
        -3825.16064453125,
        1382.5
      ],
      [
        -1663.3365478515625,
        -3824.20556640625,
        1382.5
      ],
      [
        -1656.737548828125,
        -3824.20556640625,
        1382.5
      ],
      [
        -1663.87841796875,
        -3825.16064453125,
        1382.5
      ],
      [
        -1663.669677734375,
        -3825.0458984375,
        1381.130615234375
      ],
      [
        -1656.1591796875,
        -3825.224853515625,
        1382.5
      ],
      [
        -1656.375244140625,
        -3825.106689453125,
        1381.0843505859375
      ],
      [
        -1663.669677734375,
        -3825.0458984375,
        1381.130615234375
      ],
      [
        -1661.1710205078125,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1663.2723388671875,
        -3824.315673828125,
        1381.2913818359375
      ],
      [
        -1658.8289794921875,
        -3824.39990234375,
        1380.3665771484375
      ],
      [
        -1656.375244140625,
        -3825.106689453125,
        1381.0843505859375
      ],
      [
        -1656.8040771484375,
        -3824.318603515625,
        1381.2578125
      ],
      [
        -1661.1710205078125,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1658.8289794921875,
        -3824.39990234375,
        1380.3665771484375
      ],
      [
        -1654.6494140625,
        -3818.8876953125,
        1431.0323486328125
      ],
      [
        -1656.3336181640625,
        -3815.164794921875,
        1435.0999755859375
      ],
      [
        -1661.891357421875,
        -3811.935302734375,
        1435.0999755859375
      ],
      [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1658.8765869140625,
        -3820.435302734375,
        1382.5
      ],
      [
        -1658.8765869140625,
        -3820.435302734375,
        1382.5
      ],
      [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1661.7669677734375,
        -3821.549560546875,
        1381.9002685546875
      ],
      [
        -1658.254638671875,
        -3821.653076171875,
        1381.8447265625
      ],
      [
        -1661.7669677734375,
        -3821.549560546875,
        1381.9002685546875
      ],
      [
        -1658.254638671875,
        -3821.653076171875,
        1381.8447265625
      ],
      [
        -1654.6494140625,
        -3818.8876953125,
        1431.0323486328125
      ],
      [
        -1647.086181640625,
        -3825.972412109375,
        1419.053466796875
      ],
      [
        -1641.312744140625,
        -3818.736572265625,
        1435.0999755859375
      ],
      [
        -1647.086181640625,
        -3825.972412109375,
        1419.053466796875
      ],
      [
        -1668.718505859375,
        -3830.830322265625,
        1397.9833984375
      ],
      [
        -1671.6361083984375,
        -3836.5166015625,
        1395.0447998046875
      ],
      [
        -1671.2332763671875,
        -3837.362060546875,
        1394.6064453125
      ],
      [
        -1668.718505859375,
        -3830.830322265625,
        1397.9833984375
      ],
      [
        -1671.2332763671875,
        -3837.362060546875,
        1394.6064453125
      ],
      [
        -1671.6361083984375,
        -3836.5166015625,
        1395.0447998046875
      ],
      [
        -1672.0638427734375,
        -3837.358642578125,
        1394.568359375
      ],
      [
        -1687.5968017578125,
        -3833.40283203125,
        1397.1165771484375
      ],
      [
        -1683.834716796875,
        -3837.310546875,
        1394.02783203125
      ],
      [
        -1669.895751953125,
        -3833.124755859375,
        1396.7977294921875
      ],
      [
        -1683.834716796875,
        -3837.310546875,
        1394.02783203125
      ],
      [
        -1683.9503173828125,
        -3837.2958984375,
        1393.863037109375
      ],
      [
        -1687.2039794921875,
        -3836.76904296875,
        1387.9375
      ],
      [
        -1684.05712890625,
        -3837.2822265625,
        1393.7108154296875
      ],
      [
        -1687.027099609375,
        -3834.29638671875,
        1394.2098388671875
      ],
      [
        -1687.5968017578125,
        -3833.40283203125,
        1397.1165771484375
      ],
      [
        -1687.027099609375,
        -3834.29638671875,
        1394.2098388671875
      ],
      [
        -1684.05712890625,
        -3837.2822265625,
        1393.7108154296875
      ],
      [
        -1675.417724609375,
        -3785.156494140625,
        1394.9000244140625
      ],
      [
        -1667.51806640625,
        -3791.642333984375,
        1394.9000244140625
      ],
      [
        -1666.346923828125,
        -3792.60400390625,
        1376.56298828125
      ],
      [
        -1666.2789306640625,
        -3792.65966796875,
        1373.5
      ],
      [
        -1667.51806640625,
        -3791.642333984375,
        1394.9000244140625
      ],
      [
        -1666.346923828125,
        -3792.60400390625,
        1376.56298828125
      ],
      [
        -1656.2840576171875,
        -3800.865966796875,
        1375.93994140625
      ],
      [
        -1656.7459716796875,
        -3801.82421875,
        1375.93994140625
      ],
      [
        -1659.8717041015625,
        -3803.080078125,
        1375.93994140625
      ],
      [
        -1659.8436279296875,
        -3797.94384765625,
        1375.93994140625
      ],
      [
        -1659.8436279296875,
        -3797.94384765625,
        1375.93994140625
      ],
      [
        -1659.8681640625,
        -3797.92333984375,
        1373.5
      ],
      [
        -1659.8717041015625,
        -3803.080078125,
        1375.93994140625
      ],
      [
        -1659.8773193359375,
        -3803.289306640625,
        1373.5
      ],
      [
        -1656.7459716796875,
        -3801.82421875,
        1375.93994140625
      ],
      [
        -1656.2840576171875,
        -3800.865966796875,
        1375.93994140625
      ],
      [
        -1656.249267578125,
        -3800.894775390625,
        1373.5
      ],
      [
        -1656.8094482421875,
        -3802.056884765625,
        1373.5
      ],
      [
        -1689.7711181640625,
        -3836.350341796875,
        1383.227783203125
      ],
      [
        -1689.8316650390625,
        -3835.4853515625,
        1373.5
      ],
      [
        -1689.7711181640625,
        -3836.350341796875,
        1383.227783203125
      ],
      [
        -1687.162353515625,
        -3834.084228515625,
        1394.9000244140625
      ],
      [
        -1685.6220703125,
        -3801.26708984375,
        1423.5281982421875
      ],
      [
        -1671.1722412109375,
        -3809.075927734375,
        1432.5184326171875
      ],
      [
        -1690.6954345703125,
        -3800.177001953125,
        1419.8336181640625
      ],
      [
        -1685.6220703125,
        -3801.26708984375,
        1423.5281982421875
      ],
      [
        -1690.6954345703125,
        -3800.177001953125,
        1419.8336181640625
      ],
      [
        -1684.650146484375,
        -3777.576416015625,
        1399.427490234375
      ],
      [
        -1680.03515625,
        -3781.365478515625,
        1397.505615234375
      ],
      [
        -1675.417724609375,
        -3785.156494140625,
        1394.9000244140625
      ],
      [
        -1680.03515625,
        -3781.365478515625,
        1397.505615234375
      ],
      [
        -1703.0078125,
        -3795.861572265625,
        1397.9945068359375
      ],
      [
        -1707.9254150390625,
        -3799.530517578125,
        1397.1622314453125
      ],
      [
        -1703.0078125,
        -3795.861572265625,
        1397.9945068359375
      ],
      [
        -1684.650146484375,
        -3777.576416015625,
        1399.427490234375
      ],
      [
        -1684.3076171875,
        -3777.857421875,
        1400.501708984375
      ],
      [
        -1703.353759765625,
        -3796.694580078125,
        1399.73974609375
      ],
      [
        -1707.24755859375,
        -3799.81298828125,
        1399.7498779296875
      ],
      [
        -1703.353759765625,
        -3796.694580078125,
        1399.73974609375
      ],
      [
        -1684.2139892578125,
        -3777.934326171875,
        1400.7952880859375
      ],
      [
        -1687.8275146484375,
        -3790.623291015625,
        1413.0626220703125
      ],
      [
        -1695.3194580078125,
        -3792.689453125,
        1404.236328125
      ],
      [
        -1696.6925048828125,
        -3793.14208984375,
        1402.6817626953125
      ],
      [
        -1695.3194580078125,
        -3792.689453125,
        1404.236328125
      ],
      [
        -1687.363525390625,
        -3790.29345703125,
        1413.0263671875
      ],
      [
        -1687.3360595703125,
        -3790.275390625,
        1413.028076171875
      ],
      [
        -1687.363525390625,
        -3790.29345703125,
        1413.0263671875
      ],
      [
        -1687.8275146484375,
        -3790.623291015625,
        1413.0626220703125
      ],
      [
        -1689.1737060546875,
        -3773.86181640625,
        1418.1077880859375
      ],
      [
        -1690.210205078125,
        -3773.010986328125,
        1418.5858154296875
      ],
      [
        -1683.714111328125,
        -3787.8759765625,
        1413.2591552734375
      ],
      [
        -1674.9693603515625,
        -3785.5244140625,
        1423.8892822265625
      ],
      [
        -1678.212158203125,
        -3782.862060546875,
        1421.6585693359375
      ],
      [
        -1683.714111328125,
        -3787.8759765625,
        1413.2591552734375
      ],
      [
        -1678.212158203125,
        -3782.862060546875,
        1421.6585693359375
      ],
      [
        -1681.638916015625,
        -3780.04833984375,
        1414.6324462890625
      ],
      [
        -1692.59716796875,
        -3789.4130859375,
        1399.9686279296875
      ],
      [
        -1689.1737060546875,
        -3773.86181640625,
        1418.1077880859375
      ],
      [
        -1688.5196533203125,
        -3774.39892578125,
        1416.93017578125
      ],
      [
        -1681.9296875,
        -3779.8095703125,
        1409.6258544921875
      ],
      [
        -1682.5380859375,
        -3779.31005859375,
        1412.788818359375
      ],
      [
        -1682.705322265625,
        -3779.172607421875,
        1407.329345703125
      ],
      [
        -1682.82763671875,
        -3779.6953125,
        1406.908447265625
      ],
      [
        -1681.9296875,
        -3779.8095703125,
        1409.6258544921875
      ],
      [
        -1682.82763671875,
        -3779.6953125,
        1406.908447265625
      ],
      [
        -1682.705322265625,
        -3779.172607421875,
        1407.329345703125
      ],
      [
        -1682.8382568359375,
        -3779.0634765625,
        1406.7005615234375
      ],
      [
        -1682.5380859375,
        -3779.31005859375,
        1412.788818359375
      ],
      [
        -1689.650390625,
        -3773.470458984375,
        1408.3363037109375
      ],
      [
        -1683.835205078125,
        -3778.2451171875,
        1401.983154296875
      ],
      [
        -1683.835205078125,
        -3778.2451171875,
        1401.983154296875
      ],
      [
        -1682.50390625,
        -3783.3203125,
        1407.549072265625
      ],
      [
        -1689.650390625,
        -3773.470458984375,
        1408.3363037109375
      ],
      [
        -1689.29296875,
        -3773.76416015625,
        1409.2369384765625
      ],
      [
        -1689.29296875,
        -3773.76416015625,
        1409.2369384765625
      ],
      [
        -1688.201171875,
        -3774.66064453125,
        1411.987548828125
      ],
      [
        -1688.201171875,
        -3774.66064453125,
        1411.987548828125
      ],
      [
        -1688.5196533203125,
        -3774.39892578125,
        1416.93017578125
      ],
      [
        -1690.210205078125,
        -3773.010986328125,
        1418.5858154296875
      ],
      [
        -1671.451416015625,
        -3788.412841796875,
        1426.3092041015625
      ],
      [
        -1671.451416015625,
        -3788.412841796875,
        1426.3092041015625
      ],
      [
        -1680.1611328125,
        -3786.92041015625,
        1417.5782470703125
      ],
      [
        -1678.26025390625,
        -3788.32177734375,
        1418.9630126953125
      ],
      [
        -1682.6810302734375,
        -3787.59814453125,
        1414.5150146484375
      ],
      [
        -1664.9873046875,
        -3851.680419921875,
        1387.15478515625
      ],
      [
        -1665.1240234375,
        -3851.81005859375,
        1386.5465087890625
      ],
      [
        -1667.885986328125,
        -3854.443115234375,
        1374.34912109375
      ],
      [
        -1665.1240234375,
        -3851.81005859375,
        1386.5465087890625
      ],
      [
        -1667.885986328125,
        -3854.443115234375,
        1374.34912109375
      ],
      [
        -1667.894775390625,
        -3854.43408203125,
        1374.2144775390625
      ],
      [
        -1667.9417724609375,
        -3854.385986328125,
        1373.5
      ],
      [
        -1664.6602783203125,
        -3851.158935546875,
        1387.4530029296875
      ],
      [
        -1664.9873046875,
        -3851.680419921875,
        1387.15478515625
      ],
      [
        -1663.232666015625,
        -3848.860107421875,
        1388.640625
      ],
      [
        -1664.6602783203125,
        -3851.158935546875,
        1387.4530029296875
      ],
      [
        -1663.232666015625,
        -3848.860107421875,
        1388.640625
      ],
      [
        -1613.2054443359375,
        -3836.235595703125,
        1392.0999755859375
      ],
      [
        -1614.017578125,
        -3835.56884765625,
        1392.0999755859375
      ],
      [
        -1615.930419921875,
        -3833.998291015625,
        1392.0999755859375
      ],
      [
        -1619.673095703125,
        -3830.92578125,
        1393.380126953125
      ],
      [
        -1620.206787109375,
        -3830.487548828125,
        1394.706787109375
      ],
      [
        -1616.2037353515625,
        -3833.77392578125,
        1392.0999755859375
      ],
      [
        -1625.8046875,
        -3825.89111328125,
        1408.5247802734375
      ],
      [
        -1625.6134033203125,
        -3826.04833984375,
        1408.14453125
      ],
      [
        -1625.8046875,
        -3825.89111328125,
        1408.5247802734375
      ],
      [
        -1625.6134033203125,
        -3826.04833984375,
        1408.14453125
      ],
      [
        -1614.8157958984375,
        -3834.91357421875,
        1375.0999755859375
      ],
      [
        -1615.0087890625,
        -3834.755126953125,
        1373.5
      ],
      [
        -1614.8157958984375,
        -3834.91357421875,
        1375.0999755859375
      ],
      [
        -1613.2054443359375,
        -3836.235595703125,
        1375.0999755859375
      ],
      [
        -1619.157958984375,
        -3831.3486328125,
        1392.0999755859375
      ],
      [
        -1619.157958984375,
        -3831.3486328125,
        1392.0999755859375
      ],
      [
        -1636.03857421875,
        -3740.7919921875,
        1378.358154296875
      ],
      [
        -1644.460693359375,
        -3745.654541015625,
        1435.0999755859375
      ],
      [
        -1636.03857421875,
        -3740.7919921875,
        1378.358154296875
      ],
      [
        -1627.6182861328125,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1640.79296875,
        -3739.189453125,
        1435.0999755859375
      ],
      [
        -1628.6070556640625,
        -3736.501220703125,
        1435.0999755859375
      ],
      [
        -1627.754638671875,
        -3736.009033203125,
        1434.1812744140625
      ],
      [
        -1638.60302734375,
        -3736.501220703125,
        1428.4385986328125
      ],
      [
        -1627.6688232421875,
        -3722.95361328125,
        1395.89306640625
      ],
      [
        -1625.66552734375,
        -3734.802978515625,
        1432.015869140625
      ],
      [
        -1619.2430419921875,
        -3731.09521484375,
        1406.15380859375
      ],
      [
        -1625.5048828125,
        -3721.058349609375,
        1384.9844970703125
      ],
      [
        -1625.5048828125,
        -3721.058349609375,
        1384.9844970703125
      ],
      [
        -1619.2430419921875,
        -3731.09521484375,
        1406.1539306640625
      ],
      [
        -1605.2095947265625,
        -3722.992919921875,
        1373.5
      ],
      [
        -1622.4156494140625,
        -3717.633544921875,
        1373.5
      ],
      [
        -1634.8406982421875,
        -3731.8828125,
        1416.9940185546875
      ],
      [
        -1626.607177734375,
        -3735.3466796875,
        1432.944580078125
      ],
      [
        -1625.66552734375,
        -3734.802978515625,
        1432.015869140625
      ],
      [
        -1627.6688232421875,
        -3722.95361328125,
        1395.89306640625
      ],
      [
        -1626.607177734375,
        -3735.3466796875,
        1432.944580078125
      ],
      [
        -1634.8406982421875,
        -3731.8828125,
        1416.9940185546875
      ],
      [
        -1653.8135986328125,
        -3751.0546875,
        1435.0999755859375
      ],
      [
        -1656.3861083984375,
        -3752.539794921875,
        1432.2689208984375
      ],
      [
        -1689.9173583984375,
        -3771.89892578125,
        1418.5858154296875
      ],
      [
        -1690.087890625,
        -3771.99755859375,
        1418.5858154296875
      ],
      [
        -1690.88427734375,
        -3772.45751953125,
        1418.5858154296875
      ],
      [
        -1690.087890625,
        -3771.99755859375,
        1418.5858154296875
      ],
      [
        -1692.4361572265625,
        -3771.183349609375,
        1405.224365234375
      ],
      [
        -1690.1976318359375,
        -3754.1884765625,
        1414.330810546875
      ],
      [
        -1690.548828125,
        -3772.263916015625,
        1408.3658447265625
      ],
      [
        -1690.88427734375,
        -3772.45751953125,
        1406.9580078125
      ],
      [
        -1689.9173583984375,
        -3771.89892578125,
        1418.5858154296875
      ],
      [
        -1689.9459228515625,
        -3771.91552734375,
        1416.0355224609375
      ],
      [
        -1689.875732421875,
        -3771.875244140625,
        1413.2236328125
      ],
      [
        -1689.9459228515625,
        -3771.91552734375,
        1416.0355224609375
      ],
      [
        -1689.875732421875,
        -3771.875244140625,
        1413.2236328125
      ],
      [
        -1689.9022216796875,
        -3771.890625,
        1413.0133056640625
      ],
      [
        -1691.5166015625,
        -3757.159423828125,
        1411.5057373046875
      ],
      [
        -1690.34912109375,
        -3772.1484375,
        1409.47021484375
      ],
      [
        -1690.42041015625,
        -3772.189697265625,
        1408.9046630859375
      ],
      [
        -1690.34912109375,
        -3772.1484375,
        1409.47021484375
      ],
      [
        -1690.42041015625,
        -3772.189697265625,
        1408.9046630859375
      ],
      [
        -1691.4603271484375,
        -3771.5625,
        1407.244384765625
      ],
      [
        -1661.279052734375,
        -3755.36474609375,
        1425.216552734375
      ],
      [
        -1656.3861083984375,
        -3752.539794921875,
        1432.2689208984375
      ],
      [
        -1661.279052734375,
        -3755.36474609375,
        1425.216552734375
      ],
      [
        -1679.1383056640625,
        -3765.67578125,
        1403.0179443359375
      ],
      [
        -1681.4425048828125,
        -3767.006103515625,
        1397.6380615234375
      ],
      [
        -1679.1383056640625,
        -3765.67578125,
        1403.0179443359375
      ],
      [
        -1681.4425048828125,
        -3767.006103515625,
        1397.6380615234375
      ],
      [
        -1680.727294921875,
        -3766.59326171875,
        1397.184326171875
      ],
      [
        -1661.3983154296875,
        -3755.43359375,
        1379.1407470703125
      ],
      [
        -1666.090087890625,
        -3758.142578125,
        1394.9000244140625
      ],
      [
        -1671.8389892578125,
        -3761.461669921875,
        1394.9000244140625
      ],
      [
        -1666.090087890625,
        -3758.142578125,
        1394.9000244140625
      ],
      [
        -1677.1263427734375,
        -3764.514404296875,
        1394.9000244140625
      ],
      [
        -1671.8389892578125,
        -3761.461669921875,
        1394.9000244140625
      ],
      [
        -1661.3983154296875,
        -3755.43359375,
        1379.1407470703125
      ],
      [
        -1660.781982421875,
        -3755.077880859375,
        1373.5
      ],
      [
        -1677.1263427734375,
        -3764.514404296875,
        1394.9000244140625
      ],
      [
        -1589.939208984375,
        -3773.55615234375,
        1426.400390625
      ],
      [
        -1576.4552001953125,
        -3771.714111328125,
        1379.4097900390625
      ],
      [
        -1587.1962890625,
        -3751.668701171875,
        1373.5
      ],
      [
        -1582.1431884765625,
        -3774.64501953125,
        1403.5704345703125
      ],
      [
        -1589.939208984375,
        -3773.55615234375,
        1426.400390625
      ],
      [
        -1582.1431884765625,
        -3774.64501953125,
        1403.5704345703125
      ],
      [
        -1576.4552001953125,
        -3771.714111328125,
        1379.4097900390625
      ],
      [
        -1582.7984619140625,
        -3775.082275390625,
        1403.6888427734375
      ],
      [
        -1576.7177734375,
        -3771.927001953125,
        1378.446533203125
      ],
      [
        -1567.186767578125,
        -3786.192138671875,
        1375.0999755859375
      ],
      [
        -1569.5159912109375,
        -3784.54345703125,
        1379.3818359375
      ],
      [
        -1567.5155029296875,
        -3789.132568359375,
        1381.6868896484375
      ],
      [
        -1569.5159912109375,
        -3784.54345703125,
        1379.3818359375
      ],
      [
        -1567.186767578125,
        -3786.192138671875,
        1375.0999755859375
      ],
      [
        -1566.2464599609375,
        -3787.774658203125,
        1375.0999755859375
      ],
      [
        -1566.2464599609375,
        -3787.774658203125,
        1375.0999755859375
      ],
      [
        -1566.2281494140625,
        -3787.805419921875,
        1375.0999755859375
      ],
      [
        -1582.7984619140625,
        -3775.082275390625,
        1403.6888427734375
      ],
      [
        -1591.0924072265625,
        -3773.95361328125,
        1427.8759765625
      ],
      [
        -1576.7177734375,
        -3771.927001953125,
        1378.446533203125
      ],
      [
        -1591.0924072265625,
        -3773.95361328125,
        1427.8759765625
      ],
      [
        -1600.9296875,
        -3761.2294921875,
        1435.0999755859375
      ],
      [
        -1580.1939697265625,
        -3785.400634765625,
        1375.0999755859375
      ],
      [
        -1574.1424560546875,
        -3777.183837890625,
        1375.0999755859375
      ],
      [
        -1580.620849609375,
        -3787.006103515625,
        1373.5
      ],
      [
        -1580.1939697265625,
        -3785.400634765625,
        1375.0999755859375
      ],
      [
        -1617.546630859375,
        -3832.671630859375,
        1392.0999755859375
      ],
      [
        -1581.68896484375,
        -3774.506591796875,
        1399.0831298828125
      ],
      [
        -1591.969482421875,
        -3772.8193359375,
        1428.52001953125
      ],
      [
        -1570.9874267578125,
        -3782.3896484375,
        1378.6053466796875
      ],
      [
        -1569.11962890625,
        -3783.68896484375,
        1375.0999755859375
      ],
      [
        -1570.9874267578125,
        -3782.3896484375,
        1378.6053466796875
      ],
      [
        -1571.593994140625,
        -3781.501953125,
        1378.2852783203125
      ],
      [
        -1570.1541748046875,
        -3782.34912109375,
        1375.0999755859375
      ],
      [
        -1571.593994140625,
        -3781.501953125,
        1378.2852783203125
      ],
      [
        -1582.8519287109375,
        -3782.396484375,
        1385.4105224609375
      ],
      [
        -1574.7020263671875,
        -3776.95263671875,
        1376.6451416015625
      ],
      [
        -1582.8519287109375,
        -3782.396484375,
        1385.4105224609375
      ],
      [
        -1580.341064453125,
        -3773.80712890625,
        1393.487548828125
      ],
      [
        -1574.1424560546875,
        -3777.183837890625,
        1375.0999755859375
      ],
      [
        -1574.7020263671875,
        -3776.95263671875,
        1376.6451416015625
      ],
      [
        -1580.3524169921875,
        -3777.7392578125,
        1380.4752197265625
      ],
      [
        -1579.1495361328125,
        -3773.18896484375,
        1388.5413818359375
      ],
      [
        -1576.2464599609375,
        -3774.692138671875,
        1375.830078125
      ],
      [
        -1580.3524169921875,
        -3777.7392578125,
        1380.4752197265625
      ],
      [
        -1578.1160888671875,
        -3777.18359375,
        1375.0999755859375
      ],
      [
        -1576.037841796875,
        -3774.72900390625,
        1375.0999755859375
      ],
      [
        -1578.795654296875,
        -3783.501953125,
        1375.0999755859375
      ],
      [
        -1576.037841796875,
        -3774.72900390625,
        1375.0999755859375
      ],
      [
        -1576.2464599609375,
        -3774.692138671875,
        1375.830078125
      ],
      [
        -1578.971435546875,
        -3778.814453125,
        1373.5
      ],
      [
        -1578.671630859375,
        -3777.83984375,
        1375.0999755859375
      ],
      [
        -1578.671630859375,
        -3777.83984375,
        1375.0999755859375
      ],
      [
        -1635.751220703125,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1635.8616943359375,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1638.8297119140625,
        -3746.3203125,
        1374.9000244140625
      ],
      [
        -1638.77197265625,
        -3746.21826171875,
        1374.9000244140625
      ],
      [
        -1635.751220703125,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1635.7587890625,
        -3751.43017578125,
        1373.5
      ],
      [
        -1638.77197265625,
        -3746.21826171875,
        1374.9000244140625
      ],
      [
        -1638.65380859375,
        -3746.256591796875,
        1373.5
      ],
      [
        -1626.9901123046875,
        -3736.14453125,
        1435.0999755859375
      ],
      [
        -1627.142333984375,
        -3735.981201171875,
        1434.50537109375
      ],
      [
        -1627.7547607421875,
        -3736.009033203125,
        1434.1812744140625
      ],
      [
        -1638.882080078125,
        -3746.22802734375,
        1374.9000244140625
      ],
      [
        -1638.721435546875,
        -3746.262451171875,
        1373.5
      ],
      [
        -1638.882080078125,
        -3746.22802734375,
        1374.9000244140625
      ],
      [
        -1627.3397216796875,
        -3735.76953125,
        1433.7340087890625
      ],
      [
        -1635.809326171875,
        -3751.64453125,
        1374.9000244140625
      ],
      [
        -1635.775146484375,
        -3751.4560546875,
        1373.5
      ],
      [
        -1635.809326171875,
        -3751.64453125,
        1374.9000244140625
      ],
      [
        -1666.917724609375,
        -3758.620361328125,
        1394.9000244140625
      ],
      [
        -1669.7471923828125,
        -3775.42626953125,
        1433.8359375
      ],
      [
        -1669.7750244140625,
        -3776.171875,
        1434.0556640625
      ],
      [
        -1684.4656982421875,
        -3777.727783203125,
        1400.005859375
      ],
      [
        -1669.7374267578125,
        -3779.21923828125,
        1432.6209716796875
      ],
      [
        -1669.7750244140625,
        -3776.171875,
        1434.0556640625
      ],
      [
        -1669.7374267578125,
        -3779.21923828125,
        1432.6209716796875
      ],
      [
        -1669.62451171875,
        -3789.912841796875,
        1427.879150390625
      ],
      [
        -1682.0679931640625,
        -3779.696044921875,
        1410.344970703125
      ],
      [
        -1669.770751953125,
        -3776.05859375,
        1434.022216796875
      ],
      [
        -1652.933349609375,
        -3791.783935546875,
        1375.93994140625
      ],
      [
        -1657.51318359375,
        -3799.85693359375,
        1375.93994140625
      ],
      [
        -1652.933349609375,
        -3791.783935546875,
        1375.93994140625
      ],
      [
        -1652.8016357421875,
        -3791.1171875,
        1373.5
      ],
      [
        -1578.1160888671875,
        -3777.18359375,
        1375.0999755859375
      ],
      [
        -1600.651611328125,
        -3761.58935546875,
        1434.895751953125
      ],
      [
        -1600.7596435546875,
        -3761.82470703125,
        1435.0999755859375
      ],
      [
        -1578.281494140625,
        -3768.904052734375,
        1377.7083740234375
      ],
      [
        -1626.2281494140625,
        -3800.174072265625,
        1208.100830078125
      ],
      [
        -1657.20068359375,
        -3765.369140625,
        1194.825439453125
      ],
      [
        -1658.1766357421875,
        -3765.88232421875,
        1197.60400390625
      ],
      [
        -1604.256591796875,
        -3790.28955078125,
        1195.133056640625
      ],
      [
        -1606.2392578125,
        -3788.1171875,
        1195.03173828125
      ],
      [
        -1604.256591796875,
        -3790.28955078125,
        1195.133056640625
      ],
      [
        -1610.2799072265625,
        -3783.689697265625,
        1194.825439453125
      ],
      [
        -1623.7452392578125,
        -3802.846923828125,
        1208.8314208984375
      ],
      [
        -1626.2281494140625,
        -3800.174072265625,
        1208.100830078125
      ],
      [
        -1620.809814453125,
        -3757.37158203125,
        1196.8316650390625
      ],
      [
        -1608.33056640625,
        -3760.303466796875,
        1197.725830078125
      ],
      [
        -1637.38916015625,
        -3750.3837890625,
        1194.825439453125
      ],
      [
        -1631.6580810546875,
        -3753.201171875,
        1195.625244140625
      ],
      [
        -1631.6580810546875,
        -3753.201171875,
        1195.625244140625
      ],
      [
        -1629.7398681640625,
        -3754.2158203125,
        1195.9119873046875
      ],
      [
        -1627.1986083984375,
        -3755.56005859375,
        1196.291748046875
      ],
      [
        -1626.1422119140625,
        -3756.118896484375,
        1196.4495849609375
      ],
      [
        -1598.0902099609375,
        -3763.53173828125,
        1198.6773681640625
      ],
      [
        -1589.769287109375,
        -3768.708984375,
        1200.1260986328125
      ],
      [
        -1598.0902099609375,
        -3763.53173828125,
        1198.6773681640625
      ],
      [
        -1608.33056640625,
        -3760.303466796875,
        1197.725830078125
      ],
      [
        -1624.7322998046875,
        -3756.86474609375,
        1196.6602783203125
      ],
      [
        -1620.809814453125,
        -3757.37158203125,
        1196.8316650390625
      ],
      [
        -1624.7322998046875,
        -3756.86474609375,
        1196.6602783203125
      ],
      [
        -1608.448974609375,
        -3783.412353515625,
        1194.825439453125
      ],
      [
        -1659.3355712890625,
        -3745.931396484375,
        1197.0325927734375
      ],
      [
        -1660.2440185546875,
        -3745.907470703125,
        1197.0216064453125
      ],
      [
        -1659.3355712890625,
        -3745.931396484375,
        1197.0325927734375
      ],
      [
        -1638.196044921875,
        -3738.89990234375,
        1198.0911865234375
      ],
      [
        -1636.9486083984375,
        -3740.988525390625,
        1197.8892822265625
      ],
      [
        -1636.9486083984375,
        -3740.988525390625,
        1197.8892822265625
      ],
      [
        -1638.1475830078125,
        -3743.161865234375,
        1197.6416015625
      ],
      [
        -1640.656494140625,
        -3743.169677734375,
        1197.6033935546875
      ],
      [
        -1641.8673095703125,
        -3740.98974609375,
        1197.8155517578125
      ],
      [
        -1638.1475830078125,
        -3743.161865234375,
        1197.6416015625
      ],
      [
        -1640.656494140625,
        -3743.169677734375,
        1197.6033935546875
      ],
      [
        -1626.129638671875,
        -3756.125732421875,
        1196.451416015625
      ],
      [
        -1622.869384765625,
        -3749.0,
        1197.2530517578125
      ],
      [
        -1624.123046875,
        -3751.2177734375,
        1197.0
      ],
      [
        -1628.0042724609375,
        -3750.6689453125,
        1197.0
      ],
      [
        -1628.95263671875,
        -3749.0,
        1197.162109375
      ],
      [
        -1624.4124755859375,
        -3751.486328125,
        1197.4713134765625
      ],
      [
        -1627.408203125,
        -3751.532470703125,
        1197.2767333984375
      ],
      [
        -1623.0528564453125,
        -3749.0,
        1197.9222412109375
      ],
      [
        -1624.4124755859375,
        -3751.486328125,
        1197.4713134765625
      ],
      [
        -1627.408203125,
        -3751.532470703125,
        1197.2767333984375
      ],
      [
        -1628.83642578125,
        -3749.0,
        1197.5594482421875
      ],
      [
        -1624.56494140625,
        -3751.212890625,
        1198.6224365234375
      ],
      [
        -1627.2381591796875,
        -3751.2646484375,
        1198.4049072265625
      ],
      [
        -1627.2381591796875,
        -3751.2646484375,
        1198.4049072265625
      ],
      [
        -1628.6270751953125,
        -3749.0,
        1198.2755126953125
      ],
      [
        -1623.2694091796875,
        -3749.0,
        1198.7122802734375
      ],
      [
        -1624.56494140625,
        -3751.212890625,
        1198.6224365234375
      ],
      [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ],
      [
        -1641.8642578125,
        -3740.989501953125,
        1197.8297119140625
      ],
      [
        -1639.571533203125,
        -3743.166259765625,
        1197.619873046875
      ],
      [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.7442106604576111,
        0.49613767862319946,
        0.44721105694770813
      ],
      "plane_d": 2372.6650390625,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0013514285674318671,
        0.0008796846959739923,
        0.9999986886978149
      ],
      "plane_d": -1399.8336181640625,
      "bbox_min": [
        -1594.451416015625,
        -3684.19677734375,
        1405.20703125
      ],
      "bbox_max": [
        -1581.75537109375,
        -3671.487060546875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.458728551864624,
        0.6862748861312866,
        0.5644422173500061
      ],
      "plane_d": 1004.1687622070312,
      "bbox_min": [
        -1594.451416015625,
        -3684.19677734375,
        1405.20703125
      ],
      "bbox_max": [
        -1581.75537109375,
        -3671.487060546875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5186461210250854,
        -0.7730287909507751,
        0.3652845621109009
      ],
      "plane_d": -2529.633544921875,
      "bbox_min": [
        -1594.451416015625,
        -3684.19677734375,
        1405.2071533203125
      ],
      "bbox_max": [
        -1581.864990234375,
        -3671.487060546875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5561236143112183,
        0.830130398273468,
        0.04012603312730789
      ],
      "plane_d": 2117.672119140625,
      "bbox_min": [
        -1594.451416015625,
        -3684.19677734375,
        1408.21923828125
      ],
      "bbox_max": [
        -1581.864990234375,
        -3671.487060546875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.554098904132843,
        -0.8272572159767151,
        -0.09284301102161407
      ],
      "plane_d": -2027.090087890625,
      "bbox_min": [
        -1594.451416015625,
        -3684.19677734375,
        1408.727783203125
      ],
      "bbox_max": [
        -1584.5330810546875,
        -3671.487060546875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4447454512119293,
        -0.6655421257019043,
        -0.5993790030479431
      ],
      "plane_d": -890.1010131835938,
      "bbox_min": [
        -1594.1385498046875,
        -3684.19677734375,
        1414.8931884765625
      ],
      "bbox_max": [
        -1584.5330810546875,
        -3673.680908203125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4951295852661133,
        0.737628161907196,
        -0.45907652378082275
      ],
      "plane_d": 2580.200439453125,
      "bbox_min": [
        -1592.635986328125,
        -3684.19677734375,
        1415.0062255859375
      ],
      "bbox_max": [
        -1584.5330810546875,
        -3677.00146484375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0013583962572738528,
        -0.0008820578223094344,
        -0.9999986886978149
      ],
      "plane_d": 1413.1751708984375,
      "bbox_min": [
        -1592.635986328125,
        -3682.649169921875,
        1418.5792236328125
      ],
      "bbox_max": [
        -1587.0406494140625,
        -3677.00146484375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8442121148109436,
        -0.29547277092933655,
        0.4472155272960663
      ],
      "plane_d": -371.5745849609375,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -3882.708740234375,
      "bbox_min": [
        -1587.221435546875,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8105122447013855,
        0.3782438635826111,
        0.4472152590751648
      ],
      "plane_d": -487.19195556640625,
      "bbox_min": [
        -1587.221435546875,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 3181.4287109375,
      "bbox_min": [
        -1547.9188232421875,
        -3686.0,
        1398.0
      ],
      "bbox_max": [
        -1545.5,
        -3681.810302734375,
        1405.9273681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1940271109342575,
        0.8731305003166199,
        0.4472099840641022
      ],
      "plane_d": 2891.433349609375,
      "bbox_min": [
        -1587.221435546875,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        -0.4999951720237732,
        -0.0
      ],
      "plane_d": -3193.55322265625,
      "bbox_min": [
        -1559.5,
        -3692.062255859375,
        1398.0
      ],
      "bbox_max": [
        -1547.5792236328125,
        -3681.62353515625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 492.4111328125,
      "bbox_min": [
        -1559.5,
        -3692.062255859375,
        1398.0
      ],
      "bbox_max": [
        -1547.5792236328125,
        -3681.62353515625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1409.5,
      "bbox_min": [
        -1558.869384765625,
        -3692.062255859375,
        1409.5
      ],
      "bbox_max": [
        -1547.5792236328125,
        -3687.09228515625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8600113987922668,
        -0.24571897089481354,
        0.4472164213657379
      ],
      "plane_d": -2847.55224609375,
      "bbox_min": [
        -1587.221435546875,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688879013062
      ],
      "plane_d": 156.3623046875,
      "bbox_min": [
        -1527.1983642578125,
        -3651.79052734375,
        1419.5340576171875
      ],
      "bbox_max": [
        -1524.115966796875,
        -3643.20947265625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3478024899959564,
        -0.8306763172149658,
        -0.43475309014320374
      ],
      "plane_d": -2945.328369140625,
      "bbox_min": [
        -1527.1983642578125,
        -3651.79052734375,
        1419.5340576171875
      ],
      "bbox_max": [
        -1524.115966796875,
        -3643.20947265625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5694944858551025,
        0.4109984040260315,
        -0.7118681073188782
      ],
      "plane_d": 1640.42919921875,
      "bbox_min": [
        -1527.1983642578125,
        -3644.5,
        1419.5340576171875
      ],
      "bbox_max": [
        -1524.115966796875,
        -3643.20947265625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1526.8095703125,
        -3644.5,
        1419.5340576171875
      ],
      "bbox_max": [
        -1524.115966796875,
        -3643.20947265625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45067620277404785,
        -0.7725861668586731,
        0.4472152590751648
      ],
      "plane_d": -2733.0,
      "bbox_min": [
        -1587.221435546875,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1531.2822265625,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34055110812187195,
        0.8270576000213623,
        0.4472142457962036
      ],
      "plane_d": 1887.798828125,
      "bbox_min": [
        -1586.0,
        -3693.44384765625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1531.2822265625,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1409.5,
      "bbox_min": [
        -1559.5,
        -3689.601318359375,
        1398.0
      ],
      "bbox_max": [
        -1545.5,
        -3679.937744140625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 492.4111328125,
      "bbox_min": [
        -1559.5,
        -3687.09228515625,
        1398.0
      ],
      "bbox_max": [
        -1545.5,
        -3679.937744140625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 3181.4287109375,
      "bbox_min": [
        -1559.5,
        -3687.09228515625,
        1398.0
      ],
      "bbox_max": [
        -1545.5,
        -3679.937744140625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3679.937744140625,
      "bbox_min": [
        -1559.5,
        -3687.09228515625,
        1398.0
      ],
      "bbox_max": [
        -1549.0,
        -3679.937744140625,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        -0.4999951720237732,
        -0.0
      ],
      "plane_d": -3193.55322265625,
      "bbox_min": [
        -1559.5,
        -3687.09228515625,
        1407.64111328125
      ],
      "bbox_max": [
        -1558.869384765625,
        -3686.0,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5491238236427307,
        -0.7060163617134094,
        0.4472179412841797
      ],
      "plane_d": -4047.491943359375,
      "bbox_min": [
        -1586.0,
        -3686.68603515625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1531.2822265625,
        -3630.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35053980350494385,
        -0.12268891930580139,
        0.9284768104553223
      ],
      "plane_d": -1195.668701171875,
      "bbox_min": [
        -1586.0,
        -3686.68603515625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9994093775749207,
        0.034364283084869385
      ],
      "plane_d": 3616.8056640625,
      "bbox_min": [
        -1586.0,
        -3686.68603515625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705179691314697,
        0.4910424053668976,
        0.032797958701848984
      ],
      "plane_d": 3098.40283203125,
      "bbox_min": [
        -1585.89990234375,
        -3686.68603515625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1538.8702392578125,
        -3666.9921875,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        -1585.89990234375,
        -3686.68603515625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1540.97412109375,
        -3666.9921875,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8831459283828735,
        -0.4677746593952179,
        0.03521553799510002
      ],
      "plane_d": -3131.55078125,
      "bbox_min": [
        -1556.2525634765625,
        -3680.375244140625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1542.300048828125,
        -3666.9921875,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8830874562263489,
        -0.4680272340774536,
        0.033271145075559616
      ],
      "plane_d": -401.6993408203125,
      "bbox_min": [
        -1546.8284912109375,
        -3671.136962890625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1542.300048828125,
        -3666.9921875,
        1400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8705843687057495,
        0.4907929599285126,
        0.034716952592134476
      ],
      "plane_d": 405.5611572265625,
      "bbox_min": [
        -1546.8284912109375,
        -3671.136962890625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1543.4326171875,
        -3666.9921875,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993311166763306,
        0.03657103702425957
      ],
      "plane_d": -3719.785888671875,
      "bbox_min": [
        -1545.696533203125,
        -3671.136962890625,
        1397.4000244140625
      ],
      "bbox_max": [
        -1543.4326171875,
        -3671.041748046875,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3679.937744140625,
      "bbox_min": [
        -1556.2525634765625,
        -3680.375244140625,
        1399.38330078125
      ],
      "bbox_max": [
        -1555.190185546875,
        -3679.937744140625,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8830874562263489,
        -0.4680272340774536,
        0.033271145075559616
      ],
      "plane_d": -401.6993408203125,
      "bbox_min": [
        -1545.94140625,
        -3675.93701171875,
        1400.0
      ],
      "bbox_max": [
        -1540.97412109375,
        -3667.081787109375,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9993311166763306,
        0.03657103702425957
      ],
      "plane_d": -3719.785888671875,
      "bbox_min": [
        -1545.94140625,
        -3673.015380859375,
        1400.0
      ],
      "bbox_max": [
        -1542.4365234375,
        -3667.081787109375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33654674887657166,
        0.15705682337284088,
        0.9284769892692566
      ],
      "plane_d": -1243.675537109375,
      "bbox_min": [
        -1545.94140625,
        -3671.034423828125,
        1400.0
      ],
      "bbox_max": [
        -1542.4365234375,
        -3667.081787109375,
        1401.020263671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3365485966205597,
        0.1570587456226349,
        0.9284759759902954
      ],
      "plane_d": -1243.669921875,
      "bbox_min": [
        -1545.63916015625,
        -3673.015380859375,
        1400.203369140625
      ],
      "bbox_max": [
        -1543.497802734375,
        -3671.006103515625,
        1400.974853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3365485966205597,
        0.1570587456226349,
        0.9284759759902954
      ],
      "plane_d": -1243.669921875,
      "bbox_min": [
        -1544.5609130859375,
        -3675.93701171875,
        1400.9293212890625
      ],
      "bbox_max": [
        -1540.97412109375,
        -3669.00048828125,
        1402.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0805654525756836,
        0.36254945397377014,
        0.9284756183624268
      ],
      "plane_d": 159.22897338867188,
      "bbox_min": [
        -1585.89990234375,
        -3686.68603515625,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3667.08154296875,
        1409.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 492.4111328125,
      "bbox_min": [
        -1556.6397705078125,
        -3681.0458984375,
        1400.0
      ],
      "bbox_max": [
        -1554.734130859375,
        -3679.937744140625,
        1400.9453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3679.937744140625,
      "bbox_min": [
        -1556.0,
        -3679.937744140625,
        1400.0
      ],
      "bbox_max": [
        -1554.734130859375,
        -3679.937744140625,
        1400.4571533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14140865206718445,
        0.34341609477996826,
        0.9284766912460327
      ],
      "plane_d": -257.5202941894531,
      "bbox_min": [
        -1585.89990234375,
        -3686.68603515625,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3667.08154296875,
        1409.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3679.937744140625,
      "bbox_min": [
        -1557.0716552734375,
        -3681.7939453125,
        1400.3472900390625
      ],
      "bbox_max": [
        -1552.5640869140625,
        -3679.937744140625,
        1401.999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 492.4111328125,
      "bbox_min": [
        -1557.0716552734375,
        -3681.7939453125,
        1400.4571533203125
      ],
      "bbox_max": [
        -1556.0,
        -3679.937744140625,
        1401.999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3090151250362396,
        0.2060069441795349,
        0.9284777045249939
      ],
      "plane_d": -56.20025634765625,
      "bbox_min": [
        -1585.89990234375,
        -3686.68603515625,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3667.08154296875,
        1409.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1409.5,
      "bbox_min": [
        -1559.5,
        -3686.68603515625,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3670.479248046875,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": 492.4111328125,
      "bbox_min": [
        -1559.5,
        -3686.68603515625,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3670.479248046875,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        -0.4999951720237732,
        -0.0
      ],
      "plane_d": -3193.55322265625,
      "bbox_min": [
        -1559.5,
        -3686.68603515625,
        1407.9293212890625
      ],
      "bbox_max": [
        -1559.1038818359375,
        -3686.0,
        1409.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3365485966205597,
        0.1570587456226349,
        0.9284759759902954
      ],
      "plane_d": -1243.669921875,
      "bbox_min": [
        -1546.70654296875,
        -3676.0,
        1400.0
      ],
      "bbox_max": [
        -1542.970703125,
        -3670.479248046875,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3365485966205597,
        0.1570587456226349,
        0.9284759759902954
      ],
      "plane_d": -1243.669921875,
      "bbox_min": [
        -1543.486083984375,
        -3671.65869140625,
        1400.317138671875
      ],
      "bbox_max": [
        -1538.8702392578125,
        -3667.092529296875,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        -1586.0,
        -3667.150390625,
        1397.5
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3661.927490234375,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3657.072509765625,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8592151999473572,
        0.5116145610809326,
        -0.0
      ],
      "plane_d": 3210.650390625,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8592151999473572,
        0.5116145610809326,
        0.0
      ],
      "plane_d": 528.88916015625,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8592151999473572,
        -0.5116145610809326,
        0.0
      ],
      "plane_d": -533.8568115234375,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.5,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8592151999473572,
        -0.5116145610809326,
        -0.0
      ],
      "plane_d": -3215.617919921875,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1397.5
      ],
      "bbox_max": [
        -1562.032958984375,
        -3659.5,
        1400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.371390700340271,
        0.9284766912460327
      ],
      "plane_d": -2653.58642578125,
      "bbox_min": [
        -1586.0,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8592151999473572,
        0.5116145610809326,
        0.0
      ],
      "plane_d": 528.88916015625,
      "bbox_min": [
        -1586.0,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8592151999473572,
        0.5116145610809326,
        -0.0
      ],
      "plane_d": 3210.650390625,
      "bbox_min": [
        -1563.4783935546875,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3657.072509765625,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9974077939987183,
        0.07195654511451721
      ],
      "plane_d": 3545.774169921875,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8566052317619324,
        0.5100178122520447,
        0.0781608298420906
      ],
      "plane_d": 3090.14404296875,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8569893836975098,
        0.5102465748786926,
        0.07223283499479294
      ],
      "plane_d": 425.153564453125,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3657.072509765625,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1557.69677734375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1563.4783935546875,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3666.427490234375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.5,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8592151999473572,
        -0.5116145610809326,
        0.0
      ],
      "plane_d": -533.8568115234375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.5,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3661.927490234375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1400.0
      ],
      "bbox_max": [
        -1559.1422119140625,
        -3659.5,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8592151999473572,
        -0.5116145610809326,
        -0.0
      ],
      "plane_d": -3215.617919921875,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1400.0
      ],
      "bbox_max": [
        -1562.032958984375,
        -3659.5,
        1412.0577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6643638610839844,
        -0.7474093437194824
      ],
      "plane_d": -1379.079833984375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1409.9000244140625
      ],
      "bbox_max": [
        -1559.1422119140625,
        -3661.927490234375,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7446766495704651,
        -0.44341328740119934,
        -0.4988399147987366
      ],
      "plane_d": -2083.642333984375,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1409.9000244140625
      ],
      "bbox_max": [
        -1562.032958984375,
        -3661.927490234375,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8592151999473572,
        -0.5116145610809326,
        -0.0
      ],
      "plane_d": -3217.920166015625,
      "bbox_min": [
        -1563.4783935546875,
        -3666.427490234375,
        1413.9000244140625
      ],
      "bbox_max": [
        -1562.032958984375,
        -3664.0,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7446766495704651,
        -0.44341328740119934,
        -0.4988399147987366
      ],
      "plane_d": 240.62384033203125,
      "bbox_min": [
        -1561.8216552734375,
        -3666.427490234375,
        1409.9000244140625
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.5,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6643638610839844,
        -0.7474093437194824
      ],
      "plane_d": -1379.079833984375,
      "bbox_min": [
        -1561.8216552734375,
        -3666.427490234375,
        1409.9000244140625
      ],
      "bbox_max": [
        -1557.69677734375,
        -3661.927490234375,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8592151999473572,
        -0.5116145610809326,
        0.0
      ],
      "plane_d": -536.1590576171875,
      "bbox_min": [
        -1559.1422119140625,
        -3666.427490234375,
        1413.9000244140625
      ],
      "bbox_max": [
        -1557.69677734375,
        -3664.0,
        1415.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9969451427459717,
        0.0781053975224495
      ],
      "plane_d": -3761.260009765625,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1415.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8563885688781738,
        -0.5098888278007507,
        0.08131332695484161
      ],
      "plane_d": -647.0028076171875,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1415.0
      ],
      "bbox_max": [
        -1557.69677734375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8567898869514465,
        -0.5101277828216553,
        0.07536906749010086
      ],
      "plane_d": -3313.0322265625,
      "bbox_min": [
        -1563.4783935546875,
        -3661.927490234375,
        1415.0
      ],
      "bbox_max": [
        -1561.74365234375,
        -3659.478271484375,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3571014702320099,
        -0.10203209519386292,
        0.9284762144088745
      ],
      "plane_d": -2223.77099609375,
      "bbox_min": [
        -1550.7154541015625,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22801564633846283,
        -0.2931550443172455,
        0.9284766912460327
      ],
      "plane_d": -2722.0048828125,
      "bbox_min": [
        -1550.7154541015625,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3640.0,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.33654674887657166,
        0.15705682337284088,
        0.9284769892692566
      ],
      "plane_d": -1243.675537109375,
      "bbox_min": [
        -1544.3558349609375,
        -3667.150390625,
        1400.0
      ],
      "bbox_max": [
        -1536.0,
        -3660.577880859375,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18713343143463135,
        -0.320796936750412,
        0.9284774661064148
      ],
      "plane_d": -2176.188232421875,
      "bbox_min": [
        -1586.0,
        -3667.150146484375,
        1400.0
      ],
      "bbox_max": [
        -1565.6483154296875,
        -3640.0,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3090151250362396,
        0.2060069441795349,
        0.9284777045249939
      ],
      "plane_d": -56.20025634765625,
      "bbox_min": [
        -1586.0,
        -3667.150146484375,
        1400.0
      ],
      "bbox_max": [
        -1579.9364013671875,
        -3666.2998046875,
        1402.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1452.5,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1482.47265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2141607254743576,
        0.9637326002120972,
        -0.1592312604188919
      ],
      "plane_d": 4119.8173828125,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953179717063904,
        0.41782036423683167,
        -0.15437591075897217
      ],
      "plane_d": 383.8345947265625,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3755674362182617,
        0.9120978116989136,
        -0.1643979251384735
      ],
      "plane_d": 3017.0087890625,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36323586106300354,
        0.9189608097076416,
        -0.15352772176265717
      ],
      "plane_d": 3045.769287109375,
      "bbox_min": [
        -1559.5499267578125,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1535.587158203125,
        -3680.06298828125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2674824297428131,
        0.7839431166648865,
        -0.5602554678916931
      ],
      "plane_d": 3287.69482421875,
      "bbox_min": [
        -1559.5499267578125,
        -3688.221923828125,
        1452.0
      ],
      "bbox_max": [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.907103419303894,
        0.3801177740097046,
        -0.1807592213153839
      ],
      "plane_d": 265.3135986328125,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8214341998100281,
        0.5476227402687073,
        -0.15923310816287994
      ],
      "plane_d": 3547.22900390625,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8072386980056763,
        0.5735498666763306,
        -0.13930578529834747
      ],
      "plane_d": 3591.33203125,
      "bbox_min": [
        -1597.0849609375,
        -3683.202392578125,
        1422.0
      ],
      "bbox_max": [
        -1581.3045654296875,
        -3667.136962890625,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929183840751648,
        -0.34195446968078613,
        -0.1403013914823532
      ],
      "plane_d": 429.0682373046875,
      "bbox_min": [
        -1597.0849609375,
        -3668.400390625,
        1422.0
      ],
      "bbox_max": [
        -1592.0147705078125,
        -3667.136962890625,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20665335655212402,
        0.9644396305084229,
        -0.16477403044700623
      ],
      "plane_d": 4118.60546875,
      "bbox_min": [
        -1597.0849609375,
        -3693.44384765625,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.933002769947052,
        -0.32654935121536255,
        -0.15123286843299866
      ],
      "plane_d": 507.22393798828125,
      "bbox_min": [
        -1597.0849609375,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929183840751648,
        -0.34195446968078613,
        -0.1403013914823532
      ],
      "plane_d": 429.0682373046875,
      "bbox_min": [
        -1597.0849609375,
        -3668.400390625,
        1422.0
      ],
      "bbox_max": [
        -1583.340576171875,
        -3641.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.606919527053833,
        0.0,
        -0.7947633862495422
      ],
      "plane_d": 2110.969970703125,
      "bbox_min": [
        -1595.5146484375,
        -3653.5,
        1437.68701171875
      ],
      "bbox_max": [
        -1583.340576171875,
        -3641.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19517531991004944,
        0.9468811750411987,
        -0.2555828392505646
      ],
      "plane_d": 4129.76171875,
      "bbox_min": [
        -1595.5146484375,
        -3653.5,
        1437.68701171875
      ],
      "bbox_max": [
        -1583.340576171875,
        -3641.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1595.5146484375,
        -3653.5,
        1437.68701171875
      ],
      "bbox_max": [
        -1583.8565673828125,
        -3642.666259765625,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1595.5146484375,
        -3653.5,
        1437.68701171875
      ],
      "bbox_max": [
        -1583.8565673828125,
        -3642.666259765625,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19517533481121063,
        -0.9468811750411987,
        -0.2555828392505646
      ],
      "plane_d": -2777.736572265625,
      "bbox_min": [
        -1595.5146484375,
        -3653.5,
        1437.68701171875
      ],
      "bbox_max": [
        -1586.125244140625,
        -3650.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607325553894,
        -0.49491003155708313,
        0.854576826095581
      ],
      "plane_d": -2797.03369140625,
      "bbox_min": [
        -1594.8358154296875,
        -3652.333740234375,
        1450.17578125
      ],
      "bbox_max": [
        -1586.125244140625,
        -3650.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607325553894,
        -0.49491003155708313,
        0.854576826095581
      ],
      "plane_d": -2797.03369140625,
      "bbox_min": [
        -1587.97314453125,
        -3652.567626953125,
        1449.9329833984375
      ],
      "bbox_max": [
        -1586.8245849609375,
        -3652.07958984375,
        1450.2401123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1587.972900390625,
        -3643.576904296875,
        1448.7147216796875
      ],
      "bbox_max": [
        -1583.34130859375,
        -3641.505126953125,
        1450.239990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015088819898664951,
        -0.5000050067901611,
        -0.8658910393714905
      ],
      "plane_d": -596.235595703125,
      "bbox_min": [
        -1587.5576171875,
        -3653.5,
        1448.092041015625
      ],
      "bbox_max": [
        -1587.225830078125,
        -3652.315673828125,
        1448.78173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4776396155357361,
        -0.8602526187896729,
        -0.17839840054512024
      ],
      "plane_d": -2119.705322265625,
      "bbox_min": [
        -1587.221435546875,
        -3644.81884765625,
        1422.0
      ],
      "bbox_max": [
        -1570.7779541015625,
        -3637.413818359375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3216572105884552,
        0.47581154108047485,
        0.8186208009719849
      ],
      "plane_d": 1056.01171875,
      "bbox_min": [
        -1584.40673828125,
        -3644.371826171875,
        1447.3350830078125
      ],
      "bbox_max": [
        -1580.6146240234375,
        -3641.5,
        1450.506103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1814153492450714,
        0.4930191934108734,
        -0.8508939146995544
      ],
      "plane_d": 2740.78759765625,
      "bbox_min": [
        -1584.40673828125,
        -3644.371826171875,
        1447.3350830078125
      ],
      "bbox_max": [
        -1580.6146240234375,
        -3641.5,
        1450.506103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1584.0543212890625,
        -3644.371826171875,
        1448.7078857421875
      ],
      "bbox_max": [
        -1583.296630859375,
        -3641.5,
        1450.506103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01508882362395525,
        0.5000050663948059,
        -0.8658910393714905
      ],
      "plane_d": 3051.30126953125,
      "bbox_min": [
        -1584.40673828125,
        -3643.91015625,
        1447.3350830078125
      ],
      "bbox_max": [
        -1583.3204345703125,
        -3641.5,
        1448.708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19517531991004944,
        0.9468811750411987,
        -0.2555828392505646
      ],
      "plane_d": 4129.76171875,
      "bbox_min": [
        -1584.57568359375,
        -3644.23974609375,
        1447.004638671875
      ],
      "bbox_max": [
        -1584.4796142578125,
        -3644.203857421875,
        1447.167724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1532.9171142578125,
        -3647.6865234375,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.5,
        1433.0205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1532.9171142578125,
        -3647.6865234375,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.5,
        1433.0205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5694944858551025,
        0.4109984040260315,
        -0.7118681073188782
      ],
      "plane_d": 1640.42919921875,
      "bbox_min": [
        -1527.1639404296875,
        -3644.03125,
        1422.0
      ],
      "bbox_max": [
        -1526.8095703125,
        -3643.890380859375,
        1422.324462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1530.7928466796875,
        -3647.6865234375,
        1425.26611328125
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.5,
        1433.0205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1529.2276611328125,
        -3647.6865234375,
        1431.9981689453125
      ],
      "bbox_max": [
        -1524.115966796875,
        -3644.5,
        1433.0205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.922071099281311,
        -0.3580988049507141,
        -0.14679940044879913
      ],
      "plane_d": -2507.080078125,
      "bbox_min": [
        -1534.8753662109375,
        -3649.066162109375,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.11181640625,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1532.2056884765625,
        -3649.066162109375,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.84326171875,
        1433.2489013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1532.2056884765625,
        -3649.066162109375,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3641.947265625,
        1433.2489013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1532.2056884765625,
        -3644.5,
        1422.0
      ],
      "bbox_max": [
        -1526.860107421875,
        -3641.947265625,
        1433.2489013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5694944858551025,
        0.4109984040260315,
        -0.7118681073188782
      ],
      "plane_d": 1640.42919921875,
      "bbox_min": [
        -1528.55810546875,
        -3644.3642578125,
        1422.0
      ],
      "bbox_max": [
        -1526.860107421875,
        -3643.611572265625,
        1423.6007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1532.2056884765625,
        -3642.94873046875,
        1429.5980224609375
      ],
      "bbox_max": [
        -1530.7928466796875,
        -3641.947265625,
        1430.032958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1533.279052734375,
        -3642.427490234375,
        1428.2049560546875
      ],
      "bbox_max": [
        -1531.8753662109375,
        -3641.5,
        1430.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1533.279052734375,
        -3642.427490234375,
        1429.8388671875
      ],
      "bbox_max": [
        -1532.050048828125,
        -3641.5,
        1430.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.955927312374115,
        -0.27312368154525757,
        -0.10773324221372604
      ],
      "plane_d": -2305.07177734375,
      "bbox_min": [
        -1587.5286865234375,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1531.7418212890625,
        -3653.5,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2121475338935852,
        -0.8926181793212891,
        0.39777663350105286
      ],
      "plane_d": -3504.78076171875,
      "bbox_min": [
        -1531.7418212890625,
        -3653.5,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688879013062
      ],
      "plane_d": 156.3623046875,
      "bbox_min": [
        -1531.7418212890625,
        -3653.5,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3478024899959564,
        -0.8306763172149658,
        -0.43475309014320374
      ],
      "plane_d": -2945.328369140625,
      "bbox_min": [
        -1531.7418212890625,
        -3653.5,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17066393792629242,
        -0.49266570806503296,
        0.8533196449279785
      ],
      "plane_d": -2760.316650390625,
      "bbox_min": [
        -1531.7418212890625,
        -3651.571044921875,
        1422.0
      ],
      "bbox_max": [
        -1524.115966796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1531.7418212890625,
        -3644.5,
        1422.0
      ],
      "bbox_max": [
        -1527.100341796875,
        -3642.242919921875,
        1433.4969482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4193136692047119,
        -0.4539216458797455,
        -0.7862130999565125
      ],
      "plane_d": -1176.9224853515625,
      "bbox_min": [
        -1528.5758056640625,
        -3653.5,
        1425.26611328125
      ],
      "bbox_max": [
        -1524.115966796875,
        -3652.608154296875,
        1427.532958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.922071099281311,
        -0.3580988049507141,
        -0.14679940044879913
      ],
      "plane_d": -2507.080078125,
      "bbox_min": [
        -1587.5286865234375,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3630.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1532.0504150390625,
        -3646.273193359375,
        1426.1763916015625
      ],
      "bbox_max": [
        -1531.0916748046875,
        -3642.1279296875,
        1433.5355224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24007554352283478,
        0.8600791096687317,
        -0.45014166831970215
      ],
      "plane_d": 3407.646728515625,
      "bbox_min": [
        -1531.8753662109375,
        -3646.273193359375,
        1426.1763916015625
      ],
      "bbox_max": [
        -1531.0916748046875,
        -3642.1279296875,
        1433.5355224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1531.8031005859375,
        -3646.273193359375,
        1433.393310546875
      ],
      "bbox_max": [
        -1531.0916748046875,
        -3644.5,
        1433.5355224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1532.0504150390625,
        -3643.046630859375,
        1430.0028076171875
      ],
      "bbox_max": [
        -1531.659912109375,
        -3642.427001953125,
        1430.28369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805800914764404,
        -0.19611915946006775
      ],
      "plane_d": -3280.624267578125,
      "bbox_min": [
        -1587.5286865234375,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3630.0,
        1452.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1450.5,
      "bbox_min": [
        -1563.0,
        -3636.10009765625,
        1439.0
      ],
      "bbox_max": [
        -1553.5,
        -3632.5,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1553.5,
      "bbox_min": [
        -1563.0,
        -3636.10009765625,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3636.10009765625,
        1450.5
      ],
      "bbox_max": [
        -1563.0,
        -3635.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1556.5,
      "bbox_min": [
        -1562.0,
        -3635.7001953125,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3632.5,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        -1556.5,
        -3635.7001953125,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3632.5,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1439.0,
      "bbox_min": [
        -1556.5,
        -3633.400146484375,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3632.5,
        1439.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1562.0,
      "bbox_min": [
        -1562.0,
        -3635.7001953125,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3632.5,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.5,
      "bbox_min": [
        -1562.0,
        -3635.7001953125,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3632.5,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1439.0,
      "bbox_min": [
        -1562.0,
        -3633.400146484375,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3632.5,
        1439.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2121475338935852,
        -0.8926181793212891,
        0.39777663350105286
      ],
      "plane_d": -3504.78076171875,
      "bbox_min": [
        -1587.5286865234375,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2587370276451111,
        0.4829748868942261,
        0.8365347385406494
      ],
      "plane_d": 958.00244140625,
      "bbox_min": [
        -1587.5286865234375,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33284538984298706,
        0.0,
        0.942981481552124
      ],
      "plane_d": -840.8890380859375,
      "bbox_min": [
        -1587.5286865234375,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3641.5,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2587370276451111,
        -0.4829748570919037,
        0.8365346789360046
      ],
      "plane_d": -2565.29931640625,
      "bbox_min": [
        -1587.5286865234375,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3641.5,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37312474846839905,
        -0.49763721227645874,
        -0.7830293774604797
      ],
      "plane_d": -1269.9736328125,
      "bbox_min": [
        -1587.400634765625,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3641.5,
        1450.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37312474846839905,
        0.49763742089271545,
        -0.783029317855835
      ],
      "plane_d": 2360.29052734375,
      "bbox_min": [
        -1582.5361328125,
        -3650.5,
        1424.37646484375
      ],
      "bbox_max": [
        -1530.1689453125,
        -3641.5,
        1447.5836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3959674835205078,
        0.0,
        -0.9182645082473755
      ],
      "plane_d": 705.0869750976562,
      "bbox_min": [
        -1566.2061767578125,
        -3650.5,
        1426.8192138671875
      ],
      "bbox_max": [
        -1531.8189697265625,
        -3641.64404296875,
        1442.536376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1539.115966796875,
        -3644.5,
        1430.032958984375
      ],
      "bbox_max": [
        -1531.8189697265625,
        -3641.64404296875,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1539.115966796875,
        -3644.5,
        1430.032958984375
      ],
      "bbox_max": [
        -1531.849609375,
        -3641.64404296875,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38094601035118103,
        0.4622996151447296,
        -0.8007241487503052
      ],
      "plane_d": 2244.79443359375,
      "bbox_min": [
        -1582.5361328125,
        -3647.5,
        1424.37646484375
      ],
      "bbox_max": [
        -1530.1689453125,
        -3641.5,
        1447.5836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1539.115966796875,
        -3641.945068359375,
        1430.0953369140625
      ],
      "bbox_max": [
        -1532.6890869140625,
        -3641.5,
        1433.3492431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2506912350654602,
        0.0,
        -0.9680670499801636
      ],
      "plane_d": 1003.8377685546875,
      "bbox_min": [
        -1572.48681640625,
        -3647.5,
        1441.5247802734375
      ],
      "bbox_max": [
        -1562.2998046875,
        -3645.349853515625,
        1444.162841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18083670735359192,
        0.4972553253173828,
        -0.848548948764801
      ],
      "plane_d": 2753.749267578125,
      "bbox_min": [
        -1575.9456787109375,
        -3647.5,
        1424.37646484375
      ],
      "bbox_max": [
        -1530.1689453125,
        -3641.5,
        1445.3370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2506912350654602,
        0.0,
        -0.9680670499801636
      ],
      "plane_d": 1003.8377685546875,
      "bbox_min": [
        -1572.48681640625,
        -3646.162841796875,
        1441.5150146484375
      ],
      "bbox_max": [
        -1562.26220703125,
        -3645.349853515625,
        1444.162841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5694944858551025,
        0.4109984040260315,
        -0.7118681073188782
      ],
      "plane_d": 1640.42919921875,
      "bbox_min": [
        -1539.115966796875,
        -3647.5,
        1424.37646484375
      ],
      "bbox_max": [
        -1530.1689453125,
        -3641.5,
        1433.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688879013062
      ],
      "plane_d": 156.3623046875,
      "bbox_min": [
        -1539.115966796875,
        -3647.5,
        1424.37646484375
      ],
      "bbox_max": [
        -1530.1689453125,
        -3641.5,
        1433.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4193136692047119,
        0.4539216458797455,
        0.7862131595611572
      ],
      "plane_d": 1171.475341796875,
      "bbox_min": [
        -1539.115966796875,
        -3641.8115234375,
        1430.1126708984375
      ],
      "bbox_max": [
        -1532.8662109375,
        -3641.5,
        1433.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3809460699558258,
        -0.4622996151447296,
        -0.80072420835495
      ],
      "plane_d": -1127.680908203125,
      "bbox_min": [
        -1587.400634765625,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3643.17578125,
        1450.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1808367371559143,
        -0.4972553253173828,
        -0.848548948764801
      ],
      "plane_d": -873.7284545898438,
      "bbox_min": [
        -1587.400634765625,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3643.17578125,
        1450.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2506912350654602,
        0.0,
        -0.9680670499801636
      ],
      "plane_d": 1003.8377685546875,
      "bbox_min": [
        -1585.694091796875,
        -3650.5,
        1441.5150146484375
      ],
      "bbox_max": [
        -1562.26220703125,
        -3643.17578125,
        1450.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1585.220703125,
        -3647.838134765625,
        1450.508056640625
      ],
      "bbox_max": [
        -1583.6610107421875,
        -3647.20849609375,
        1450.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01508882362395525,
        0.5000050663948059,
        -0.8658910393714905
      ],
      "plane_d": 3051.30126953125,
      "bbox_min": [
        -1584.27685546875,
        -3644.5,
        1446.97607421875
      ],
      "bbox_max": [
        -1583.341796875,
        -3643.6259765625,
        1447.4805908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.606919527053833,
        0.0,
        -0.7947633862495422
      ],
      "plane_d": 2110.969970703125,
      "bbox_min": [
        -1585.694091796875,
        -3650.5,
        1445.1864013671875
      ],
      "bbox_max": [
        -1583.3505859375,
        -3644.112548828125,
        1447.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19517531991004944,
        0.9468811750411987,
        -0.2555828392505646
      ],
      "plane_d": 4129.76171875,
      "bbox_min": [
        -1584.85791015625,
        -3644.5,
        1445.8250732421875
      ],
      "bbox_max": [
        -1583.3505859375,
        -3644.112548828125,
        1447.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01508882362395525,
        0.5000050663948059,
        -0.8658910393714905
      ],
      "plane_d": 3051.30126953125,
      "bbox_min": [
        -1584.4796142578125,
        -3644.5,
        1446.97607421875
      ],
      "bbox_max": [
        -1583.3505859375,
        -3644.112548828125,
        1447.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1814153492450714,
        -0.4930192232131958,
        -0.8508938550949097
      ],
      "plane_d": -855.7877197265625,
      "bbox_min": [
        -1587.400634765625,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3645.94580078125,
        1448.48974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3478024899959564,
        -0.8306763172149658,
        -0.43475309014320374
      ],
      "plane_d": -2945.328369140625,
      "bbox_min": [
        -1539.115966796875,
        -3653.5,
        1423.232421875
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3650.5,
        1433.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4193136692047119,
        -0.4539216458797455,
        -0.7862130999565125
      ],
      "plane_d": -1176.9224853515625,
      "bbox_min": [
        -1539.115966796875,
        -3653.5,
        1427.129638671875
      ],
      "bbox_max": [
        -1528.3663330078125,
        -3650.5,
        1433.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.606919527053833,
        0.0,
        -0.7947633862495422
      ],
      "plane_d": 2110.969970703125,
      "bbox_min": [
        -1587.400634765625,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1558.3485107421875,
        -3646.59375,
        1448.48974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19517533481121063,
        -0.9468811750411987,
        -0.2555828392505646
      ],
      "plane_d": -2777.736572265625,
      "bbox_min": [
        -1587.400634765625,
        -3652.9990234375,
        1443.994873046875
      ],
      "bbox_max": [
        -1583.3358154296875,
        -3650.5,
        1448.48974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015088819898664951,
        -0.5000050067901611,
        -0.8658910393714905
      ],
      "plane_d": -596.235595703125,
      "bbox_min": [
        -1587.400634765625,
        -3652.9990234375,
        1446.97607421875
      ],
      "bbox_max": [
        -1583.3358154296875,
        -3650.5,
        1448.48974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9974077939987183,
        0.07195654511451721
      ],
      "plane_d": 3545.774169921875,
      "bbox_min": [
        -1562.87548828125,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1558.3485107421875,
        -3657.577392578125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8563885688781738,
        -0.5098888278007507,
        0.08131332695484161
      ],
      "plane_d": -647.0028076171875,
      "bbox_min": [
        -1562.87548828125,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1558.3485107421875,
        -3657.577392578125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8566052317619324,
        0.5100178122520447,
        0.0781608298420906
      ],
      "plane_d": 3090.14404296875,
      "bbox_min": [
        -1562.87548828125,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1558.3485107421875,
        -3657.577392578125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8567898869514465,
        -0.5101277828216553,
        0.07536906749010086
      ],
      "plane_d": -3313.0322265625,
      "bbox_min": [
        -1562.87548828125,
        -3661.379150390625,
        1422.0
      ],
      "bbox_max": [
        -1558.6278076171875,
        -3657.577392578125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8569893836975098,
        0.5102465748786926,
        0.07223283499479294
      ],
      "plane_d": 425.153564453125,
      "bbox_min": [
        -1562.87548828125,
        -3661.14404296875,
        1422.0
      ],
      "bbox_max": [
        -1558.6278076171875,
        -3657.577392578125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1425.0,
      "bbox_min": [
        -1562.6170654296875,
        -3661.14404296875,
        1425.0
      ],
      "bbox_max": [
        -1558.6278076171875,
        -3657.7939453125,
        1425.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25565317273139954,
        -0.4998825788497925,
        0.8275015950202942
      ],
      "plane_d": -2618.8046875,
      "bbox_min": [
        -1587.5286865234375,
        -3653.5,
        1432.720703125
      ],
      "bbox_max": [
        -1532.6636962890625,
        -3647.500244140625,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1585.25390625,
        -3647.935791015625,
        1450.4617919921875
      ],
      "bbox_max": [
        -1583.409912109375,
        -3647.500244140625,
        1450.8013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3216572105884552,
        -0.47581154108047485,
        0.8186208605766296
      ],
      "plane_d": -2415.03369140625,
      "bbox_min": [
        -1587.5286865234375,
        -3653.5,
        1432.720703125
      ],
      "bbox_max": [
        -1532.6636962890625,
        -3647.5546875,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1814153492450714,
        -0.4930192232131958,
        -0.8508938550949097
      ],
      "plane_d": -855.7877197265625,
      "bbox_min": [
        -1587.5286865234375,
        -3653.5,
        1442.251953125
      ],
      "bbox_max": [
        -1562.0084228515625,
        -3647.5546875,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010915984399616718,
        -0.7794032692909241,
        0.6264276504516602
      ],
      "plane_d": -3737.777099609375,
      "bbox_min": [
        -1587.2939453125,
        -3653.5,
        1448.7078857421875
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3647.5546875,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1586.125244140625,
        -3650.5,
        1450.439697265625
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3647.5546875,
        1450.9617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015088819898664951,
        -0.5000050067901611,
        -0.8658910393714905
      ],
      "plane_d": -596.235595703125,
      "bbox_min": [
        -1587.5286865234375,
        -3653.5,
        1447.82568359375
      ],
      "bbox_max": [
        -1583.3204345703125,
        -3651.9716796875,
        1449.3079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010915984399616718,
        -0.7794032692909241,
        0.6264276504516602
      ],
      "plane_d": -3737.777099609375,
      "bbox_min": [
        -1587.5286865234375,
        -3653.5,
        1448.7078857421875
      ],
      "bbox_max": [
        -1583.3204345703125,
        -3653.073486328125,
        1449.3079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.317152738571167,
        -0.49971896409988403,
        0.8060365915298462
      ],
      "plane_d": -2491.186767578125,
      "bbox_min": [
        -1583.2901611328125,
        -3653.5,
        1432.720703125
      ],
      "bbox_max": [
        -1532.6636962890625,
        -3648.85009765625,
        1450.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1539.115966796875,
        -3652.20947265625,
        1432.4224853515625
      ],
      "bbox_max": [
        -1529.4716796875,
        -3644.00244140625,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17066393792629242,
        -0.49266570806503296,
        0.8533196449279785
      ],
      "plane_d": -2760.316650390625,
      "bbox_min": [
        -1539.115966796875,
        -3652.20947265625,
        1432.4224853515625
      ],
      "bbox_max": [
        -1529.4716796875,
        -3644.00244140625,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1539.115966796875,
        -3644.5,
        1432.4224853515625
      ],
      "bbox_max": [
        -1531.818359375,
        -3644.00244140625,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2556532323360443,
        0.49988216161727905,
        0.8275017142295837
      ],
      "plane_d": 1027.837158203125,
      "bbox_min": [
        -1585.0067138671875,
        -3647.58056640625,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2020263671875,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33284538984298706,
        0.0,
        0.942981481552124
      ],
      "plane_d": -840.8890380859375,
      "bbox_min": [
        -1585.0067138671875,
        -3647.58056640625,
        1433.4154052734375
      ],
      "bbox_max": [
        -1531.2020263671875,
        -3644.5,
        1450.755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3269585967063904,
        0.0,
        0.9450386762619019
      ],
      "plane_d": -853.0512084960938,
      "bbox_min": [
        -1585.0067138671875,
        -3647.58056640625,
        1442.989013671875
      ],
      "bbox_max": [
        -1561.7547607421875,
        -3646.14990234375,
        1450.755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1585.0067138671875,
        -3647.58056640625,
        1450.439697265625
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3647.121826171875,
        1450.755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1539.115966796875,
        -3645.998046875,
        1433.4154052734375
      ],
      "bbox_max": [
        -1531.2020263671875,
        -3644.5,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3171527683734894,
        0.49971896409988403,
        0.8060365915298462
      ],
      "plane_d": 1154.26318359375,
      "bbox_min": [
        -1584.977294921875,
        -3647.47021484375,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3269585967063904,
        0.0,
        0.9450386762619019
      ],
      "plane_d": -853.0512084960938,
      "bbox_min": [
        -1584.977294921875,
        -3647.47021484375,
        1442.251953125
      ],
      "bbox_max": [
        -1561.7547607421875,
        -3642.0244140625,
        1450.75048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1584.977294921875,
        -3647.47021484375,
        1450.3050537109375
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3644.252197265625,
        1450.75048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1583.683837890625,
        -3644.5,
        1450.3050537109375
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3644.252197265625,
        1450.51220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3216572105884552,
        0.47581154108047485,
        0.8186208009719849
      ],
      "plane_d": 1056.01171875,
      "bbox_min": [
        -1583.338134765625,
        -3645.921875,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1814153492450714,
        0.4930191934108734,
        -0.8508939146995544
      ],
      "plane_d": 2740.78759765625,
      "bbox_min": [
        -1583.338134765625,
        -3644.800048828125,
        1442.251953125
      ],
      "bbox_max": [
        -1562.0084228515625,
        -3641.958740234375,
        1450.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1583.338134765625,
        -3644.5,
        1450.2779541015625
      ],
      "bbox_max": [
        -1583.2901611328125,
        -3644.219970703125,
        1450.439697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1450.5,
      "bbox_min": [
        -1563.0,
        -3645.921875,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3633.400146484375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721364974975586,
        -0.8944272994995117
      ],
      "plane_d": -330.4908447265625,
      "bbox_min": [
        -1563.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.7001953125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3642.0,
      "bbox_min": [
        -1563.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.7001953125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1553.5,
      "bbox_min": [
        -1563.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.7001953125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.7001953125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3640.0,
      "bbox_min": [
        -1563.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1553.5,
        -3640.0,
        1452.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1561.0,
      "bbox_min": [
        -1561.0,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1555.5,
        -3640.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1555.5,
      "bbox_min": [
        -1555.5,
        -3642.0,
        1450.5
      ],
      "bbox_max": [
        -1555.5,
        -3640.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1556.5,
      "bbox_min": [
        -1562.0,
        -3645.921875,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        -1556.5,
        -3645.921875,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3639.0,
      "bbox_min": [
        -1556.5,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1439.0,
      "bbox_min": [
        -1556.5,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3633.400146484375,
        1441.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1554.2208251953125,
      "bbox_min": [
        -1556.5,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1555.0,
        -3637.0,
        1441.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        0.980580747127533
      ],
      "plane_d": -1105.2861328125,
      "bbox_min": [
        -1539.115966796875,
        -3645.921875,
        1432.46484375
      ],
      "bbox_max": [
        -1531.2325439453125,
        -3644.021484375,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0811399444937706,
        0.9103977084159851,
        0.4056997299194336
      ],
      "plane_d": 2860.64990234375,
      "bbox_min": [
        -1539.115966796875,
        -3644.5,
        1432.46484375
      ],
      "bbox_max": [
        -1531.8031005859375,
        -3644.021484375,
        1434.9981689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1562.0,
      "bbox_min": [
        -1562.0,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.5,
      "bbox_min": [
        -1562.0,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3639.0,
      "bbox_min": [
        -1562.0,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3633.400146484375,
        1450.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1439.0,
      "bbox_min": [
        -1562.0,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3633.400146484375,
        1441.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1554.220947265625,
      "bbox_min": [
        -1562.0,
        -3639.0,
        1439.0
      ],
      "bbox_max": [
        -1560.5,
        -3637.0,
        1441.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8830063343048096,
        -0.4676658809185028,
        -0.03985436633229256
      ],
      "plane_d": -295.9820556640625,
      "bbox_min": [
        -1570.2978515625,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1542.4527587890625,
        -3666.065185546875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8704397678375244,
        0.49070483446121216,
        -0.03928520157933235
      ],
      "plane_d": 3200.06982421875,
      "bbox_min": [
        -1570.2978515625,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1542.4527587890625,
        -3666.065185546875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9990394115447998,
        -0.043820571154356
      ],
      "plane_d": -3603.813720703125,
      "bbox_min": [
        -1570.2978515625,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1543.5064697265625,
        -3666.065185546875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829215168952942,
        -0.46762096881866455,
        -0.042193811386823654
      ],
      "plane_d": -3020.0009765625,
      "bbox_min": [
        -1549.668701171875,
        -3670.989501953125,
        1422.0
      ],
      "bbox_max": [
        -1543.5064697265625,
        -3666.065185546875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.870358407497406,
        0.4906589984893799,
        -0.041592687368392944
      ],
      "plane_d": 514.486083984375,
      "bbox_min": [
        -1546.686279296875,
        -3669.0,
        1422.0
      ],
      "bbox_max": [
        -1543.5064697265625,
        -3667.114990234375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9991520047187805,
        -0.041172198951244354
      ],
      "plane_d": 3723.82373046875,
      "bbox_min": [
        -1545.6138916015625,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1543.5064697265625,
        -3667.130859375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3667.9755859375,
      "bbox_min": [
        -1545.1104736328125,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3667.838134765625,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9994093775749207,
        0.034364283084869385
      ],
      "plane_d": 3616.8056640625,
      "bbox_min": [
        -1544.8236083984375,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1544.22607421875,
        -3667.838134765625,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        -1546.686279296875,
        -3669.0,
        1422.0
      ],
      "bbox_max": [
        -1544.5550537109375,
        -3667.114990234375,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8705843687057495,
        0.4907929599285126,
        0.034716952592134476
      ],
      "plane_d": 405.5611572265625,
      "bbox_min": [
        -1546.4359130859375,
        -3668.73779296875,
        1422.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3667.251708984375,
        1428.2735595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7256290316581726,
        0.40907421708106995,
        -0.5532819032669067
      ],
      "plane_d": 1168.2772216796875,
      "bbox_min": [
        -1546.4359130859375,
        -3668.73779296875,
        1426.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3667.251708984375,
        1428.2735595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3667.9755859375,
      "bbox_min": [
        -1545.232421875,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1544.5550537109375,
        -3667.838134765625,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9994093775749207,
        0.034364283084869385
      ],
      "plane_d": 3616.8056640625,
      "bbox_min": [
        -1545.232421875,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1544.5550537109375,
        -3667.838134765625,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8705843687057495,
        0.4907929599285126,
        0.034716952592134476
      ],
      "plane_d": 405.5611572265625,
      "bbox_min": [
        -1545.232421875,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3667.838134765625,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        -1549.668701171875,
        -3670.09033203125,
        1422.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3666.065185546875,
        1432.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7979102730751038,
        0.28827255964279175,
        -0.5293753147125244
      ],
      "plane_d": 579.240966796875,
      "bbox_min": [
        -1549.668701171875,
        -3670.090087890625,
        1424.936767578125
      ],
      "bbox_max": [
        -1545.25,
        -3666.065185546875,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7361656427383423,
        -0.3899238109588623,
        -0.5531905293464661
      ],
      "plane_d": -1779.6630859375,
      "bbox_min": [
        -1549.668701171875,
        -3670.090087890625,
        1425.0078125
      ],
      "bbox_max": [
        -1545.25,
        -3669.0,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7992929816246033,
        -0.28270214796066284,
        -0.5302925705909729
      ],
      "plane_d": -1516.494384765625,
      "bbox_min": [
        -1549.668701171875,
        -3670.090087890625,
        1426.0
      ],
      "bbox_max": [
        -1545.68798828125,
        -3669.0,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8831459283828735,
        -0.4677746593952179,
        0.03521553799510002
      ],
      "plane_d": -3131.55078125,
      "bbox_min": [
        -1545.68798828125,
        -3669.826904296875,
        1425.0078125
      ],
      "bbox_max": [
        -1545.25,
        -3669.0,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8831459283828735,
        -0.4677746593952179,
        0.03521553799510002
      ],
      "plane_d": -3131.55078125,
      "bbox_min": [
        -1545.68798828125,
        -3669.783447265625,
        1424.936767578125
      ],
      "bbox_max": [
        -1545.3126220703125,
        -3669.0,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8705843687057495,
        0.4907929599285126,
        0.034716952592134476
      ],
      "plane_d": 405.5611572265625,
      "bbox_min": [
        -1545.8475341796875,
        -3669.7802734375,
        1422.0
      ],
      "bbox_max": [
        -1545.317138671875,
        -3668.417236328125,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21276737749576569,
        0.8294805884361267,
        -0.5164223313331604
      ],
      "plane_d": 4140.97509765625,
      "bbox_min": [
        -1559.807373046875,
        -3688.221923828125,
        1452.0
      ],
      "bbox_max": [
        -1559.5499267578125,
        -3687.844482421875,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3680970072746277,
        0.7740258574485779,
        -0.5151588320732117
      ],
      "plane_d": 3028.72412109375,
      "bbox_min": [
        -1559.5792236328125,
        -3688.221923828125,
        1452.0
      ],
      "bbox_max": [
        -1559.5499267578125,
        -3687.892578125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2674824297428131,
        0.7839431166648865,
        -0.5602554678916931
      ],
      "plane_d": 3287.69482421875,
      "bbox_min": [
        -1559.55712890625,
        -3688.221923828125,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3669.651611328125,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3680970072746277,
        0.7740258574485779,
        -0.5151588320732117
      ],
      "plane_d": 3028.72412109375,
      "bbox_min": [
        -1559.55712890625,
        -3688.221923828125,
        1452.0
      ],
      "bbox_max": [
        -1559.3671875,
        -3687.80224609375,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        -1549.2830810546875,
        -3672.000244140625,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3669.651611328125,
        1432.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7361656427383423,
        -0.3899238109588623,
        -0.5531905293464661
      ],
      "plane_d": -1779.6630859375,
      "bbox_min": [
        -1549.2830810546875,
        -3672.000244140625,
        1422.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3669.651611328125,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7992929816246033,
        -0.28270214796066284,
        -0.5302925705909729
      ],
      "plane_d": -1516.494384765625,
      "bbox_min": [
        -1549.2830810546875,
        -3672.000244140625,
        1427.8128662109375
      ],
      "bbox_max": [
        -1546.570068359375,
        -3669.906494140625,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3670.09033203125,
      "bbox_min": [
        -1545.234130859375,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3670.09033203125,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993311166763306,
        0.03657103702425957
      ],
      "plane_d": -3719.785888671875,
      "bbox_min": [
        -1545.234130859375,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1544.2264404296875,
        -3670.09033203125,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8831459283828735,
        -0.4677746593952179,
        0.03521553799510002
      ],
      "plane_d": -3131.55078125,
      "bbox_min": [
        -1545.234130859375,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1545.1104736328125,
        -3670.09033203125,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3667.9755859375,
      "bbox_min": [
        -1544.484130859375,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3667.838134765625,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9994093775749207,
        0.034364283084869385
      ],
      "plane_d": 3616.8056640625,
      "bbox_min": [
        -1544.0330810546875,
        -3667.9755859375,
        1422.0
      ],
      "bbox_max": [
        -1543.88232421875,
        -3667.838134765625,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8711538314819336,
        0.4910101890563965,
        0.0
      ],
      "plane_d": 3146.0361328125,
      "bbox_min": [
        -1544.484619140625,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.227294921875,
        -3668.44921875,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3670.09033203125,
      "bbox_min": [
        -1544.484619140625,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3670.09033203125,
        1432.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993311166763306,
        0.03657103702425957
      ],
      "plane_d": -3719.785888671875,
      "bbox_min": [
        -1544.484619140625,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.9554443359375,
        -3670.09033203125,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.883245050907135,
        -0.46772828698158264,
        0.033291663974523544
      ],
      "plane_d": -400.387939453125,
      "bbox_min": [
        -1544.0330810546875,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.30029296875,
        -3669.0,
        1426.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9993311166763306,
        0.03657103702425957
      ],
      "plane_d": -3719.785888671875,
      "bbox_min": [
        -1544.0330810546875,
        -3670.23681640625,
        1422.0
      ],
      "bbox_max": [
        -1543.88232421875,
        -3670.09033203125,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8706845641136169,
        0.4907456934452057,
        0.032818228006362915
      ],
      "plane_d": 3097.54248046875,
      "bbox_min": [
        -1543.5377197265625,
        -3669.137939453125,
        1422.0
      ],
      "bbox_max": [
        -1543.227294921875,
        -3668.44921875,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.883245050907135,
        -0.46772828698158264,
        0.033291663974523544
      ],
      "plane_d": -400.387939453125,
      "bbox_min": [
        -1543.3780517578125,
        -3669.137939453125,
        1422.0
      ],
      "bbox_max": [
        -1543.227294921875,
        -3669.0,
        1426.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6136823892593384,
        0.5524325370788574,
        -0.5641030073165894
      ],
      "plane_d": 3824.7568359375,
      "bbox_min": [
        -1595.2913818359375,
        -3687.903076171875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21276737749576569,
        0.8294805884361267,
        -0.5164223313331604
      ],
      "plane_d": 4140.97509765625,
      "bbox_min": [
        -1595.2913818359375,
        -3687.903076171875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15827645361423492,
        0.8256217241287231,
        -0.5415694713592529
      ],
      "plane_d": 4078.275146484375,
      "bbox_min": [
        -1582.396728515625,
        -3687.844482421875,
        1452.5
      ],
      "bbox_max": [
        -1559.807373046875,
        -3670.10986328125,
        1476.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20665335655212402,
        0.9644396305084229,
        -0.16477403044700623
      ],
      "plane_d": 4118.60546875,
      "bbox_min": [
        -1582.396728515625,
        -3685.83349609375,
        1452.5
      ],
      "bbox_max": [
        -1570.2978515625,
        -3681.418701171875,
        1453.5147705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8072386980056763,
        0.5735498666763306,
        -0.13930578529834747
      ],
      "plane_d": 3591.33203125,
      "bbox_min": [
        -1582.396728515625,
        -3683.516845703125,
        1452.5
      ],
      "bbox_max": [
        -1581.0458984375,
        -3681.418701171875,
        1453.5147705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8214341998100281,
        0.5476227402687073,
        -0.15923310816287994
      ],
      "plane_d": 3547.22900390625,
      "bbox_min": [
        -1581.3045654296875,
        -3683.516845703125,
        1452.5
      ],
      "bbox_max": [
        -1581.0458984375,
        -3683.202392578125,
        1453.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7325636148452759,
        0.38139545917510986,
        -0.5638155341148376
      ],
      "plane_d": 1095.647216796875,
      "bbox_min": [
        -1595.2913818359375,
        -3687.903076171875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8830063343048096,
        -0.4676658809185028,
        -0.03985436633229256
      ],
      "plane_d": -295.9820556640625,
      "bbox_min": [
        -1548.0999755859375,
        -3672.30419921875,
        1464.7470703125
      ],
      "bbox_max": [
        -1541.0999755859375,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8704397678375244,
        0.49070483446121216,
        -0.03928520157933235
      ],
      "plane_d": 3200.06982421875,
      "bbox_min": [
        -1548.0999755859375,
        -3672.30419921875,
        1464.7470703125
      ],
      "bbox_max": [
        -1541.0999755859375,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9990394115447998,
        -0.043820571154356
      ],
      "plane_d": -3603.813720703125,
      "bbox_min": [
        -1548.0999755859375,
        -3672.30419921875,
        1464.7747802734375
      ],
      "bbox_max": [
        -1542.8499755859375,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9991520047187805,
        -0.041172198951244354
      ],
      "plane_d": 3723.82373046875,
      "bbox_min": [
        -1548.0999755859375,
        -3672.30419921875,
        1468.08935546875
      ],
      "bbox_max": [
        -1542.8499755859375,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829215168952942,
        -0.46762096881866455,
        -0.042193811386823654
      ],
      "plane_d": -3020.0009765625,
      "bbox_min": [
        -1548.0999755859375,
        -3672.30419921875,
        1468.2618408203125
      ],
      "bbox_max": [
        -1546.0009765625,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.870358407497406,
        0.4906589984893799,
        -0.041592687368392944
      ],
      "plane_d": 514.486083984375,
      "bbox_min": [
        -1548.0999755859375,
        -3669.0,
        1472.002685546875
      ],
      "bbox_max": [
        -1546.0928955078125,
        -3665.895751953125,
        1482.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2674824297428131,
        0.7839431166648865,
        -0.5602554678916931
      ],
      "plane_d": 3287.69482421875,
      "bbox_min": [
        -1595.2913818359375,
        -3687.903076171875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3680970072746277,
        0.7740258574485779,
        -0.5151588320732117
      ],
      "plane_d": 3028.72412109375,
      "bbox_min": [
        -1563.124755859375,
        -3687.903076171875,
        1452.5
      ],
      "bbox_max": [
        -1550.4129638671875,
        -3667.23779296875,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004683134611696005,
        0.3088335692882538,
        -0.9511045217514038
      ],
      "plane_d": 2530.086669921875,
      "bbox_min": [
        -1563.124755859375,
        -3673.55615234375,
        1475.0
      ],
      "bbox_max": [
        -1550.4129638671875,
        -3667.23779296875,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010306568816304207,
        0.3088834285736084,
        -0.9510440230369568
      ],
      "plane_d": 2553.578125,
      "bbox_min": [
        -1563.124755859375,
        -3673.55615234375,
        1475.0
      ],
      "bbox_max": [
        -1560.9000244140625,
        -3671.852294921875,
        1475.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7345868945121765,
        0.2842475175857544,
        -0.6161049008369446
      ],
      "plane_d": 813.47705078125,
      "bbox_min": [
        -1595.2913818359375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.639800488948822,
        0.47990140318870544,
        -0.6002915501594543
      ],
      "plane_d": 3653.029052734375,
      "bbox_min": [
        -1595.2913818359375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8004388213157654,
        -0.05824600160121918,
        -0.5965778231620789
      ],
      "plane_d": -568.4349365234375,
      "bbox_min": [
        -1595.2913818359375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9229816794395447,
        0.01431254856288433,
        -0.3845776617527008
      ],
      "plane_d": 2074.458984375,
      "bbox_min": [
        -1595.2913818359375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.782606303691864,
        -0.2469756007194519,
        -0.5714284181594849
      ],
      "plane_d": 1172.289794921875,
      "bbox_min": [
        -1595.2913818359375,
        -3678.189697265625,
        1452.5
      ],
      "bbox_max": [
        -1574.9150390625,
        -3644.386474609375,
        1478.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1810941845178604,
        -0.0,
        0.9834657311439514
      ],
      "plane_d": -1139.733154296875,
      "bbox_min": [
        -1595.2913818359375,
        -3650.619873046875,
        1452.5
      ],
      "bbox_max": [
        -1594.47900390625,
        -3644.386474609375,
        1452.6490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607623577118,
        0.49491000175476074,
        0.854576826095581
      ],
      "plane_d": 813.3350219726562,
      "bbox_min": [
        -1595.2913818359375,
        -3650.619873046875,
        1452.5
      ],
      "bbox_max": [
        -1594.47900390625,
        -3644.386474609375,
        1452.6490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1573607325553894,
        -0.49491003155708313,
        0.854576826095581
      ],
      "plane_d": -2797.03369140625,
      "bbox_min": [
        -1595.2913818359375,
        -3650.619873046875,
        1452.5
      ],
      "bbox_max": [
        -1594.47900390625,
        -3650.5,
        1452.6490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010915984399616718,
        -0.7794032692909241,
        0.6264276504516602
      ],
      "plane_d": -3737.777099609375,
      "bbox_min": [
        -1595.2913818359375,
        -3650.619873046875,
        1452.5
      ],
      "bbox_max": [
        -1594.8358154296875,
        -3650.5,
        1452.6490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929183840751648,
        -0.34195446968078613,
        -0.1403013914823532
      ],
      "plane_d": 429.0682373046875,
      "bbox_min": [
        -1592.255126953125,
        -3678.189697265625,
        1452.5
      ],
      "bbox_max": [
        -1583.1107177734375,
        -3645.609375,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8072386980056763,
        0.5735498666763306,
        -0.13930578529834747
      ],
      "plane_d": 3591.33203125,
      "bbox_min": [
        -1592.255126953125,
        -3678.189697265625,
        1452.5
      ],
      "bbox_max": [
        -1584.54931640625,
        -3667.7001953125,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24291568994522095,
        0.04278014600276947,
        -0.9691036343574524
      ],
      "plane_d": 1971.6361083984375,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010306568816304207,
        0.3088834285736084,
        -0.9510440230369568
      ],
      "plane_d": 2553.578125,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004683134611696005,
        0.3088335692882538,
        -0.9511045217514038
      ],
      "plane_d": 2530.086669921875,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.09480908513069153,
        -0.9954954385757446
      ],
      "plane_d": 1129.0814208984375,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1564.13330078125,
        -3632.0,
        1480.0950927734375
      ],
      "bbox_max": [
        -1552.466796875,
        -3632.0,
        1481.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.12428124994039536,
        -0.07472212612628937,
        -0.9894295334815979
      ],
      "plane_d": 1387.4525146484375,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12053396552801132,
        -0.045261990278959274,
        -0.9916768670082092
      ],
      "plane_d": 1116.21484375,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1552.8375244140625,
        -3632.0,
        1480.0438232421875
      ],
      "bbox_max": [
        -1552.41552734375,
        -3632.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.870358407497406,
        0.4906589984893799,
        -0.041592687368392944
      ],
      "plane_d": 514.486083984375,
      "bbox_min": [
        -1585.7491455078125,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9991520047187805,
        -0.041172198951244354
      ],
      "plane_d": 3723.82373046875,
      "bbox_min": [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3646.565185546875,
        1472.1624755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8829215168952942,
        -0.46762096881866455,
        -0.042193811386823654
      ],
      "plane_d": -3020.0009765625,
      "bbox_min": [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1538.640380859375,
        -3666.488525390625,
        1472.1624755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9990394115447998,
        -0.043820571154356
      ],
      "plane_d": -3603.813720703125,
      "bbox_min": [
        -1546.0009765625,
        -3680.61474609375,
        1452.5
      ],
      "bbox_max": [
        -1538.640380859375,
        -3666.488525390625,
        1468.2618408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8704397678375244,
        0.49070483446121216,
        -0.03928520157933235
      ],
      "plane_d": 3200.06982421875,
      "bbox_min": [
        -1543.5064697265625,
        -3671.52783203125,
        1452.5
      ],
      "bbox_max": [
        -1541.9000244140625,
        -3666.488525390625,
        1468.08935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8830063343048096,
        -0.4676658809185028,
        -0.03985436633229256
      ],
      "plane_d": -295.9820556640625,
      "bbox_min": [
        -1543.5064697265625,
        -3671.52783203125,
        1452.5
      ],
      "bbox_max": [
        -1541.9000244140625,
        -3669.0,
        1464.7747802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36323586106300354,
        0.9189608097076416,
        -0.15352772176265717
      ],
      "plane_d": 3045.769287109375,
      "bbox_min": [
        -1540.6697998046875,
        -3680.61474609375,
        1452.5
      ],
      "bbox_max": [
        -1538.640380859375,
        -3679.03564453125,
        1454.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8953179717063904,
        0.41782036423683167,
        -0.15437591075897217
      ],
      "plane_d": 383.8345947265625,
      "bbox_min": [
        -1539.2935791015625,
        -3680.06298828125,
        1452.5
      ],
      "bbox_max": [
        -1538.640380859375,
        -3679.03564453125,
        1454.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36323586106300354,
        0.9189608097076416,
        -0.15352772176265717
      ],
      "plane_d": 3045.769287109375,
      "bbox_min": [
        -1554.48583984375,
        -3686.13671875,
        1452.5
      ],
      "bbox_max": [
        -1540.5159912109375,
        -3680.44775390625,
        1453.8641357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.922071099281311,
        -0.3580988049507141,
        -0.14679940044879913
      ],
      "plane_d": -2507.080078125,
      "bbox_min": [
        -1534.7388916015625,
        -3658.09765625,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3646.565185546875,
        1458.818115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.955927312374115,
        -0.27312368154525757,
        -0.10773324221372604
      ],
      "plane_d": -2305.07177734375,
      "bbox_min": [
        -1530.771484375,
        -3658.09765625,
        1452.5
      ],
      "bbox_max": [
        -1529.866455078125,
        -3654.93017578125,
        1458.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2007702738046646,
        0.04578416422009468,
        -0.978567898273468
      ],
      "plane_d": 1304.0390625,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3630.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7850790023803711,
        -0.08285395801067352,
        -0.6138289570808411
      ],
      "plane_d": -609.06103515625,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.764629065990448,
        -0.28712761402130127,
        -0.5769748687744141
      ],
      "plane_d": -1375.671630859375,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1551.083984375,
        -3632.0,
        1475.685546875
      ],
      "bbox_max": [
        -1548.800048828125,
        -3632.0,
        1478.7122802734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8018544316291809,
        -0.5364022850990295,
        0.26325303316116333
      ],
      "plane_d": -3575.15185546875,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5693315267562866,
        -0.8221023082733154,
        0.003061754396185279
      ],
      "plane_d": -3875.364990234375,
      "bbox_min": [
        -1549.3641357421875,
        -3647.304443359375,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3636.10009765625,
        1469.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.544562041759491,
        -0.8248180747032166,
        -0.1520768105983734
      ],
      "plane_d": -3620.879638671875,
      "bbox_min": [
        -1548.6080322265625,
        -3646.069580078125,
        1452.5
      ],
      "bbox_max": [
        -1534.212646484375,
        -3636.10009765625,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6033744812011719,
        -0.7757671475410461,
        -0.1847287267446518
      ],
      "plane_d": -3485.9072265625,
      "bbox_min": [
        -1547.390625,
        -3637.528564453125,
        1452.5
      ],
      "bbox_max": [
        -1545.22705078125,
        -3636.10009765625,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.1350774911988992e-05,
        -0.9805808067321777,
        -0.1961156278848648
      ],
      "plane_d": -3280.6142578125,
      "bbox_min": [
        -1547.390625,
        -3637.0,
        1452.5
      ],
      "bbox_max": [
        -1547.0638427734375,
        -3636.10009765625,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.922071099281311,
        -0.3580988049507141,
        -0.14679940044879913
      ],
      "plane_d": -2507.080078125,
      "bbox_min": [
        -1548.6080322265625,
        -3646.069580078125,
        1452.5
      ],
      "bbox_max": [
        -1534.212646484375,
        -3636.10009765625,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.1350774911988992e-05,
        -0.9805808067321777,
        -0.1961156278848648
      ],
      "plane_d": -3280.6142578125,
      "bbox_min": [
        -1548.6080322265625,
        -3637.0,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3636.10009765625,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.922071099281311,
        -0.3580988049507141,
        -0.14679940044879913
      ],
      "plane_d": -2507.080078125,
      "bbox_min": [
        -1549.3641357421875,
        -3647.304443359375,
        1452.5
      ],
      "bbox_max": [
        -1534.0201416015625,
        -3636.10009765625,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.1350774911988992e-05,
        -0.9805808067321777,
        -0.1961156278848648
      ],
      "plane_d": -3280.6142578125,
      "bbox_min": [
        -1549.3641357421875,
        -3637.0,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3636.10009765625,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6734187006950378,
        -0.7391934394836426,
        -0.010020788758993149
      ],
      "plane_d": -1614.0938720703125,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1540.0,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4776396155357361,
        -0.8602526187896729,
        -0.17839840054512024
      ],
      "plane_d": -2119.705322265625,
      "bbox_min": [
        -1584.6121826171875,
        -3646.88916015625,
        1452.5
      ],
      "bbox_max": [
        -1565.7286376953125,
        -3630.0,
        1475.67138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1565.800048828125,
      "bbox_min": [
        -1567.800048828125,
        -3631.7802734375,
        1465.846435546875
      ],
      "bbox_max": [
        -1565.7286376953125,
        -3630.0,
        1475.67138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1567.800048828125,
        -3631.7802734375,
        1465.846435546875
      ],
      "bbox_max": [
        -1565.8748779296875,
        -3630.0,
        1467.7716064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2150.5947265625,
      "bbox_min": [
        -1565.800048828125,
        -3630.06396484375,
        1475.5999755859375
      ],
      "bbox_max": [
        -1565.7286376953125,
        -3630.0,
        1475.67138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.933002769947052,
        -0.32654935121536255,
        -0.15123286843299866
      ],
      "plane_d": 507.22393798828125,
      "bbox_min": [
        -1584.6121826171875,
        -3646.88916015625,
        1452.5
      ],
      "bbox_max": [
        -1583.1107177734375,
        -3644.662353515625,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4830859303474426,
        -0.7087025046348572,
        0.5141680836677551
      ],
      "plane_d": -2569.04541015625,
      "bbox_min": [
        -1585.7491455078125,
        -3682.13623046875,
        1452.5
      ],
      "bbox_max": [
        -1540.0,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4776396155357361,
        -0.8602526187896729,
        -0.17839840054512024
      ],
      "plane_d": -2119.705322265625,
      "bbox_min": [
        -1585.7491455078125,
        -3650.11181640625,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2724874977720901e-05,
        -0.980580747127533,
        -0.1961156576871872
      ],
      "plane_d": -3280.651611328125,
      "bbox_min": [
        -1570.7779541015625,
        -3637.413818359375,
        1452.5
      ],
      "bbox_max": [
        -1559.797119140625,
        -3630.0,
        1458.611083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1561.0,
      "bbox_min": [
        -1561.0,
        -3632.71142578125,
        1452.5
      ],
      "bbox_max": [
        -1559.797119140625,
        -3630.0,
        1458.611083984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7432941794395447,
        -0.6689648032188416
      ],
      "plane_d": 3673.91748046875,
      "bbox_min": [
        -1561.0,
        -3631.626220703125,
        1457.5
      ],
      "bbox_max": [
        -1559.797119140625,
        -3630.0,
        1458.611083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1457.5,
      "bbox_min": [
        -1561.0,
        -3631.626220703125,
        1457.5
      ],
      "bbox_max": [
        -1560.0811767578125,
        -3631.0,
        1457.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4948137104511261,
        -0.8482503294944763,
        -0.18876129388809204
      ],
      "plane_d": -2034.019287109375,
      "bbox_min": [
        -1570.7779541015625,
        -3637.413818359375,
        1452.5
      ],
      "bbox_max": [
        -1568.351806640625,
        -3636.10009765625,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.929183840751648,
        -0.34195446968078613,
        -0.1403013914823532
      ],
      "plane_d": 429.0682373046875,
      "bbox_min": [
        -1585.7491455078125,
        -3650.11181640625,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.933002769947052,
        -0.32654935121536255,
        -0.15123286843299866
      ],
      "plane_d": 507.22393798828125,
      "bbox_min": [
        -1585.565673828125,
        -3649.61328125,
        1452.5
      ],
      "bbox_max": [
        -1583.1107177734375,
        -3645.609375,
        1459.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1561.0,
      "bbox_min": [
        -1568.41162109375,
        -3637.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1457.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3636.211669921875,
        1452.5
      ],
      "bbox_max": [
        -1563.0,
        -3635.0,
        1454.7288818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3636.616943359375,
        1452.5
      ],
      "bbox_max": [
        -1563.0,
        -3636.10009765625,
        1453.05859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5324364304542542,
        -0.7549000382423401,
        -0.38293254375457764
      ],
      "plane_d": -1346.100830078125,
      "bbox_min": [
        -1579.0,
        -3642.0,
        1452.5
      ],
      "bbox_max": [
        -1540.0,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -53.1744384765625,
      "bbox_min": [
        -1570.778564453125,
        -3641.78125,
        1464.0
      ],
      "bbox_max": [
        -1554.545654296875,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.848170280456543,
        -0.5099655985832214,
        -0.14332501590251923
      ],
      "plane_d": -312.7744140625,
      "bbox_min": [
        -1570.778564453125,
        -3641.78125,
        1464.0
      ],
      "bbox_max": [
        -1554.800048828125,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1567.800048828125,
        -3632.0,
        1466.1922607421875
      ],
      "bbox_max": [
        -1564.161865234375,
        -3630.0,
        1479.1947021484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1567.800048828125,
        -3632.0,
        1466.1922607421875
      ],
      "bbox_max": [
        -1566.220703125,
        -3630.31982421875,
        1467.7716064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2150.5947265625,
      "bbox_min": [
        -1565.800048828125,
        -3632.0,
        1468.4471435546875
      ],
      "bbox_max": [
        -1564.161865234375,
        -3630.0,
        1477.2381591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3631.099853515625,
      "bbox_min": [
        -1565.800048828125,
        -3631.10009765625,
        1468.4471435546875
      ],
      "bbox_max": [
        -1564.9576416015625,
        -3630.0,
        1476.4423828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 68.7308349609375,
      "bbox_min": [
        -1565.800048828125,
        -3630.297119140625,
        1468.4471435546875
      ],
      "bbox_max": [
        -1565.647216796875,
        -3630.0,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1464.0
      ],
      "bbox_max": [
        -1554.800048828125,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2150.5947265625,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1464.0
      ],
      "bbox_max": [
        -1554.800048828125,
        -3630.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3631.0,
      "bbox_min": [
        -1564.8853759765625,
        -3631.0,
        1476.5145263671875
      ],
      "bbox_max": [
        -1561.800048828125,
        -3631.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1479.5999755859375,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1464.0
      ],
      "bbox_max": [
        -1554.800048828125,
        -3630.0,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 3631.099853515625,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1464.0
      ],
      "bbox_max": [
        -1555.9224853515625,
        -3630.0,
        1479.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1565.800048828125,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1465.81103515625
      ],
      "bbox_max": [
        -1564.65625,
        -3631.10009765625,
        1474.6595458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1567.0848388671875,
        -3632.0,
        1465.81103515625
      ],
      "bbox_max": [
        -1565.8394775390625,
        -3631.10009765625,
        1467.056396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1566.6219482421875,
        -3631.10009765625,
        1465.728515625
      ],
      "bbox_max": [
        -1565.7569580078125,
        -3631.0,
        1466.593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3631.0,
      "bbox_min": [
        -1566.16162109375,
        -3631.0,
        1468.5999755859375
      ],
      "bbox_max": [
        -1565.7999267578125,
        -3631.0,
        1471.101806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1459.5,
      "bbox_min": [
        -1568.351806640625,
        -3642.0,
        1452.5
      ],
      "bbox_max": [
        -1540.0,
        -3630.0,
        1480.0950927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3639.999755859375,
      "bbox_min": [
        -1568.351806640625,
        -3640.0,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3630.0,
        1459.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.5,
      "bbox_min": [
        -1568.351806640625,
        -3640.0,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3630.0,
        1459.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9805848598480225,
        -0.19609570503234863
      ],
      "plane_d": -3280.675537109375,
      "bbox_min": [
        -1555.5,
        -3640.0,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3634.857177734375,
        1459.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7593351006507874,
        0.6506997346878052
      ],
      "plane_d": -3709.771240234375,
      "bbox_min": [
        -1555.5,
        -3637.499755859375,
        1452.5
      ],
      "bbox_max": [
        -1547.284423828125,
        -3634.857177734375,
        1459.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1553.5,
      "bbox_min": [
        -1553.5,
        -3636.999755859375,
        1452.5
      ],
      "bbox_max": [
        -1553.5,
        -3635.0,
        1459.333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1553.5,
      "bbox_min": [
        -1553.5,
        -3637.499755859375,
        1457.0
      ],
      "bbox_max": [
        -1553.5,
        -3635.0,
        1459.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9805848598480225,
        -0.19609570503234863
      ],
      "plane_d": -3280.67578125,
      "bbox_min": [
        -1568.351806640625,
        -3640.0,
        1452.5
      ],
      "bbox_max": [
        -1561.0,
        -3634.857177734375,
        1459.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7593351006507874,
        0.6506997346878052
      ],
      "plane_d": -3709.771240234375,
      "bbox_min": [
        -1568.351806640625,
        -3637.5,
        1453.058349609375
      ],
      "bbox_max": [
        -1561.0,
        -3634.857177734375,
        1459.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3637.0,
        1453.058349609375
      ],
      "bbox_max": [
        -1563.0,
        -3635.0,
        1459.333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3637.5,
        1456.999755859375
      ],
      "bbox_max": [
        -1563.0,
        -3635.0,
        1459.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1563.0,
      "bbox_min": [
        -1563.0,
        -3640.0,
        1452.5
      ],
      "bbox_max": [
        -1563.0,
        -3636.2119140625,
        1459.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1457.5,
      "bbox_min": [
        -1561.0,
        -3640.0,
        1457.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1459.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7592505216598511,
        0.6507983803749084
      ],
      "plane_d": -3709.607421875,
      "bbox_min": [
        -1561.0,
        -3636.571533203125,
        1457.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1459.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7432941794395447,
        -0.6689648032188416
      ],
      "plane_d": 3673.91748046875,
      "bbox_min": [
        -1560.0811767578125,
        -3631.0,
        1457.5
      ],
      "bbox_max": [
        -1555.5,
        -3630.0,
        1458.611083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1557.1982421875,
        -3632.0,
        1479.5999755859375
      ],
      "bbox_max": [
        -1551.9716796875,
        -3631.0,
        1480.0950927734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7284740209579468,
        -0.6670239567756653,
        -0.15621985495090485
      ],
      "plane_d": -3321.6640625,
      "bbox_min": [
        -1552.4310302734375,
        -3631.39990234375,
        1479.5999755859375
      ],
      "bbox_max": [
        -1551.97900390625,
        -3631.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -53.1744384765625,
      "bbox_min": [
        -1567.8690185546875,
        -3642.0,
        1459.5
      ],
      "bbox_max": [
        -1540.0,
        -3630.0,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7284740209579468,
        -0.6670239567756653,
        -0.15621985495090485
      ],
      "plane_d": -3321.6640625,
      "bbox_min": [
        -1554.800048828125,
        -3642.0,
        1467.5
      ],
      "bbox_max": [
        -1540.0,
        -3631.068359375,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1551.281005859375,
        -3632.0,
        1473.60009765625
      ],
      "bbox_max": [
        -1548.800048828125,
        -3632.0,
        1478.9093017578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1554.800048828125,
        -3632.0,
        1475.30908203125
      ],
      "bbox_max": [
        -1550.509033203125,
        -3632.0,
        1479.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3630.999755859375,
      "bbox_min": [
        -1567.8690185546875,
        -3638.699951171875,
        1459.5
      ],
      "bbox_max": [
        -1542.7000732421875,
        -3630.0,
        1479.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1550.800048828125,
      "bbox_min": [
        -1565.7569580078125,
        -3631.0,
        1462.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3630.0,
        1475.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2135.03857421875,
      "bbox_min": [
        -1565.7569580078125,
        -3631.0,
        1462.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3630.0,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1565.7569580078125,
        -3631.0,
        1462.5999755859375
      ],
      "bbox_max": [
        -1554.800048828125,
        -3630.0,
        1467.37353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 68.7308349609375,
      "bbox_min": [
        -1564.57373046875,
        -3631.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1561.800048828125,
        -3630.0,
        1467.37353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7592505812644958,
        0.6507984399795532
      ],
      "plane_d": -3709.60791015625,
      "bbox_min": [
        -1567.8690185546875,
        -3638.699951171875,
        1459.5
      ],
      "bbox_max": [
        -1542.7000732421875,
        -3631.0,
        1479.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1564.028564453125,
        -3632.0,
        1462.5999755859375
      ],
      "bbox_max": [
        -1552.571533203125,
        -3631.0,
        1464.0001220703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -70.730712890625,
      "bbox_min": [
        -1566.5816650390625,
        -3638.699951171875,
        1462.8333740234375
      ],
      "bbox_max": [
        -1542.7000732421875,
        -3631.0,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2133.03857421875,
      "bbox_min": [
        -1566.5816650390625,
        -3638.699951171875,
        1462.8333740234375
      ],
      "bbox_max": [
        -1542.7000732421875,
        -3631.0,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.728472888469696,
        -0.6670275926589966,
        -0.1562095284461975
      ],
      "plane_d": -3321.69091796875,
      "bbox_min": [
        -1550.800048828125,
        -3635.966796875,
        1465.7716064453125
      ],
      "bbox_max": [
        -1545.885986328125,
        -3631.0,
        1475.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1550.5091552734375,
        -3632.0,
        1467.6949462890625
      ],
      "bbox_max": [
        -1548.800048828125,
        -3632.0,
        1475.30908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1550.800048828125,
        -3632.0,
        1465.7716064453125
      ],
      "bbox_max": [
        -1548.876708984375,
        -3632.0,
        1475.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3632.0,
      "bbox_min": [
        -1566.5816650390625,
        -3632.0,
        1462.8333740234375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.0,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3631.099853515625,
      "bbox_min": [
        -1565.3983154296875,
        -3632.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.0,
        1479.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1464.5999755859375,
      "bbox_min": [
        -1564.65625,
        -3631.10009765625,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.0,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2135.03857421875,
      "bbox_min": [
        -1564.65625,
        -3631.10009765625,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.0,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 68.7308349609375,
      "bbox_min": [
        -1564.65625,
        -3631.10009765625,
        1464.5999755859375
      ],
      "bbox_max": [
        -1561.800048828125,
        -3631.0,
        1467.4560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1464.5999755859375,
      "bbox_min": [
        -1565.3983154296875,
        -3632.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.10009765625,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2135.03857421875,
      "bbox_min": [
        -1565.3983154296875,
        -3632.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3631.10009765625,
        1468.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.728472888469696,
        -0.6670275926589966,
        -0.1562095284461975
      ],
      "plane_d": -3321.69091796875,
      "bbox_min": [
        -1549.6307373046875,
        -3638.699951171875,
        1464.0
      ],
      "bbox_max": [
        -1542.7000732421875,
        -3631.0,
        1470.6859130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1476.00341796875,
        -3971.23486328125,
        1335.75
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3942.9375,
        1363.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1473.24609375,
        -3971.23486328125,
        1347.04443359375
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3956.25634765625,
        1355.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1473.24609375,
        -3971.23486328125,
        1347.04443359375
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3956.25634765625,
        1355.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1471.226806640625,
        -3971.23486328125,
        1353.6009521484375
      ],
      "bbox_max": [
        -1460.104248046875,
        -3960.219482421875,
        1355.642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3696383833885193,
        0.8643922209739685,
        0.3408718407154083
      ],
      "plane_d": 2437.450927734375,
      "bbox_min": [
        -1610.94873046875,
        -3967.612548828125,
        1301.125
      ],
      "bbox_max": [
        -1448.71875,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5008262395858765,
        0.8646190762519836,
        0.04008767381310463
      ],
      "plane_d": 2332.68017578125,
      "bbox_min": [
        -1610.94873046875,
        -3912.760009765625,
        1351.5150146484375
      ],
      "bbox_max": [
        -1492.65380859375,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1500.8284912109375,
        -3912.760009765625,
        1351.5150146484375
      ],
      "bbox_max": [
        -1492.65380859375,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1500.8284912109375,
        -3905.83837890625,
        1351.5150146484375
      ],
      "bbox_max": [
        -1497.78759765625,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1500.8284912109375,
        -3905.83837890625,
        1355.6229248046875
      ],
      "bbox_max": [
        -1497.78759765625,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1610.94873046875,
        -3694.238037109375,
        1405.224365234375
      ],
      "bbox_max": [
        -1589.41748046875,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.41391289234161377,
        0.714564323425293,
        0.5639804601669312
      ],
      "plane_d": 1180.2740478515625,
      "bbox_min": [
        -1610.94873046875,
        -3693.995361328125,
        1405.224365234375
      ],
      "bbox_max": [
        -1589.5657958984375,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1418.5858154296875,
      "bbox_min": [
        -1610.94873046875,
        -3692.593994140625,
        1405.224365234375
      ],
      "bbox_max": [
        -1590.422119140625,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4991301894187927,
        -0.8615527749061584,
        -0.0927150547504425
      ],
      "plane_d": -2241.0009765625,
      "bbox_min": [
        -1610.94873046875,
        -3688.971923828125,
        1405.224365234375
      ],
      "bbox_max": [
        -1592.635986328125,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4014309346675873,
        -0.6929348707199097,
        -0.5989109873771667
      ],
      "plane_d": -1060.533447265625,
      "bbox_min": [
        -1610.94873046875,
        -3688.971923828125,
        1405.224365234375
      ],
      "bbox_max": [
        -1592.635986328125,
        -3676.445068359375,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.466681569814682,
        -0.8056060075759888,
        0.3649757206439972
      ],
      "plane_d": -2731.82177734375,
      "bbox_min": [
        -1610.94873046875,
        -3687.232421875,
        1405.224365234375
      ],
      "bbox_max": [
        -1593.7000732421875,
        -3676.445068359375,
        1408.7421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1482.5,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3610.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1610.0,
        -3610.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3605.0,
      "bbox_min": [
        -1610.0,
        -3610.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1610.0,
        -3610.0,
        1475.0
      ],
      "bbox_max": [
        -1600.0,
        -3605.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        -1610.0,
        -3610.0,
        1475.0
      ],
      "bbox_max": [
        -1600.0,
        -3605.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1610.0,
        -3610.0,
        1475.0
      ],
      "bbox_max": [
        -1610.0,
        -3605.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24253562092781067,
        0.0,
        0.9701424837112427
      ],
      "plane_d": -1819.0172119140625,
      "bbox_min": [
        -1610.0,
        -3605.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1477.5,
      "bbox_min": [
        -1590.0,
        -3605.0,
        1477.5
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1480.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3595.0,
      "bbox_min": [
        -1590.0,
        -3595.0,
        1477.5
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1480.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3595.0,
      "bbox_min": [
        -1610.0,
        -3605.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3595.0,
        1482.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.24253562092781067,
        0.0,
        -0.9701424837112427
      ],
      "plane_d": 1823.867919921875,
      "bbox_min": [
        -1600.0,
        -3605.0,
        1480.0
      ],
      "bbox_max": [
        -1590.0,
        -3595.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1610.0,
        -3605.0,
        1475.0
      ],
      "bbox_max": [
        -1610.0,
        -3595.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1580.0,
        -3610.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        -0.0,
        -0.9578262567520142
      ],
      "plane_d": 957.8262329101562,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1580.0,
        -3610.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1477.0,
      "bbox_min": [
        -1590.0,
        -3620.0,
        1474.0
      ],
      "bbox_max": [
        -1580.0,
        -3610.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3620.0,
      "bbox_min": [
        -1590.0,
        -3620.0,
        1474.0
      ],
      "bbox_max": [
        -1580.0,
        -3620.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3620.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1580.0,
        -3610.0,
        1480.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2873478829860687,
        -0.0,
        0.9578262567520142
      ],
      "plane_d": -953.037109375,
      "bbox_min": [
        -1600.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1590.0,
        -3610.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1610.0,
        -3620.0,
        1475.0
      ],
      "bbox_max": [
        -1610.0,
        -3610.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1477.0,
      "bbox_min": [
        -1580.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1477.5,
      "bbox_min": [
        -1580.0,
        -3605.0,
        1477.5
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1482.5,
      "bbox_min": [
        -1580.0,
        -3605.0,
        1477.5
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        -1580.0,
        -3605.0,
        1477.5
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3605.0,
      "bbox_min": [
        -1580.0,
        -3605.0,
        1477.5
      ],
      "bbox_max": [
        -1570.0,
        -3605.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        -1580.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3594.5,
        1477.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3620.0,
      "bbox_min": [
        -1580.0,
        -3620.0,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3620.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1464.5999755859375,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.7310552597045898,
        0.6823182702064514
      ],
      "plane_d": -3643.3359375,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3621.0,
        1464.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1555.4998779296875,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3621.0,
        1464.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1561.0,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3621.0,
        1464.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7432941794395447,
        -0.6689648032188416
      ],
      "plane_d": 3673.91748046875,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3621.0,
        1464.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3626.5,
      "bbox_min": [
        -1561.0,
        -3626.5,
        1462.5
      ],
      "bbox_max": [
        -1555.5,
        -3626.5,
        1464.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3621.0,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3621.0,
        1464.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1452.5,
      "bbox_min": [
        -1561.0,
        -3630.0,
        1452.5
      ],
      "bbox_max": [
        -1555.5,
        -3628.0,
        1452.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1479.5999755859375,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1550.800048828125,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 68.7308349609375,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 2150.594482421875,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -2135.0380859375,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -53.174560546875,
      "bbox_min": [
        -1565.800048828125,
        -3630.0,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.733762264251709,
        0.6794063448905945
      ],
      "plane_d": -3636.23583984375,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6770545840263367,
        -0.7359328269958496
      ],
      "plane_d": -1348.171630859375,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7581815123558044,
        -0.6520434617996216,
        0.0
      ],
      "plane_d": -1159.869873046875,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7657085657119751,
        -0.6431877017021179,
        -0.0
      ],
      "plane_d": -3502.615234375,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.550512433052063,
        -0.6275922656059265,
        0.550512433052063
      ],
      "plane_d": -2205.508544921875,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554326057434082,
        -0.6208423972129822,
        0.554326057434082
      ],
      "plane_d": -3908.454345703125,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1464.5999755859375
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.58119797706604,
        -0.5695768594741821,
        -0.58119797706604
      ],
      "plane_d": -282.5362548828125,
      "bbox_min": [
        -1565.800048828125,
        -3599.5,
        1475.0
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.585048258304596,
        -0.5616377592086792,
        -0.585048258304596
      ],
      "plane_d": -2065.61083984375,
      "bbox_min": [
        -1555.0,
        -3599.5,
        1475.0
      ],
      "bbox_max": [
        -1550.800048828125,
        -3594.5,
        1479.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1482.5999755859375,
      "bbox_min": [
        -1615.0,
        -3594.5,
        1468.5
      ],
      "bbox_max": [
        -1540.0,
        -3490.0,
        1515.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1468.5,
      "bbox_min": [
        -1610.0,
        -3594.5,
        1468.5
      ],
      "bbox_max": [
        -1540.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1610.0,
        -3594.5,
        1468.5
      ],
      "bbox_max": [
        -1540.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3544.0,
      "bbox_min": [
        -1610.0,
        -3594.5,
        1468.5
      ],
      "bbox_max": [
        -1540.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        -1610.0,
        -3594.5,
        1468.5
      ],
      "bbox_max": [
        -1540.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        -1590.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1540.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        -1590.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1540.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1482.5,
      "bbox_min": [
        -1590.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1482.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        -1590.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1482.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.22903934121131897,
        0.0,
        0.9734172224998474
      ],
      "plane_d": -1073.2783203125,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3576.0,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1570.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1480.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1570.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1480.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        -1570.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1550.0,
        -3550.0,
        1480.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": -1013.5677490234375,
      "bbox_min": [
        -1558.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1550.0,
        -3560.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3565.0,
      "bbox_min": [
        -1558.0,
        -3565.0,
        1475.0
      ],
      "bbox_max": [
        -1554.0,
        -3565.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3575.0,
      "bbox_min": [
        -1558.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1550.0,
        -3575.0,
        1480.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1567.5,
      "bbox_min": [
        -1570.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1558.0,
        -3550.0,
        1480.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -1570.0,
        -3560.0,
        1475.0
      ],
      "bbox_max": [
        -1567.5,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1570.0,
        -3550.0,
        1475.0
      ],
      "bbox_max": [
        -1567.5,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3575.0,
      "bbox_min": [
        -1567.5,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1558.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1567.5,
        -3550.0,
        1475.0
      ],
      "bbox_max": [
        -1558.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1477.5,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1550.0,
        -3576.0,
        1482.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1555.0,
        -3580.0,
        1477.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22903934121131897,
        0.0,
        -0.9734172224998474
      ],
      "plane_d": 1078.1453857421875,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1555.0,
        -3580.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1561.5,
        -3594.5,
        1473.470458984375
      ],
      "bbox_max": [
        -1555.0,
        -3580.0,
        1475.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3580.0,
      "bbox_min": [
        -1561.5,
        -3580.0,
        1473.470458984375
      ],
      "bbox_max": [
        -1555.0,
        -3580.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3590.0,
      "bbox_min": [
        -1570.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1561.5,
        -3590.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1561.5,
      "bbox_min": [
        -1561.5,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1561.5,
        -3590.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3590.0,
      "bbox_min": [
        -1570.0,
        -3590.0,
        1477.5
      ],
      "bbox_max": [
        -1550.0,
        -3576.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3580.0,
      "bbox_min": [
        -1570.0,
        -3580.0,
        1477.5
      ],
      "bbox_max": [
        -1560.0,
        -3576.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        -3580.0,
        1477.5
      ],
      "bbox_max": [
        -1560.0,
        -3576.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1590.0,
        -3594.5,
        1470.0
      ],
      "bbox_max": [
        -1570.0,
        -3550.0,
        1482.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24253562092781067,
        0.0,
        0.9701424837112427
      ],
      "plane_d": -1811.2559814453125,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3580.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3580.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3580.0,
        1477.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24253562092781067,
        0.0,
        -0.9701424837112427
      ],
      "plane_d": 1816.106689453125,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3580.0,
        1477.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1474.5
      ],
      "bbox_max": [
        -1588.0,
        -3580.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3590.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1474.5
      ],
      "bbox_max": [
        -1588.0,
        -3590.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3590.0,
      "bbox_min": [
        -1590.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1580.0,
        -3590.0,
        1477.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1590.0,
        -3550.0,
        1475.0
      ],
      "bbox_max": [
        -1580.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3550.0,
        1482.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.2873478829860687,
        0.9578262567520142
      ],
      "plane_d": -2437.18896484375,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3565.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1472.0
      ],
      "bbox_max": [
        -1570.0,
        -3575.0,
        1472.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.2873478829860687,
        -0.9578262567520142
      ],
      "plane_d": 2441.97802734375,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1475.0
      ],
      "bbox_max": [
        -1570.0,
        -3550.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1477.0,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1477.0
      ],
      "bbox_max": [
        -1570.0,
        -3575.0,
        1482.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1477.5,
      "bbox_min": [
        -1580.0,
        -3594.5,
        1477.0
      ],
      "bbox_max": [
        -1570.0,
        -3580.0,
        1482.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1579.699951171875,
      "bbox_min": [
        -1579.699951171875,
        -3589.699951171875,
        1477.0
      ],
      "bbox_max": [
        -1570.300048828125,
        -3580.300048828125,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3589.699951171875,
      "bbox_min": [
        -1579.699951171875,
        -3589.699951171875,
        1477.0
      ],
      "bbox_max": [
        -1570.300048828125,
        -3580.300048828125,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3580.300048828125,
      "bbox_min": [
        -1579.699951171875,
        -3589.699951171875,
        1477.0
      ],
      "bbox_max": [
        -1570.300048828125,
        -3580.300048828125,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1570.300048828125,
      "bbox_min": [
        -1570.300048828125,
        -3589.699951171875,
        1477.0
      ],
      "bbox_max": [
        -1570.300048828125,
        -3580.300048828125,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3580.0,
      "bbox_min": [
        -1580.0,
        -3580.0,
        1477.5
      ],
      "bbox_max": [
        -1570.0,
        -3580.0,
        1482.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1580.0,
        -3565.0,
        1475.0
      ],
      "bbox_max": [
        -1570.0,
        -3550.0,
        1480.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1580.0,
        -3550.0,
        1475.0
      ],
      "bbox_max": [
        -1570.0,
        -3550.0,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1540.0,
        -3560.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1540.0,
        -3560.0,
        1482.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3575.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1475.0
      ],
      "bbox_max": [
        -1540.0,
        -3575.0,
        1482.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3566.0,
      "bbox_min": [
        -1610.0,
        -3590.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        -1605.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1605.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1605.0,
      "bbox_min": [
        -1605.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807856678962708,
        0.1950882375240326,
        -0.0
      ],
      "plane_d": 2272.186767578125,
      "bbox_min": [
        -1605.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555782914161682,
        0.8314642310142517,
        -0.0
      ],
      "plane_d": 3871.78466796875,
      "bbox_min": [
        -1604.0865478515625,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314642310142517,
        0.5555782914161682,
        -0.0
      ],
      "plane_d": 3324.151123046875,
      "bbox_min": [
        -1604.0865478515625,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950681358575821,
        0.9807897210121155,
        -0.0
      ],
      "plane_d": 3831.778564453125,
      "bbox_min": [
        -1597.5921630859375,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1595.0,
      "bbox_min": [
        -1595.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3566.0,
        1475.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3580.0,
      "bbox_min": [
        -1595.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3578.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314723372459412,
        -0.5555661916732788,
        -0.0
      ],
      "plane_d": -3314.312744140625,
      "bbox_min": [
        -1595.0,
        -3580.0,
        1470.0
      ],
      "bbox_max": [
        -1593.0,
        -3578.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19521361589431763,
        -0.9807607531547546,
        -0.0
      ],
      "plane_d": -3822.098876953125,
      "bbox_min": [
        -1595.0,
        -3580.0,
        1470.0
      ],
      "bbox_max": [
        -1593.0,
        -3578.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807906746864319,
        -0.19506315886974335,
        -0.0
      ],
      "plane_d": -2262.297119140625,
      "bbox_min": [
        -1595.0,
        -3579.84765625,
        1470.0
      ],
      "bbox_max": [
        -1593.765380859375,
        -3578.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5554220676422119,
        -0.8315685987472534,
        -0.0
      ],
      "plane_d": -3862.101318359375,
      "bbox_min": [
        -1594.4141845703125,
        -3579.84765625,
        1470.0
      ],
      "bbox_max": [
        -1593.765380859375,
        -3579.414306640625,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3590.0,
      "bbox_min": [
        -1593.0,
        -3590.0,
        1470.0
      ],
      "bbox_max": [
        -1590.0,
        -3590.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1607.0,
      "bbox_min": [
        -1610.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1610.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1607.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3550.0,
      "bbox_min": [
        -1610.0,
        -3550.0,
        1468.5
      ],
      "bbox_max": [
        -1607.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3547.0,
      "bbox_min": [
        -1605.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3544.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1477.5,
      "bbox_min": [
        -1605.0,
        -3547.0,
        1468.5
      ],
      "bbox_max": [
        -1595.0,
        -3544.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1605.0,
      "bbox_min": [
        -1605.0,
        -3547.0,
        1468.5
      ],
      "bbox_max": [
        -1595.0,
        -3544.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        -1595.0,
        -3547.0,
        1468.5
      ],
      "bbox_max": [
        -1595.0,
        -3544.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1480.0
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3550.0,
      "bbox_min": [
        -1593.0,
        -3550.0,
        1480.0
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1482.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3550.0,
      "bbox_min": [
        -1593.0,
        -3550.0,
        1468.5
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        -1610.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3518.0,
        1515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3526.0,
      "bbox_min": [
        -1590.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3518.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        -1590.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3526.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3542.5,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1562.5,
        -3526.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3560.0,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25766265392303467,
        0.0,
        -0.9662349224090576
      ],
      "plane_d": 1848.343017578125,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1488.933349609375
      ],
      "bbox_max": [
        -1586.0,
        -3550.0,
        1490.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1590.0,
        -3550.0,
        1488.933349609375
      ],
      "bbox_max": [
        -1586.0,
        -3550.0,
        1490.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1487.5,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3162277638912201,
        0.0,
        0.9486833214759827
      ],
      "plane_d": -1910.3319091796875,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1485.0
      ],
      "bbox_max": [
        -1578.5,
        -3550.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "bbox_max": [
        -1578.5,
        -3550.0,
        1487.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19510963559150696,
        0.9807814359664917,
        0.0
      ],
      "plane_d": 3184.576904296875,
      "bbox_min": [
        -1590.0,
        -3560.0,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.5,
      "bbox_min": [
        -1590.0,
        -3556.778076171875,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3542.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3550.0,
      "bbox_min": [
        -1590.0,
        -3550.0,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3549.0,
        1492.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8316168189048767,
        -0.5553498268127441,
        0.0
      ],
      "plane_d": -663.3682250976562,
      "bbox_min": [
        -1572.7928466796875,
        -3549.70703125,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3549.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807488322257996,
        -0.1952735334634781,
        0.0
      ],
      "plane_d": 849.2017822265625,
      "bbox_min": [
        -1572.576171875,
        -3549.382568359375,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3549.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314635157585144,
        0.5555793642997742,
        0.0
      ],
      "plane_d": 674.23193359375,
      "bbox_min": [
        -1565.7218017578125,
        -3556.778076171875,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3549.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807868599891663,
        0.19508227705955505,
        0.0
      ],
      "plane_d": -840.1324462890625,
      "bbox_min": [
        -1563.3372802734375,
        -3553.20947265625,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3549.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3535.0,
      "bbox_min": [
        -1590.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1562.5,
        -3526.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1495.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -2053.8193359375,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3529.181884765625,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3152.86767578125,
      "bbox_min": [
        -1590.0,
        -3530.5,
        1494.4000244140625
      ],
      "bbox_max": [
        -1586.2779541015625,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557108521461487,
        -0.8313755393028259,
        0.00039655392174609005
      ],
      "plane_d": -3818.9052734375,
      "bbox_min": [
        -1590.0,
        -3530.157470703125,
        1494.4000244140625
      ],
      "bbox_max": [
        -1589.7220458984375,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807887077331543,
        0.1950732171535492,
        0.0
      ],
      "plane_d": -865.250732421875,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314400911331177,
        0.5556144714355469,
        0.0
      ],
      "plane_d": 643.1832885742188,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.842529296875,
        -3527.72216796875,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.555598258972168,
        0.831450879573822,
        0.0
      ],
      "plane_d": 2053.8193359375,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3529.181884765625,
        1494.4000244140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1585.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.1950865238904953,
        0.9807860255241394,
        -0.0
      ],
      "plane_d": 3772.46240234375,
      "bbox_min": [
        -1590.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950865238904953,
        0.9807860255241394,
        0.0
      ],
      "plane_d": 3152.86767578125,
      "bbox_min": [
        -1590.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.555598258972168,
        0.831450879573822,
        -0.0
      ],
      "plane_d": 3818.3994140625,
      "bbox_min": [
        -1590.0,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.555598258972168,
        0.831450879573822,
        0.0
      ],
      "plane_d": 2053.8193359375,
      "bbox_min": [
        -1586.2779541015625,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1590.0,
        -3542.5,
        1490.0
      ],
      "bbox_max": [
        -1585.0,
        -3535.0,
        1490.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23337295651435852,
        0.0,
        -0.9723873138427734
      ],
      "plane_d": 1083.8228759765625,
      "bbox_min": [
        -1590.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1572.5,
        -3542.5,
        1489.5999755859375
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1562.5,
      "bbox_min": [
        -1562.5,
        -3542.5,
        1489.5999755859375
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1487.5,
      "bbox_min": [
        -1590.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1590.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1562.5,
      "bbox_min": [
        -1562.5,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1562.5,
        -3535.0,
        1489.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1483.5,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3560.0,
        1483.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3560.0,
        1483.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3560.0,
        1483.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3575.0,
      "bbox_min": [
        -1550.0,
        -3575.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1540.0,
        -3575.0,
        1483.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9131380319595337,
        -0.0,
        -0.4076504707336426
      ],
      "plane_d": -833.809814453125,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3518.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555341243743896,
        0.8314937353134155,
        0.0
      ],
      "plane_d": 3809.131103515625,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.1951693892478943,
        0.9807695746421814,
        -7.659360368172941e-10
      ],
      "plane_d": 3763.218505859375,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5555462837219238,
        0.8314856290817261,
        -3.1574852528137853e-06
      ],
      "plane_d": 2044.7115478515625,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19503216445446014,
        0.9807968735694885,
        0.0
      ],
      "plane_d": 3143.6748046875,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8315012454986572,
        0.5555229187011719,
        -0.0
      ],
      "plane_d": 3274.2939453125,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807887077331543,
        -0.1950732171535492,
        0.0
      ],
      "plane_d": -2240.906982421875,
      "bbox_min": [
        -1590.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.4808349609375,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1582.4808349609375,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8411329984664917,
        -4.856037048739381e-05,
        0.5408283472061157
      ],
      "plane_d": 534.5991821289062,
      "bbox_min": [
        -1590.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19518284499645233,
        -0.9807668924331665,
        0.0
      ],
      "plane_d": -3143.820068359375,
      "bbox_min": [
        -1590.0,
        -3522.0283203125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.0498046875,
        -3521.708740234375,
        1484.0777587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5556199550628662,
        -0.8314363956451416,
        -4.38160786870867e-05
      ],
      "plane_d": -2044.841796875,
      "bbox_min": [
        -1590.0,
        -3522.0283203125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.7220458984375,
        -3521.842529296875,
        1484.0777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -2044.9923095703125,
      "bbox_min": [
        -1590.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.645942211151123,
        0.0,
        -0.7633863091468811
      ],
      "plane_d": 2163.237060546875,
      "bbox_min": [
        -1590.0,
        -3522.0283203125,
        1483.13134765625
      ],
      "bbox_max": [
        -1588.6566162109375,
        -3521.130615234375,
        1489.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07122974097728729,
        0.0,
        -0.9974599480628967
      ],
      "plane_d": 1372.2332763671875,
      "bbox_min": [
        -1589.0,
        -3521.360107421875,
        1489.1754150390625
      ],
      "bbox_max": [
        -1588.65673828125,
        -3521.130615234375,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3144.04052734375,
      "bbox_min": [
        -1589.7220458984375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.07122974097728729,
        0.0,
        -0.9974599480628967
      ],
      "plane_d": 1372.2332763671875,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1483.0
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.0,
        1489.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2940921485424042,
        0.0,
        0.9557770490646362
      ],
      "plane_d": -1884.4356689453125,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1483.0
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.0,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.645942211151123,
        0.0,
        -0.7633863091468811
      ],
      "plane_d": 2163.237060546875,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1488.5889892578125
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.07958984375,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34176817536354065,
        0.0,
        -0.9397842884063721
      ],
      "plane_d": 856.8416137695312,
      "bbox_min": [
        -1587.5999755859375,
        -3521.42041015625,
        1488.7882080078125
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.07958984375,
        1489.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.80877286195755,
        0.0,
        0.5881211161613464
      ],
      "plane_d": -2155.69873046875,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556027889251709,
        -0.8314478397369385,
        0.0
      ],
      "plane_d": -3809.56884765625,
      "bbox_min": [
        -1587.2816162109375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.642822265625,
        1485.9881591796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2940921485424042,
        0.0,
        0.9557770490646362
      ],
      "plane_d": -1884.4356689453125,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3763.635498046875,
      "bbox_min": [
        -1588.0,
        -3521.758544921875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.699951171875,
        -3521.5,
        1483.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -3809.572265625,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1484.5
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9079519510269165,
        1.94264230231056e-05,
        -0.41907423734664917
      ],
      "plane_d": -816.5215454101562,
      "bbox_min": [
        -1587.0677490234375,
        -3522.228759765625,
        1486.199951171875
      ],
      "bbox_max": [
        -1585.699951171875,
        -3521.25,
        1488.9063720703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34176817536354065,
        0.0,
        -0.9397842884063721
      ],
      "plane_d": 856.8416137695312,
      "bbox_min": [
        -1587.0677490234375,
        -3521.69384765625,
        1488.699951171875
      ],
      "bbox_max": [
        -1586.5,
        -3521.25,
        1488.9063720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3763.635498046875,
      "bbox_min": [
        -1588.0,
        -3521.842529296875,
        1488.2188720703125
      ],
      "bbox_max": [
        -1586.2779541015625,
        -3521.314697265625,
        1494.4000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9079519510269165,
        1.94264230231056e-05,
        -0.41907423734664917
      ],
      "plane_d": -816.5215454101562,
      "bbox_min": [
        -1588.0,
        -3521.842529296875,
        1488.2188720703125
      ],
      "bbox_max": [
        -1586.2779541015625,
        -3521.42041015625,
        1489.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07122542709112167,
        0.0,
        -0.9974602460861206
      ],
      "plane_d": 1372.2406005859375,
      "bbox_min": [
        -1588.0,
        -3521.57958984375,
        1489.0999755859375
      ],
      "bbox_max": [
        -1587.5999755859375,
        -3521.42041015625,
        1489.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3717041015625,
        -3525.433837890625,
        1483.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3544.0,
      "bbox_min": [
        -1610.0,
        -3566.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3526.0,
      "bbox_min": [
        -1607.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1505.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1606.5,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1495.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3535.0,
      "bbox_min": [
        -1606.5,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807887077331543,
        0.1950732171535492,
        0.0
      ],
      "plane_d": -878.9818115234375,
      "bbox_min": [
        -1606.5,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.555598258972168,
        0.831450879573822,
        -0.0
      ],
      "plane_d": 3818.3994140625,
      "bbox_min": [
        -1592.5,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1495.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8314400911331177,
        0.5556144714355469,
        -0.0
      ],
      "plane_d": 3283.837158203125,
      "bbox_min": [
        -1592.5,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1592.5,
        -3529.9716796875,
        1494.4000244140625
      ],
      "bbox_max": [
        -1590.0,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1606.5,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3526.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807925820350647,
        -0.19505371153354645,
        0.0
      ],
      "plane_d": 884.6572265625,
      "bbox_min": [
        -1605.1820068359375,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1598.8179931640625,
        -3529.181884765625,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -2046.0408935546875,
      "bbox_min": [
        -1604.0,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1598.8179931640625,
        -3529.181884765625,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3150.136474609375,
      "bbox_min": [
        -1604.0,
        -3530.5,
        1494.4000244140625
      ],
      "bbox_max": [
        -1600.2779541015625,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        -1600.0,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807925820350647,
        -0.19505371153354645,
        0.0
      ],
      "plane_d": 884.6572265625,
      "bbox_min": [
        -1606.5,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.842529296875,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807887077331543,
        0.1950732171535492,
        -0.0
      ],
      "plane_d": 2263.46533203125,
      "bbox_min": [
        -1606.5,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1604.0,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314400911331177,
        0.5556144714355469,
        -0.0
      ],
      "plane_d": 3295.477294921875,
      "bbox_min": [
        -1606.157470703125,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1604.0,
        -3527.72216796875,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.555598258972168,
        0.831450879573822,
        -0.0
      ],
      "plane_d": 3826.177734375,
      "bbox_min": [
        -1605.1820068359375,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1604.0,
        -3529.181884765625,
        1494.4000244140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.555598258972168,
        0.831450879573822,
        0.0
      ],
      "plane_d": 2046.0408935546875,
      "bbox_min": [
        -1600.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1598.8179931640625,
        -3529.181884765625,
        1494.4000244140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1605.0,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.1950865238904953,
        0.9807860255241394,
        -0.0
      ],
      "plane_d": 3775.193603515625,
      "bbox_min": [
        -1604.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950865238904953,
        0.9807860255241394,
        0.0
      ],
      "plane_d": 3150.136474609375,
      "bbox_min": [
        -1604.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.555598258972168,
        0.831450879573822,
        -0.0
      ],
      "plane_d": 3826.177734375,
      "bbox_min": [
        -1604.0,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.555598258972168,
        0.831450879573822,
        0.0
      ],
      "plane_d": 2046.0408935546875,
      "bbox_min": [
        -1600.2779541015625,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3542.5,
      "bbox_min": [
        -1605.0,
        -3542.5,
        1490.0
      ],
      "bbox_max": [
        -1590.0,
        -3535.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1605.0,
      "bbox_min": [
        -1605.0,
        -3542.5,
        1490.0
      ],
      "bbox_max": [
        -1605.0,
        -3535.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555483877658844,
        0.8315272927284241,
        0.0
      ],
      "plane_d": 2044.952880859375,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1495.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8315012454986572,
        0.5555229187011719,
        0.0
      ],
      "plane_d": 633.4459228515625,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807887077331543,
        -0.1950732171535492,
        0.0
      ],
      "plane_d": 874.077880859375,
      "bbox_min": [
        -1593.519287109375,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.519287109375,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1489.0,
      "bbox_min": [
        -1593.519287109375,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1593.519287109375,
        -3526.0,
        1492.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.0,
      "bbox_min": [
        -1593.519287109375,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1486.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5556613802909851,
        -0.831408679485321,
        0.0
      ],
      "plane_d": -2044.7431640625,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1494.4000244140625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9986185431480408,
        -0.0,
        0.05254536122083664
      ],
      "plane_d": 1510.1888427734375,
      "bbox_min": [
        -1590.5,
        -3522.3623046875,
        1484.0777587890625
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.99123215675354,
        0.0,
        -0.13213200867176056
      ],
      "plane_d": 1772.982177734375,
      "bbox_min": [
        -1590.5,
        -3522.3623046875,
        1484.0777587890625
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8411626815795898,
        -0.0,
        0.5407822132110596
      ],
      "plane_d": 534.8858032226562,
      "bbox_min": [
        -1590.4000244140625,
        -3522.295654296875,
        1484.0777587890625
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6458552479743958,
        9.336621587863192e-05,
        -0.7634598612785339
      ],
      "plane_d": 2163.537109375,
      "bbox_min": [
        -1590.300048828125,
        -3522.228759765625,
        1488.0999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3521.4384765625,
        1488.3538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314400911331177,
        -0.5556144714355469,
        0.0
      ],
      "plane_d": -634.356201171875,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3522.0283203125,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1590.0,
        -3522.0283203125,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.800048828125,
        -3525.43359375,
        1486.0
      ],
      "bbox_max": [
        -1592.62841796875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1489.0,
      "bbox_min": [
        -1593.800048828125,
        -3525.43359375,
        1486.0
      ],
      "bbox_max": [
        -1592.62841796875,
        -3524.10009765625,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1593.800048828125,
        -3525.43359375,
        1492.0
      ],
      "bbox_max": [
        -1592.62841796875,
        -3524.10009765625,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.0,
      "bbox_min": [
        -1593.800048828125,
        -3525.43359375,
        1486.0
      ],
      "bbox_max": [
        -1592.62841796875,
        -3524.10009765625,
        1486.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -3817.350830078125,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.555598258972168,
        -0.831450879573822,
        0.0
      ],
      "plane_d": -2037.2138671875,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807887077331543,
        -0.1950732171535492,
        0.0
      ],
      "plane_d": -2254.63818359375,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807887077331543,
        -0.1950732171535492,
        0.0
      ],
      "plane_d": 887.8088989257812,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3766.36669921875,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1950865238904953,
        -0.9807860255241394,
        0.0
      ],
      "plane_d": -3141.309326171875,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314400911331177,
        -0.5556144714355469,
        0.0
      ],
      "plane_d": -3286.650146484375,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314400911331177,
        -0.5556144714355469,
        0.0
      ],
      "plane_d": -622.716064453125,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1606.5,
        -3526.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1597.5,
        -3521.5,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3566.0,
      "bbox_min": [
        -1610.0,
        -3566.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3544.0,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1515.0,
      "bbox_min": [
        -1610.0,
        -3566.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3544.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1610.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1607.0,
      "bbox_min": [
        -1610.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1610.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1607.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3550.0,
      "bbox_min": [
        -1610.0,
        -3550.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1607.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3560.0,
      "bbox_min": [
        -1593.0,
        -3560.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3550.0,
      "bbox_min": [
        -1593.0,
        -3550.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3550.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3893.5,
      "bbox_min": [
        -1591.0,
        -4003.02978515625,
        1222.0
      ],
      "bbox_max": [
        -1466.8427734375,
        -3887.25,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1528.0,
        -4003.02978515625,
        1236.0
      ],
      "bbox_max": [
        -1466.8427734375,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1501.704833984375,
        -3982.1611328125,
        1301.125
      ],
      "bbox_max": [
        -1466.8427734375,
        -3954.0,
        1413.5855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1477.5335693359375,
        -3960.896240234375,
        1348.7724609375
      ],
      "bbox_max": [
        -1470.8817138671875,
        -3954.433837890625,
        1356.8001708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1477.5335693359375,
        -3960.219482421875,
        1352.68408203125
      ],
      "bbox_max": [
        -1471.226806640625,
        -3954.433837890625,
        1356.8001708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9277945756912231,
        0.35961028933525085,
        -0.09938639402389526
      ],
      "plane_d": 187.175537109375,
      "bbox_min": [
        -1501.704833984375,
        -3982.1611328125,
        1301.125
      ],
      "bbox_max": [
        -1475.5670166015625,
        -3954.0,
        1413.5855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3696383833885193,
        0.8643922209739685,
        0.3408718407154083
      ],
      "plane_d": 2437.450927734375,
      "bbox_min": [
        -1501.704833984375,
        -3982.1611328125,
        1301.125
      ],
      "bbox_max": [
        -1475.5670166015625,
        -3954.0,
        1413.5855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.849248468875885,
        0.329166054725647,
        -0.41282767057418823
      ],
      "plane_d": 613.5584716796875,
      "bbox_min": [
        -1492.6265869140625,
        -3978.5654296875,
        1374.0
      ],
      "bbox_max": [
        -1478.0,
        -3954.0,
        1391.5518798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1501.704833984375,
        -3982.1611328125,
        1333.5626220703125
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1413.5855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1493.041259765625,
        -3982.1611328125,
        1333.5626220703125
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1359.498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1486.0059814453125,
        -3982.1611328125,
        1333.5626220703125
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1357.6602783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1486.0059814453125,
        -3982.1611328125,
        1333.5626220703125
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1357.6602783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3005174696445465,
        0.9509676098823547,
        0.07314186543226242
      ],
      "plane_d": 3242.37646484375,
      "bbox_min": [
        -1486.0059814453125,
        -3982.1611328125,
        1333.5626220703125
      ],
      "bbox_max": [
        -1484.53125,
        -3981.18994140625,
        1341.60693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2882758378982544,
        0.9122296571731567,
        0.2910911738872528
      ],
      "plane_d": 2815.191650390625,
      "bbox_min": [
        -1486.0059814453125,
        -3981.7802734375,
        1333.5626220703125
      ],
      "bbox_max": [
        -1484.53125,
        -3981.18994140625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2752452492713928,
        0.9601578116416931,
        0.048342589288949966
      ],
      "plane_d": 3350.75341796875,
      "bbox_min": [
        -1528.0,
        -4003.02978515625,
        1301.125
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1527.9971923828125,
        -4003.02978515625,
        1331.3504638671875
      ],
      "bbox_max": [
        -1518.828369140625,
        -3992.6494140625,
        1339.807373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3005174696445465,
        0.9509676098823547,
        0.07314186543226242
      ],
      "plane_d": 3242.37646484375,
      "bbox_min": [
        -1528.0,
        -3997.0,
        1301.125
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1526.57177734375,
        -3994.58447265625,
        1332.6416015625
      ],
      "bbox_max": [
        -1518.8038330078125,
        -3992.565673828125,
        1339.8251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1527.7362060546875,
        -3994.984375,
        1332.659912109375
      ],
      "bbox_max": [
        -1524.9742431640625,
        -3993.268310546875,
        1335.4656982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25569286942481995,
        0.891951858997345,
        -0.372884601354599
      ],
      "plane_d": 3686.7763671875,
      "bbox_min": [
        -1528.0,
        -3997.0,
        1301.125
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3589284121990204,
        0.894342839717865,
        -0.2670607268810272
      ],
      "plane_d": 3393.18701171875,
      "bbox_min": [
        -1528.0,
        -3997.0,
        1374.0
      ],
      "bbox_max": [
        -1500.22216796875,
        -3977.888916015625,
        1411.894775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3871349096298218,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 1908.636474609375,
      "bbox_min": [
        -1528.0,
        -3986.25,
        1400.6666259765625
      ],
      "bbox_max": [
        -1500.22216796875,
        -3977.888916015625,
        1411.894775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1527.9906005859375,
        -3994.25,
        1334.7578125
      ],
      "bbox_max": [
        -1525.125,
        -3993.05126953125,
        1336.2152099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1527.693115234375,
        -3993.763427734375,
        1335.749755859375
      ],
      "bbox_max": [
        -1527.30517578125,
        -3993.50537109375,
        1336.1990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1527.6148681640625,
        -3994.477294921875,
        1301.125
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1344.59619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3696383833885193,
        0.8643922209739685,
        0.3408718407154083
      ],
      "plane_d": 2437.450927734375,
      "bbox_min": [
        -1527.603759765625,
        -3994.477294921875,
        1301.940673828125
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3971.189208984375,
        1342.047607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9277945756912231,
        0.35961028933525085,
        -0.09938639402389526
      ],
      "plane_d": 187.175537109375,
      "bbox_min": [
        -1485.5106201171875,
        -3982.214111328125,
        1341.60693359375
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3982.1123046875,
        1342.047607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.849248468875885,
        0.329166054725647,
        -0.41282767057418823
      ],
      "plane_d": 613.5584716796875,
      "bbox_min": [
        -1491.4862060546875,
        -3986.25,
        1374.0
      ],
      "bbox_max": [
        -1487.521484375,
        -3976.25341796875,
        1378.5897216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1500.22216796875,
        -3977.888916015625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1494.5736083984375,
        -3965.383056640625,
        1405.5526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1528.0,
        -3997.0,
        1335.7412109375
      ],
      "bbox_max": [
        -1488.8564453125,
        -3966.3515625,
        1402.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.849248468875885,
        0.329166054725647,
        -0.41282767057418823
      ],
      "plane_d": 613.5584716796875,
      "bbox_min": [
        -1527.9971923828125,
        -3993.344482421875,
        1335.7412109375
      ],
      "bbox_max": [
        -1488.8564453125,
        -3966.3515625,
        1402.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1500.22216796875,
        -3977.888916015625,
        1391.5518798828125
      ],
      "bbox_max": [
        -1492.6265869140625,
        -3966.3515625,
        1402.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23686562478542328,
        0.7495455145835876,
        0.6181230545043945
      ],
      "plane_d": 2529.4638671875,
      "bbox_min": [
        -1527.9971923828125,
        -3993.344482421875,
        1335.7412109375
      ],
      "bbox_max": [
        -1527.9906005859375,
        -3993.335205078125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1580.941162109375,
        -4001.042236328125,
        1236.0
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1580.6329345703125,
        -4001.042236328125,
        1236.0
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3955.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1566.3095703125,
        -4001.042236328125,
        1301.125
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3955.164306640625,
        1415.6007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1529.572021484375,
        -4001.042236328125,
        1332.6766357421875
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3994.801025390625,
        1336.69921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1529.572021484375,
        -4001.042236328125,
        1334.7818603515625
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3994.801025390625,
        1336.69921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25569289922714233,
        0.8919519186019897,
        -0.3728846311569214
      ],
      "plane_d": 4468.17431640625,
      "bbox_min": [
        -1565.986083984375,
        -3997.0,
        1348.35595703125
      ],
      "bbox_max": [
        -1528.0,
        -3983.01318359375,
        1376.098388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9316552877426147,
        0.3611066937446594,
        0.04025277495384216
      ],
      "plane_d": 2842.66064453125,
      "bbox_min": [
        -1565.986083984375,
        -3986.25,
        1348.35595703125
      ],
      "bbox_max": [
        -1564.7349853515625,
        -3983.01318359375,
        1376.098388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492484092712402,
        0.3291660249233246,
        -0.4128277003765106
      ],
      "plane_d": 3208.86181640625,
      "bbox_min": [
        -1565.986083984375,
        -3986.25,
        1374.0
      ],
      "bbox_max": [
        -1564.7349853515625,
        -3984.995849609375,
        1376.098388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23686562478542328,
        0.7495455145835876,
        0.6181230545043945
      ],
      "plane_d": 2529.4638671875,
      "bbox_min": [
        -1566.3095703125,
        -3997.0,
        1301.125
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3955.164306640625,
        1415.6007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3320657014846802,
        0.7765291333198547,
        0.5354762673377991
      ],
      "plane_d": 2892.8310546875,
      "bbox_min": [
        -1554.9559326171875,
        -3991.38525390625,
        1301.125
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3958.979248046875,
        1333.3768310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.358928382396698,
        0.8943427801132202,
        -0.26706069707870483
      ],
      "plane_d": 4490.072265625,
      "bbox_min": [
        -1555.77783203125,
        -3997.0,
        1374.0
      ],
      "bbox_max": [
        -1528.0,
        -3977.888916015625,
        1410.5526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38713499903678894,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 3091.720703125,
      "bbox_min": [
        -1555.77783203125,
        -3986.193603515625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1528.18701171875,
        -3977.888916015625,
        1410.5526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38713499903678894,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 3091.720703125,
      "bbox_min": [
        -1566.3095703125,
        -3985.592041015625,
        1336.5
      ],
      "bbox_max": [
        -1531.31982421875,
        -3955.164306640625,
        1415.6007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1558.9488525390625,
        -3977.888916015625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1540.54541015625,
        -3955.164306640625,
        1415.6007080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.84065842628479,
        0.4561693072319031,
        -0.2918952703475952
      ],
      "plane_d": 3531.31640625,
      "bbox_min": [
        -1558.9488525390625,
        -3977.888916015625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1555.77783203125,
        -3970.868896484375,
        1403.409423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492484092712402,
        0.3291660249233246,
        -0.4128277003765106
      ],
      "plane_d": 3208.86181640625,
      "bbox_min": [
        -1566.3095703125,
        -3985.592041015625,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1401.655517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.84065842628479,
        0.4561693072319031,
        -0.2918952703475952
      ],
      "plane_d": 3531.31640625,
      "bbox_min": [
        -1560.0416259765625,
        -3977.888916015625,
        1395.550048828125
      ],
      "bbox_max": [
        -1555.77783203125,
        -3971.41259765625,
        1401.655517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9316552877426147,
        0.3611066937446594,
        0.04025277495384216
      ],
      "plane_d": 2842.66064453125,
      "bbox_min": [
        -1566.3095703125,
        -3984.995849609375,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1556.0213623046875,
        -3966.34228515625,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1548.9287109375,
        -3958.0,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1580.6329345703125,
        -3984.161376953125,
        1301.125
      ],
      "bbox_max": [
        -1549.5673828125,
        -3955.164306640625,
        1414.491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1580.6329345703125,
        -3984.0,
        1339.0
      ],
      "bbox_max": [
        -1567.1689453125,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3320657014846802,
        0.7765291333198547,
        0.5354762673377991
      ],
      "plane_d": 2892.8310546875,
      "bbox_min": [
        -1564.31298828125,
        -3964.4970703125,
        1301.125
      ],
      "bbox_max": [
        -1551.77001953125,
        -3955.164306640625,
        1311.102294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.84065842628479,
        0.4561693072319031,
        -0.2918952703475952
      ],
      "plane_d": 3531.31640625,
      "bbox_min": [
        -1577.5487060546875,
        -3984.161376953125,
        1335.75
      ],
      "bbox_max": [
        -1549.5673828125,
        -3955.164306640625,
        1414.491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492484092712402,
        0.3291660249233246,
        -0.4128277003765106
      ],
      "plane_d": 3208.86181640625,
      "bbox_min": [
        -1577.5487060546875,
        -3984.161376953125,
        1374.0
      ],
      "bbox_max": [
        -1560.0416259765625,
        -3955.164306640625,
        1395.550048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1575.1754150390625,
        -3983.01318359375,
        1335.75
      ],
      "bbox_max": [
        -1549.5673828125,
        -3955.164306640625,
        1414.491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27361223101615906,
        0.9544612765312195,
        0.11891253292560577
      ],
      "plane_d": 4069.675537109375,
      "bbox_min": [
        -1565.71875,
        -3982.012939453125,
        1335.75
      ],
      "bbox_max": [
        -1564.880859375,
        -3981.421875,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1565.71875,
        -3981.752197265625,
        1335.75
      ],
      "bbox_max": [
        -1564.880859375,
        -3981.421875,
        1336.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27361223101615906,
        0.9544612765312195,
        0.11891253292560577
      ],
      "plane_d": 4069.675537109375,
      "bbox_min": [
        -1565.7001953125,
        -3983.01318359375,
        1339.0
      ],
      "bbox_max": [
        -1565.0692138671875,
        -3981.83203125,
        1348.35595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1580.941162109375,
        -3955.164306640625,
        1301.125
      ],
      "bbox_max": [
        -1546.1025390625,
        -3954.0,
        1415.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1580.941162109375,
        -3955.164306640625,
        1339.0
      ],
      "bbox_max": [
        -1575.1754150390625,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.84065842628479,
        0.4561693072319031,
        -0.2918952703475952
      ],
      "plane_d": 3531.31640625,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1301.125
      ],
      "bbox_max": [
        -1546.1025390625,
        -3954.0,
        1415.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492484092712402,
        0.3291660249233246,
        -0.4128277003765106
      ],
      "plane_d": 3208.86181640625,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1373.5372314453125
      ],
      "bbox_max": [
        -1576.9168701171875,
        -3954.0,
        1375.2996826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9316552877426147,
        0.3611066937446594,
        0.04025277495384216
      ],
      "plane_d": 2842.66064453125,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1373.5372314453125
      ],
      "bbox_max": [
        -1577.5286865234375,
        -3954.0,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1301.125
      ],
      "bbox_max": [
        -1546.1025390625,
        -3954.0,
        1415.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3320657014846802,
        0.7765291333198547,
        0.5354762673377991
      ],
      "plane_d": 2892.8310546875,
      "bbox_min": [
        -1566.961181640625,
        -3955.164306640625,
        1301.125
      ],
      "bbox_max": [
        -1548.9287109375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23686562478542328,
        0.7495455145835876,
        0.6181230545043945
      ],
      "plane_d": 2529.4638671875,
      "bbox_min": [
        -1566.961181640625,
        -3955.164306640625,
        1302.406494140625
      ],
      "bbox_max": [
        -1564.31298828125,
        -3954.0,
        1304.365478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1549.31005859375,
        -3955.164306640625,
        1336.5
      ],
      "bbox_max": [
        -1548.9287109375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1372.3759765625
      ],
      "bbox_max": [
        -1546.1025390625,
        -3954.0,
        1415.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9316552877426147,
        0.3611066937446594,
        0.04025277495384216
      ],
      "plane_d": 2842.66064453125,
      "bbox_min": [
        -1578.0,
        -3955.164306640625,
        1372.3759765625
      ],
      "bbox_max": [
        -1577.478515625,
        -3954.0,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3320657014846802,
        0.7765291333198547,
        0.5354762673377991
      ],
      "plane_d": 2892.8310546875,
      "bbox_min": [
        -1546.7747802734375,
        -3986.522216796875,
        1301.125
      ],
      "bbox_max": [
        -1527.9971923828125,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1546.7747802734375,
        -3964.7890625,
        1412.3651123046875
      ],
      "bbox_max": [
        -1528.0,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.358928382396698,
        0.8943427801132202,
        -0.26706069707870483
      ],
      "plane_d": 4490.072265625,
      "bbox_min": [
        -1528.18701171875,
        -3986.517578125,
        1409.10400390625
      ],
      "bbox_max": [
        -1528.0,
        -3986.193603515625,
        1410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1222.0
      ],
      "bbox_max": [
        -1474.3956298828125,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1222.0
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1222.0
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425083994865417,
        -0.06766778975725174,
        -0.3272598683834076
      ],
      "plane_d": 1669.374755859375,
      "bbox_min": [
        -1584.77734375,
        -3954.0,
        1301.125
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3913.164306640625,
        1417.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9404411315917969,
        -0.06316715478897095,
        -0.3340364396572113
      ],
      "plane_d": 1693.21923828125,
      "bbox_min": [
        -1578.0,
        -3954.0,
        1374.0
      ],
      "bbox_max": [
        -1566.833984375,
        -3913.164306640625,
        1397.714599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1578.0,
        -3954.0,
        1374.0
      ],
      "bbox_max": [
        -1574.5908203125,
        -3921.86474609375,
        1377.333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1584.77734375,
        -3954.0,
        1301.125
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3913.164306640625,
        1417.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1584.77734375,
        -3954.0,
        1301.125
      ],
      "bbox_max": [
        -1561.4742431640625,
        -3916.0,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1584.77734375,
        -3954.0,
        1339.0
      ],
      "bbox_max": [
        -1575.584716796875,
        -3935.09716796875,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1582.23095703125,
        -3954.0,
        1301.125
      ],
      "bbox_max": [
        -1561.4742431640625,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23686562478542328,
        0.7495455145835876,
        0.6181230545043945
      ],
      "plane_d": 2529.4638671875,
      "bbox_min": [
        -1567.03125,
        -3954.0,
        1301.125
      ],
      "bbox_max": [
        -1565.4803466796875,
        -3952.453125,
        1302.973876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29454997181892395,
        -0.16321972012519836,
        -0.9415941834449768
      ],
      "plane_d": 1143.39501953125,
      "bbox_min": [
        -1565.5684814453125,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3915.0859375,
        1417.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005312979221344,
        -0.16630962491035461,
        -0.9391602873802185
      ],
      "plane_d": 1137.109619140625,
      "bbox_min": [
        -1565.5,
        -3954.0,
        1409.7821044921875
      ],
      "bbox_max": [
        -1542.5252685546875,
        -3933.079833984375,
        1417.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1565.5684814453125,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1549.31005859375,
        -3924.9970703125,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1553.1943359375,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1549.31005859375,
        -3942.14013671875,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1591.0,
        -3939.507568359375,
        1339.0
      ],
      "bbox_max": [
        -1569.5673828125,
        -3913.164306640625,
        1390.0189208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9404411315917969,
        -0.06316715478897095,
        -0.3340364396572113
      ],
      "plane_d": 1693.21923828125,
      "bbox_min": [
        -1574.666259765625,
        -3921.995361328125,
        1366.488525390625
      ],
      "bbox_max": [
        -1569.5673828125,
        -3913.164306640625,
        1390.0189208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9404411315917969,
        -0.06316715478897095,
        -0.3340364396572113
      ],
      "plane_d": 1693.21923828125,
      "bbox_min": [
        -1573.746337890625,
        -3913.164306640625,
        1372.9881591796875
      ],
      "bbox_max": [
        -1566.102783203125,
        -3906.0,
        1399.8203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425083994865417,
        -0.06766778975725174,
        -0.3272598683834076
      ],
      "plane_d": 1669.374755859375,
      "bbox_min": [
        -1566.833984375,
        -3913.164306640625,
        1397.714599609375
      ],
      "bbox_max": [
        -1566.102783203125,
        -3912.304931640625,
        1399.8203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1547.8350830078125,
        -3954.0,
        1222.0
      ],
      "bbox_max": [
        -1474.3956298828125,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1547.8350830078125,
        -3954.0,
        1222.0
      ],
      "bbox_max": [
        -1474.3956298828125,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1531.300048828125,
        -3954.0,
        1335.08251953125
      ],
      "bbox_max": [
        -1474.3956298828125,
        -3913.164306640625,
        1416.065673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1525.088134765625,
        -3954.0,
        1335.08251953125
      ],
      "bbox_max": [
        -1474.3956298828125,
        -3926.92431640625,
        1365.0850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1522.6693115234375,
        -3954.0,
        1346.24755859375
      ],
      "bbox_max": [
        -1482.21923828125,
        -3931.113525390625,
        1365.0850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1513.787353515625,
        -3949.865966796875,
        1346.24755859375
      ],
      "bbox_max": [
        -1510.195556640625,
        -3944.2490234375,
        1350.09521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1510.1956787109375,
        -3946.631591796875,
        1349.5888671875
      ],
      "bbox_max": [
        -1501.9366455078125,
        -3932.1484375,
        1352.667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2899436950683594,
        -0.30815955996513367,
        -0.9060741066932678
      ],
      "plane_d": -373.0594787597656,
      "bbox_min": [
        -1531.300048828125,
        -3954.0,
        1346.746337890625
      ],
      "bbox_max": [
        -1475.3541259765625,
        -3913.164306640625,
        1416.065673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1531.300048828125,
        -3954.0,
        1346.746337890625
      ],
      "bbox_max": [
        -1475.3541259765625,
        -3913.164306640625,
        1412.57275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1508.565673828125,
        -3932.148681640625,
        1346.746337890625
      ],
      "bbox_max": [
        -1501.0831298828125,
        -3913.164306640625,
        1356.7025146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1508.565673828125,
        -3928.5166015625,
        1346.746337890625
      ],
      "bbox_max": [
        -1501.49169921875,
        -3913.164306640625,
        1353.2760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1531.300048828125,
        -3954.0,
        1349.5955810546875
      ],
      "bbox_max": [
        -1475.3541259765625,
        -3913.164306640625,
        1412.57275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1478.0,
        -3954.0,
        1349.5955810546875
      ],
      "bbox_max": [
        -1475.3541259765625,
        -3950.8447265625,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005312979221344,
        -0.16630962491035461,
        -0.9391602873802185
      ],
      "plane_d": 1137.109619140625,
      "bbox_min": [
        -1547.8350830078125,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1509.4552001953125,
        -3921.625732421875,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1538.34521484375,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1509.4552001953125,
        -3921.625732421875,
        1367.8140869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1535.8900146484375,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1509.4552001953125,
        -3921.625732421875,
        1367.473388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1535.8900146484375,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1509.4552001953125,
        -3921.625732421875,
        1363.9189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1516.0362548828125,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1509.4552001953125,
        -3946.496826171875,
        1348.9013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1513.84765625,
        -3951.2021484375,
        1341.7645263671875
      ],
      "bbox_max": [
        -1512.1131591796875,
        -3946.440185546875,
        1346.24755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1513.84765625,
        -3946.534423828125,
        1346.1829833984375
      ],
      "bbox_max": [
        -1513.787353515625,
        -3946.440185546875,
        1346.24755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2899436950683594,
        -0.30815955996513367,
        -0.9060741066932678
      ],
      "plane_d": -373.0594787597656,
      "bbox_min": [
        -1517.8974609375,
        -3913.164306640625,
        1349.849609375
      ],
      "bbox_max": [
        -1495.40869140625,
        -3906.0,
        1404.8787841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1504.065185546875,
        -3913.164306640625,
        1349.849609375
      ],
      "bbox_max": [
        -1495.40869140625,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1504.065185546875,
        -3913.164306640625,
        1349.849609375
      ],
      "bbox_max": [
        -1495.40869140625,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1501.0831298828125,
        -3913.164306640625,
        1356.7025146484375
      ],
      "bbox_max": [
        -1495.40869140625,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1570.2392578125,
        -3924.11474609375,
        1356.125
      ],
      "bbox_max": [
        -1534.452880859375,
        -3906.0,
        1371.2274169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1570.2392578125,
        -3910.641845703125,
        1361.8370361328125
      ],
      "bbox_max": [
        -1567.55908203125,
        -3906.0,
        1371.2274169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29454997181892395,
        -0.16321972012519836,
        -0.9415941834449768
      ],
      "plane_d": 1143.39501953125,
      "bbox_min": [
        -1570.2392578125,
        -3944.803466796875,
        1386.7725830078125
      ],
      "bbox_max": [
        -1525.430908203125,
        -3906.0,
        1414.18408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005312979221344,
        -0.16630962491035461,
        -0.9391602873802185
      ],
      "plane_d": 1137.109619140625,
      "bbox_min": [
        -1554.60400390625,
        -3944.803466796875,
        1409.5
      ],
      "bbox_max": [
        -1535.7059326171875,
        -3906.0,
        1414.18408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1540.5,
        -3923.986572265625,
        1409.5
      ],
      "bbox_max": [
        -1535.7059326171875,
        -3906.0,
        1414.18408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1570.2392578125,
        -3923.796142578125,
        1386.7725830078125
      ],
      "bbox_max": [
        -1525.430908203125,
        -3906.0,
        1414.0845947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9404411315917969,
        -0.06316715478897095,
        -0.3340364396572113
      ],
      "plane_d": 1693.21923828125,
      "bbox_min": [
        -1570.2392578125,
        -3915.0859375,
        1386.7725830078125
      ],
      "bbox_max": [
        -1564.875,
        -3906.0,
        1403.4129638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425083994865417,
        -0.06766778975725174,
        -0.3272598683834076
      ],
      "plane_d": 1669.374755859375,
      "bbox_min": [
        -1566.5989990234375,
        -3915.0859375,
        1398.213623046875
      ],
      "bbox_max": [
        -1564.875,
        -3906.0,
        1403.4129638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4108384847640991,
        0.9117081165313721
      ],
      "plane_d": -2853.853515625,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1351.3724365234375
      ],
      "bbox_max": [
        -1498.8531494140625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1576.8819580078125,
        -3906.0,
        1351.3724365234375
      ],
      "bbox_max": [
        -1498.8531494140625,
        -3898.70556640625,
        1372.8731689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1576.8819580078125,
        -3906.0,
        1366.5819091796875
      ],
      "bbox_max": [
        -1562.0701904296875,
        -3898.70556640625,
        1371.3546142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1501.9649658203125,
        -3906.0,
        1351.3724365234375
      ],
      "bbox_max": [
        -1498.8531494140625,
        -3902.123046875,
        1358.2596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1501.9649658203125,
        -3906.0,
        1354.798828125
      ],
      "bbox_max": [
        -1498.8531494140625,
        -3902.123046875,
        1358.2596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1498.98291015625,
        -3906.0,
        1358.225341796875
      ],
      "bbox_max": [
        -1498.8531494140625,
        -3905.83837890625,
        1358.2596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7475398778915405,
        -0.6035469174385071,
        -0.27733591198921204
      ],
      "plane_d": -3118.83935546875,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1531.4375,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2527981102466583,
        -0.47287169098854065,
        -0.8440885543823242
      ],
      "plane_d": -1057.8648681640625,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7292430400848389,
        -0.6243412494659424,
        0.28000470995903015
      ],
      "plane_d": -3942.46484375,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7413931488990784,
        -0.607699990272522,
        -0.2846699357032776
      ],
      "plane_d": -3115.388671875,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24435769021511078,
        -0.47669079899787903,
        -0.8444259166717529
      ],
      "plane_d": -1059.228271484375,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1544.59375,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25911954045295715,
        -0.36200475692749023,
        -0.8954383134841919
      ],
      "plane_d": 240.3250732421875,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1549.90625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.266791433095932,
        -0.36779916286468506,
        -0.8908120393753052
      ],
      "plane_d": 223.23550415039062,
      "bbox_min": [
        -1563.7578125,
        -3906.0,
        1393.0
      ],
      "bbox_max": [
        -1549.90625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.894402265548706,
        -0.2998984456062317,
        0.3318215608596802
      ],
      "plane_d": -227.3988037109375,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1394.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925831317901611,
        -0.2929800748825073,
        0.3427217900753021
      ],
      "plane_d": -218.2987060546875,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.1719970703125
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1383.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1370.1719970703125
      ],
      "bbox_max": [
        -1563.7257080078125,
        -3899.814453125,
        1375.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1577.9947509765625,
        -3906.0,
        1373.232421875
      ],
      "bbox_max": [
        -1567.0555419921875,
        -3901.21142578125,
        1375.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9007346630096436,
        -0.26279979944229126,
        -0.34585168957710266
      ],
      "plane_d": 864.344482421875,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1382.53125
      ],
      "bbox_max": [
        -1564.451171875,
        -3893.5,
        1383.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9007346630096436,
        -0.26279979944229126,
        -0.34585168957710266
      ],
      "plane_d": 864.344482421875,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1382.53125
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1390.53125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1563.9417724609375,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1563.3594970703125,
        -3905.808837890625,
        1370.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25277045369148254,
        -0.4160633385181427,
        -0.8734978437423706
      ],
      "plane_d": -10.57598876953125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1393.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25196951627731323,
        -0.42230406403541565,
        -0.8707300424575806
      ],
      "plane_d": -822.654052734375,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1393.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26930010318756104,
        -0.24784131348133087,
        0.9306192398071289
      ],
      "plane_d": -1824.6865234375,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2687537372112274,
        -0.255401074886322,
        0.9287312030792236
      ],
      "plane_d": -2687.1923828125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8721579313278198,
        -0.356646329164505,
        0.33487921953201294
      ],
      "plane_d": -3196.431640625,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1375.71875
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8801052570343018,
        -0.33349302411079407,
        0.33793070912361145
      ],
      "plane_d": -388.9307861328125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1375.71875
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8490763902664185,
        -0.4156712293624878,
        -0.3260166645050049
      ],
      "plane_d": -2476.5576171875,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1382.46875
      ],
      "bbox_max": [
        -1541.75,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8579274415969849,
        -0.3942665457725525,
        -0.3294152319431305
      ],
      "plane_d": 262.7730712890625,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1382.46875
      ],
      "bbox_max": [
        -1559.7109375,
        -3887.25,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1368.8232421875
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3787.640625,
        1393.05517578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4040.78076171875,
      "bbox_min": [
        -1573.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -963.1756591796875,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3548.5302734375,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8271644711494446,
        0.49159952998161316,
        0.2722660005092621
      ],
      "plane_d": 2790.077392578125,
      "bbox_min": [
        -1573.7880859375,
        -3803.400634765625,
        1369.247802734375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8275795578956604,
        0.49191412329673767,
        0.2704302966594696
      ],
      "plane_d": 198.2255859375,
      "bbox_min": [
        -1573.7880859375,
        -3803.400634765625,
        1369.247802734375
      ],
      "bbox_max": [
        -1565.978759765625,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9642329216003418,
        0.265056312084198
      ],
      "plane_d": 3300.131103515625,
      "bbox_min": [
        -1571.134033203125,
        -3800.544189453125,
        1369.247802734375
      ],
      "bbox_max": [
        -1565.978759765625,
        -3798.935546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -969.6336669921875,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3553.34326171875,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4051.794921875,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8271644711494446,
        0.49159952998161316,
        0.2722660005092621
      ],
      "plane_d": 2794.903564453125,
      "bbox_min": [
        -1572.7880859375,
        -3814.900634765625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8275795578956604,
        0.49191412329673767,
        0.2704302966594696
      ],
      "plane_d": 204.7100830078125,
      "bbox_min": [
        -1572.7880859375,
        -3814.900634765625,
        1369.247802734375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9642329216003418,
        0.265056312084198
      ],
      "plane_d": 3311.2197265625,
      "bbox_min": [
        -1570.134033203125,
        -3812.044189453125,
        1369.247802734375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3810.435546875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1630.884033203125,
        -3854.4609375,
        1368.8232421875
      ],
      "bbox_max": [
        -1629.1417236328125,
        -3852.664794921875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1630.884033203125,
        -3854.4609375,
        1375.022705078125
      ],
      "bbox_max": [
        -1629.17919921875,
        -3854.36181640625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3787.640625,
        1393.05517578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1573.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2757.938232421875,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 951.1123046875,
      "bbox_min": [
        -1573.7880859375,
        -3803.400634765625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3544.34716796875,
      "bbox_min": [
        -1571.134033203125,
        -3803.400634765625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4033.89306640625,
      "bbox_min": [
        -1571.134033203125,
        -3799.203125,
        1392.0999755859375
      ],
      "bbox_max": [
        -1565.978759765625,
        -3798.935546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2762.74365234375,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 957.587646484375,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3549.166259765625,
      "bbox_min": [
        -1570.134033203125,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1570.134033203125,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4044.966796875,
      "bbox_min": [
        -1570.134033203125,
        -3810.703125,
        1392.0999755859375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3810.435546875,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7829016447067261,
        -0.42999276518821716,
        0.4496346414089203
      ],
      "plane_d": -3476.609375,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3787.640625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9219957590103149,
        -0.3687887489795685,
        -0.117977574467659
      ],
      "plane_d": -2678.5166015625,
      "bbox_min": [
        -1566.88525390625,
        -3818.29052734375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1553.8087158203125,
        -3787.640625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1566.88525390625,
        -3789.5859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.068359375,
        -3787.640625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1566.88525390625,
        -3789.5859375,
        1380.7889404296875
      ],
      "bbox_max": [
        -1566.07080078125,
        -3788.446044921875,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321924567222595,
        -0.15732266008853912,
        0.6626793146133423
      ],
      "plane_d": -2651.123779296875,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8603194952011108,
        -0.13034118711948395,
        0.49280983209609985
      ],
      "plane_d": -2512.115234375,
      "bbox_min": [
        -1553.8087158203125,
        -3850.2529296875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3818.267578125,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47025132179260254,
        -0.10104064643383026,
        -0.8767293095588684
      ],
      "plane_d": 96.09918212890625,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3544.34716796875,
      "bbox_min": [
        -1573.462646484375,
        -3819.073486328125,
        1387.4808349609375
      ],
      "bbox_max": [
        -1562.65283203125,
        -3799.203125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4044.966796875,
      "bbox_min": [
        -1573.462646484375,
        -3819.073486328125,
        1387.4808349609375
      ],
      "bbox_max": [
        -1562.65283203125,
        -3799.203125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3549.166259765625,
      "bbox_min": [
        -1571.6571044921875,
        -3819.073486328125,
        1388.14794921875
      ],
      "bbox_max": [
        -1562.65283203125,
        -3810.703125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1571.6571044921875,
        -3819.073486328125,
        1388.14794921875
      ],
      "bbox_max": [
        -1562.65283203125,
        -3810.703125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1571.6571044921875,
        -3819.073486328125,
        1389.392822265625
      ],
      "bbox_max": [
        -1565.14013671875,
        -3810.703125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 957.587646484375,
      "bbox_min": [
        -1571.6571044921875,
        -3819.073486328125,
        1390.79736328125
      ],
      "bbox_max": [
        -1569.758056640625,
        -3810.703125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1573.462646484375,
        -3807.573486328125,
        1388.645263671875
      ],
      "bbox_max": [
        -1566.14013671875,
        -3799.203125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 951.1123046875,
      "bbox_min": [
        -1573.462646484375,
        -3807.573486328125,
        1389.9605712890625
      ],
      "bbox_max": [
        -1570.6187744140625,
        -3799.203125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2757.938232421875,
      "bbox_min": [
        -1573.462646484375,
        -3807.573486328125,
        1390.8974609375
      ],
      "bbox_max": [
        -1570.7747802734375,
        -3803.385009765625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5650427341461182,
        -0.31033819913864136,
        -0.764471709728241
      ],
      "plane_d": -1005.0618286132812,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4033.89306640625,
      "bbox_min": [
        -1572.7763671875,
        -3806.57666015625,
        1386.4254150390625
      ],
      "bbox_max": [
        -1565.2379150390625,
        -3799.802490234375,
        1391.440673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 951.1123046875,
      "bbox_min": [
        -1572.7763671875,
        -3806.57666015625,
        1386.4254150390625
      ],
      "bbox_max": [
        -1565.2379150390625,
        -3799.802490234375,
        1391.440673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3544.34716796875,
      "bbox_min": [
        -1567.08740234375,
        -3806.57666015625,
        1386.4254150390625
      ],
      "bbox_max": [
        -1565.2379150390625,
        -3800.353515625,
        1388.843017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1567.07958984375,
        -3806.57666015625,
        1388.5555419921875
      ],
      "bbox_max": [
        -1566.723876953125,
        -3806.48876953125,
        1388.843017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4044.966796875,
      "bbox_min": [
        -1573.3787841796875,
        -3818.981201171875,
        1387.7940673828125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3801.584716796875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1572.462646484375,
        -3818.981201171875,
        1387.7940673828125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3811.068115234375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 957.587646484375,
      "bbox_min": [
        -1572.462646484375,
        -3818.981201171875,
        1387.7940673828125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3811.068115234375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3549.166259765625,
      "bbox_min": [
        -1565.7802734375,
        -3814.837158203125,
        1387.7940673828125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3811.656494140625,
        1388.6966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2757.938232421875,
      "bbox_min": [
        -1573.3787841796875,
        -3807.20556640625,
        1388.041748046875
      ],
      "bbox_max": [
        -1566.46435546875,
        -3801.584716796875,
        1391.8538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1573.3787841796875,
        -3807.20556640625,
        1388.041748046875
      ],
      "bbox_max": [
        -1566.46435546875,
        -3801.584716796875,
        1391.8538818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1566.7867431640625,
        -3806.48876953125,
        1388.041748046875
      ],
      "bbox_max": [
        -1566.46435546875,
        -3805.72314453125,
        1388.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1569.7987060546875,
        -3818.74951171875,
        1387.671875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3811.233154296875,
        1391.041259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4044.966796875,
      "bbox_min": [
        -1569.659912109375,
        -3818.095458984375,
        1387.671875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3811.233154296875,
        1390.2080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1565.8155517578125,
        -3818.095458984375,
        1387.671875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3811.764404296875,
        1388.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3549.166259765625,
      "bbox_min": [
        -1565.8155517578125,
        -3814.83251953125,
        1387.671875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3811.764404296875,
        1388.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2757.938232421875,
      "bbox_min": [
        -1576.2244873046875,
        -3807.01953125,
        1387.2935791015625
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3797.046142578125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1576.2244873046875,
        -3807.01953125,
        1387.2935791015625
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3797.046142578125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 951.1123046875,
      "bbox_min": [
        -1576.2244873046875,
        -3806.40234375,
        1387.2935791015625
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3797.046142578125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1566.8492431640625,
        -3806.40234375,
        1387.2935791015625
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3804.6083984375,
        1388.2728271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43648433685302734,
        -0.46496182680130005,
        -0.7702544331550598
      ],
      "plane_d": -1381.702880859375,
      "bbox_min": [
        -1576.2244873046875,
        -3798.283203125,
        1390.63671875
      ],
      "bbox_max": [
        -1574.70263671875,
        -3797.046142578125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07172953337430954,
        0.11237809807062149,
        0.9910731911659241
      ],
      "plane_d": -1041.2471923828125,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23484168946743011,
        -0.08580072969198227,
        0.9682394862174988
      ],
      "plane_d": -1298.018798828125,
      "bbox_min": [
        -1561.7548828125,
        -3870.458984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.7347412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1561.7548828125,
        -3870.458984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.7347412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1561.7548828125,
        -3870.458984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.7347412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19392429292201996,
        0.045363664627075195,
        0.9799670577049255
      ],
      "plane_d": -870.432861328125,
      "bbox_min": [
        -1561.7548828125,
        -3870.458984375,
        1375.6214599609375
      ],
      "bbox_max": [
        -1557.9388427734375,
        -3868.9267578125,
        1376.46728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1561.7548828125,
        -3870.458984375,
        1376.43505859375
      ],
      "bbox_max": [
        -1561.7230224609375,
        -3870.18994140625,
        1376.46728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18132080137729645,
        0.5047606825828552,
        -0.8440020680427551
      ],
      "plane_d": 3411.70654296875,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48407191038131714,
        0.23269326984882355,
        -0.8435213565826416
      ],
      "plane_d": 1313.933349609375,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7980432510375977,
        -0.5389218330383301,
        -0.26961150765419006
      ],
      "plane_d": -2948.3935546875,
      "bbox_min": [
        -1563.3109130859375,
        -3870.385986328125,
        1381.0711669921875
      ],
      "bbox_max": [
        -1550.589111328125,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1563.3109130859375,
        -3870.385986328125,
        1381.0711669921875
      ],
      "bbox_max": [
        -1550.589111328125,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2782386839389801,
        -0.046120766550302505,
        -0.9594039916992188
      ],
      "plane_d": 1586.4541015625,
      "bbox_min": [
        -1558.3336181640625,
        -3869.08642578125,
        1387.6256103515625
      ],
      "bbox_max": [
        -1558.1209716796875,
        -3868.402099609375,
        1387.700927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476256012916565,
        0.1850539743900299,
        -0.9491318464279175
      ],
      "plane_d": 1635.9110107421875,
      "bbox_min": [
        -1563.3109130859375,
        -3868.849853515625,
        1381.0711669921875
      ],
      "bbox_max": [
        -1550.589111328125,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13550253212451935,
        -0.1595839411020279,
        -0.9778404235839844
      ],
      "plane_d": 528.3904418945312,
      "bbox_min": [
        -1558.28173828125,
        -3868.849853515625,
        1386.29443359375
      ],
      "bbox_max": [
        -1551.9443359375,
        -3866.154296875,
        1387.6256103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9023956656455994,
        -0.25720053911209106,
        -0.3457311689853668
      ],
      "plane_d": -1915.646728515625,
      "bbox_min": [
        -1552.103515625,
        -3866.569091796875,
        1386.29443359375
      ],
      "bbox_max": [
        -1551.9443359375,
        -3866.154296875,
        1386.4703369140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2754978537559509,
        -0.1472751498222351,
        -0.9499531984329224
      ],
      "plane_d": 320.03118896484375,
      "bbox_min": [
        -1552.103515625,
        -3866.569091796875,
        1386.3995361328125
      ],
      "bbox_max": [
        -1551.98779296875,
        -3866.154296875,
        1386.4703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205530881881714,
        -0.2767222225666046,
        -0.2756933867931366
      ],
      "plane_d": -2116.40283203125,
      "bbox_min": [
        -1552.0811767578125,
        -3866.5048828125,
        1381.0711669921875
      ],
      "bbox_max": [
        -1550.589111328125,
        -3865.6220703125,
        1386.3995361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9298285841941833,
        -0.24718093872070312,
        0.2726173400878906
      ],
      "plane_d": -2773.91748046875,
      "bbox_min": [
        -1550.6839599609375,
        -3865.97314453125,
        1381.0711669921875
      ],
      "bbox_max": [
        -1550.589111328125,
        -3865.6220703125,
        1381.2196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08961550891399384,
        0.6345558762550354,
        -0.7676638960838318
      ],
      "plane_d": 3659.609130859375,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20497587323188782,
        0.7754420638084412,
        -0.5972223281860352
      ],
      "plane_d": 4150.05712890625,
      "bbox_min": [
        -1597.1497802734375,
        -3871.086181640625,
        1383.978759765625
      ],
      "bbox_max": [
        -1561.3458251953125,
        -3857.524169921875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23571813106536865,
        0.7597424983978271,
        -0.6059936881065369
      ],
      "plane_d": 4149.951171875,
      "bbox_min": [
        -1576.157470703125,
        -3871.086181640625,
        1383.978759765625
      ],
      "bbox_max": [
        -1570.6883544921875,
        -3864.002197265625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04376031830906868,
        0.7580565214157104,
        -0.6507191061973572
      ],
      "plane_d": 3903.817626953125,
      "bbox_min": [
        -1572.642822265625,
        -3870.885498046875,
        1384.304931640625
      ],
      "bbox_max": [
        -1561.3458251953125,
        -3861.292724609375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44569045305252075,
        -0.05709591880440712,
        -0.8933644890785217
      ],
      "plane_d": 1713.296630859375,
      "bbox_min": [
        -1562.5367431640625,
        -3870.784423828125,
        1385.1798095703125
      ],
      "bbox_max": [
        -1561.3458251953125,
        -3869.739990234375,
        1386.1824951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9788185358047485,
        0.07095997035503387,
        -0.19203943014144897
      ],
      "plane_d": 2070.119873046875,
      "bbox_min": [
        -1562.5367431640625,
        -3870.784423828125,
        1385.1798095703125
      ],
      "bbox_max": [
        -1562.3983154296875,
        -3870.226318359375,
        1385.7205810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291770458221436,
        0.09949781745672226,
        -0.3559917211532593
      ],
      "plane_d": 2330.1787109375,
      "bbox_min": [
        -1562.4896240234375,
        -3870.75830078125,
        1385.5201416015625
      ],
      "bbox_max": [
        -1562.3983154296875,
        -3870.226318359375,
        1385.7205810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37581175565719604,
        0.30167463421821594,
        -0.8762179613113403
      ],
      "plane_d": 1794.4366455078125,
      "bbox_min": [
        -1572.642822265625,
        -3869.936279296875,
        1385.8470458984375
      ],
      "bbox_max": [
        -1562.827392578125,
        -3861.292724609375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26621708273887634,
        0.15397192537784576,
        -0.951536238193512
      ],
      "plane_d": 2347.12158203125,
      "bbox_min": [
        -1631.0516357421875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1631.0516357421875,
        -3854.6337890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1629.17919921875,
        -3854.36181640625,
        1386.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1575.336669921875,
        -3872.4970703125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1561.7315673828125,
        -3865.60595703125,
        1379.745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1561.8089599609375,
        -3870.490234375,
        1376.43505859375
      ],
      "bbox_max": [
        -1561.7315673828125,
        -3870.18994140625,
        1376.7056884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20014050602912903,
        0.645072340965271,
        0.7374451160430908
      ],
      "plane_d": 1794.3597412109375,
      "bbox_min": [
        -1575.336669921875,
        -3872.4970703125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1561.7548828125,
        -3865.60595703125,
        1379.745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1562.0927734375,
        -3870.60498046875,
        1376.43505859375
      ],
      "bbox_max": [
        -1561.7548828125,
        -3870.18994140625,
        1377.5804443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40307989716529846,
        0.9129976034164429,
        -0.06294482201337814
      ],
      "plane_d": 2990.6015625,
      "bbox_min": [
        -1564.6534423828125,
        -3871.307861328125,
        1377.228515625
      ],
      "bbox_max": [
        -1562.017822265625,
        -3870.25146484375,
        1378.782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1562.29541015625,
        -3870.686767578125,
        1377.228515625
      ],
      "bbox_max": [
        -1562.017822265625,
        -3870.25146484375,
        1378.204833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0681077316403389,
        0.5112215876579285,
        0.8567460775375366
      ],
      "plane_d": 904.2274780273438,
      "bbox_min": [
        -1629.17919921875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14916349947452545,
        0.6815324425697327,
        0.7164244055747986
      ],
      "plane_d": 1884.0177001953125,
      "bbox_min": [
        -1595.336181640625,
        -3872.758544921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1562.2646484375,
        -3860.7216796875,
        1380.1209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1571.21337890625,
        -3872.758544921875,
        1378.7728271484375
      ],
      "bbox_max": [
        -1564.6534423828125,
        -3870.365234375,
        1380.1209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40307989716529846,
        0.9129976034164429,
        -0.06294482201337814
      ],
      "plane_d": 2990.6015625,
      "bbox_min": [
        -1568.1483154296875,
        -3872.758544921875,
        1378.782470703125
      ],
      "bbox_max": [
        -1564.6534423828125,
        -3871.307861328125,
        1380.1209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40307989716529846,
        0.9129976034164429,
        -0.06294482201337814
      ],
      "plane_d": 2990.6015625,
      "bbox_min": [
        -1565.3740234375,
        -3871.5966796875,
        1377.973388671875
      ],
      "bbox_max": [
        -1562.2646484375,
        -3870.30908203125,
        1379.207275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1562.3731689453125,
        -3870.71826171875,
        1377.973388671875
      ],
      "bbox_max": [
        -1562.2646484375,
        -3870.30908203125,
        1378.444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6908631324768066,
        0.3320978283882141,
        0.6421985626220703
      ],
      "plane_d": -674.5504150390625,
      "bbox_min": [
        -1629.17919921875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1551.662841796875,
        -3866.39111328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9298285841941833,
        -0.24718093872070312,
        0.2726173400878906
      ],
      "plane_d": -2773.91748046875,
      "bbox_min": [
        -1551.2940673828125,
        -3866.2421875,
        1378.5570068359375
      ],
      "bbox_max": [
        -1550.62841796875,
        -3865.6220703125,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1391441822052002,
        0.49288704991340637,
        0.8588953614234924
      ],
      "plane_d": 945.3888549804688,
      "bbox_min": [
        -1629.17919921875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1561.318359375,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20497587323188782,
        0.7754420638084412,
        -0.5972223281860352
      ],
      "plane_d": 4150.05712890625,
      "bbox_min": [
        -1598.1192626953125,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1561.318359375,
        -3788.48291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23571813106536865,
        0.7597424983978271,
        -0.6059936881065369
      ],
      "plane_d": 4149.951171875,
      "bbox_min": [
        -1579.16015625,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1568.397705078125,
        -3867.600341796875,
        1386.221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20014050602912903,
        0.645072340965271,
        0.7374451160430908
      ],
      "plane_d": 1794.3597412109375,
      "bbox_min": [
        -1579.16015625,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1568.397705078125,
        -3870.67431640625,
        1384.304931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40385907888412476,
        0.914762556552887,
        -0.01035915594547987
      ],
      "plane_d": 2923.58349609375,
      "bbox_min": [
        -1570.0196533203125,
        -3873.51025390625,
        1381.199951171875
      ],
      "bbox_max": [
        -1568.397705078125,
        -3872.783447265625,
        1382.1558837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1570.126220703125,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1569.641845703125,
        -3873.2294921875,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40385907888412476,
        0.914762556552887,
        -0.01035915594547987
      ],
      "plane_d": 2923.58349609375,
      "bbox_min": [
        -1569.425537109375,
        -3873.248046875,
        1381.199951171875
      ],
      "bbox_max": [
        -1568.7542724609375,
        -3872.95166015625,
        1381.4500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1563.3109130859375,
        -3870.314697265625,
        1385.5733642578125
      ],
      "bbox_max": [
        -1561.318359375,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291770458221436,
        0.09949781745672226,
        -0.3559917211532593
      ],
      "plane_d": 2330.1787109375,
      "bbox_min": [
        -1562.494384765625,
        -3870.2705078125,
        1385.6103515625
      ],
      "bbox_max": [
        -1562.47998046875,
        -3870.1376953125,
        1385.647705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9788185358047485,
        0.07095997035503387,
        -0.19203943014144897
      ],
      "plane_d": 2070.119873046875,
      "bbox_min": [
        -1563.333984375,
        -3871.087890625,
        1378.208984375
      ],
      "bbox_max": [
        -1562.3427734375,
        -3870.1376953125,
        1385.6348876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1563.333984375,
        -3871.087890625,
        1378.208984375
      ],
      "bbox_max": [
        -1562.3427734375,
        -3870.327392578125,
        1381.240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9283306002616882,
        0.10818085074424744,
        0.35566747188568115
      ],
      "plane_d": 1378.76318359375,
      "bbox_min": [
        -1563.333984375,
        -3871.087890625,
        1381.0677490234375
      ],
      "bbox_max": [
        -1563.224609375,
        -3870.55859375,
        1381.240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04376031830906868,
        0.7580565214157104,
        -0.6507191061973572
      ],
      "plane_d": 3903.817626953125,
      "bbox_min": [
        -1572.9398193359375,
        -3872.783447265625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1562.494384765625,
        -3788.48291015625,
        1391.759521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2762.74365234375,
      "bbox_min": [
        -1572.9398193359375,
        -3818.730712890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3800.156494140625,
        1391.759521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 957.587646484375,
      "bbox_min": [
        -1572.9398193359375,
        -3818.730712890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3800.156494140625,
        1391.759521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1569.78857421875,
        -3818.730712890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3811.310302734375,
        1390.980224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4044.966796875,
      "bbox_min": [
        -1569.6141357421875,
        -3818.07861328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3811.310302734375,
        1389.9329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1566.970947265625,
        -3818.07861328125,
        1377.8209228515625
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3811.82275390625,
        1388.849365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.825981080532074,
        0.49089622497558594,
        -0.27708524465560913
      ],
      "plane_d": 3549.166259765625,
      "bbox_min": [
        -1566.970947265625,
        -3814.8310546875,
        1380.080078125
      ],
      "bbox_max": [
        -1564.1722412109375,
        -3811.82275390625,
        1388.1029052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8271644711494446,
        0.49159952998161316,
        0.2722660005092621
      ],
      "plane_d": 2794.903564453125,
      "bbox_min": [
        -1568.1707763671875,
        -3814.703369140625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.863525390625,
        -3812.7412109375,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -969.6336669921875,
      "bbox_min": [
        -1568.1707763671875,
        -3816.7548828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.2955322265625,
        -3813.87060546875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4051.794921875,
      "bbox_min": [
        -1568.1707763671875,
        -3816.7548828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.2955322265625,
        -3813.87060546875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8275795578956604,
        0.49191412329673767,
        0.2704302966594696
      ],
      "plane_d": 204.7100830078125,
      "bbox_min": [
        -1568.7706298828125,
        -3814.748046875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.52978515625,
        -3812.044189453125,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8264107704162598,
        0.4912193715572357,
        -0.2752249836921692
      ],
      "plane_d": 951.1123046875,
      "bbox_min": [
        -1572.9398193359375,
        -3806.885986328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.2955322265625,
        -3800.156494140625,
        1390.565673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9629257917404175,
        -0.26976674795150757
      ],
      "plane_d": 4033.89306640625,
      "bbox_min": [
        -1570.408447265625,
        -3806.2890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.60009765625,
        -3800.156494140625,
        1388.697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1567.970947265625,
        -3806.2890625,
        1377.8209228515625
      ],
      "bbox_max": [
        -1565.60009765625,
        -3800.77392578125,
        1387.9029541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8271644711494446,
        0.49159952998161316,
        0.2722660005092621
      ],
      "plane_d": 2790.077392578125,
      "bbox_min": [
        -1569.1707763671875,
        -3803.203369140625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.863525390625,
        -3801.241455078125,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -963.1756591796875,
      "bbox_min": [
        -1569.1707763671875,
        -3805.2548828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.2955322265625,
        -3802.37060546875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4040.78076171875,
      "bbox_min": [
        -1569.1707763671875,
        -3805.2548828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.2955322265625,
        -3802.37060546875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8275795578956604,
        0.49191412329673767,
        0.2704302966594696
      ],
      "plane_d": 198.2255859375,
      "bbox_min": [
        -1569.7706298828125,
        -3803.248046875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.52978515625,
        -3800.544189453125,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -963.1756591796875,
      "bbox_min": [
        -1570.1778564453125,
        -3806.1083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.435791015625,
        -3800.544189453125,
        1377.9420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205530881881714,
        -0.2767222225666046,
        -0.2756933867931366
      ],
      "plane_d": -2116.40283203125,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1544.5625,
        -3865.957275390625,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9023956656455994,
        -0.25720053911209106,
        -0.3457311689853668
      ],
      "plane_d": -1915.646728515625,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1544.5625,
        -3865.957275390625,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2754978537559509,
        -0.1472751498222351,
        -0.9499531984329224
      ],
      "plane_d": 320.03118896484375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1544.5625,
        -3865.957275390625,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9298285841941833,
        -0.24718093872070312,
        0.2726173400878906
      ],
      "plane_d": -2773.91748046875,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1544.5625,
        -3865.957275390625,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1551.9136962890625,
        -3866.78125,
        1376.2174072265625
      ],
      "bbox_max": [
        -1551.2940673828125,
        -3866.2421875,
        1378.5570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1551.9136962890625,
        -3866.78125,
        1376.2174072265625
      ],
      "bbox_max": [
        -1551.76416015625,
        -3866.431884765625,
        1376.258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9114702343940735,
        -0.21743008494377136,
        0.3492078185081482
      ],
      "plane_d": -2735.796875,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1544.5625,
        -3866.4921875,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13550253212451935,
        -0.1595839411020279,
        -0.9778404235839844
      ],
      "plane_d": 528.3904418945312,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1546.7265625,
        -3866.4921875,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0954543873667717,
        -0.05763554200530052,
        0.99376380443573
      ],
      "plane_d": -1738.6685791015625,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1546.7265625,
        -3866.4921875,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1557.711669921875,
        -3868.8515625,
        1375.572509765625
      ],
      "bbox_max": [
        -1551.8245849609375,
        -3866.4921875,
        1376.258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27827781438827515,
        -0.04297422617673874,
        0.9595388174057007
      ],
      "plane_d": -1918.583740234375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1546.7265625,
        -3866.78125,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2782386839389801,
        -0.046120766550302505,
        -0.9594039916992188
      ],
      "plane_d": 1586.4541015625,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1553.21875,
        -3868.8310546875,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27836617827415466,
        0.03482351079583168,
        0.9598435759544373
      ],
      "plane_d": -751.99365234375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1374.9375
      ],
      "bbox_max": [
        -1553.21875,
        -3868.8310546875,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19392429292201996,
        0.045363664627075195,
        0.9799670577049255
      ],
      "plane_d": -870.432861328125,
      "bbox_min": [
        -1561.850341796875,
        -3887.25,
        1375.572509765625
      ],
      "bbox_max": [
        -1557.7020263671875,
        -3868.8310546875,
        1376.833251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1561.850341796875,
        -3887.25,
        1376.4410400390625
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.45556640625,
        1376.833251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44569045305252075,
        -0.05709591880440712,
        -0.8933644890785217
      ],
      "plane_d": 1713.296630859375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1376.8203125
      ],
      "bbox_max": [
        -1558.3336181640625,
        -3869.08642578125,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291770458221436,
        0.09949781745672226,
        -0.3559917211532593
      ],
      "plane_d": 2330.1787109375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1376.8203125
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.507080078125,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9283306002616882,
        0.10818085074424744,
        0.35566747188568115
      ],
      "plane_d": 1378.76318359375,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1376.8203125
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.507080078125,
        1385.5201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1563.224609375,
        -3887.25,
        1376.8203125
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.507080078125,
        1381.0677490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9788185358047485,
        0.07095997035503387,
        -0.19203943014144897
      ],
      "plane_d": 2070.119873046875,
      "bbox_min": [
        -1563.2877197265625,
        -3887.25,
        1381.240234375
      ],
      "bbox_max": [
        -1561.875,
        -3870.75830078125,
        1385.5201416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2639053463935852,
        0.9637477397918701,
        0.03929918631911278
      ],
      "plane_d": 3080.673828125,
      "bbox_min": [
        -1650.1533203125,
        -3705.382568359375,
        1405.224365234375
      ],
      "bbox_max": [
        -1606.7525634765625,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2637690603733063,
        0.9637511968612671,
        0.04012034833431244
      ],
      "plane_d": 3079.749267578125,
      "bbox_min": [
        -1650.1533203125,
        -3705.382568359375,
        1405.224365234375
      ],
      "bbox_max": [
        -1606.7525634765625,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356482297182083,
        0.860556423664093,
        -0.45156675577163696
      ],
      "plane_d": 3439.44580078125,
      "bbox_min": [
        -1650.1533203125,
        -3705.382568359375,
        1405.224365234375
      ],
      "bbox_max": [
        -1606.7525634765625,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21934282779693604,
        0.8014279007911682,
        0.5564188361167908
      ],
      "plane_d": 1824.4462890625,
      "bbox_min": [
        -1650.1533203125,
        -3705.382568359375,
        1405.224365234375
      ],
      "bbox_max": [
        -1606.876220703125,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2338891476392746,
        0.8571308255195618,
        -0.45893651247024536
      ],
      "plane_d": 3440.0791015625,
      "bbox_min": [
        -1650.1533203125,
        -3705.382568359375,
        1405.224365234375
      ],
      "bbox_max": [
        -1607.5899658203125,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2171442210674286,
        0.7965154051780701,
        0.5642797946929932
      ],
      "plane_d": 1798.797119140625,
      "bbox_min": [
        -1650.1533203125,
        -3705.1220703125,
        1405.224365234375
      ],
      "bbox_max": [
        -1607.5899658203125,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1418.585693359375,
      "bbox_min": [
        -1650.1533203125,
        -3703.6181640625,
        1405.224365234375
      ],
      "bbox_max": [
        -1607.5899658203125,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1650.1533203125,
        -3703.15380859375,
        1405.224365234375
      ],
      "bbox_max": [
        -1607.810302734375,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.20809638500213623,
        -0.7730529308319092,
        -0.5992369055747986
      ],
      "plane_d": -1666.8306884765625,
      "bbox_min": [
        -1650.1533203125,
        -3699.730712890625,
        1405.224365234375
      ],
      "bbox_max": [
        -1609.435302734375,
        -3686.002685546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21075879037380219,
        -0.7785492539405823,
        -0.59113609790802
      ],
      "plane_d": -1694.2664794921875,
      "bbox_min": [
        -1649.1785888671875,
        -3699.730712890625,
        1414.902587890625
      ],
      "bbox_max": [
        -1609.435302734375,
        -3686.514404296875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25853103399276733,
        -0.9615395665168762,
        -0.09275555610656738
      ],
      "plane_d": -2997.08837890625,
      "bbox_min": [
        -1650.1533203125,
        -3697.864013671875,
        1405.224365234375
      ],
      "bbox_max": [
        -1610.322265625,
        -3686.002685546875,
        1414.902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588600516319275,
        -0.9616338014602661,
        -0.0908404216170311
      ],
      "plane_d": -2999.603759765625,
      "bbox_min": [
        -1649.9852294921875,
        -3697.0927734375,
        1408.7421875
      ],
      "bbox_max": [
        -1610.6878662109375,
        -3686.002685546875,
        1414.902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24298441410064697,
        -0.9012511372566223,
        0.35875484347343445
      ],
      "plane_d": -3435.9716796875,
      "bbox_min": [
        -1650.1533203125,
        -3697.864013671875,
        1405.224365234375
      ],
      "bbox_max": [
        -1610.322265625,
        -3686.002685546875,
        1408.7421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24171987175941467,
        -0.8990147709846497,
        0.3651629090309143
      ],
      "plane_d": -3438.79296875,
      "bbox_min": [
        -1650.1533203125,
        -3697.864013671875,
        1405.224853515625
      ],
      "bbox_max": [
        -1610.94873046875,
        -3686.002685546875,
        1408.7421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.581928551197052,
        -0.808499813079834,
        -0.08767619729042053
      ],
      "plane_d": -1904.870361328125,
      "bbox_min": [
        -1687.3729248046875,
        -3728.63427734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1647.450927734375,
        -3696.543701171875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5476986765861511,
        -0.760942816734314,
        0.34783926606178284
      ],
      "plane_d": -2399.08740234375,
      "bbox_min": [
        -1687.3729248046875,
        -3728.63427734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1647.450927734375,
        -3696.543701171875,
        1418.5858154296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1686.2406005859375,
        -3728.63427734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1647.450927734375,
        -3697.864013671875,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.489881306886673,
        0.6815534234046936,
        0.5436003804206848
      ],
      "plane_d": 952.6276245117188,
      "bbox_min": [
        -1680.02490234375,
        -3728.47802734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1647.530517578125,
        -3703.15380859375,
        1408.244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583228588104248,
        0.8114240169525146,
        0.03788614273071289
      ],
      "plane_d": 1992.185546875,
      "bbox_min": [
        -1680.02490234375,
        -3728.47802734375,
        1408.234130859375
      ],
      "bbox_max": [
        -1647.530517578125,
        -3705.1220703125,
        1408.244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5242039561271667,
        0.7293413877487183,
        -0.4396265149116516
      ],
      "plane_d": 2460.966796875,
      "bbox_min": [
        -1679.8017578125,
        -3728.63427734375,
        1415.00439453125
      ],
      "bbox_max": [
        -1647.450927734375,
        -3703.6181640625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583228588104248,
        0.8114240169525146,
        0.03788614273071289
      ],
      "plane_d": 1992.185546875,
      "bbox_min": [
        -1680.02490234375,
        -3728.63427734375,
        1408.234130859375
      ],
      "bbox_max": [
        -1647.4510498046875,
        -3705.12255859375,
        1415.0157470703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8697153925895691,
        -0.34168773889541626,
        0.3561524748802185
      ],
      "plane_d": -306.4100341796875,
      "bbox_min": [
        -1702.01416015625,
        -3760.60009765625,
        1405.224365234375
      ],
      "bbox_max": [
        -1686.24072265625,
        -3723.3330078125,
        1408.8626708984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9269459843635559,
        -0.364172101020813,
        -0.09027688205242157
      ],
      "plane_d": 335.346435546875,
      "bbox_min": [
        -1702.01416015625,
        -3760.60009765625,
        1408.7421875
      ],
      "bbox_max": [
        -1686.90234375,
        -3723.33935546875,
        1414.902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1418.5858154296875,
      "bbox_min": [
        -1701.43994140625,
        -3760.734130859375,
        1414.902587890625
      ],
      "bbox_max": [
        -1684.6427001953125,
        -3725.244384765625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7969731092453003,
        0.09249168634414673,
        -0.5968911647796631
      ],
      "plane_d": 2548.369140625,
      "bbox_min": [
        -1701.43994140625,
        -3760.734130859375,
        1414.902587890625
      ],
      "bbox_max": [
        -1699.703125,
        -3760.60009765625,
        1417.2216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3724.1259765625,
        1418.5858154296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7722088098526001,
        0.31050994992256165,
        0.5543257594108582
      ],
      "plane_d": -920.2210083007812,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3727.29736328125,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8285152316093445,
        0.3337593078613281,
        -0.44963014125823975
      ],
      "plane_d": 488.9586181640625,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3727.575927734375,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7828393578529358,
        0.31728696823120117,
        0.5352489352226257
      ],
      "plane_d": -885.9479370117188,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3728.47802734375,
        1418.0283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8357576131820679,
        0.3390980362892151,
        -0.43188145756721497
      ],
      "plane_d": 471.5845947265625,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3728.47802734375,
        1418.0283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.926063060760498,
        0.3753359615802765,
        0.039119306951761246
      ],
      "plane_d": -211.46630859375,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3728.47802734375,
        1416.9354248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.925990104675293,
        0.3757087290287018,
        0.03721969202160835
      ],
      "plane_d": -207.265869140625,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1679.8017578125,
        -3728.63427734375,
        1416.9354248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9884322285652161,
        0.1204712986946106,
        -0.09213302284479141
      ],
      "plane_d": 2265.16162109375,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1699.9019775390625,
        -3760.60009765625,
        1416.9354248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9903883337974548,
        0.11493825167417526,
        -0.07694196701049805
      ],
      "plane_d": 2226.1884765625,
      "bbox_min": [
        -1701.43994140625,
        -3761.706787109375,
        1414.4871826171875
      ],
      "bbox_max": [
        -1701.30712890625,
        -3760.60009765625,
        1414.912353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7969731092453003,
        0.09249168634414673,
        -0.5968911647796631
      ],
      "plane_d": 2548.369140625,
      "bbox_min": [
        -1701.43994140625,
        -3761.6865234375,
        1414.902587890625
      ],
      "bbox_max": [
        -1701.30712890625,
        -3760.60009765625,
        1414.912353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291348457336426,
        0.06194232776761055,
        0.36451566219329834
      ],
      "plane_d": 1300.832275390625,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1405.224365234375
      ],
      "bbox_max": [
        -1699.9019775390625,
        -3760.60009765625,
        1416.9354248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7969731092453003,
        0.09249168634414673,
        -0.5968911647796631
      ],
      "plane_d": 2548.369140625,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1408.412109375
      ],
      "bbox_max": [
        -1699.9019775390625,
        -3760.60009765625,
        1416.9354248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9808455109596252,
        0.11954662203788757,
        0.153787299990654
      ],
      "plane_d": 1902.333251953125,
      "bbox_min": [
        -1702.01416015625,
        -3762.04052734375,
        1408.412109375
      ],
      "bbox_max": [
        -1701.790771484375,
        -3760.60009765625,
        1408.7421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1373.5,
      "bbox_min": [
        -1708.5179443359375,
        -3856.43603515625,
        1210.0
      ],
      "bbox_max": [
        -1566.068359375,
        -3715.59619140625,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1251.0999755859375,
      "bbox_min": [
        -1697.310791015625,
        -3855.679931640625,
        1210.0
      ],
      "bbox_max": [
        -1579.6533203125,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.8687447905540466,
        -0.3647114336490631,
        -0.3350641429424286
      ],
      "plane_d": -2363.34619140625,
      "bbox_min": [
        -1679.140625,
        -3841.1748046875,
        1210.0
      ],
      "bbox_max": [
        -1597.027587890625,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8646363615989685,
        0.49052292108535767,
        0.1085875928401947
      ],
      "plane_d": 3102.247802734375,
      "bbox_min": [
        -1635.23779296875,
        -3787.808349609375,
        1242.515380859375
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9938765168190002,
        0.11049634218215942
      ],
      "plane_d": 3573.1875,
      "bbox_min": [
        -1635.23779296875,
        -3734.29638671875,
        1242.515380859375
      ],
      "bbox_max": [
        -1625.97802734375,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09095914661884308,
        0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": 3882.0458984375,
      "bbox_min": [
        -1614.307373046875,
        -3787.808349609375,
        1246.5
      ],
      "bbox_max": [
        -1601.682861328125,
        -3774.191650390625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09095914661884308,
        -0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": -3939.883056640625,
      "bbox_min": [
        -1614.307373046875,
        -3787.808349609375,
        1246.5
      ],
      "bbox_max": [
        -1601.682861328125,
        -3774.191650390625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9821799397468567,
        -0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": 843.1284790039062,
      "bbox_min": [
        -1614.307373046875,
        -3787.808349609375,
        1246.5
      ],
      "bbox_max": [
        -1601.682861328125,
        -3774.191650390625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1614.307373046875,
        -3780.4306640625,
        1246.5
      ],
      "bbox_max": [
        -1613.0626220703125,
        -3774.191650390625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39069291949272156,
        0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": 2792.57861328125,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39069291949272156,
        -0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": -2834.691650390625,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.944113552570343,
        0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": -314.7994384765625,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4191102683544159,
        0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": 4039.34228515625,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1599.1527099609375,
        -3733.010009765625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4191102683544159,
        -0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": -4095.93798828125,
      "bbox_min": [
        -1614.8472900390625,
        -3744.989990234375,
        1246.5
      ],
      "bbox_max": [
        -1609.0611572265625,
        -3742.288330078125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5621868371963501,
        -0.7578160762786865,
        -0.331150621175766
      ],
      "plane_d": -3357.07421875,
      "bbox_min": [
        -1679.140625,
        -3841.1748046875,
        1210.0
      ],
      "bbox_max": [
        -1606.1904296875,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5760646462440491,
        -0.7587732076644897,
        -0.3039945960044861
      ],
      "plane_d": -3416.222900390625,
      "bbox_min": [
        -1647.8931884765625,
        -3770.57861328125,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1647.8931884765625,
        -3759.095458984375,
        1210.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1647.8931884765625,
        -3759.095458984375,
        1210.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9940398931503296,
        0.10901788622140884
      ],
      "plane_d": -3872.147216796875,
      "bbox_min": [
        -1640.5880126953125,
        -3759.095458984375,
        1210.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9938765168190002,
        0.11049634218215942
      ],
      "plane_d": 3573.1875,
      "bbox_min": [
        -1640.5880126953125,
        -3759.095458984375,
        1210.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3733.342041015625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829205334186554,
        -0.49467000365257263,
        -0.2602307200431824
      ],
      "plane_d": -194.2471923828125,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1210.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3748.927978515625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1630.0799560546875,
        -3751.81640625,
        1210.0
      ],
      "bbox_max": [
        -1628.09033203125,
        -3748.927978515625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1645.1119384765625,
        -3759.095458984375,
        1242.515380859375
      ],
      "bbox_max": [
        -1634.6077880859375,
        -3751.12109375,
        1250.600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9940398931503296,
        0.10901788622140884
      ],
      "plane_d": -3872.147216796875,
      "bbox_min": [
        -1640.2171630859375,
        -3759.095458984375,
        1242.515380859375
      ],
      "bbox_max": [
        -1634.6077880859375,
        -3758.208740234375,
        1250.600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1679.140625,
        -3841.1748046875,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9503167867660522,
        0.3110123574733734,
        0.013012579642236233
      ],
      "plane_d": -415.693359375,
      "bbox_min": [
        -1679.140625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3769.202880859375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1672.76513671875,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3769.202880859375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1672.76513671875,
        -3834.699951171875,
        1242.515380859375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3769.202880859375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9698894619941711,
        -0.2424565553665161,
        0.023007404059171677
      ],
      "plane_d": -2563.630615234375,
      "bbox_min": [
        -1663.17626953125,
        -3819.988525390625,
        1242.515380859375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3769.202880859375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1653.9532470703125,
        -3774.44384765625,
        1246.58984375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3769.202880859375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1663.17626953125,
        -3819.988525390625,
        1242.515380859375
      ],
      "bbox_max": [
        -1662.4638671875,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661102056503296,
        0.49135321378707886,
        0.09178858995437622
      ],
      "plane_d": 319.3603515625,
      "bbox_min": [
        -1672.76513671875,
        -3834.699951171875,
        1242.515380859375
      ],
      "bbox_max": [
        -1663.1539306640625,
        -3815.76708984375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661896586418152,
        -0.49140921235084534,
        0.09073296934366226
      ],
      "plane_d": -3443.62451171875,
      "bbox_min": [
        -1672.49560546875,
        -3834.699951171875,
        1242.515380859375
      ],
      "bbox_max": [
        -1663.1539306640625,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622641444206238,
        -0.8268104195594788,
        0.015609738416969776
      ],
      "plane_d": -2242.9638671875,
      "bbox_min": [
        -1672.76513671875,
        -3826.804931640625,
        1246.5
      ],
      "bbox_max": [
        -1668.6497802734375,
        -3815.76708984375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1669.9351806640625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1654.165771484375,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661896586418152,
        -0.49140921235084534,
        0.09073296934366226
      ],
      "plane_d": -3443.62451171875,
      "bbox_min": [
        -1669.9351806640625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1665.80029296875,
        -3833.68017578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5622904300689697,
        0.8267924785614014,
        0.015609785914421082
      ],
      "plane_d": 2191.310791015625,
      "bbox_min": [
        -1679.140625,
        -3828.38037109375,
        1246.5
      ],
      "bbox_max": [
        -1669.134033203125,
        -3811.496337890625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7683862447738647,
        -0.6397959589958191,
        0.015609897673130035
      ],
      "plane_d": -3755.94970703125,
      "bbox_min": [
        -1679.140625,
        -3828.38037109375,
        1246.5
      ],
      "bbox_max": [
        -1669.134033203125,
        -3811.496337890625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7684020400047302,
        0.6397770047187805,
        0.015609982423484325
      ],
      "plane_d": 3704.36279296875,
      "bbox_min": [
        -1675.0816650390625,
        -3828.38037109375,
        1246.5
      ],
      "bbox_max": [
        -1669.134033203125,
        -3811.496337890625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024573173373937607,
        0.9913090467453003,
        0.1292390078306198
      ],
      "plane_d": 3556.2431640625,
      "bbox_min": [
        -1657.119140625,
        -3841.1748046875,
        1225.596923828125
      ],
      "bbox_max": [
        -1613.82470703125,
        -3753.43115234375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1657.119140625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661673665046692,
        -0.49139657616615295,
        0.09101392328739166
      ],
      "plane_d": -568.1634521484375,
      "bbox_min": [
        -1657.119140625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1657.119140625,
        -3841.1748046875,
        1242.515380859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3819.198486328125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3353404402732849,
        0.9221861362457275,
        0.1926640123128891
      ],
      "plane_d": 2712.318115234375,
      "bbox_min": [
        -1643.8013916015625,
        -3790.7578125,
        1225.596923828125
      ],
      "bbox_max": [
        -1613.82470703125,
        -3753.43115234375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9551894068717957,
        0.29186341166496277,
        0.04928591102361679
      ],
      "plane_d": -499.5145263671875,
      "bbox_min": [
        -1643.8013916015625,
        -3790.7578125,
        1225.596923828125
      ],
      "bbox_max": [
        -1613.82470703125,
        -3753.43115234375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1613.9210205078125,
        -3781.07666015625,
        1246.5
      ],
      "bbox_max": [
        -1613.82470703125,
        -3780.948974609375,
        1246.6031494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1616.6602783203125,
        -3780.952392578125,
        1225.7862548828125
      ],
      "bbox_max": [
        -1613.8426513671875,
        -3771.956787109375,
        1247.0408935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1614.317138671875,
        -3780.952392578125,
        1246.5
      ],
      "bbox_max": [
        -1613.916748046875,
        -3780.065673828125,
        1247.0408935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1614.317138671875,
        -3780.424072265625,
        1246.5
      ],
      "bbox_max": [
        -1614.2491455078125,
        -3780.065673828125,
        1247.0408935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20494157075881958,
        -0.5635892152786255,
        -0.8002288937568665
      ],
      "plane_d": -1476.2454833984375,
      "bbox_min": [
        -1616.6602783203125,
        -3778.811767578125,
        1225.7862548828125
      ],
      "bbox_max": [
        -1613.8426513671875,
        -3771.956787109375,
        1226.7838134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1342277079820633,
        -0.058762725442647934,
        -0.9892066717147827
      ],
      "plane_d": 1209.8074951171875,
      "bbox_min": [
        -1629.593505859375,
        -3783.95263671875,
        1226.470458984375
      ],
      "bbox_max": [
        -1626.71484375,
        -3780.66064453125,
        1226.72412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023511899635195732,
        0.7411308884620667,
        -0.67094886302948
      ],
      "plane_d": 3665.660400390625,
      "bbox_min": [
        -1629.570068359375,
        -3783.95263671875,
        1226.634521484375
      ],
      "bbox_max": [
        -1626.71484375,
        -3781.993408203125,
        1226.72412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01595359295606613,
        0.043872375041246414,
        -0.9989098310470581
      ],
      "plane_d": 1417.3284912109375,
      "bbox_min": [
        -1629.570068359375,
        -3783.88720703125,
        1226.662353515625
      ],
      "bbox_max": [
        -1626.7784423828125,
        -3781.993408203125,
        1226.72412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02571098506450653,
        0.00785613339394331,
        -0.999638557434082
      ],
      "plane_d": 1297.8431396484375,
      "bbox_min": [
        -1629.570068359375,
        -3783.8369140625,
        1226.662353515625
      ],
      "bbox_max": [
        -1627.3514404296875,
        -3781.993408203125,
        1226.72412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33623701333999634,
        0.9246517419815063,
        0.17878443002700806
      ],
      "plane_d": 3827.11474609375,
      "bbox_min": [
        -1643.8013916015625,
        -3790.7578125,
        1225.596923828125
      ],
      "bbox_max": [
        -1614.625244140625,
        -3753.43115234375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9940398931503296,
        0.10901788622140884
      ],
      "plane_d": -3872.147216796875,
      "bbox_min": [
        -1643.8013916015625,
        -3788.8125,
        1225.596923828125
      ],
      "bbox_max": [
        -1614.625244140625,
        -3753.43115234375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1643.8013916015625,
        -3759.095458984375,
        1242.515380859375
      ],
      "bbox_max": [
        -1640.2171630859375,
        -3753.43115234375,
        1248.0130615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467028379440308,
        0.2892703115940094,
        0.14169162511825562
      ],
      "plane_d": -609.8890991210938,
      "bbox_min": [
        -1629.699951171875,
        -3788.8125,
        1225.596923828125
      ],
      "bbox_max": [
        -1614.625244140625,
        -3766.1982421875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1616.5963134765625,
        -3783.056396484375,
        1226.176025390625
      ],
      "bbox_max": [
        -1614.625244140625,
        -3777.94091796875,
        1226.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1615.0,
        -3778.0,
        1226.7838134765625
      ],
      "bbox_max": [
        -1614.9757080078125,
        -3777.94091796875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": -2447.9609375,
      "bbox_min": [
        -1629.699951171875,
        -3788.8125,
        1225.596923828125
      ],
      "bbox_max": [
        -1614.984375,
        -3766.1982421875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1616.69921875,
        -3778.0,
        1225.785888671875
      ],
      "bbox_max": [
        -1614.984375,
        -3771.94189453125,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20494157075881958,
        -0.5635892152786255,
        -0.8002288937568665
      ],
      "plane_d": -1476.2454833984375,
      "bbox_min": [
        -1616.69921875,
        -3773.5,
        1225.785888671875
      ],
      "bbox_max": [
        -1616.344970703125,
        -3771.94189453125,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20802104473114014,
        0.572057843208313,
        -0.7933959364891052
      ],
      "plane_d": 2800.906982421875,
      "bbox_min": [
        -1621.2711181640625,
        -3784.2158203125,
        1226.4569091796875
      ],
      "bbox_max": [
        -1616.375,
        -3782.5,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023511899635195732,
        0.7411308884620667,
        -0.67094886302948
      ],
      "plane_d": 3665.660400390625,
      "bbox_min": [
        -1621.2711181640625,
        -3784.2158203125,
        1226.5712890625
      ],
      "bbox_max": [
        -1620.221435546875,
        -3784.0,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31043097376823425,
        0.8536851406097412,
        0.4181557595729828
      ],
      "plane_d": 3220.404541015625,
      "bbox_min": [
        -1629.699951171875,
        -3788.8125,
        1225.596923828125
      ],
      "bbox_max": [
        -1616.375,
        -3766.1982421875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023511899635195732,
        0.7411308884620667,
        -0.67094886302948
      ],
      "plane_d": 3665.660400390625,
      "bbox_min": [
        -1629.594482421875,
        -3784.17333984375,
        1226.46240234375
      ],
      "bbox_max": [
        -1620.5,
        -3780.527587890625,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02571098506450653,
        0.00785613339394331,
        -0.999638557434082
      ],
      "plane_d": 1297.8431396484375,
      "bbox_min": [
        -1629.594482421875,
        -3783.237060546875,
        1226.46240234375
      ],
      "bbox_max": [
        -1624.625,
        -3780.527587890625,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1342277079820633,
        -0.058762725442647934,
        -0.9892066717147827
      ],
      "plane_d": 1209.8074951171875,
      "bbox_min": [
        -1629.594482421875,
        -3781.993408203125,
        1226.46240234375
      ],
      "bbox_max": [
        -1627.982666015625,
        -3780.527587890625,
        1226.7235107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939045250415802,
        0.28693050146102905,
        0.18938039243221283
      ],
      "plane_d": 2378.09912109375,
      "bbox_min": [
        -1629.699951171875,
        -3787.3125,
        1225.596923828125
      ],
      "bbox_max": [
        -1616.375,
        -3766.1982421875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1342277079820633,
        -0.058762725442647934,
        -0.9892066717147827
      ],
      "plane_d": 1209.8074951171875,
      "bbox_min": [
        -1629.699951171875,
        -3787.3125,
        1225.596923828125
      ],
      "bbox_max": [
        -1624.625,
        -3766.1982421875,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": 620.3029174804688,
      "bbox_min": [
        -1629.699951171875,
        -3787.3125,
        1225.596923828125
      ],
      "bbox_max": [
        -1624.625,
        -3766.1982421875,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.047367218881845474,
        -0.13025984168052673,
        -0.9903478026390076
      ],
      "plane_d": 800.377197265625,
      "bbox_min": [
        -1629.699951171875,
        -3768.203369140625,
        1225.596923828125
      ],
      "bbox_max": [
        -1628.3062744140625,
        -3766.1982421875,
        1225.9273681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02571098506450653,
        0.00785613339394331,
        -0.999638557434082
      ],
      "plane_d": 1297.8431396484375,
      "bbox_min": [
        -1629.699951171875,
        -3782.72900390625,
        1225.596923828125
      ],
      "bbox_max": [
        -1624.625,
        -3766.1982421875,
        1227.267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        0.2892703115940094,
        0.14169162511825562
      ],
      "plane_d": 2458.374755859375,
      "bbox_min": [
        -1626.0,
        -3782.72900390625,
        1226.800048828125
      ],
      "bbox_max": [
        -1624.625,
        -3778.0,
        1227.267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.047367218881845474,
        -0.13025984168052673,
        -0.9903478026390076
      ],
      "plane_d": 800.377197265625,
      "bbox_min": [
        -1629.699951171875,
        -3767.740234375,
        1225.596923828125
      ],
      "bbox_max": [
        -1628.434326171875,
        -3766.1982421875,
        1225.8602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21937446296215057,
        -0.5191641449928284,
        -0.8260408043861389
      ],
      "plane_d": -1300.396484375,
      "bbox_min": [
        -1629.699951171875,
        -3766.83935546875,
        1225.596923828125
      ],
      "bbox_max": [
        -1628.6832275390625,
        -3766.1982421875,
        1225.7298583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34157514572143555,
        -0.9393316507339478,
        0.0313434861600399
      ],
      "plane_d": -3032.91748046875,
      "bbox_min": [
        -1628.7220458984375,
        -3784.3994140625,
        1225.6114501953125
      ],
      "bbox_max": [
        -1616.375,
        -3766.634521484375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31043097376823425,
        -0.8536851406097412,
        -0.4181557595729828
      ],
      "plane_d": -2204.053466796875,
      "bbox_min": [
        -1628.7220458984375,
        -3778.97265625,
        1225.6114501953125
      ],
      "bbox_max": [
        -1616.375,
        -3766.634521484375,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21937446296215057,
        -0.5191641449928284,
        -0.8260408043861389
      ],
      "plane_d": -1300.396484375,
      "bbox_min": [
        -1628.7220458984375,
        -3774.08056640625,
        1225.6114501953125
      ],
      "bbox_max": [
        -1619.0355224609375,
        -3766.634521484375,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16228698194026947,
        -0.049587681889534,
        -0.9854968190193176
      ],
      "plane_d": 1285.5439453125,
      "bbox_min": [
        -1628.3062744140625,
        -3774.08056640625,
        1225.9273681640625
      ],
      "bbox_max": [
        -1624.625,
        -3768.203369140625,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043097376823425,
        -0.8536851406097412,
        -0.4181557595729828
      ],
      "plane_d": -3210.160400390625,
      "bbox_min": [
        -1626.6258544921875,
        -3778.97265625,
        1225.754638671875
      ],
      "bbox_max": [
        -1616.375,
        -3770.95556640625,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21937446296215057,
        -0.5191641449928284,
        -0.8260408043861389
      ],
      "plane_d": -1300.396484375,
      "bbox_min": [
        -1620.5,
        -3772.0,
        1225.754638671875
      ],
      "bbox_max": [
        -1617.5269775390625,
        -3770.95556640625,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": 620.3029174804688,
      "bbox_min": [
        -1626.6258544921875,
        -3778.97265625,
        1226.499755859375
      ],
      "bbox_max": [
        -1624.625,
        -3773.5,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16228698194026947,
        -0.049587681889534,
        -0.9854968190193176
      ],
      "plane_d": 1285.5439453125,
      "bbox_min": [
        -1626.6258544921875,
        -3777.16357421875,
        1226.499755859375
      ],
      "bbox_max": [
        -1624.625,
        -3773.5,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9433103799819946,
        -0.2882337272167206,
        0.16458085179328918
      ],
      "plane_d": 239.9637451171875,
      "bbox_min": [
        -1628.434326171875,
        -3784.3994140625,
        1229.946533203125
      ],
      "bbox_max": [
        -1616.375,
        -3775.504150390625,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": 620.3029174804688,
      "bbox_min": [
        -1626.0,
        -3782.8125,
        1229.946533203125
      ],
      "bbox_max": [
        -1624.625,
        -3778.3125,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043097376823425,
        -0.8536851406097412,
        -0.4181557595729828
      ],
      "plane_d": -3210.160400390625,
      "bbox_min": [
        -1620.5,
        -3778.3125,
        1230.8917236328125
      ],
      "bbox_max": [
        -1616.375,
        -3775.504150390625,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0829281285405159,
        -0.9958572387695312,
        -0.03730132058262825
      ],
      "plane_d": -3580.6533203125,
      "bbox_min": [
        -1627.546142578125,
        -3779.607421875,
        1236.625
      ],
      "bbox_max": [
        -1618.92041015625,
        -3776.8125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4981979429721832,
        -0.8667582869529724,
        0.022999893873929977
      ],
      "plane_d": -2493.941162109375,
      "bbox_min": [
        -1627.546142578125,
        -3779.607421875,
        1236.625
      ],
      "bbox_max": [
        -1624.1566162109375,
        -3777.6591796875,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15403299033641815,
        0.4843456745147705,
        -0.861210286617279
      ],
      "plane_d": 2638.091552734375,
      "bbox_min": [
        -1629.699951171875,
        -3797.19580078125,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023511899635195732,
        0.7411308884620667,
        -0.67094886302948
      ],
      "plane_d": 3665.660400390625,
      "bbox_min": [
        -1629.570068359375,
        -3790.956787109375,
        1219.43017578125
      ],
      "bbox_max": [
        -1611.5223388671875,
        -3779.949462890625,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1616.1395263671875,
        -3790.956787109375,
        1219.43017578125
      ],
      "bbox_max": [
        -1611.5223388671875,
        -3779.949462890625,
        1226.4425048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7045546770095825,
        0.19844281673431396,
        -0.6813392043113708
      ],
      "plane_d": 447.7281494140625,
      "bbox_min": [
        -1629.699951171875,
        -3790.956787109375,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1226.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21937446296215057,
        -0.5191641449928284,
        -0.8260408043861389
      ],
      "plane_d": -1300.396484375,
      "bbox_min": [
        -1629.699951171875,
        -3790.956787109375,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1226.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1614.5391845703125,
        -3772.97900390625,
        1222.8856201171875
      ],
      "bbox_max": [
        -1609.124267578125,
        -3770.57861328125,
        1225.8216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1628.356689453125,
        -3790.956787109375,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1226.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1628.356689453125,
        -3776.5380859375,
        1210.0
      ],
      "bbox_max": [
        -1609.124267578125,
        -3750.8779296875,
        1226.029052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1628.356689453125,
        -3752.46142578125,
        1210.0
      ],
      "bbox_max": [
        -1626.8687744140625,
        -3750.8779296875,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9677070379257202,
        -0.2520774304866791
      ],
      "plane_d": -3325.6142578125,
      "bbox_min": [
        -1628.356689453125,
        -3752.46142578125,
        1210.0
      ],
      "bbox_max": [
        -1626.8687744140625,
        -3751.7841796875,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1212.60009765625,
      "bbox_min": [
        -1628.356689453125,
        -3752.46142578125,
        1212.60009765625
      ],
      "bbox_max": [
        -1627.4873046875,
        -3751.81640625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9790384769439697,
        -0.18357063829898834,
        0.08823531866073608
      ],
      "plane_d": 815.200439453125,
      "bbox_min": [
        -1697.310791015625,
        -3855.679931640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9864533543586731,
        -0.07981184124946594,
        0.14331689476966858
      ],
      "plane_d": 1149.176513671875,
      "bbox_min": [
        -1697.310791015625,
        -3848.75,
        1251.0999755859375
      ],
      "bbox_max": [
        -1651.3360595703125,
        -3752.542236328125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43471652269363403,
        -0.8809210062026978,
        0.18708239495754242
      ],
      "plane_d": -2878.06201171875,
      "bbox_min": [
        -1697.310791015625,
        -3848.75,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6115925312042236,
        -0.7828433513641357,
        0.11450304836034775
      ],
      "plane_d": -2113.3125,
      "bbox_min": [
        -1684.9361572265625,
        -3832.8896484375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5622904300689697,
        0.8267924785614014,
        0.015609785914421082
      ],
      "plane_d": 2191.310791015625,
      "bbox_min": [
        -1679.0809326171875,
        -3826.403564453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1316.9749755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7684020400047302,
        0.6397770047187805,
        0.015609982423484325
      ],
      "plane_d": 3704.36279296875,
      "bbox_min": [
        -1679.0809326171875,
        -3826.403564453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1660.3514404296875,
        -3804.12451171875,
        1316.9749755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7683862447738647,
        -0.6397959589958191,
        0.015609897673130035
      ],
      "plane_d": -3755.94970703125,
      "bbox_min": [
        -1679.0809326171875,
        -3826.403564453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1668.70947265625,
        -3816.411865234375,
        1282.2269287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902018308639526,
        -0.13916033506393433,
        0.011614802293479443
      ],
      "plane_d": 1106.7347412109375,
      "bbox_min": [
        -1669.3094482421875,
        -3820.68115234375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1668.70947265625,
        -3816.411865234375,
        1277.3194580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1661.9598388671875,
        -3806.57373046875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1661.451416015625,
        -3804.12451171875,
        1281.02197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1661.7418212890625,
        -3804.492431640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1295.346435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9503167867660522,
        0.3110123574733734,
        0.013012579642236233
      ],
      "plane_d": -415.693359375,
      "bbox_min": [
        -1660.4202880859375,
        -3789.814453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1295.346435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1654.096923828125,
        -3770.854736328125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1652.44775390625,
        -3769.5166015625,
        1266.9339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7683862447738647,
        -0.6397959589958191,
        0.015609897673130035
      ],
      "plane_d": -3755.94970703125,
      "bbox_min": [
        -1678.3868408203125,
        -3828.096923828125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1669.0494384765625,
        -3814.17578125,
        1308.55029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1665.80029296875,
        -3820.9501953125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1661.660400390625,
        -3819.988525390625,
        1261.54833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8532995581626892,
        0.5179274678230286,
        0.060255978256464005
      ],
      "plane_d": 3347.52783203125,
      "bbox_min": [
        -1697.310791015625,
        -3848.75,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3812.967529296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622641444206238,
        -0.8268104195594788,
        0.015609738416969776
      ],
      "plane_d": -2242.9638671875,
      "bbox_min": [
        -1686.6661376953125,
        -3848.75,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3812.967529296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9902018308639526,
        0.13916033506393433,
        0.011615406721830368
      ],
      "plane_d": -1145.0863037109375,
      "bbox_min": [
        -1678.67724609375,
        -3823.1904296875,
        1282.2269287109375
      ],
      "bbox_max": [
        -1669.2208251953125,
        -3812.967529296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7684020400047302,
        0.6397770047187805,
        0.015609982423484325
      ],
      "plane_d": 3704.36279296875,
      "bbox_min": [
        -1677.2822265625,
        -3817.122802734375,
        1290.5335693359375
      ],
      "bbox_max": [
        -1669.2208251953125,
        -3812.967529296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5622904300689697,
        0.8267924785614014,
        0.015609785914421082
      ],
      "plane_d": 2191.310791015625,
      "bbox_min": [
        -1677.2822265625,
        -3816.090576171875,
        1313.4520263671875
      ],
      "bbox_max": [
        -1672.9154052734375,
        -3812.967529296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661102056503296,
        0.49135321378707886,
        0.09178858995437622
      ],
      "plane_d": 319.3603515625,
      "bbox_min": [
        -1666.2939453125,
        -3822.18359375,
        1258.192626953125
      ],
      "bbox_max": [
        -1664.334228515625,
        -3820.815185546875,
        1264.615966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1665.238525390625,
        -3821.232421875,
        1260.0823974609375
      ],
      "bbox_max": [
        -1664.334228515625,
        -3820.815185546875,
        1264.615966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6011608242988586,
        0.7953794598579407,
        0.07731172442436218
      ],
      "plane_d": 3964.79443359375,
      "bbox_min": [
        -1685.4661865234375,
        -3834.88916015625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1683.494140625,
        -3832.8896484375,
        1275.7928466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6134501695632935,
        0.7864651083946228,
        0.07177400588989258
      ],
      "plane_d": 3958.26220703125,
      "bbox_min": [
        -1684.9361572265625,
        -3834.16015625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1683.494140625,
        -3832.8896484375,
        1255.5928955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6011608242988586,
        0.7953794598579407,
        0.07731172442436218
      ],
      "plane_d": 3964.79443359375,
      "bbox_min": [
        -1686.6661376953125,
        -3848.75,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3820.50634765625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6134501695632935,
        0.7864651083946228,
        0.07177400588989258
      ],
      "plane_d": 3958.26220703125,
      "bbox_min": [
        -1683.8331298828125,
        -3848.06396484375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1666.7406005859375,
        -3834.014404296875,
        1304.765380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661896586418152,
        -0.49140921235084534,
        0.09073296934366226
      ],
      "plane_d": -3443.62451171875,
      "bbox_min": [
        -1671.591064453125,
        -3840.4033203125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3820.50634765625,
        1292.0670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661102056503296,
        0.49135321378707886,
        0.09178858995437622
      ],
      "plane_d": 319.3603515625,
      "bbox_min": [
        -1671.591064453125,
        -3840.4033203125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3820.50634765625,
        1292.0670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1665.80029296875,
        -3840.4033203125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1662.2646484375,
        -3820.50634765625,
        1276.7904052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9503167867660522,
        0.3110123574733734,
        0.013012579642236233
      ],
      "plane_d": -415.693359375,
      "bbox_min": [
        -1657.9615478515625,
        -3783.245361328125,
        1262.5123291015625
      ],
      "bbox_max": [
        -1653.4718017578125,
        -3770.618408203125,
        1286.5020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8383026123046875,
        -0.528494656085968,
        0.1339486539363861
      ],
      "plane_d": -773.007080078125,
      "bbox_min": [
        -1674.317138671875,
        -3855.679931640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1646.7763671875,
        -3752.261474609375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1632.026123046875,
        -3734.29638671875,
        1277.9498291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1646.7763671875,
        -3752.261474609375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1643.3519287109375,
        -3746.22509765625,
        1276.0009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066479921340942,
        0.6295457482337952,
        0.3229873776435852
      ],
      "plane_d": 837.9146728515625,
      "bbox_min": [
        -1660.5916748046875,
        -3842.62841796875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1608.82666015625,
        -3820.07373046875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661673665046692,
        -0.49139657616615295,
        0.09101392328739166
      ],
      "plane_d": -568.1634521484375,
      "bbox_min": [
        -1660.5916748046875,
        -3840.4033203125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1648.4681396484375,
        -3826.401611328125,
        1263.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1650.6207275390625,
        -3830.2060546875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1648.4681396484375,
        -3826.401611328125,
        1260.480712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6134501695632935,
        0.7864651083946228,
        0.07177400588989258
      ],
      "plane_d": 3958.26220703125,
      "bbox_min": [
        -1670.849365234375,
        -3855.679931640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1649.4595947265625,
        -3824.776611328125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6011608242988586,
        0.7953794598579407,
        0.07731172442436218
      ],
      "plane_d": 3964.79443359375,
      "bbox_min": [
        -1667.5399169921875,
        -3855.679931640625,
        1321.958740234375
      ],
      "bbox_max": [
        -1665.1484375,
        -3852.925537109375,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1666.14697265625,
        -3840.4033203125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1649.4595947265625,
        -3824.776611328125,
        1287.565673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661673665046692,
        -0.49139657616615295,
        0.09101392328739166
      ],
      "plane_d": -568.1634521484375,
      "bbox_min": [
        -1666.14697265625,
        -3840.1826171875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1649.4595947265625,
        -3824.776611328125,
        1287.565673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1666.14697265625,
        -3840.1826171875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1649.4595947265625,
        -3824.776611328125,
        1273.562744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661896586418152,
        -0.49140921235084534,
        0.09073296934366226
      ],
      "plane_d": -3443.62451171875,
      "bbox_min": [
        -1666.14697265625,
        -3840.1826171875,
        1253.5570068359375
      ],
      "bbox_max": [
        -1664.6136474609375,
        -3837.2197265625,
        1273.1697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7003374099731445,
        0.6937866806983948,
        0.1678919494152069
      ],
      "plane_d": 1284.84912109375,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9062009453773499,
        0.24006804823875427,
        0.34809064865112305
      ],
      "plane_d": -990.2747802734375,
      "bbox_min": [
        -1660.1837158203125,
        -3837.736328125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3768.76806640625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9340085983276367,
        0.04827304556965828,
        0.3539741337299347
      ],
      "plane_d": -1770.29931640625,
      "bbox_min": [
        -1617.860595703125,
        -3804.47119140625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1586.87890625,
        -3775.898681640625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7985454797744751,
        0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": 3537.88037109375,
      "bbox_min": [
        -1612.6331787109375,
        -3787.71826171875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1601.766357421875,
        -3775.898681640625,
        1282.5230712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09095914661884308,
        -0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": -3939.883056640625,
      "bbox_min": [
        -1612.6331787109375,
        -3787.71826171875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1602.9373779296875,
        -3782.5546875,
        1282.5230712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1612.6331787109375,
        -3787.149169921875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1609.1153564453125,
        -3782.5546875,
        1267.4744873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8717682361602783,
        0.3423979878425598,
        0.3504050374031067
      ],
      "plane_d": -550.267578125,
      "bbox_min": [
        -1660.1837158203125,
        -3837.736328125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1586.87890625,
        -3779.6845703125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9340085983276367,
        0.04827304556965828,
        0.3539741337299347
      ],
      "plane_d": -1770.29931640625,
      "bbox_min": [
        -1617.32470703125,
        -3796.04296875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1586.87890625,
        -3790.616455078125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1660.1837158203125,
        -3837.736328125,
        1280.77783203125
      ],
      "bbox_max": [
        -1656.2314453125,
        -3836.722412109375,
        1292.0601806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1611.85400390625,
        -3787.103759765625,
        1257.9847412109375
      ],
      "bbox_max": [
        -1602.3179931640625,
        -3779.6845703125,
        1305.1856689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7985454797744751,
        0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": 3537.88037109375,
      "bbox_min": [
        -1603.6214599609375,
        -3781.518798828125,
        1276.83154296875
      ],
      "bbox_max": [
        -1602.3179931640625,
        -3779.6845703125,
        1289.211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607436418533325,
        -0.5049654841423035,
        0.06426729261875153
      ],
      "plane_d": -3348.892578125,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8440349102020264,
        -0.5322351455688477,
        0.06580871343612671
      ],
      "plane_d": -3426.790771484375,
      "bbox_min": [
        -1606.768310546875,
        -3768.76806640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1579.6533203125,
        -3733.0869140625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4191102683544159,
        0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": 4039.34228515625,
      "bbox_min": [
        -1606.768310546875,
        -3741.9306640625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1599.2535400390625,
        -3733.0869140625,
        1314.1124267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1594.2821044921875,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6477246880531311,
        -0.756960928440094,
        0.08638834208250046
      ],
      "plane_d": -1876.1256103515625,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1594.2821044921875,
        -3720.443603515625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1594.2821044921875,
        -3726.33447265625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4191102683544159,
        0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": 4039.34228515625,
      "bbox_min": [
        -1606.0516357421875,
        -3738.50830078125,
        1261.8797607421875
      ],
      "bbox_max": [
        -1600.635009765625,
        -3733.510498046875,
        1314.541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1606.0516357421875,
        -3738.50830078125,
        1261.8797607421875
      ],
      "bbox_max": [
        -1600.635009765625,
        -3733.510498046875,
        1314.541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.864705502986908,
        -0.4905621111392975,
        0.1078575849533081
      ],
      "plane_d": -572.09228515625,
      "bbox_min": [
        -1643.5369873046875,
        -3758.154052734375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1619.747314453125,
        -3734.29638671875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1643.5369873046875,
        -3758.154052734375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1626.5146484375,
        -3734.29638671875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9938765168190002,
        0.11049634218215942
      ],
      "plane_d": 3573.1875,
      "bbox_min": [
        -1643.5369873046875,
        -3746.285888671875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1626.5146484375,
        -3734.29638671875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1643.5369873046875,
        -3746.285888671875,
        1276.0009765625
      ],
      "bbox_max": [
        -1634.5731201171875,
        -3737.281494140625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.944113552570343,
        0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": -314.7994384765625,
      "bbox_min": [
        -1614.7464599609375,
        -3744.9130859375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1600.6444091796875,
        -3733.513916015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4191102683544159,
        -0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": -4095.93798828125,
      "bbox_min": [
        -1614.7464599609375,
        -3744.9130859375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1600.6444091796875,
        -3733.513916015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39069291949272156,
        -0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": -2834.691650390625,
      "bbox_min": [
        -1612.685302734375,
        -3744.9130859375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1600.6444091796875,
        -3733.513916015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1605.4090576171875,
        -3741.54736328125,
        1261.5196533203125
      ],
      "bbox_max": [
        -1600.6444091796875,
        -3733.513916015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4191102683544159,
        0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": 4039.34228515625,
      "bbox_min": [
        -1605.4090576171875,
        -3736.4619140625,
        1276.6099853515625
      ],
      "bbox_max": [
        -1600.6444091796875,
        -3733.513916015625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1602.4581298828125,
        -3770.8154296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1661.5487060546875,
        -3813.964599609375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1648.41015625,
        -3770.8154296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1661.5487060546875,
        -3813.964599609375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1648.41015625,
        -3770.8154296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1661.5487060546875,
        -3805.46923828125,
        1280.0687255859375
      ],
      "bbox_max": [
        -1659.6370849609375,
        -3789.814453125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1602.4581298828125,
        -3774.28173828125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09095914661884308,
        0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": 3882.0458984375,
      "bbox_min": [
        -1614.233642578125,
        -3786.660400390625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1602.4581298828125,
        -3774.28173828125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1614.233642578125,
        -3786.660400390625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1602.4581298828125,
        -3774.850830078125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9821799397468567,
        -0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": 843.1284790039062,
      "bbox_min": [
        -1604.12548828125,
        -3786.660400390625,
        1289.211181640625
      ],
      "bbox_max": [
        -1602.4581298828125,
        -3781.435546875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1251.0999755859375
      ],
      "bbox_max": [
        -1651.955078125,
        -3819.988525390625,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661673665046692,
        -0.49139657616615295,
        0.09101392328739166
      ],
      "plane_d": -568.1634521484375,
      "bbox_min": [
        -1658.618896484375,
        -3836.722412109375,
        1284.09130859375
      ],
      "bbox_max": [
        -1651.955078125,
        -3830.231689453125,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6011608242988586,
        0.7953794598579407,
        0.07731172442436218
      ],
      "plane_d": 3964.79443359375,
      "bbox_min": [
        -1674.317138671875,
        -3854.7607421875,
        1295.0205078125
      ],
      "bbox_max": [
        -1666.364501953125,
        -3847.8857421875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3388913869857788,
        0.9406852722167969,
        0.016243943944573402
      ],
      "plane_d": 3041.044921875,
      "bbox_min": [
        -1701.213134765625,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1665.245361328125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1618.614501953125,
        -3839.637451171875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1665.245361328125,
        -3856.43603515625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1665.1510009765625,
        -3856.4267578125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1701.213134765625,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1701.213134765625,
        -3852.0048828125,
        1331.699951171875
      ],
      "bbox_max": [
        -1662.90380859375,
        -3759.604736328125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977416396141052,
        -0.018138699233531952,
        0.06467321515083313
      ],
      "plane_d": 1504.76416015625,
      "bbox_min": [
        -1701.213134765625,
        -3821.879150390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1662.90380859375,
        -3759.604736328125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37160712480545044,
        -0.925055980682373,
        0.07860997319221497
      ],
      "plane_d": -3009.404296875,
      "bbox_min": [
        -1701.213134765625,
        -3821.879150390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1677.7623291015625,
        -3810.47412109375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1701.213134765625,
        -3821.879150390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1697.310791015625,
        -3819.89453125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847064733505249,
        -0.5281789302825928,
        0.059230607002973557
      ],
      "plane_d": -657.9163818359375,
      "bbox_min": [
        -1665.6068115234375,
        -3763.168212890625,
        1331.699951171875
      ],
      "bbox_max": [
        -1662.90380859375,
        -3759.604736328125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8548005819320679,
        0.5188385844230652,
        0.011062489822506905
      ],
      "plane_d": 3419.06884765625,
      "bbox_min": [
        -1700.058349609375,
        -3852.0048828125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1700.058349609375,
        -3837.422607421875,
        1331.699951171875
      ],
      "bbox_max": [
        -1688.4173583984375,
        -3821.476318359375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053097248077393,
        0.7958692908287048,
        0.013866530731320381
      ],
      "plane_d": 4058.1630859375,
      "bbox_min": [
        -1686.849853515625,
        -3852.0048828125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902018308639526,
        -0.13916033506393433,
        0.011614802293479443
      ],
      "plane_d": 1106.7347412109375,
      "bbox_min": [
        -1678.0355224609375,
        -3826.60205078125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9902018308639526,
        0.13916033506393433,
        0.011615406721830368
      ],
      "plane_d": -1145.0863037109375,
      "bbox_min": [
        -1678.0355224609375,
        -3826.60205078125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5622904300689697,
        0.8267924785614014,
        0.015609785914421082
      ],
      "plane_d": 2191.310791015625,
      "bbox_min": [
        -1677.09912109375,
        -3826.60205078125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7684020400047302,
        0.6397770047187805,
        0.015609982423484325
      ],
      "plane_d": 3704.36279296875,
      "bbox_min": [
        -1674.8316650390625,
        -3826.60205078125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.7547607421875,
        -3813.27490234375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622641444206238,
        -0.8268104195594788,
        0.015609738416969776
      ],
      "plane_d": -2242.9638671875,
      "bbox_min": [
        -1674.8316650390625,
        -3826.60205078125,
        1331.699951171875
      ],
      "bbox_max": [
        -1670.6912841796875,
        -3823.282470703125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.602889895439148,
        0.7976671457290649,
        0.015840327367186546
      ],
      "plane_d": 4058.35595703125,
      "bbox_min": [
        -1686.6661376953125,
        -3852.0048828125,
        1331.699951171875
      ],
      "bbox_max": [
        -1670.0867919921875,
        -3839.41650390625,
        1362.5904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6985849142074585,
        0.7094742059707642,
        0.09287343174219131
      ],
      "plane_d": 1462.6622314453125,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7434534430503845,
        0.6623353362083435,
        0.09267634153366089
      ],
      "plane_d": 1210.6651611328125,
      "bbox_min": [
        -1628.92041015625,
        -3842.62841796875,
        1331.699951171875
      ],
      "bbox_max": [
        -1606.09130859375,
        -3820.07373046875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7948121428489685,
        0.5870009660720825,
        0.15395909547805786
      ],
      "plane_d": 755.9136962890625,
      "bbox_min": [
        -1628.92041015625,
        -3842.62841796875,
        1331.699951171875
      ],
      "bbox_max": [
        -1606.83203125,
        -3823.68359375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320245504379272,
        0.6685720682144165,
        0.13096371293067932
      ],
      "plane_d": 1201.8897705078125,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9611096382141113,
        0.25461429357528687,
        0.10695737600326538
      ],
      "plane_d": -701.0729370117188,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847064733505249,
        -0.5281789302825928,
        0.059230607002973557
      ],
      "plane_d": -657.9163818359375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.949376106262207,
        -0.19030731916427612,
        0.24993644654750824
      ],
      "plane_d": 517.9078369140625,
      "bbox_min": [
        -1659.3966064453125,
        -3752.85595703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1643.7506103515625,
        -3727.763916015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1655.8121337890625,
        -3734.974853515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1643.7506103515625,
        -3727.763916015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1645.6759033203125,
        -3733.75439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1643.7506103515625,
        -3727.763916015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783594012260437,
        0.19699105620384216,
        0.0633055791258812
      ],
      "plane_d": -887.359130859375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8440349102020264,
        -0.5322351455688477,
        0.06580871343612671
      ],
      "plane_d": -3426.790771484375,
      "bbox_min": [
        -1587.2730712890625,
        -3769.259765625,
        1331.699951171875
      ],
      "bbox_max": [
        -1579.398193359375,
        -3751.5205078125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4371967911720276,
        -0.8732787370681763,
        -0.2150418758392334
      ],
      "plane_d": -3674.721435546875,
      "bbox_min": [
        -1587.2730712890625,
        -3751.540283203125,
        1373.4637451171875
      ],
      "bbox_max": [
        -1587.251220703125,
        -3751.5205078125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100038409233093,
        -0.41456741094589233,
        0.005178479943424463
      ],
      "plane_d": -3006.795166015625,
      "bbox_min": [
        -1587.2730712890625,
        -3769.259765625,
        1331.699951171875
      ],
      "bbox_max": [
        -1579.398193359375,
        -3751.5205078125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6477246880531311,
        -0.756960928440094,
        0.08638834208250046
      ],
      "plane_d": -1876.1256103515625,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1644.5631103515625,
        -3733.75439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.9127197265625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9503167867660522,
        0.3110123574733734,
        0.013012579642236233
      ],
      "plane_d": -415.693359375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8607436418533325,
        -0.5049654841423035,
        0.06426729261875153
      ],
      "plane_d": -3348.892578125,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8440349102020264,
        -0.5322351455688477,
        0.06580871343612671
      ],
      "plane_d": -3426.790771484375,
      "bbox_min": [
        -1588.548095703125,
        -3769.45751953125,
        1331.699951171875
      ],
      "bbox_max": [
        -1579.2955322265625,
        -3751.5205078125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100038409233093,
        -0.41456741094589233,
        0.005178479943424463
      ],
      "plane_d": -3006.795166015625,
      "bbox_min": [
        -1587.2730712890625,
        -3769.45751953125,
        1337.1728515625
      ],
      "bbox_max": [
        -1579.2955322265625,
        -3751.5205078125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1650.4403076171875,
        -3778.8974609375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1660.81591796875,
        -3809.16064453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1650.4403076171875,
        -3778.8974609375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1660.81591796875,
        -3809.16064453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.0323486328125,
        -3790.256103515625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9698894619941711,
        -0.2424565553665161,
        0.023007404059171677
      ],
      "plane_d": -2563.630615234375,
      "bbox_min": [
        -1660.81591796875,
        -3809.16064453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.0323486328125,
        -3801.907470703125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.602889895439148,
        0.7976671457290649,
        0.015840327367186546
      ],
      "plane_d": 4058.35595703125,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3825.025146484375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8662683367729187,
        -0.49144446849823,
        -0.08978576213121414
      ],
      "plane_d": -3202.08837890625,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3825.025146484375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661858439445496,
        0.4913976788520813,
        -0.09083105623722076
      ],
      "plane_d": 564.0211181640625,
      "bbox_min": [
        -1665.8248291015625,
        -3835.4853515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3825.025146484375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958792328834534,
        -0.09068919718265533
      ],
      "plane_d": 3933.82470703125,
      "bbox_min": [
        -1662.8577880859375,
        -3835.4853515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3825.025146484375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661637902259827,
        0.4913851320743561,
        -0.09110943228006363
      ],
      "plane_d": 3440.12255859375,
      "bbox_min": [
        -1662.8577880859375,
        -3835.4853515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3825.025146484375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8662463426589966,
        -0.4914320111274719,
        -0.09006507694721222
      ],
      "plane_d": -325.61572265625,
      "bbox_min": [
        -1662.8577880859375,
        -3835.4853515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1654.2523193359375,
        -3830.25537109375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9960699081420898,
        -0.08857003599405289
      ],
      "plane_d": -3698.760498046875,
      "bbox_min": [
        -1662.8577880859375,
        -3835.4853515625,
        1332.997802734375
      ],
      "bbox_max": [
        -1657.2193603515625,
        -3832.460693359375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1661.048095703125,
        -3833.04345703125,
        1332.997802734375
      ],
      "bbox_max": [
        -1659.0400390625,
        -3832.460693359375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1660.0450439453125,
        -3833.16015625,
        1331.699951171875
      ],
      "bbox_max": [
        -1658.618896484375,
        -3832.460693359375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1659.0400390625,
        -3831.734130859375,
        1331.699951171875
      ],
      "bbox_max": [
        -1656.98681640625,
        -3828.122802734375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661673665046692,
        -0.49139657616615295,
        0.09101392328739166
      ],
      "plane_d": -568.1634521484375,
      "bbox_min": [
        -1657.8099365234375,
        -3831.734130859375,
        1331.699951171875
      ],
      "bbox_max": [
        -1656.98681640625,
        -3830.283203125,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1661.048095703125,
        -3828.83154296875,
        1331.699951171875
      ],
      "bbox_max": [
        -1657.810302734375,
        -3827.40625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1659.0400390625,
        -3828.83154296875,
        1331.699951171875
      ],
      "bbox_max": [
        -1657.810302734375,
        -3827.40625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661102056503296,
        0.49135321378707886,
        0.09178858995437622
      ],
      "plane_d": 319.3603515625,
      "bbox_min": [
        -1662.28759765625,
        -3830.291748046875,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.8253173828125,
        -3827.40625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1661.4666748046875,
        -3828.122802734375,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.8253173828125,
        -3827.40625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053097248077393,
        0.7958692908287048,
        0.013866530731320381
      ],
      "plane_d": 4058.1630859375,
      "bbox_min": [
        -1671.080078125,
        -3856.43603515625,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.8443603515625,
        -3828.853515625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661102056503296,
        0.49135321378707886,
        0.09178858995437622
      ],
      "plane_d": 319.3603515625,
      "bbox_min": [
        -1663.0987548828125,
        -3833.16015625,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.8443603515625,
        -3828.853515625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9959864616394043,
        0.08950401842594147
      ],
      "plane_d": -3936.96826171875,
      "bbox_min": [
        -1661.4666748046875,
        -3833.16015625,
        1331.699951171875
      ],
      "bbox_max": [
        -1659.8443603515625,
        -3832.460693359375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124725103378296,
        0.8080757856369019,
        -0.2904915511608124
      ],
      "plane_d": 4368.66455078125,
      "bbox_min": [
        -1665.353515625,
        -3856.43603515625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1665.21728515625,
        -3856.3544921875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1665.245361328125,
        -3856.43603515625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1665.21728515625,
        -3856.425048828125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.944113552570343,
        0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": -314.7994384765625,
      "bbox_min": [
        -1646.2557373046875,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39069291949272156,
        -0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": -2834.691650390625,
      "bbox_min": [
        -1612.9793701171875,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1577.7047119140625,
        -3722.833251953125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4191102683544159,
        0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": 4039.34228515625,
      "bbox_min": [
        -1612.9793701171875,
        -3743.56396484375,
        1331.699951171875
      ],
      "bbox_max": [
        -1595.6251220703125,
        -3722.833251953125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39069291949272156,
        0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": 2792.57861328125,
      "bbox_min": [
        -1612.9793701171875,
        -3743.56396484375,
        1331.699951171875
      ],
      "bbox_max": [
        -1601.0206298828125,
        -3734.43603515625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1612.9793701171875,
        -3743.56396484375,
        1331.699951171875
      ],
      "bbox_max": [
        -1601.0206298828125,
        -3736.4619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4191102683544159,
        -0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": -4095.93798828125,
      "bbox_min": [
        -1612.9793701171875,
        -3743.56396484375,
        1331.699951171875
      ],
      "bbox_max": [
        -1608.3470458984375,
        -3741.14892578125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8297655582427979,
        -0.4930509030818939,
        -0.2615146338939667
      ],
      "plane_d": -2807.57421875,
      "bbox_min": [
        -1605.681884765625,
        -3737.468505859375,
        1373.4637451171875
      ],
      "bbox_max": [
        -1595.6251220703125,
        -3722.833251953125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1587.2730712890625,
        -3751.989013671875,
        1373.4637451171875
      ],
      "bbox_max": [
        -1587.0594482421875,
        -3751.5205078125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7985454797744751,
        0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": 3537.88037109375,
      "bbox_min": [
        -1612.770751953125,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1587.26123046875,
        -3737.464599609375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1612.770751953125,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1603.229248046875,
        -3775.858154296875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9821799397468567,
        -0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": 843.1284790039062,
      "bbox_min": [
        -1612.770751953125,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1603.229248046875,
        -3775.858154296875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1612.770751953125,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1603.92431640625,
        -3775.858154296875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09095914661884308,
        0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": 3882.0458984375,
      "bbox_min": [
        -1612.07568359375,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1603.92431640625,
        -3775.858154296875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09095914661884308,
        -0.9956895112991333,
        0.01813572272658348
      ],
      "plane_d": -3939.883056640625,
      "bbox_min": [
        -1612.07568359375,
        -3786.141845703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1603.92431640625,
        -3776.607421875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        -1612.07568359375,
        -3785.392578125,
        1370.0
      ],
      "bbox_max": [
        -1603.92431640625,
        -3776.607421875,
        1370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8297655582427979,
        -0.4930509030818939,
        -0.2615146338939667
      ],
      "plane_d": -2807.57421875,
      "bbox_min": [
        -1595.63427734375,
        -3751.535400390625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1587.26123046875,
        -3737.464599609375,
        1373.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4371967911720276,
        -0.8732787370681763,
        -0.2150418758392334
      ],
      "plane_d": -3674.721435546875,
      "bbox_min": [
        -1587.2813720703125,
        -3751.535400390625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1587.26123046875,
        -3751.5205078125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664397597312927,
        -0.49154171347618103,
        -0.08757215738296509
      ],
      "plane_d": -311.1588134765625,
      "bbox_min": [
        -1646.2557373046875,
        -3756.767333984375,
        1331.699951171875
      ],
      "bbox_max": [
        -1605.677978515625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9962114691734314,
        -0.08696449548006058
      ],
      "plane_d": -3617.77197265625,
      "bbox_min": [
        -1646.2557373046875,
        -3756.767333984375,
        1331.699951171875
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664997220039368,
        0.4915757477283478,
        -0.08678330481052399
      ],
      "plane_d": 3370.92724609375,
      "bbox_min": [
        -1646.2557373046875,
        -3751.43017578125,
        1331.699951171875
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9963495135307312,
        -0.08536812663078308
      ],
      "plane_d": 3844.80419921875,
      "bbox_min": [
        -1646.2557373046875,
        -3751.43017578125,
        1331.699951171875
      ],
      "bbox_max": [
        -1629.959716796875,
        -3730.40087890625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8664623498916626,
        -0.49155452847480774,
        -0.0872773602604866
      ],
      "plane_d": -3141.50732421875,
      "bbox_min": [
        -1646.2557373046875,
        -3751.43017578125,
        1331.699951171875
      ],
      "bbox_max": [
        -1629.959716796875,
        -3741.208251953125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8665220737457275,
        0.49158841371536255,
        -0.08649006485939026
      ],
      "plane_d": 540.480712890625,
      "bbox_min": [
        -1638.721435546875,
        -3751.43017578125,
        1331.99169921875
      ],
      "bbox_max": [
        -1629.959716796875,
        -3741.208251953125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8790856003761292,
        -0.474399209022522,
        -0.04641010984778404
      ],
      "plane_d": -278.5462646484375,
      "bbox_min": [
        -1638.65380859375,
        -3751.43017578125,
        1361.0
      ],
      "bbox_max": [
        -1629.959716796875,
        -3741.251220703125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.924848198890686,
        -0.375645250082016,
        -0.059552282094955444
      ],
      "plane_d": -2836.9599609375,
      "bbox_min": [
        -1638.65380859375,
        -3751.43017578125,
        1361.0
      ],
      "bbox_max": [
        -1629.959716796875,
        -3741.251220703125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1634.424560546875,
        -3748.005615234375,
        1363.5
      ],
      "bbox_max": [
        -1632.0208740234375,
        -3745.692138671875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1634.424560546875,
        -3746.20947265625,
        1373.0
      ],
      "bbox_max": [
        -1632.185546875,
        -3745.70654296875,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1632.5020751953125,
        -3746.20947265625,
        1373.0
      ],
      "bbox_max": [
        -1632.0208740234375,
        -3745.692138671875,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1638.65380859375,
        -3751.43017578125,
        1363.5
      ],
      "bbox_max": [
        -1633.4478759765625,
        -3745.888916015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44637808203697205,
        0.8144006133079529,
        -0.37080734968185425
      ],
      "plane_d": 2826.673583984375,
      "bbox_min": [
        -1637.917724609375,
        -3748.2744140625,
        1363.5
      ],
      "bbox_max": [
        -1635.1839599609375,
        -3746.298828125,
        1366.4920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5709734559059143,
        -0.33700570464134216,
        -0.7486096620559692
      ],
      "plane_d": -1175.90087890625,
      "bbox_min": [
        -1637.4873046875,
        -3748.2744140625,
        1363.5
      ],
      "bbox_max": [
        -1635.31201171875,
        -3746.632080078125,
        1364.9459228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.924848198890686,
        -0.375645250082016,
        -0.059552282094955444
      ],
      "plane_d": -2836.9599609375,
      "bbox_min": [
        -1638.721435546875,
        -3746.3173828125,
        1331.99169921875
      ],
      "bbox_max": [
        -1634.048095703125,
        -3741.251220703125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1638.721435546875,
        -3746.3173828125,
        1331.99169921875
      ],
      "bbox_max": [
        -1634.048095703125,
        -3744.122802734375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44637808203697205,
        0.8144006133079529,
        -0.37080734968185425
      ],
      "plane_d": 2826.673583984375,
      "bbox_min": [
        -1645.3358154296875,
        -3751.38232421875,
        1364.9202880859375
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3746.262451171875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1635.79541015625,
        -3751.38232421875,
        1366.2606201171875
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3750.48193359375,
        1372.9520263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1636.291259765625,
        -3746.291748046875,
        1331.699951171875
      ],
      "bbox_max": [
        -1635.278564453125,
        -3744.764892578125,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3099275529384613,
        0.6927969455718994,
        -0.6511353850364685
      ],
      "plane_d": 3984.376220703125,
      "bbox_min": [
        -1638.0,
        -3742.279296875,
        1361.0
      ],
      "bbox_max": [
        -1630.3123779296875,
        -3730.40087890625,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1638.0,
        -3742.279296875,
        1361.0
      ],
      "bbox_max": [
        -1630.3123779296875,
        -3730.40087890625,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132316708564758,
        0.15480175614356995,
        -0.3768877387046814
      ],
      "plane_d": 2582.4140625,
      "bbox_min": [
        -1631.7900390625,
        -3742.279296875,
        1361.0
      ],
      "bbox_max": [
        -1630.8106689453125,
        -3741.1015625,
        1363.339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642286658287048,
        0.4902915954589844,
        0.11279557645320892
      ],
      "plane_d": 272.432861328125,
      "bbox_min": [
        -1635.4425048828125,
        -3744.789794921875,
        1331.699951171875
      ],
      "bbox_max": [
        -1634.048095703125,
        -3743.25732421875,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1636.4681396484375,
        -3746.291748046875,
        1331.699951171875
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9132316708564758,
        0.15480175614356995,
        -0.3768877387046814
      ],
      "plane_d": 2582.4140625,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1362.0958251953125
      ],
      "bbox_max": [
        -1627.5999755859375,
        -3728.79052734375,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1363.5902099609375
      ],
      "bbox_max": [
        -1627.5999755859375,
        -3728.79052734375,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8790856003761292,
        -0.474399209022522,
        -0.04641010984778404
      ],
      "plane_d": -278.5462646484375,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1363.5902099609375
      ],
      "bbox_max": [
        -1627.5999755859375,
        -3728.79052734375,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9078222513198853,
        0.20757806301116943,
        -0.3643762767314911
      ],
      "plane_d": -210.9842529296875,
      "bbox_min": [
        -1636.4681396484375,
        -3733.032958984375,
        1368.822509765625
      ],
      "bbox_max": [
        -1635.393310546875,
        -3728.79052734375,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8646363615989685,
        0.49052292108535767,
        0.1085875928401947
      ],
      "plane_d": 3102.247802734375,
      "bbox_min": [
        -1633.3109130859375,
        -3746.291748046875,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.9107666015625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9938765168190002,
        0.11049634218215942
      ],
      "plane_d": 3573.1875,
      "bbox_min": [
        -1633.3109130859375,
        -3744.122802734375,
        1331.699951171875
      ],
      "bbox_max": [
        -1631.5533447265625,
        -3743.25732421875,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1628.9420166015625,
        -3715.61572265625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1628.9107666015625,
        -3715.59619140625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36749404668807983,
        -0.6063629984855652,
        -0.7051751613616943
      ],
      "plane_d": -1911.773193359375,
      "bbox_min": [
        -1646.0711669921875,
        -3756.767333984375,
        1331.699951171875
      ],
      "bbox_max": [
        -1632.0400390625,
        -3747.781005859375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1646.0711669921875,
        -3756.767333984375,
        1366.66552734375
      ],
      "bbox_max": [
        -1635.7589111328125,
        -3750.83349609375,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8643004298210144,
        -0.49033236503601074,
        0.11206679791212082
      ],
      "plane_d": -3400.411865234375,
      "bbox_min": [
        -1635.4429931640625,
        -3749.314453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1634.048095703125,
        -3747.781005859375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.864705502986908,
        -0.4905621111392975,
        0.1078575849533081
      ],
      "plane_d": -572.09228515625,
      "bbox_min": [
        -1633.3111572265625,
        -3749.314453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1605.677978515625,
        -3720.61279296875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8646363615989685,
        0.49052292108535767,
        0.1085875928401947
      ],
      "plane_d": 3102.247802734375,
      "bbox_min": [
        -1633.3111572265625,
        -3749.314453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1629.835205078125,
        -3744.736572265625,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9940398931503296,
        0.10901788622140884
      ],
      "plane_d": -3872.147216796875,
      "bbox_min": [
        -1633.3111572265625,
        -3749.314453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1631.5533447265625,
        -3748.460693359375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1612.810791015625,
        -3722.845947265625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1605.677978515625,
        -3720.61279296875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5709734559059143,
        -0.33700570464134216,
        -0.7486096620559692
      ],
      "plane_d": -1175.90087890625,
      "bbox_min": [
        -1647.7288818359375,
        -3751.117431640625,
        1371.4952392578125
      ],
      "bbox_max": [
        -1644.9384765625,
        -3747.092041015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44637808203697205,
        0.8144006133079529,
        -0.37080734968185425
      ],
      "plane_d": 2826.673583984375,
      "bbox_min": [
        -1647.7288818359375,
        -3748.62158203125,
        1371.4952392578125
      ],
      "bbox_max": [
        -1644.9384765625,
        -3747.092041015625,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1435.0999755859375,
      "bbox_min": [
        -1708.5179443359375,
        -3856.43115234375,
        1373.5
      ],
      "bbox_max": [
        -1566.068359375,
        -3715.608154296875,
        1437.484619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8661637902259827,
        0.4913851320743561,
        -0.09110943228006363
      ],
      "plane_d": 3440.12255859375,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661858439445496,
        0.4913976788520813,
        -0.09083105623722076
      ],
      "plane_d": 564.0211181640625,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8662463426589966,
        -0.4914320111274719,
        -0.09006507694721222
      ],
      "plane_d": -325.61572265625,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8662683367729187,
        -0.49144446849823,
        -0.08978576213121414
      ],
      "plane_d": -3202.08837890625,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958792328834534,
        -0.09068919718265533
      ],
      "plane_d": 3933.82470703125,
      "bbox_min": [
        -1666.2618408203125,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9960699081420898,
        -0.08857003599405289
      ],
      "plane_d": -3698.760498046875,
      "bbox_min": [
        -1666.2618408203125,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3840.962646484375,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664397597312927,
        -0.49154171347618103,
        -0.08757215738296509
      ],
      "plane_d": -311.1588134765625,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664997220039368,
        0.4915757477283478,
        -0.08678330481052399
      ],
      "plane_d": 3370.92724609375,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8664623498916626,
        -0.49155452847480774,
        -0.0872773602604866
      ],
      "plane_d": -3141.50732421875,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8665220737457275,
        0.49158841371536255,
        -0.08649006485939026
      ],
      "plane_d": 540.480712890625,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9962114691734314,
        -0.08696449548006058
      ],
      "plane_d": -3617.77197265625,
      "bbox_min": [
        -1639.066162109375,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9963495135307312,
        -0.08536812663078308
      ],
      "plane_d": 3844.80419921875,
      "bbox_min": [
        -1639.066162109375,
        -3735.930419921875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9808455109596252,
        0.11954662203788757,
        0.153787299990654
      ],
      "plane_d": 1902.333251953125,
      "bbox_min": [
        -1701.6458740234375,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3763.621826171875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9903883337974548,
        0.11493825167417526,
        -0.07694196701049805
      ],
      "plane_d": 2226.1884765625,
      "bbox_min": [
        -1701.6458740234375,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3763.621826171875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9884322285652161,
        0.1204712986946106,
        -0.09213302284479141
      ],
      "plane_d": 2265.16162109375,
      "bbox_min": [
        -1701.6458740234375,
        -3777.009521484375,
        1408.7421875
      ],
      "bbox_max": [
        -1700.01416015625,
        -3763.621826171875,
        1413.6126708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291348457336426,
        0.06194232776761055,
        0.36451566219329834
      ],
      "plane_d": 1300.832275390625,
      "bbox_min": [
        -1701.5181884765625,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3763.7265625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1418.5858154296875,
      "bbox_min": [
        -1701.0306396484375,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3764.127197265625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9468005895614624,
        0.026867033913731575,
        -0.3206973075866699
      ],
      "plane_d": 2164.285400390625,
      "bbox_min": [
        -1699.4202880859375,
        -3777.3857421875,
        1414.998291015625
      ],
      "bbox_max": [
        -1698.2247314453125,
        -3765.865478515625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22611576318740845,
        -0.2783043384552002,
        0.9334979057312012
      ],
      "plane_d": -1978.227783203125,
      "bbox_min": [
        -1700.3623046875,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3764.67578125,
        1412.5760498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1700.3623046875,
        -3775.60595703125,
        1405.224365234375
      ],
      "bbox_max": [
        -1693.30859375,
        -3764.67578125,
        1405.224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8742771744728088,
        0.4108754098415375,
        0.25849705934524536
      ],
      "plane_d": 2674.00830078125,
      "bbox_min": [
        -1700.01416015625,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3770.9658203125,
        1412.5760498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8549758195877075,
        0.5185649394989014,
        -0.01033354364335537
      ],
      "plane_d": 3426.653076171875,
      "bbox_min": [
        -1700.01416015625,
        -3777.54345703125,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3770.9658203125,
        1412.5760498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1692.7010498046875,
        -3772.851806640625,
        1404.091552734375
      ],
      "bbox_max": [
        -1690.88427734375,
        -3770.9658203125,
        1406.9580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8661858439445496,
        0.4913976788520813,
        -0.09083105623722076
      ],
      "plane_d": 564.0211181640625,
      "bbox_min": [
        -1708.5179443359375,
        -3840.962646484375,
        1373.5
      ],
      "bbox_max": [
        -1641.312744140625,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8662683367729187,
        -0.49144446849823,
        -0.08978576213121414
      ],
      "plane_d": -3202.08837890625,
      "bbox_min": [
        -1672.2469482421875,
        -3840.962646484375,
        1373.5
      ],
      "bbox_max": [
        -1641.312744140625,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661637902259827,
        0.4913851320743561,
        -0.09110943228006363
      ],
      "plane_d": 3440.12255859375,
      "bbox_min": [
        -1668.5179443359375,
        -3837.37109375,
        1373.5
      ],
      "bbox_max": [
        -1641.312744140625,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958792328834534,
        -0.09068919718265533
      ],
      "plane_d": 3933.82470703125,
      "bbox_min": [
        -1668.5179443359375,
        -3837.37109375,
        1373.5
      ],
      "bbox_max": [
        -1650.5738525390625,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1668.5179443359375,
        -3837.37109375,
        1379.0
      ],
      "bbox_max": [
        -1650.5738525390625,
        -3819.96044921875,
        1429.1146240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1667.7969970703125,
        -3837.37109375,
        1394.5888671875
      ],
      "bbox_max": [
        -1655.5018310546875,
        -3831.215576171875,
        1397.7823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1660.445068359375,
        -3837.37109375,
        1394.5888671875
      ],
      "bbox_max": [
        -1655.6619873046875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3837.21484375,
        1394.7890625
      ],
      "bbox_max": [
        -1655.6619873046875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3836.669189453125,
        1394.93896484375
      ],
      "bbox_max": [
        -1655.5018310546875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1477023810148239,
        0.8970673680305481,
        -0.41647815704345703
      ],
      "plane_d": 4266.4384765625,
      "bbox_min": [
        -1666.414794921875,
        -3836.400390625,
        1379.0
      ],
      "bbox_max": [
        -1650.5738525390625,
        -3820.2060546875,
        1426.417724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3836.400390625,
        1395.0128173828125
      ],
      "bbox_max": [
        -1655.1014404296875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1666.414794921875,
        -3835.728515625,
        1379.0
      ],
      "bbox_max": [
        -1652.8970947265625,
        -3820.2060546875,
        1426.417724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3835.728515625,
        1395.1973876953125
      ],
      "bbox_max": [
        -1654.4971923828125,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1382.5,
      "bbox_min": [
        -1663.87841796875,
        -3830.064697265625,
        1379.0
      ],
      "bbox_max": [
        -1656.1591796875,
        -3824.20556640625,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8496569395065308,
        -0.49872028827667236,
        -0.1713510900735855
      ],
      "plane_d": -3084.51806640625,
      "bbox_min": [
        -1663.87841796875,
        -3830.064697265625,
        1379.0
      ],
      "bbox_max": [
        -1656.1591796875,
        -3824.315673828125,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8496588468551636,
        -0.4987213611602783,
        -0.17133881151676178
      ],
      "plane_d": -263.67529296875,
      "bbox_min": [
        -1663.669677734375,
        -3830.064697265625,
        1379.0
      ],
      "bbox_max": [
        -1656.1591796875,
        -3824.315673828125,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1663.669677734375,
        -3827.840087890625,
        1379.0
      ],
      "bbox_max": [
        -1656.375244140625,
        -3824.315673828125,
        1381.2913818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1661.1710205078125,
        -3827.840087890625,
        1379.0
      ],
      "bbox_max": [
        -1656.375244140625,
        -3824.318603515625,
        1381.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1661.1710205078125,
        -3826.939208984375,
        1379.0
      ],
      "bbox_max": [
        -1658.8289794921875,
        -3824.39990234375,
        1380.3665771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1665.2738037109375,
        -3824.39990234375,
        1380.366455078125
      ],
      "bbox_max": [
        -1654.2425537109375,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1663.2723388671875,
        -3824.39990234375,
        1380.366455078125
      ],
      "bbox_max": [
        -1656.8040771484375,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1663.2723388671875,
        -3824.39990234375,
        1380.366455078125
      ],
      "bbox_max": [
        -1656.8040771484375,
        -3821.549560546875,
        1381.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1658.8289794921875,
        -3824.39990234375,
        1380.3665771484375
      ],
      "bbox_max": [
        -1656.8040771484375,
        -3821.653076171875,
        1381.8447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1657.73828125,
        -3820.2060546875,
        1426.417724609375
      ],
      "bbox_max": [
        -1654.2425537109375,
        -3818.8876953125,
        1431.0323486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1658.8765869140625,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1651.9266357421875,
        -3815.164794921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1658.8765869140625,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1651.9266357421875,
        -3815.164794921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1382.5,
      "bbox_min": [
        -1658.8765869140625,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1658.8765869140625,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8496588468551636,
        -0.4987213611602783,
        -0.17133881151676178
      ],
      "plane_d": -263.67529296875,
      "bbox_min": [
        -1658.8765869140625,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1658.8765869140625,
        -3821.653076171875,
        1381.8447265625
      ],
      "bbox_max": [
        -1658.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1672.0638427734375,
        -3837.362060546875,
        1394.568359375
      ],
      "bbox_max": [
        -1663.9801025390625,
        -3830.227783203125,
        1399.33056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1668.718505859375,
        -3831.215576171875,
        1397.7823486328125
      ],
      "bbox_max": [
        -1667.7969970703125,
        -3830.227783203125,
        1399.33056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1672.0638427734375,
        -3837.362060546875,
        1394.568359375
      ],
      "bbox_max": [
        -1671.2332763671875,
        -3836.5166015625,
        1395.0447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42730265855789185,
        0.7768415808677673,
        -0.4625251591205597
      ],
      "plane_d": 4345.2626953125,
      "bbox_min": [
        -1687.5968017578125,
        -3837.358642578125,
        1387.9375
      ],
      "bbox_max": [
        -1669.895751953125,
        -3823.24462890625,
        1418.6871337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1683.9769287109375,
        -3837.358642578125,
        1393.863037109375
      ],
      "bbox_max": [
        -1669.895751953125,
        -3827.89208984375,
        1399.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5122923851013184,
        0.8093295097351074,
        -0.2873016893863678
      ],
      "plane_d": 4368.77099609375,
      "bbox_min": [
        -1683.9769287109375,
        -3837.310546875,
        1393.863037109375
      ],
      "bbox_max": [
        -1683.834716796875,
        -3837.2021484375,
        1394.0797119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527439951896667,
        0.69832843542099,
        -0.293705016374588
      ],
      "plane_d": 4188.28125,
      "bbox_min": [
        -1687.5968017578125,
        -3837.2958984375,
        1387.9375
      ],
      "bbox_max": [
        -1683.9503173828125,
        -3833.40283203125,
        1397.1165771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6851163506507874,
        0.7231000661849976,
        -0.08798906207084656
      ],
      "plane_d": 4051.06494140625,
      "bbox_min": [
        -1687.5968017578125,
        -3837.2021484375,
        1394.0797119140625
      ],
      "bbox_max": [
        -1683.9769287109375,
        -3833.40283203125,
        1397.1165771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5122923851013184,
        0.8093295097351074,
        -0.2873016893863678
      ],
      "plane_d": 4368.77099609375,
      "bbox_min": [
        -1684.05712890625,
        -3837.2958984375,
        1393.7108154296875
      ],
      "bbox_max": [
        -1683.9503173828125,
        -3837.2021484375,
        1394.0797119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1675.744873046875,
        -3833.124755859375,
        1396.7977294921875
      ],
      "bbox_max": [
        -1666.414794921875,
        -3823.90966796875,
        1413.455322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1675.744873046875,
        -3833.124755859375,
        1396.7977294921875
      ],
      "bbox_max": [
        -1668.718505859375,
        -3827.89208984375,
        1399.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1394.9000244140625,
      "bbox_min": [
        -1708.5179443359375,
        -3836.76904296875,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.37160712480545044,
        -0.925055980682373,
        0.07860997319221497
      ],
      "plane_d": -3009.404296875,
      "bbox_min": [
        -1703.2109375,
        -3836.76904296875,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3791.642333984375,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1677.7623291015625,
        -3810.47412109375,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3791.642333984375,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977416396141052,
        -0.018138699233531952,
        0.06467321515083313
      ],
      "plane_d": 1504.76416015625,
      "bbox_min": [
        -1667.7542724609375,
        -3804.63525390625,
        1376.56298828125
      ],
      "bbox_max": [
        -1666.346923828125,
        -3791.642333984375,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.93994140625,
      "bbox_min": [
        -1660.2227783203125,
        -3803.289306640625,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3797.92333984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1660.2227783203125,
        -3803.289306640625,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3797.92333984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9698894619941711,
        -0.2424565553665161,
        0.023007404059171677
      ],
      "plane_d": -2563.630615234375,
      "bbox_min": [
        -1660.2227783203125,
        -3803.289306640625,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3800.865966796875,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1656.8094482421875,
        -3802.056884765625,
        1373.5
      ],
      "bbox_max": [
        -1656.249267578125,
        -3800.865966796875,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1703.2109375,
        -3836.76904296875,
        1373.5
      ],
      "bbox_max": [
        -1656.7459716796875,
        -3801.82421875,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527439951896667,
        0.69832843542099,
        -0.293705016374588
      ],
      "plane_d": 4188.28125,
      "bbox_min": [
        -1703.2109375,
        -3836.76904296875,
        1373.5
      ],
      "bbox_max": [
        -1656.7459716796875,
        -3801.82421875,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6851163506507874,
        0.7231000661849976,
        -0.08798906207084656
      ],
      "plane_d": 4051.06494140625,
      "bbox_min": [
        -1703.2109375,
        -3834.29638671875,
        1394.2098388671875
      ],
      "bbox_max": [
        -1687.027099609375,
        -3818.878662109375,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902018308639526,
        -0.13916033506393433,
        0.011614802293479443
      ],
      "plane_d": 1106.7347412109375,
      "bbox_min": [
        -1677.493408203125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1656.7459716796875,
        -3801.82421875,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9902018308639526,
        0.13916033506393433,
        0.011615406721830368
      ],
      "plane_d": -1145.0863037109375,
      "bbox_min": [
        -1677.493408203125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1670.296875,
        -3814.1474609375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7683862447738647,
        -0.6397959589958191,
        0.015609897673130035
      ],
      "plane_d": -3755.94970703125,
      "bbox_min": [
        -1677.493408203125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1670.296875,
        -3814.1474609375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7684020400047302,
        0.6397770047187805,
        0.015609982423484325
      ],
      "plane_d": 3704.36279296875,
      "bbox_min": [
        -1677.2794189453125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1670.296875,
        -3814.1474609375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5622904300689697,
        0.8267924785614014,
        0.015609785914421082
      ],
      "plane_d": 2191.310791015625,
      "bbox_min": [
        -1677.2794189453125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1670.5108642578125,
        -3814.1474609375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622641444206238,
        -0.8268104195594788,
        0.015609738416969776
      ],
      "plane_d": -2242.9638671875,
      "bbox_min": [
        -1677.2794189453125,
        -3825.7294921875,
        1373.5
      ],
      "bbox_max": [
        -1670.5108642578125,
        -3814.491943359375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        -1677.2794189453125,
        -3825.385009765625,
        1390.0
      ],
      "bbox_max": [
        -1670.5108642578125,
        -3814.491943359375,
        1390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1665.0,
        -3825.16064453125,
        1373.5
      ],
      "bbox_max": [
        -1656.7459716796875,
        -3801.82421875,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9698894619941711,
        -0.2424565553665161,
        0.023007404059171677
      ],
      "plane_d": -2563.630615234375,
      "bbox_min": [
        -1659.8773193359375,
        -3806.669189453125,
        1373.5
      ],
      "bbox_max": [
        -1659.0108642578125,
        -3803.080078125,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1665.0,
        -3825.16064453125,
        1381.130615234375
      ],
      "bbox_max": [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8496569395065308,
        -0.49872028827667236,
        -0.1713510900735855
      ],
      "plane_d": -3084.51806640625,
      "bbox_min": [
        -1665.0,
        -3825.16064453125,
        1381.130615234375
      ],
      "bbox_max": [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1662.0,
        -3821.549560546875,
        1381.9002685546875
      ],
      "bbox_max": [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1708.5179443359375,
        -3834.084228515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.604570209980011,
        0.24677103757858276,
        -0.7573631405830383
      ],
      "plane_d": 3035.247314453125,
      "bbox_min": [
        -1708.5179443359375,
        -3834.084228515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7312896847724915,
        0.5189598798751831,
        -0.44260138273239136
      ],
      "plane_d": 3842.576171875,
      "bbox_min": [
        -1705.0323486328125,
        -3823.24462890625,
        1408.20703125
      ],
      "bbox_max": [
        -1671.1722412109375,
        -3800.177001953125,
        1432.5184326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1705.0323486328125,
        -3809.075927734375,
        1408.20703125
      ],
      "bbox_max": [
        -1671.1722412109375,
        -3800.177001953125,
        1432.5184326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5214120149612427,
        -0.5920462012290955,
        -0.6145005822181702
      ],
      "plane_d": -495.84271240234375,
      "bbox_min": [
        -1705.0323486328125,
        -3805.5263671875,
        1408.20703125
      ],
      "bbox_max": [
        -1685.6220703125,
        -3800.177001953125,
        1423.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37773242592811584,
        -0.6081996560096741,
        -0.6981486082077026
      ],
      "plane_d": -681.380859375,
      "bbox_min": [
        -1692.30126953125,
        -3805.5263671875,
        1419.8336181640625
      ],
      "bbox_max": [
        -1685.6220703125,
        -3800.177001953125,
        1423.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42730265855789185,
        0.7768415808677673,
        -0.4625251591205597
      ],
      "plane_d": 4345.2626953125,
      "bbox_min": [
        -1708.5179443359375,
        -3834.084228515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418246150016785,
        0.2550792098045349,
        -0.21886266767978668
      ],
      "plane_d": 2883.5341796875,
      "bbox_min": [
        -1708.5179443359375,
        -3834.084228515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6851163506507874,
        0.7231000661849976,
        -0.08798906207084656
      ],
      "plane_d": 4051.06494140625,
      "bbox_min": [
        -1708.5179443359375,
        -3834.084228515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17676745355129242,
        -0.21756620705127716,
        0.9599053263664246
      ],
      "plane_d": -1868.552490234375,
      "bbox_min": [
        -1708.5179443359375,
        -3810.1064453125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11556665599346161,
        -0.3644982576370239,
        0.9240050911903381
      ],
      "plane_d": -2478.528076171875,
      "bbox_min": [
        -1708.5179443359375,
        -3799.81298828125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3777.576416015625,
        1400.501708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35810279846191406,
        -0.03704282268881798,
        0.9329470992088318
      ],
      "plane_d": -842.2459106445312,
      "bbox_min": [
        -1708.5179443359375,
        -3799.67138671875,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3777.576416015625,
        1400.501708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17232948541641235,
        -0.3948441743850708,
        0.9024415016174316
      ],
      "plane_d": -3050.379150390625,
      "bbox_min": [
        -1708.5179443359375,
        -3799.67138671875,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3781.365478515625,
        1399.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5174413919448853,
        0.042831193655729294,
        0.8546460866928101
      ],
      "plane_d": -163.09271240234375,
      "bbox_min": [
        -1680.03515625,
        -3794.7080078125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3781.365478515625,
        1397.505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.543486475944519,
        -0.794340193271637,
        -0.2713780403137207
      ],
      "plane_d": -1710.2587890625,
      "bbox_min": [
        -1708.5179443359375,
        -3799.530517578125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1691.7803955078125,
        -3788.66943359375,
        1399.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6062149405479431,
        -0.7577535510063171,
        -0.24148109555244446
      ],
      "plane_d": -1506.3494873046875,
      "bbox_min": [
        -1708.5179443359375,
        -3799.530517578125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1702.3944091796875,
        -3794.384765625,
        1397.9945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1685.2486572265625,
        -3783.362548828125,
        1399.427490234375
      ],
      "bbox_max": [
        -1684.3076171875,
        -3777.576416015625,
        1400.501708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.543486475944519,
        -0.794340193271637,
        -0.2713780403137207
      ],
      "plane_d": -1710.2587890625,
      "bbox_min": [
        -1707.9254150390625,
        -3799.81298828125,
        1397.1622314453125
      ],
      "bbox_max": [
        -1691.7803955078125,
        -3788.66943359375,
        1399.7498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6062149405479431,
        -0.7577535510063171,
        -0.24148109555244446
      ],
      "plane_d": -1506.3494873046875,
      "bbox_min": [
        -1707.9254150390625,
        -3799.81298828125,
        1397.1622314453125
      ],
      "bbox_max": [
        -1703.0078125,
        -3795.861572265625,
        1399.7498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.543486475944519,
        -0.794340193271637,
        -0.2713780403137207
      ],
      "plane_d": -1710.2587890625,
      "bbox_min": [
        -1707.24755859375,
        -3810.1064453125,
        1399.427490234375
      ],
      "bbox_max": [
        -1661.2216796875,
        -3772.45751953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22611574828624725,
        -0.2783043384552002,
        0.9334978461265564
      ],
      "plane_d": -1978.2275390625,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1399.427490234375
      ],
      "bbox_max": [
        -1674.9693603515625,
        -3772.45751953125,
        1423.8892822265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1685.2486572265625,
        -3783.362548828125,
        1399.427490234375
      ],
      "bbox_max": [
        -1684.2139892578125,
        -3777.857421875,
        1400.7952880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44601723551750183,
        0.6731513142585754,
        -0.5898609161376953
      ],
      "plane_d": 4137.5,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1399.427490234375
      ],
      "bbox_max": [
        -1674.9693603515625,
        -3772.45751953125,
        1423.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5214120149612427,
        -0.5920462012290955,
        -0.6145005822181702
      ],
      "plane_d": -495.84271240234375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1402.6817626953125
      ],
      "bbox_max": [
        -1687.3360595703125,
        -3790.237060546875,
        1413.0626220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5898225903511047,
        -0.7913569808006287,
        -0.16082163155078888
      ],
      "plane_d": -1775.6019287109375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1402.6817626953125
      ],
      "bbox_max": [
        -1687.3360595703125,
        -3790.237060546875,
        1413.0626220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5521392226219177,
        -0.7932242155075073,
        -0.25678348541259766
      ],
      "plane_d": -1711.816162109375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1402.6817626953125
      ],
      "bbox_max": [
        -1695.3194580078125,
        -3792.689453125,
        1408.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37773242592811584,
        -0.6081996560096741,
        -0.6981486082077026
      ],
      "plane_d": -681.380859375,
      "bbox_min": [
        -1687.8275146484375,
        -3790.623291015625,
        1412.788818359375
      ],
      "bbox_max": [
        -1687.3360595703125,
        -3790.237060546875,
        1413.0626220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1914781779050827,
        0.2929966151714325,
        -0.9367438554763794
      ],
      "plane_d": 2110.692626953125,
      "bbox_min": [
        -1699.6932373046875,
        -3793.14208984375,
        1399.427490234375
      ],
      "bbox_max": [
        -1674.9693603515625,
        -3772.45751953125,
        1423.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2051539123058319,
        0.2744576930999756,
        -0.9394598603248596
      ],
      "plane_d": 2021.2774658203125,
      "bbox_min": [
        -1698.181396484375,
        -3790.275390625,
        1412.788818359375
      ],
      "bbox_max": [
        -1674.9693603515625,
        -3778.22021484375,
        1423.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1687.7115478515625,
        -3790.275390625,
        1412.788818359375
      ],
      "bbox_max": [
        -1674.9693603515625,
        -3780.04833984375,
        1423.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40925341844558716,
        -0.5475047826766968,
        -0.7298974394798279
      ],
      "plane_d": -353.2802734375,
      "bbox_min": [
        -1687.7115478515625,
        -3790.275390625,
        1412.788818359375
      ],
      "bbox_max": [
        -1683.714111328125,
        -3787.648681640625,
        1413.2591552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1684.248779296875,
        -3787.648681640625,
        1412.788818359375
      ],
      "bbox_max": [
        -1678.212158203125,
        -3780.04833984375,
        1421.6585693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8549758195877075,
        0.5185649394989014,
        -0.01033354364335537
      ],
      "plane_d": 3426.653076171875,
      "bbox_min": [
        -1699.6932373046875,
        -3793.14208984375,
        1399.427490234375
      ],
      "bbox_max": [
        -1681.638916015625,
        -3772.45751953125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5898225903511047,
        -0.7913569808006287,
        -0.16082163155078888
      ],
      "plane_d": -1775.6019287109375,
      "bbox_min": [
        -1696.6925048828125,
        -3793.14208984375,
        1399.9686279296875
      ],
      "bbox_max": [
        -1691.586669921875,
        -3789.4130859375,
        1409.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8742781281471252,
        0.4108649492263794,
        0.258510947227478
      ],
      "plane_d": 2673.95068359375,
      "bbox_min": [
        -1699.6932373046875,
        -3790.072998046875,
        1399.427490234375
      ],
      "bbox_max": [
        -1681.638916015625,
        -3772.45751953125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5521392226219177,
        -0.7932242155075073,
        -0.25678348541259766
      ],
      "plane_d": -1711.816162109375,
      "bbox_min": [
        -1692.59716796875,
        -3790.072998046875,
        1399.427490234375
      ],
      "bbox_max": [
        -1691.7803955078125,
        -3788.66943359375,
        1402.945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9494562149047852,
        0.029552865773439407,
        -0.3125053644180298
      ],
      "plane_d": 2149.138427734375,
      "bbox_min": [
        -1682.8382568359375,
        -3784.2802734375,
        1406.7005615234375
      ],
      "bbox_max": [
        -1681.9296875,
        -3779.0634765625,
        1409.6258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749769568443298,
        -0.0545491948723793,
        -0.21550977230072021
      ],
      "plane_d": 1737.7413330078125,
      "bbox_min": [
        -1682.8382568359375,
        -3779.6953125,
        1406.7005615234375
      ],
      "bbox_max": [
        -1682.705322265625,
        -3779.0634765625,
        1407.329345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1684.248779296875,
        -3787.648681640625,
        1412.788818359375
      ],
      "bbox_max": [
        -1681.638916015625,
        -3779.31005859375,
        1414.6324462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7706742882728577,
        -0.5802126526832581,
        0.2634660601615906
      ],
      "plane_d": -3862.63427734375,
      "bbox_min": [
        -1699.65673828125,
        -3784.2802734375,
        1399.427490234375
      ],
      "bbox_max": [
        -1682.418212890625,
        -3772.45751953125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9749769568443298,
        -0.0545491948723793,
        -0.21550977230072021
      ],
      "plane_d": 1737.7413330078125,
      "bbox_min": [
        -1683.835205078125,
        -3783.384033203125,
        1401.983154296875
      ],
      "bbox_max": [
        -1682.50390625,
        -3778.2451171875,
        1407.549072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9494562149047852,
        0.029552865773439407,
        -0.3125053644180298
      ],
      "plane_d": 2149.138427734375,
      "bbox_min": [
        -1683.6907958984375,
        -3783.384033203125,
        1403.9371337890625
      ],
      "bbox_max": [
        -1682.50390625,
        -3779.6953125,
        1407.549072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8186903595924377,
        -0.5559530854225159,
        0.14374381303787231
      ],
      "plane_d": -3683.61279296875,
      "bbox_min": [
        -1699.65673828125,
        -3784.2802734375,
        1403.9371337890625
      ],
      "bbox_max": [
        -1682.418212890625,
        -3772.45751953125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9494562149047852,
        0.029552865773439407,
        -0.3125053644180298
      ],
      "plane_d": 2149.138427734375,
      "bbox_min": [
        -1683.6907958984375,
        -3784.2802734375,
        1403.9371337890625
      ],
      "bbox_max": [
        -1682.418212890625,
        -3783.3203125,
        1407.71875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9468005895614624,
        0.026867033913731575,
        -0.3206973075866699
      ],
      "plane_d": 2164.285400390625,
      "bbox_min": [
        -1699.4874267578125,
        -3778.22021484375,
        1414.902587890625
      ],
      "bbox_max": [
        -1698.181396484375,
        -3776.6953125,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7969731092453003,
        0.09249168634414673,
        -0.5968911647796631
      ],
      "plane_d": 2548.369140625,
      "bbox_min": [
        -1699.4874267578125,
        -3777.83349609375,
        1414.902587890625
      ],
      "bbox_max": [
        -1699.4202880859375,
        -3777.3857421875,
        1414.998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1707.24755859375,
        -3810.1064453125,
        1399.73974609375
      ],
      "bbox_max": [
        -1661.2216796875,
        -3785.5244140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6806304454803467,
        -0.1954345554113388,
        -0.7060790657997131
      ],
      "plane_d": 1401.94384765625,
      "bbox_min": [
        -1680.1611328125,
        -3810.1064453125,
        1417.5782470703125
      ],
      "bbox_max": [
        -1661.2216796875,
        -3785.5244140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5214120149612427,
        -0.5920462012290955,
        -0.6145005822181702
      ],
      "plane_d": -495.84271240234375,
      "bbox_min": [
        -1707.24755859375,
        -3801.26708984375,
        1399.73974609375
      ],
      "bbox_max": [
        -1672.25927734375,
        -3786.92041015625,
        1423.5281982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1682.6810302734375,
        -3788.32177734375,
        1414.5150146484375
      ],
      "bbox_max": [
        -1678.26025390625,
        -3786.92041015625,
        1418.9630126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1683.714111328125,
        -3792.74560546875,
        1413.2591552734375
      ],
      "bbox_max": [
        -1672.25927734375,
        -3787.59814453125,
        1423.3345947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6062149405479431,
        -0.7577535510063171,
        -0.24148109555244446
      ],
      "plane_d": -1506.3494873046875,
      "bbox_min": [
        -1707.24755859375,
        -3800.73583984375,
        1399.73974609375
      ],
      "bbox_max": [
        -1703.353759765625,
        -3796.694580078125,
        1408.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5122923851013184,
        0.8093295097351074,
        -0.2873016893863678
      ],
      "plane_d": 4368.77099609375,
      "bbox_min": [
        -1689.8316650390625,
        -3854.443115234375,
        1373.5
      ],
      "bbox_max": [
        -1656.084228515625,
        -3835.4853515625,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124725103378296,
        0.8080757856369019,
        -0.2904915511608124
      ],
      "plane_d": 4368.66455078125,
      "bbox_min": [
        -1686.881591796875,
        -3854.443115234375,
        1374.2144775390625
      ],
      "bbox_max": [
        -1665.1240234375,
        -3840.106689453125,
        1386.5465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053097248077393,
        0.7958692908287048,
        0.013866530731320381
      ],
      "plane_d": 4058.1630859375,
      "bbox_min": [
        -1686.881591796875,
        -3854.443115234375,
        1374.2144775390625
      ],
      "bbox_max": [
        -1667.885986328125,
        -3840.106689453125,
        1380.71826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053097248077393,
        0.7958692908287048,
        0.013866530731320381
      ],
      "plane_d": 4058.1630859375,
      "bbox_min": [
        -1689.8316650390625,
        -3854.43408203125,
        1373.5
      ],
      "bbox_max": [
        -1656.084228515625,
        -3835.4853515625,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1689.8316650390625,
        -3851.158935546875,
        1373.5
      ],
      "bbox_max": [
        -1656.084228515625,
        -3835.4853515625,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1663.232666015625,
        -3848.860107421875,
        1388.640625
      ],
      "bbox_max": [
        -1656.084228515625,
        -3837.360595703125,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527439951896667,
        0.69832843542099,
        -0.293705016374588
      ],
      "plane_d": 4188.28125,
      "bbox_min": [
        -1689.8316650390625,
        -3840.106689453125,
        1373.5
      ],
      "bbox_max": [
        -1684.05712890625,
        -3835.4853515625,
        1393.7108154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1689.8316650390625,
        -3840.106689453125,
        1373.5
      ],
      "bbox_max": [
        -1686.849853515625,
        -3835.4853515625,
        1383.227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8548005819320679,
        0.5188385844230652,
        0.011062489822506905
      ],
      "plane_d": 3419.06884765625,
      "bbox_min": [
        -1688.4173583984375,
        -3840.106689453125,
        1373.5
      ],
      "bbox_max": [
        -1686.849853515625,
        -3837.422607421875,
        1380.71826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1667.9417724609375,
        -3856.43115234375,
        1373.5
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3818.736572265625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1667.9417724609375,
        -3856.43115234375,
        1373.5
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3818.736572265625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009981022449210286,
        0.9665272831916809,
        -0.25656211376190186
      ],
      "plane_d": 4062.731201171875,
      "bbox_min": [
        -1654.4971923828125,
        -3854.6337890625,
        1386.602294921875
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3818.736572265625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26621708273887634,
        0.15397192537784576,
        -0.951536238193512
      ],
      "plane_d": 2347.12158203125,
      "bbox_min": [
        -1631.0516357421875,
        -3854.6337890625,
        1386.602294921875
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3835.56884765625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2064199149608612,
        0.8485844731330872,
        -0.48712968826293945
      ],
      "plane_d": 3598.04443359375,
      "bbox_min": [
        -1644.084228515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "bbox_max": [
        -1614.017578125,
        -3827.154296875,
        1409.101806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1622.4228515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "bbox_max": [
        -1614.017578125,
        -3833.998291015625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.702180027961731,
        0.5420933961868286,
        -0.4616036117076874
      ],
      "plane_d": 1582.606689453125,
      "bbox_min": [
        -1626.77978515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "bbox_max": [
        -1615.930419921875,
        -3827.154296875,
        1408.6197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1622.4228515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "bbox_max": [
        -1615.930419921875,
        -3833.77392578125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7525864839553833,
        0.5542891025543213,
        -0.3554956614971161
      ],
      "plane_d": 1397.815673828125,
      "bbox_min": [
        -1652.8970947265625,
        -3833.04541015625,
        1394.706787109375
      ],
      "bbox_max": [
        -1620.206787109375,
        -3818.736572265625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.68327796459198,
        0.48658624291419983,
        -0.544394314289093
      ],
      "plane_d": 1517.5426025390625,
      "bbox_min": [
        -1626.77978515625,
        -3827.154296875,
        1408.14453125
      ],
      "bbox_max": [
        -1625.6134033203125,
        -3825.89111328125,
        1408.6197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08537863940000534,
        0.896403968334198,
        -0.4349372982978821
      ],
      "plane_d": 4187.44189453125,
      "bbox_min": [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      "bbox_max": [
        -1633.62744140625,
        -3818.736572265625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1477023810148239,
        0.8970673680305481,
        -0.41647815704345703
      ],
      "plane_d": 4266.4384765625,
      "bbox_min": [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      "bbox_max": [
        -1644.084228515625,
        -3825.972412109375,
        1419.053466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1667.9417724609375,
        -3856.425048828125,
        1373.5
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3830.92578125,
        1394.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1664.9873046875,
        -3852.36962890625,
        1386.8251953125
      ],
      "bbox_max": [
        -1663.232666015625,
        -3848.860107421875,
        1388.640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1664.9873046875,
        -3852.36962890625,
        1386.8251953125
      ],
      "bbox_max": [
        -1664.08349609375,
        -3851.158935546875,
        1387.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1667.9417724609375,
        -3856.425048828125,
        1373.5
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3830.92578125,
        1393.380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1624.04638671875,
        -3847.411865234375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1613.2054443359375,
        -3834.91357421875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1667.9417724609375,
        -3856.3544921875,
        1373.5
      ],
      "bbox_max": [
        -1616.2037353515625,
        -3830.92578125,
        1393.380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.702180027961731,
        0.5420933961868286,
        -0.4616036117076874
      ],
      "plane_d": 1582.606689453125,
      "bbox_min": [
        -1622.4228515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "bbox_max": [
        -1619.157958984375,
        -3830.92578125,
        1393.380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053097248077393,
        0.7958692908287048,
        0.013866530731320381
      ],
      "plane_d": 4058.1630859375,
      "bbox_min": [
        -1667.9417724609375,
        -3856.3544921875,
        1373.5
      ],
      "bbox_max": [
        -1665.353515625,
        -3854.385986328125,
        1374.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9963495135307312,
        -0.08536812663078308
      ],
      "plane_d": 3844.80419921875,
      "bbox_min": [
        -1640.79296875,
        -3740.7919921875,
        1373.5
      ],
      "bbox_max": [
        -1605.2095947265625,
        -3717.633544921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1640.79296875,
        -3739.189453125,
        1428.4385986328125
      ],
      "bbox_max": [
        -1627.754638671875,
        -3736.009033203125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5037271976470947,
        -0.8287147879600525,
        -0.24390731751918793
      ],
      "plane_d": -3564.69921875,
      "bbox_min": [
        -1638.60302734375,
        -3736.501220703125,
        1373.5
      ],
      "bbox_max": [
        -1605.2095947265625,
        -3717.633544921875,
        1434.1812744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1625.5048828125,
        -3731.09521484375,
        1373.5
      ],
      "bbox_max": [
        -1605.2095947265625,
        -3717.633544921875,
        1406.1539306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1638.60302734375,
        -3736.501220703125,
        1395.89306640625
      ],
      "bbox_max": [
        -1625.66552734375,
        -3722.95361328125,
        1434.1812744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1638.60302734375,
        -3736.501220703125,
        1416.9940185546875
      ],
      "bbox_max": [
        -1626.607177734375,
        -3731.8828125,
        1434.1812744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321675419807434,
        -0.5764033794403076,
        -0.36289089918136597
      ],
      "plane_d": -430.4671630859375,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1418.5858154296875,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1404.928466796875
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1405.224365234375,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1404.928466796875
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1693.30859375,
        -3771.183349609375,
        1404.928466796875
      ],
      "bbox_max": [
        -1692.4361572265625,
        -3770.299072265625,
        1405.224365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22611576318740845,
        -0.2783043384552002,
        0.9334979057312012
      ],
      "plane_d": -1978.227783203125,
      "bbox_min": [
        -1693.30859375,
        -3770.9658203125,
        1404.928466796875
      ],
      "bbox_max": [
        -1692.7010498046875,
        -3770.299072265625,
        1405.224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7969731092453003,
        0.09249168634414673,
        -0.5968911647796631
      ],
      "plane_d": 2548.369140625,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9468005895614624,
        0.026867033913731575,
        -0.3206973075866699
      ],
      "plane_d": 2164.285400390625,
      "bbox_min": [
        -1698.9132080078125,
        -3766.185791015625,
        1417.46044921875
      ],
      "bbox_max": [
        -1698.52294921875,
        -3760.60009765625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9884322285652161,
        0.1204712986946106,
        -0.09213302284479141
      ],
      "plane_d": 2265.16162109375,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9903883337974548,
        0.11493825167417526,
        -0.07694196701049805
      ],
      "plane_d": 2226.1884765625,
      "bbox_min": [
        -1701.34375,
        -3764.127197265625,
        1413.6126708984375
      ],
      "bbox_max": [
        -1701.0306396484375,
        -3761.6865234375,
        1414.902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291348457336426,
        0.06194232776761055,
        0.36451566219329834
      ],
      "plane_d": 1300.832275390625,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137869238853455,
        -0.16780886054039001,
        0.5564090013504028
      ],
      "plane_d": -2792.393310546875,
      "bbox_min": [
        -1701.838623046875,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.925990104675293,
        0.3757087290287018,
        0.03721969202160835
      ],
      "plane_d": -207.265869140625,
      "bbox_min": [
        -1695.1019287109375,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1690.1976318359375,
        -3754.1884765625,
        1414.330810546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1693.1019287109375,
        -3772.45751953125,
        1405.224365234375
      ],
      "bbox_max": [
        -1690.548828125,
        -3770.299072265625,
        1408.3658447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7828393578529358,
        0.31728696823120117,
        0.5352489352226257
      ],
      "plane_d": -885.9479370117188,
      "bbox_min": [
        -1695.1019287109375,
        -3760.60009765625,
        1405.224365234375
      ],
      "bbox_max": [
        -1690.5386962890625,
        -3754.418701171875,
        1408.234130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7722088098526001,
        0.31050994992256165,
        0.5543257594108582
      ],
      "plane_d": -920.2210083007812,
      "bbox_min": [
        -1695.1019287109375,
        -3760.60009765625,
        1405.224365234375
      ],
      "bbox_max": [
        -1692.9703369140625,
        -3756.058837890625,
        1405.64990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8792824149131775,
        -0.14285479485988617,
        -0.4543730914592743
      ],
      "plane_d": -1382.69873046875,
      "bbox_min": [
        -1701.838623046875,
        -3772.263916015625,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232587218284607,
        -0.3839646577835083,
        0.012823851779103279
      ],
      "plane_d": -3026.698486328125,
      "bbox_min": [
        -1694.6163330078125,
        -3771.91552734375,
        1411.5057373046875
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8357576131820679,
        0.3390980362892151,
        -0.43188145756721497
      ],
      "plane_d": 471.5845947265625,
      "bbox_min": [
        -1694.6163330078125,
        -3771.91552734375,
        1411.5057373046875
      ],
      "bbox_max": [
        -1689.875732421875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622873425483704,
        -0.50560063123703,
        -0.028786351904273033
      ],
      "plane_d": -3323.539306640625,
      "bbox_min": [
        -1690.271484375,
        -3771.91552734375,
        1413.0133056640625
      ],
      "bbox_max": [
        -1689.875732421875,
        -3771.216796875,
        1416.0355224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8186903595924377,
        -0.5559530854225159,
        0.14374381303787231
      ],
      "plane_d": -3683.61279296875,
      "bbox_min": [
        -1690.271484375,
        -3771.890625,
        1413.0133056640625
      ],
      "bbox_max": [
        -1689.875732421875,
        -3771.216796875,
        1413.5157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.925990104675293,
        0.3757087290287018,
        0.03721969202160835
      ],
      "plane_d": -207.265869140625,
      "bbox_min": [
        -1694.6163330078125,
        -3760.60009765625,
        1411.5057373046875
      ],
      "bbox_max": [
        -1690.15966796875,
        -3754.162841796875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8285152316093445,
        0.3337593078613281,
        -0.44963014125823975
      ],
      "plane_d": 488.9586181640625,
      "bbox_min": [
        -1694.6163330078125,
        -3760.60009765625,
        1418.0283203125
      ],
      "bbox_max": [
        -1692.3031005859375,
        -3755.608642578125,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9884277582168579,
        -0.1463971883058548,
        0.03972926363348961
      ],
      "plane_d": -2279.941162109375,
      "bbox_min": [
        -1701.838623046875,
        -3772.263916015625,
        1405.224365234375
      ],
      "bbox_max": [
        -1689.9022216796875,
        -3757.159423828125,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9330036044120789,
        -0.2555065155029297,
        0.2534179091453552
      ],
      "plane_d": -2898.81005859375,
      "bbox_min": [
        -1693.0440673828125,
        -3772.263916015625,
        1407.244384765625
      ],
      "bbox_max": [
        -1689.9022216796875,
        -3757.159423828125,
        1415.0157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.925990104675293,
        0.3757087290287018,
        0.03721969202160835
      ],
      "plane_d": -207.265869140625,
      "bbox_min": [
        -1693.0440673828125,
        -3772.263916015625,
        1407.244384765625
      ],
      "bbox_max": [
        -1689.9022216796875,
        -3757.159423828125,
        1415.0157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8186903595924377,
        -0.5559530854225159,
        0.14374381303787231
      ],
      "plane_d": -3683.61279296875,
      "bbox_min": [
        -1691.5440673828125,
        -3772.263916015625,
        1407.244384765625
      ],
      "bbox_max": [
        -1689.9022216796875,
        -3770.320556640625,
        1413.5157470703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1691.5440673828125,
        -3772.263916015625,
        1407.244384765625
      ],
      "bbox_max": [
        -1690.42041015625,
        -3770.320556640625,
        1409.734130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1693.1019287109375,
        -3771.5625,
        1405.224365234375
      ],
      "bbox_max": [
        -1691.4603271484375,
        -3770.299072265625,
        1409.734130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7628061175346375,
        -0.3028874695301056,
        -0.5713018774986267
      ],
      "plane_d": 967.1665649414062,
      "bbox_min": [
        -1701.838623046875,
        -3763.7265625,
        1408.0091552734375
      ],
      "bbox_max": [
        -1698.3077392578125,
        -3759.658935546875,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9808455109596252,
        0.11954662203788757,
        0.153787299990654
      ],
      "plane_d": 1902.333251953125,
      "bbox_min": [
        -1701.838623046875,
        -3763.7265625,
        1408.0091552734375
      ],
      "bbox_max": [
        -1701.5181884765625,
        -3762.008056640625,
        1408.7421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4656049609184265,
        -0.8380515575408936,
        -0.28439682722091675
      ],
      "plane_d": -1960.2840576171875,
      "bbox_min": [
        -1681.4425048828125,
        -3767.006103515625,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7880221605300903,
        -0.5122191309928894,
        -0.3415447771549225
      ],
      "plane_d": -127.6697998046875,
      "bbox_min": [
        -1681.4425048828125,
        -3767.006103515625,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7211121916770935,
        -0.6304303407669067,
        -0.28732365369796753
      ],
      "plane_d": -760.0289306640625,
      "bbox_min": [
        -1681.4425048828125,
        -3767.006103515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.279052734375,
        -3755.36474609375,
        1425.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8100697994232178,
        -0.5467621684074402,
        -0.21174998581409454
      ],
      "plane_d": -401.6207275390625,
      "bbox_min": [
        -1681.4425048828125,
        -3767.006103515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1677.4923095703125,
        -3760.09326171875,
        1403.0179443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5174413919448853,
        0.042831193655729294,
        0.8546460866928101
      ],
      "plane_d": -163.09271240234375,
      "bbox_min": [
        -1681.4425048828125,
        -3767.006103515625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1677.4923095703125,
        -3760.09326171875,
        1397.6380615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1680.727294921875,
        -3766.59326171875,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1646.24560546875,
        -3740.171630859375,
        1394.9000244140625
      ],
      "bbox_max": [
        -1634.8406982421875,
        -3727.0849609375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.949376106262207,
        -0.19030731916427612,
        0.24993644654750824
      ],
      "plane_d": 517.9078369140625,
      "bbox_min": [
        -1680.727294921875,
        -3766.59326171875,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1397.184326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1394.9000244140625,
      "bbox_min": [
        -1680.727294921875,
        -3766.59326171875,
        1373.5
      ],
      "bbox_max": [
        -1659.3966064453125,
        -3735.599609375,
        1397.184326171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.847064733505249,
        -0.5281789302825928,
        0.059230607002973557
      ],
      "plane_d": -657.9163818359375,
      "bbox_min": [
        -1661.3983154296875,
        -3755.43359375,
        1373.5
      ],
      "bbox_max": [
        -1659.3966064453125,
        -3752.85595703125,
        1379.1407470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1661.5712890625,
        -3735.599609375,
        1373.5
      ],
      "bbox_max": [
        -1645.6759033203125,
        -3727.0849609375,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5037271976470947,
        -0.8287147879600525,
        -0.24390731751918793
      ],
      "plane_d": -3564.69921875,
      "bbox_min": [
        -1628.9107666015625,
        -3722.95361328125,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.608154296875,
        1395.89306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1628.9019775390625,
        -3721.058349609375,
        1373.5
      ],
      "bbox_max": [
        -1622.4156494140625,
        -3715.61328125,
        1384.9844970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4371967911720276,
        -0.8732787370681763,
        -0.2150418758392334
      ],
      "plane_d": -3674.721435546875,
      "bbox_min": [
        -1601.3858642578125,
        -3774.64501953125,
        1373.5
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3751.525390625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1601.3858642578125,
        -3774.64501953125,
        1373.5
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3751.540283203125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1582.1431884765625,
        -3774.64501953125,
        1379.4097900390625
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3766.8388671875,
        1403.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1601.3858642578125,
        -3789.132568359375,
        1373.5
      ],
      "bbox_max": [
        -1566.068359375,
        -3751.668701171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1569.5159912109375,
        -3789.132568359375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.068359375,
        -3784.54345703125,
        1381.6868896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1569.5159912109375,
        -3789.132568359375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.068359375,
        -3784.54345703125,
        1381.6868896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1567.186767578125,
        -3787.805419921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.068359375,
        -3786.192138671875,
        1375.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5685507655143738,
        0.7893170714378357,
        -0.23179426789283752
      ],
      "plane_d": 2405.20263671875,
      "bbox_min": [
        -1601.3858642578125,
        -3775.082275390625,
        1373.5
      ],
      "bbox_max": [
        -1576.4552001953125,
        -3751.668701171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7402814030647278,
        0.6267737746238708,
        -0.2431829869747162
      ],
      "plane_d": 1533.5904541015625,
      "bbox_min": [
        -1690.88427734375,
        -3836.235595703125,
        1373.5
      ],
      "bbox_max": [
        -1566.2281494140625,
        -3722.992919921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7525864839553833,
        0.5542891025543213,
        -0.3554956614971161
      ],
      "plane_d": 1397.815673828125,
      "bbox_min": [
        -1633.62744140625,
        -3836.235595703125,
        1373.5
      ],
      "bbox_max": [
        -1566.2281494140625,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1625.8046875,
        -3836.235595703125,
        1373.5
      ],
      "bbox_max": [
        -1566.2281494140625,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6985849142074585,
        0.7094742059707642,
        0.09287343174219131
      ],
      "plane_d": 1462.6622314453125,
      "bbox_min": [
        -1615.0087890625,
        -3834.91357421875,
        1373.5
      ],
      "bbox_max": [
        -1580.1939697265625,
        -3785.400634765625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7948121428489685,
        0.5870009660720825,
        0.15395909547805786
      ],
      "plane_d": 755.9136962890625,
      "bbox_min": [
        -1615.0087890625,
        -3834.91357421875,
        1373.5
      ],
      "bbox_max": [
        -1605.986572265625,
        -3822.85205078125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7434534430503845,
        0.6623353362083435,
        0.09267634153366089
      ],
      "plane_d": 1210.6651611328125,
      "bbox_min": [
        -1606.83203125,
        -3823.68359375,
        1373.5
      ],
      "bbox_max": [
        -1605.986572265625,
        -3822.85205078125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783594012260437,
        0.19699105620384216,
        0.0633055791258812
      ],
      "plane_d": -887.359130859375,
      "bbox_min": [
        -1584.191162109375,
        -3801.2880859375,
        1373.5
      ],
      "bbox_max": [
        -1580.1939697265625,
        -3785.400634765625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9611096382141113,
        0.25461429357528687,
        0.10695737600326538
      ],
      "plane_d": -701.0729370117188,
      "bbox_min": [
        -1583.3819580078125,
        -3800.569091796875,
        1373.5
      ],
      "bbox_max": [
        -1583.1156005859375,
        -3799.396728515625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.68327796459198,
        0.48658624291419983,
        -0.544394314289093
      ],
      "plane_d": 1517.5426025390625,
      "bbox_min": [
        -1625.8046875,
        -3836.235595703125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1567.186767578125,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1617.546630859375,
        -3836.235595703125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1567.186767578125,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1596.7384033203125,
        -3780.28564453125,
        1399.0831298828125
      ],
      "bbox_max": [
        -1581.68896484375,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1596.7384033203125,
        -3775.89892578125,
        1427.8759765625
      ],
      "bbox_max": [
        -1591.0924072265625,
        -3772.8193359375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1586.23974609375,
        -3798.111083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1567.186767578125,
        -3782.3896484375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43648433685302734,
        -0.46496182680130005,
        -0.7702544331550598
      ],
      "plane_d": -1381.702880859375,
      "bbox_min": [
        -1586.23974609375,
        -3798.111083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1567.186767578125,
        -3782.3896484375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1570.9874267578125,
        -3786.192138671875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1567.186767578125,
        -3782.3896484375,
        1379.3818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.702180027961731,
        0.5420933961868286,
        -0.4616036117076874
      ],
      "plane_d": 1582.606689453125,
      "bbox_min": [
        -1625.6134033203125,
        -3832.671630859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3773.80712890625,
        1408.14453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1619.157958984375,
        -3832.671630859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3781.501953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1586.23974609375,
        -3788.709228515625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3781.501953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1571.593994140625,
        -3783.68896484375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3781.501953125,
        1378.6053466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9223183989524841,
        0.09922067075967789,
        -0.3734757602214813
      ],
      "plane_d": -567.1842041015625,
      "bbox_min": [
        -1590.5966796875,
        -3788.709228515625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1570.1541748046875,
        -3773.80712890625,
        1405.0975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1590.5966796875,
        -3788.709228515625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1570.1541748046875,
        -3773.80712890625,
        1405.0975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1590.5966796875,
        -3780.28564453125,
        1393.487548828125
      ],
      "bbox_max": [
        -1580.341064453125,
        -3773.80712890625,
        1405.0975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1574.7020263671875,
        -3782.34912109375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1570.1541748046875,
        -3776.95263671875,
        1378.2852783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9223183989524841,
        0.09922067075967789,
        -0.3734757602214813
      ],
      "plane_d": -567.1842041015625,
      "bbox_min": [
        -1590.5966796875,
        -3787.006103515625,
        1373.5
      ],
      "bbox_max": [
        -1574.1424560546875,
        -3773.18896484375,
        1405.0975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1590.5966796875,
        -3783.501953125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.1424560546875,
        -3773.18896484375,
        1405.0975341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1582.8519287109375,
        -3783.501953125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.1424560546875,
        -3774.692138671875,
        1385.4105224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1578.795654296875,
        -3783.501953125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.1424560546875,
        -3774.692138671875,
        1376.6451416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1576.2464599609375,
        -3777.183837890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.1424560546875,
        -3774.692138671875,
        1376.6451416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783594012260437,
        0.19699105620384216,
        0.0633055791258812
      ],
      "plane_d": -887.359130859375,
      "bbox_min": [
        -1580.620849609375,
        -3787.006103515625,
        1373.5
      ],
      "bbox_max": [
        -1578.1160888671875,
        -3777.18359375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1580.1939697265625,
        -3785.400634765625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1578.1160888671875,
        -3777.18359375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664997220039368,
        0.4915757477283478,
        -0.08678330481052399
      ],
      "plane_d": 3370.92724609375,
      "bbox_min": [
        -1690.88427734375,
        -3800.894775390625,
        1373.5
      ],
      "bbox_max": [
        -1576.037841796875,
        -3722.992919921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664397597312927,
        -0.49154171347618103,
        -0.08757215738296509
      ],
      "plane_d": -311.1588134765625,
      "bbox_min": [
        -1690.88427734375,
        -3800.894775390625,
        1373.5
      ],
      "bbox_max": [
        -1621.1893310546875,
        -3735.76953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8664623498916626,
        -0.49155452847480774,
        -0.0872773602604866
      ],
      "plane_d": -3141.50732421875,
      "bbox_min": [
        -1690.88427734375,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1626.9901123046875,
        -3735.76953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9962114691734314,
        -0.08696449548006058
      ],
      "plane_d": -3617.77197265625,
      "bbox_min": [
        -1644.865966796875,
        -3756.807373046875,
        1373.5
      ],
      "bbox_max": [
        -1626.9901123046875,
        -3735.76953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9963495135307312,
        -0.08536812663078308
      ],
      "plane_d": 3844.80419921875,
      "bbox_min": [
        -1644.865966796875,
        -3751.55224609375,
        1373.5
      ],
      "bbox_max": [
        -1626.9901123046875,
        -3735.76953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1638.77197265625,
        -3751.55224609375,
        1373.5
      ],
      "bbox_max": [
        -1633.2000732421875,
        -3745.8173828125,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08733058720827103,
        0.9955815076828003,
        -0.03450729325413704
      ],
      "plane_d": 3633.9951171875,
      "bbox_min": [
        -1638.77197265625,
        -3746.256591796875,
        1373.5
      ],
      "bbox_max": [
        -1634.0968017578125,
        -3745.8173828125,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1628.6070556640625,
        -3736.501220703125,
        1434.1812744140625
      ],
      "bbox_max": [
        -1626.9901123046875,
        -3735.981201171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08733058720827103,
        0.9955815076828003,
        -0.03450729325413704
      ],
      "plane_d": 3633.9951171875,
      "bbox_min": [
        -1638.882080078125,
        -3746.3203125,
        1373.5
      ],
      "bbox_max": [
        -1638.65380859375,
        -3746.21826171875,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1638.882080078125,
        -3746.3203125,
        1374.9000244140625
      ],
      "bbox_max": [
        -1638.77197265625,
        -3746.21826171875,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1627.7547607421875,
        -3736.009033203125,
        1433.7340087890625
      ],
      "bbox_max": [
        -1627.142333984375,
        -3735.76953125,
        1434.50537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1635.8616943359375,
        -3751.64453125,
        1374.9000244140625
      ],
      "bbox_max": [
        -1635.751220703125,
        -3751.55224609375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1690.88427734375,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8186903595924377,
        -0.5559530854225159,
        0.14374381303787231
      ],
      "plane_d": -3683.61279296875,
      "bbox_min": [
        -1690.88427734375,
        -3774.66064453125,
        1406.9580078125
      ],
      "bbox_max": [
        -1688.201171875,
        -3771.875244140625,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8919509649276733,
        -0.1547216773033142,
        -0.4248347282409668
      ],
      "plane_d": -1488.096923828125,
      "bbox_min": [
        -1690.88427734375,
        -3774.66064453125,
        1406.9580078125
      ],
      "bbox_max": [
        -1688.201171875,
        -3771.875244140625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232587218284607,
        -0.3839646577835083,
        0.012823851779103279
      ],
      "plane_d": -3026.698486328125,
      "bbox_min": [
        -1690.88427734375,
        -3774.66064453125,
        1406.9580078125
      ],
      "bbox_max": [
        -1688.201171875,
        -3771.875244140625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622873425483704,
        -0.50560063123703,
        -0.028786351904273033
      ],
      "plane_d": -3323.539306640625,
      "bbox_min": [
        -1689.9459228515625,
        -3774.66064453125,
        1411.987548828125
      ],
      "bbox_max": [
        -1688.201171875,
        -3771.875244140625,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7706760764122009,
        -0.5802133679389954,
        0.26345959305763245
      ],
      "plane_d": -3862.630859375,
      "bbox_min": [
        -1690.88427734375,
        -3773.86181640625,
        1406.9580078125
      ],
      "bbox_max": [
        -1689.1737060546875,
        -3771.89892578125,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1418.5858154296875,
      "bbox_min": [
        -1690.88427734375,
        -3773.86181640625,
        1418.1077880859375
      ],
      "bbox_max": [
        -1689.1737060546875,
        -3771.89892578125,
        1418.5858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1914781779050827,
        0.2929966151714325,
        -0.9367438554763794
      ],
      "plane_d": 2110.692626953125,
      "bbox_min": [
        -1690.210205078125,
        -3773.86181640625,
        1418.1077880859375
      ],
      "bbox_max": [
        -1689.1737060546875,
        -3772.622802734375,
        1418.5858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7211121916770935,
        -0.6304303407669067,
        -0.28732365369796753
      ],
      "plane_d": -760.0289306640625,
      "bbox_min": [
        -1684.650146484375,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7880221605300903,
        -0.5122191309928894,
        -0.3415447771549225
      ],
      "plane_d": -127.6697998046875,
      "bbox_min": [
        -1661.279052734375,
        -3755.36474609375,
        1425.216552734375
      ],
      "bbox_max": [
        -1653.8135986328125,
        -3751.0546875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321675419807434,
        -0.5764033794403076,
        -0.36289089918136597
      ],
      "plane_d": -430.4671630859375,
      "bbox_min": [
        -1656.3861083984375,
        -3753.8232421875,
        1432.2689208984375
      ],
      "bbox_max": [
        -1653.8135986328125,
        -3751.0546875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977416396141052,
        -0.018138699233531952,
        0.06467321515083313
      ],
      "plane_d": 1504.76416015625,
      "bbox_min": [
        -1684.650146484375,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1394.9000244140625,
      "bbox_min": [
        -1684.650146484375,
        -3792.65966796875,
        1373.5
      ],
      "bbox_max": [
        -1666.11181640625,
        -3758.620361328125,
        1434.0556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1666.346923828125,
        -3792.65966796875,
        1373.5
      ],
      "bbox_max": [
        -1666.11181640625,
        -3790.59423828125,
        1376.56298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35810279846191406,
        -0.03704282268881798,
        0.9329470992088318
      ],
      "plane_d": -842.2459106445312,
      "bbox_min": [
        -1684.650146484375,
        -3781.365478515625,
        1397.505615234375
      ],
      "bbox_max": [
        -1680.03515625,
        -3771.52392578125,
        1400.005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1684.650146484375,
        -3777.727783203125,
        1399.427490234375
      ],
      "bbox_max": [
        -1684.0240478515625,
        -3771.52392578125,
        1400.005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1684.4656982421875,
        -3789.912841796875,
        1397.6380615234375
      ],
      "bbox_max": [
        -1669.62451171875,
        -3765.67578125,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467292547225952,
        0.2761877775192261,
        -0.6050750017166138
      ],
      "plane_d": 3157.458984375,
      "bbox_min": [
        -1671.451416015625,
        -3789.912841796875,
        1426.3092041015625
      ],
      "bbox_max": [
        -1669.62451171875,
        -3779.21923828125,
        1432.6209716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9566844701766968,
        -0.1962704360485077,
        0.2150178998708725
      ],
      "plane_d": 564.1163330078125,
      "bbox_min": [
        -1684.4656982421875,
        -3779.696044921875,
        1399.427490234375
      ],
      "bbox_max": [
        -1681.119384765625,
        -3771.52392578125,
        1412.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1684.4656982421875,
        -3778.2451171875,
        1399.427490234375
      ],
      "bbox_max": [
        -1683.835205078125,
        -3771.52392578125,
        1401.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9494562149047852,
        0.029552865773439407,
        -0.3125053644180298
      ],
      "plane_d": 2149.138427734375,
      "bbox_min": [
        -1682.705322265625,
        -3779.8095703125,
        1407.329345703125
      ],
      "bbox_max": [
        -1681.119384765625,
        -3772.39501953125,
        1412.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9566844701766968,
        -0.1962704360485077,
        0.2150178998708725
      ],
      "plane_d": 564.1163330078125,
      "bbox_min": [
        -1682.0679931640625,
        -3779.8095703125,
        1409.6258544921875
      ],
      "bbox_max": [
        -1681.119384765625,
        -3772.39501953125,
        1412.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847064733505249,
        -0.5281789302825928,
        0.059230607002973557
      ],
      "plane_d": -657.9163818359375,
      "bbox_min": [
        -1669.7750244140625,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1394.9000244140625,
      "bbox_min": [
        -1666.99072265625,
        -3762.63525390625,
        1394.9000244140625
      ],
      "bbox_max": [
        -1666.090087890625,
        -3758.142578125,
        1394.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467292547225952,
        0.2761877775192261,
        -0.6050750017166138
      ],
      "plane_d": 3157.458984375,
      "bbox_min": [
        -1669.7750244140625,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1669.7750244140625,
        -3779.21923828125,
        1432.6209716796875
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1669.7750244140625,
        -3776.171875,
        1434.022216796875
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.93994140625,
      "bbox_min": [
        -1669.770751953125,
        -3799.85693359375,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1649.4000244140625,
        -3757.98291015625,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1649.4000244140625,
        -3757.98291015625,
        1373.5
      ],
      "bbox_max": [
        -1635.775146484375,
        -3746.22802734375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44637808203697205,
        0.8144006133079529,
        -0.37080734968185425
      ],
      "plane_d": 2826.673583984375,
      "bbox_min": [
        -1649.4000244140625,
        -3748.900146484375,
        1373.5
      ],
      "bbox_max": [
        -1644.3209228515625,
        -3746.753662109375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9503167867660522,
        0.3110123574733734,
        0.013012579642236233
      ],
      "plane_d": -415.693359375,
      "bbox_min": [
        -1659.8681640625,
        -3797.94384765625,
        1373.5
      ],
      "bbox_max": [
        -1651.4931640625,
        -3778.032958984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1659.8681640625,
        -3797.94384765625,
        1373.5
      ],
      "bbox_max": [
        -1651.4931640625,
        -3778.032958984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9960047602653503,
        0.08865047246217728,
        0.010755551047623158
      ],
      "plane_d": -1331.3216552734375,
      "bbox_min": [
        -1659.8681640625,
        -3797.94384765625,
        1373.5
      ],
      "bbox_max": [
        -1651.4931640625,
        -3778.032958984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1655.0865478515625,
        -3781.342041015625,
        1373.5
      ],
      "bbox_max": [
        -1651.4931640625,
        -3778.032958984375,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1669.770751953125,
        -3776.05859375,
        1433.8359375
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.42626953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1653.3206787109375,
        -3794.731689453125,
        1373.5
      ],
      "bbox_max": [
        -1652.8016357421875,
        -3791.1171875,
        1375.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1627.3397216796875,
        -3736.14453125,
        1432.015869140625
      ],
      "bbox_max": [
        -1625.4945068359375,
        -3734.802978515625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1627.3397216796875,
        -3736.14453125,
        1432.944580078125
      ],
      "bbox_max": [
        -1625.4945068359375,
        -3735.3466796875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5586407780647278,
        0.8288311958312988,
        -0.030971452593803406
      ],
      "plane_d": 2288.16455078125,
      "bbox_min": [
        -1600.7596435546875,
        -3780.28564453125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.037841796875,
        -3761.58935546875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1580.3524169921875,
        -3777.7392578125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.037841796875,
        -3772.6669921875,
        1380.4752197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1578.1160888671875,
        -3777.18359375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.037841796875,
        -3772.6669921875,
        1375.830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1577.630126953125,
        -3774.72900390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.037841796875,
        -3772.6669921875,
        1375.830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1600.7596435546875,
        -3775.89892578125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.7177734375,
        -3761.58935546875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1578.281494140625,
        -3772.6669921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1576.7177734375,
        -3768.904052734375,
        1378.446533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100038409233093,
        -0.41456741094589233,
        0.005178479943424463
      ],
      "plane_d": -3006.795166015625,
      "bbox_min": [
        -1600.9296875,
        -3778.814453125,
        1373.5
      ],
      "bbox_max": [
        -1577.630126953125,
        -3751.668701171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1587.1962890625,
        -3772.6669921875,
        1373.5
      ],
      "bbox_max": [
        -1577.630126953125,
        -3751.668701171875,
        1377.7083740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1578.671630859375,
        -3777.83984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1577.630126953125,
        -3772.6669921875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1600.9296875,
        -3761.82470703125,
        1434.895751953125
      ],
      "bbox_max": [
        -1600.651611328125,
        -3761.2294921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1194.825439453125,
      "bbox_min": [
        -1663.5753173828125,
        -3806.130126953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3725.436767578125,
        1210.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.009213004261255264,
        0.25568875670433044,
        0.9667152166366577
      ],
      "plane_d": -211.2101287841797,
      "bbox_min": [
        -1663.5753173828125,
        -3806.130126953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3725.436767578125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4071606397628784,
        0.40963250398635864,
        0.8163464069366455
      ],
      "plane_d": 1230.17333984375,
      "bbox_min": [
        -1663.5753173828125,
        -3806.130126953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3750.3837890625,
        1208.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30472713708877563,
        0.354938805103302,
        0.8838325142860413
      ],
      "plane_d": 776.626220703125,
      "bbox_min": [
        -1663.5753173828125,
        -3806.130126953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1604.256591796875,
        -3759.6015625,
        1208.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2777150273323059,
        0.8931024670600891,
        0.35389572381973267
      ],
      "plane_d": 3403.28466796875,
      "bbox_min": [
        -1658.1766357421875,
        -3778.8251953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1634.1810302734375,
        -3765.369140625,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30048149824142456,
        0.9013935923576355,
        0.3117698132991791
      ],
      "plane_d": 3522.477783203125,
      "bbox_min": [
        -1651.4718017578125,
        -3778.8251953125,
        1194.825439453125
      ],
      "bbox_max": [
        -1634.1810302734375,
        -3770.552490234375,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6286960244178772,
        0.6948664784431458,
        0.3491445779800415
      ],
      "plane_d": 3241.1376953125,
      "bbox_min": [
        -1658.1766357421875,
        -3772.49560546875,
        1194.825439453125
      ],
      "bbox_max": [
        -1651.4718017578125,
        -3765.369140625,
        1200.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3374372720718384,
        0.8074705600738525,
        0.48386695981025696
      ],
      "plane_d": 3022.5615234375,
      "bbox_min": [
        -1663.5753173828125,
        -3790.28955078125,
        1194.825439453125
      ],
      "bbox_max": [
        -1604.256591796875,
        -3759.6015625,
        1199.062744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4140835106372833,
        0.769829273223877,
        0.4856930077075958
      ],
      "plane_d": 3001.704345703125,
      "bbox_min": [
        -1615.9910888671875,
        -3790.28955078125,
        1194.825439453125
      ],
      "bbox_max": [
        -1604.256591796875,
        -3784.38525390625,
        1199.062744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1614.8726806640625,
        -3790.28955078125,
        1194.825439453125
      ],
      "bbox_max": [
        -1604.256591796875,
        -3784.38525390625,
        1195.133056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6286960244178772,
        0.6948664784431458,
        0.3491445779800415
      ],
      "plane_d": 3241.1376953125,
      "bbox_min": [
        -1663.5753173828125,
        -3788.1171875,
        1194.825439453125
      ],
      "bbox_max": [
        -1606.2392578125,
        -3759.6015625,
        1197.60400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1614.8726806640625,
        -3788.1171875,
        1194.825439453125
      ],
      "bbox_max": [
        -1606.2392578125,
        -3783.689697265625,
        1195.03173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2026163637638092,
        0.42885521054267883,
        0.8803577423095703
      ],
      "plane_d": 895.6639404296875,
      "bbox_min": [
        -1626.2281494140625,
        -3806.130126953125,
        1199.062744140625
      ],
      "bbox_max": [
        -1614.9180908203125,
        -3786.45703125,
        1208.8314208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20422875881195068,
        -0.3231890797615051,
        0.9240343570709229
      ],
      "plane_d": -2652.574462890625,
      "bbox_min": [
        -1637.38916015625,
        -3802.837646484375,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3750.3837890625,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1637.38916015625,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1588.425048828125,
        -3750.3837890625,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09997844696044922,
        -0.12448713183403015,
        0.9871712923049927
      ],
      "plane_d": -1811.268310546875,
      "bbox_min": [
        -1637.38916015625,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1588.425048828125,
        -3750.3837890625,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29123783111572266,
        -0.3972978889942169,
        0.8702499270439148
      ],
      "plane_d": -3007.05078125,
      "bbox_min": [
        -1637.38916015625,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1597.6488037109375,
        -3750.3837890625,
        1196.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32098761200904846,
        -0.4236999452114105,
        0.8470214605331421
      ],
      "plane_d": -3126.75048828125,
      "bbox_min": [
        -1637.38916015625,
        -3772.504638671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1608.4658203125,
        -3750.3837890625,
        1196.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3252005875110626,
        -0.4211671054363251,
        0.8466775417327881
      ],
      "plane_d": -3123.650146484375,
      "bbox_min": [
        -1637.38916015625,
        -3761.466796875,
        1194.825439453125
      ],
      "bbox_max": [
        -1621.7266845703125,
        -3750.3837890625,
        1196.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1631.6580810546875,
        -3759.05859375,
        1195.625244140625
      ],
      "bbox_max": [
        -1621.7266845703125,
        -3753.201171875,
        1196.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1629.7398681640625,
        -3759.05859375,
        1195.9119873046875
      ],
      "bbox_max": [
        -1621.7266845703125,
        -3754.2158203125,
        1196.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3170998692512512,
        -0.3699498772621155,
        0.8732609748840332
      ],
      "plane_d": -2949.076416015625,
      "bbox_min": [
        -1627.1986083984375,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1597.6488037109375,
        -3755.56005859375,
        1196.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1627.1986083984375,
        -3759.05859375,
        1196.291748046875
      ],
      "bbox_max": [
        -1621.7266845703125,
        -3755.56005859375,
        1196.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20201623439788818,
        -0.05099478363990784,
        0.9780535697937012
      ],
      "plane_d": -1687.13134765625,
      "bbox_min": [
        -1626.1422119140625,
        -3772.17236328125,
        1196.4495849609375
      ],
      "bbox_max": [
        -1588.425048828125,
        -3756.118896484375,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1329224854707718,
        -0.13213592767715454,
        0.9822788238525391
      ],
      "plane_d": -1887.1551513671875,
      "bbox_min": [
        -1626.1422119140625,
        -3770.25830078125,
        1196.4495849609375
      ],
      "bbox_max": [
        -1598.0902099609375,
        -3756.118896484375,
        1198.6773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1626.1422119140625,
        -3759.05859375,
        1196.4495849609375
      ],
      "bbox_max": [
        -1620.809814453125,
        -3756.118896484375,
        1196.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06193792074918747,
        -0.1452135592699051,
        0.9874597191810608
      ],
      "plane_d": -1827.8341064453125,
      "bbox_min": [
        -1624.7322998046875,
        -3759.05859375,
        1196.526123046875
      ],
      "bbox_max": [
        -1620.809814453125,
        -3756.86474609375,
        1196.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3525896966457367,
        0.3399505913257599,
        0.8718452453613281
      ],
      "plane_d": 811.5929565429688,
      "bbox_min": [
        -1615.9910888671875,
        -3802.837646484375,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3781.7763671875,
        1199.8636474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4140835106372833,
        0.769829273223877,
        0.4856930077075958
      ],
      "plane_d": 3001.704345703125,
      "bbox_min": [
        -1615.9910888671875,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1601.1234130859375,
        -3783.412353515625,
        1199.062744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020206311717629433,
        0.03197619691491127,
        0.9992844462394714
      ],
      "plane_d": -1040.7611083984375,
      "bbox_min": [
        -1608.448974609375,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3781.7763671875,
        1195.223876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1608.448974609375,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1597.6488037109375,
        -3781.7763671875,
        1195.223876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17675535380840302,
        0.48145797848701477,
        0.8584612011909485
      ],
      "plane_d": 1082.657958984375,
      "bbox_min": [
        -1604.5966796875,
        -3802.837646484375,
        1195.223876953125
      ],
      "bbox_max": [
        -1594.2252197265625,
        -3792.0322265625,
        1199.8636474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014848561026155949,
        -0.10505770891904831,
        0.9943552017211914
      ],
      "plane_d": -1608.453369140625,
      "bbox_min": [
        -1660.2626953125,
        -3802.846923828125,
        1194.825439453125
      ],
      "bbox_max": [
        -1589.769287109375,
        -3725.436767578125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005586736369878054,
        -0.7528338432312012,
        0.6581868529319763
      ],
      "plane_d": -3617.205322265625,
      "bbox_min": [
        -1660.2440185546875,
        -3756.125732421875,
        1194.825439453125
      ],
      "bbox_max": [
        -1622.800048828125,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526269197463989,
        0.49214035272598267,
        0.17557108402252197
      ],
      "plane_d": 3026.4833984375,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500179648399353,
        -0.49077823758125305,
        0.19132709503173828
      ],
      "plane_d": -673.748779296875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3740.988525390625,
        1197.8892822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8499592542648315,
        -0.4908689260482788,
        0.1913560926914215
      ],
      "plane_d": -3461.065673828125,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3740.98974609375,
        1197.8155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        0.19917234778404236
      ],
      "plane_d": -3906.702880859375,
      "bbox_min": [
        -1640.699951171875,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3743.161865234375,
        1197.6416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1640.4752197265625,
        -3756.125732421875,
        1194.825439453125
      ],
      "bbox_max": [
        -1622.800048828125,
        -3745.810546875,
        1197.3359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1629.0,
        -3751.2177734375,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3749.0,
        1197.2530517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1629.0,
        -3750.6689453125,
        1197.0
      ],
      "bbox_max": [
        -1628.0042724609375,
        -3749.0,
        1197.162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3252005875110626,
        -0.4211671054363251,
        0.8466775417327881
      ],
      "plane_d": -3123.650146484375,
      "bbox_min": [
        -1640.4752197265625,
        -3753.201171875,
        1194.825439453125
      ],
      "bbox_max": [
        -1631.6580810546875,
        -3748.0009765625,
        1195.625244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08123259246349335,
        0.00713521521538496,
        0.996669590473175
      ],
      "plane_d": -1299.83251953125,
      "bbox_min": [
        -1660.2626953125,
        -3802.846923828125,
        1196.451416015625
      ],
      "bbox_max": [
        -1589.769287109375,
        -3725.436767578125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06193792074918747,
        -0.1452135592699051,
        0.9874597191810608
      ],
      "plane_d": -1827.8341064453125,
      "bbox_min": [
        -1639.8760986328125,
        -3768.708984375,
        1196.451416015625
      ],
      "bbox_max": [
        -1589.769287109375,
        -3742.5048828125,
        1200.1260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1639.8760986328125,
        -3756.86474609375,
        1196.451416015625
      ],
      "bbox_max": [
        -1622.869384765625,
        -3745.810546875,
        1197.9222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1628.95263671875,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.869384765625,
        -3749.0,
        1197.9222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1628.95263671875,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.869384765625,
        -3749.0,
        1197.9222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1628.95263671875,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1627.408203125,
        -3749.0,
        1197.5594482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1329224854707718,
        -0.13213592767715454,
        0.9822788238525391
      ],
      "plane_d": -1887.1551513671875,
      "bbox_min": [
        -1628.83642578125,
        -3768.708984375,
        1196.8316650390625
      ],
      "bbox_max": [
        -1589.769287109375,
        -3742.5048828125,
        1200.1260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09997844696044922,
        -0.12448713183403015,
        0.9871712923049927
      ],
      "plane_d": -1811.268310546875,
      "bbox_min": [
        -1628.83642578125,
        -3768.708984375,
        1196.8316650390625
      ],
      "bbox_max": [
        -1589.769287109375,
        -3742.5048828125,
        1200.1260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20201623439788818,
        -0.05099478363990784,
        0.9780535697937012
      ],
      "plane_d": -1687.13134765625,
      "bbox_min": [
        -1628.83642578125,
        -3768.708984375,
        1197.2767333984375
      ],
      "bbox_max": [
        -1589.769287109375,
        -3749.0,
        1200.1260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3749.0,
        1198.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3749.0,
        1198.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1624.56494140625,
        -3751.486328125,
        1197.4713134765625
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3749.0,
        1198.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009403778240084648,
        -0.10570655763149261,
        0.9943529367446899
      ],
      "plane_d": -1601.9522705078125,
      "bbox_min": [
        -1660.2626953125,
        -3802.846923828125,
        1197.0216064453125
      ],
      "bbox_max": [
        -1622.47705078125,
        -3725.436767578125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005586736369878054,
        -0.7528338432312012,
        0.6581868529319763
      ],
      "plane_d": -3617.205322265625,
      "bbox_min": [
        -1660.2626953125,
        -3745.931396484375,
        1197.0216064453125
      ],
      "bbox_max": [
        -1639.571533203125,
        -3740.989501953125,
        1197.8297119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028623001649975777,
        -0.8394990563392639,
        0.5426066517829895
      ],
      "plane_d": -3841.718994140625,
      "bbox_min": [
        -1660.2626953125,
        -3745.931396484375,
        1197.0216064453125
      ],
      "bbox_max": [
        -1659.3355712890625,
        -3745.82958984375,
        1197.14111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.046580925583839417,
        0.26604676246643066,
        0.9628340005874634
      ],
      "plane_d": -228.47975158691406,
      "bbox_min": [
        -1641.8642578125,
        -3802.846923828125,
        1197.609375
      ],
      "bbox_max": [
        -1622.47705078125,
        -3738.89990234375,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30472713708877563,
        0.354938805103302,
        0.8838325142860413
      ],
      "plane_d": 776.626220703125,
      "bbox_min": [
        -1634.48876953125,
        -3802.846923828125,
        1202.37548828125
      ],
      "bbox_max": [
        -1623.7452392578125,
        -3778.8251953125,
        1209.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2026163637638092,
        0.42885521054267883,
        0.8803577423095703
      ],
      "plane_d": 895.6639404296875,
      "bbox_min": [
        -1627.25,
        -3802.846923828125,
        1208.100830078125
      ],
      "bbox_max": [
        -1623.7452392578125,
        -3800.174072265625,
        1209.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        0.19917234778404236
      ],
      "plane_d": -3906.702880859375,
      "bbox_min": [
        -1641.8642578125,
        -3751.7841796875,
        1197.609375
      ],
      "bbox_max": [
        -1622.47705078125,
        -3738.89990234375,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500179648399353,
        -0.49077823758125305,
        0.19132709503173828
      ],
      "plane_d": -673.748779296875,
      "bbox_min": [
        -1638.9189453125,
        -3743.161865234375,
        1197.6416015625
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3738.89990234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526269197463989,
        0.49214035272598267,
        0.17557108402252197
      ],
      "plane_d": 3026.4833984375,
      "bbox_min": [
        -1638.9189453125,
        -3740.988525390625,
        1197.8892822265625
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3738.89990234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1202.800048828125,
      "bbox_min": [
        -1629.24072265625,
        -3751.7841796875,
        1198.2755126953125
      ],
      "bbox_max": [
        -1622.47705078125,
        -3747.77880859375,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1628.6270751953125,
        -3751.2646484375,
        1198.2755126953125
      ],
      "bbox_max": [
        -1623.2694091796875,
        -3749.0,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1627.2381591796875,
        -3751.2646484375,
        1198.4049072265625
      ],
      "bbox_max": [
        -1623.2694091796875,
        -3749.0,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1625.1185302734375,
        -3751.212890625,
        1198.6224365234375
      ],
      "bbox_max": [
        -1623.2694091796875,
        -3749.0,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9677070379257202,
        -0.2520774304866791
      ],
      "plane_d": -3325.6142578125,
      "bbox_min": [
        -1629.24072265625,
        -3751.7841796875,
        1204.0
      ],
      "bbox_max": [
        -1622.47705078125,
        -3748.94970703125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1629.24072265625,
        -3751.7841796875,
        1204.0
      ],
      "bbox_max": [
        -1622.47705078125,
        -3748.94970703125,
        1210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829205334186554,
        -0.49467000365257263,
        -0.2602307200431824
      ],
      "plane_d": -194.2471923828125,
      "bbox_min": [
        -1625.1185302734375,
        -3751.7841796875,
        1204.0
      ],
      "bbox_max": [
        -1622.47705078125,
        -3748.94970703125,
        1210.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02e",
      "entity_class": "CGameArea",
      "piece_name": "mt02e",
      "offset": 54,
      "centroid": [
        -1587.1018676757812,
        -3728.9278157552085,
        1368.3333333333333
      ],
      "bbox_min": [
        -1627.0,
        -3880.6669921875,
        1230.5
      ],
      "bbox_max": [
        -1539.5228271484375,
        -3532.0,
        1495.0
      ],
      "dimensions_source": {
        "span_x": 87.4771728515625,
        "span_y": 348.6669921875,
        "height_z": 264.5,
        "door_width": 348.6669921875,
        "door_depth": 87.4771728515625,
        "leaf_depth": 87.4771728515625,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -1627.0,
          -3785.5,
          1230.5
        ],
        [
          -1627.0,
          -3772.5,
          1230.5
        ],
        [
          -1612.5,
          -3772.5,
          1230.5
        ],
        [
          -1612.5,
          -3785.5,
          1230.5
        ],
        [
          -1567.888427734375,
          -3880.6669921875,
          1372.0
        ],
        [
          -1539.5228271484375,
          -3870.89990234375,
          1372.0
        ],
        [
          -1539.5228271484375,
          -3870.89990234375,
          1392.0
        ],
        [
          -1567.888427734375,
          -3880.6669921875,
          1392.0
        ],
        [
          -1590.0999755859375,
          -3532.0,
          1490.0
        ],
        [
          -1590.0999755859375,
          -3532.0,
          1495.0
        ],
        [
          -1585.5999755859375,
          -3532.0,
          1495.0
        ],
        [
          -1585.5999755859375,
          -3532.0,
          1490.0
        ]
      ],
      "plane_distance": -1230.5
    }
  ],
  "tutorial_messages": []
}